(() => {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bgb0K", function(module, exports) {
!/**
 * Highcharts JS v11.4.0 (2024-03-04)
 *
 * Exporting module
 *
 * (c) 2010-2024 Torstein Honsi
 *
 * License: www.highcharts.com/license
 */ function(e) {
    (0, module.exports) ? (e.default = e, module.exports = e) : "function" == typeof define && define.amd ? define("highcharts/modules/exporting", [
        "highcharts"
    ], function(t) {
        return e(t), e.Highcharts = t, e;
    }) : e("undefined" != typeof Highcharts ? Highcharts : void 0);
}(function(e) {
    "use strict";
    var t = e ? e._modules : {};
    function n(e, t, n, i) {
        e.hasOwnProperty(t) || (e[t] = i.apply(null, n), "function" == typeof CustomEvent && window.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", {
            detail: {
                path: t,
                module: e[t]
            }
        })));
    }
    n(t, "Core/Chart/ChartNavigationComposition.js", [], function() {
        var e;
        return function(e) {
            e.compose = function(e) {
                return e.navigation || (e.navigation = new t(e)), e;
            };
            class t {
                constructor(e){
                    this.updates = [], this.chart = e;
                }
                addUpdate(e) {
                    this.chart.navigation.updates.push(e);
                }
                update(e, t) {
                    this.updates.forEach((n)=>{
                        n.call(this.chart, e, t);
                    });
                }
            }
            e.Additions = t;
        }(e || (e = {})), e;
    }), n(t, "Extensions/Exporting/ExportingDefaults.js", [
        t["Core/Globals.js"]
    ], function(e) {
        let { isTouchDevice: t } = e;
        return {
            exporting: {
                allowTableSorting: !0,
                type: "image/png",
                url: "https://export.highcharts.com/",
                pdfFont: {
                    normal: void 0,
                    bold: void 0,
                    bolditalic: void 0,
                    italic: void 0
                },
                printMaxWidth: 780,
                scale: 2,
                buttons: {
                    contextButton: {
                        className: "highcharts-contextbutton",
                        menuClassName: "highcharts-contextmenu",
                        symbol: "menu",
                        titleKey: "contextButtonTitle",
                        menuItems: [
                            "viewFullscreen",
                            "printChart",
                            "separator",
                            "downloadPNG",
                            "downloadJPEG",
                            "downloadPDF",
                            "downloadSVG"
                        ]
                    }
                },
                menuItemDefinitions: {
                    viewFullscreen: {
                        textKey: "viewFullscreen",
                        onclick: function() {
                            this.fullscreen && this.fullscreen.toggle();
                        }
                    },
                    printChart: {
                        textKey: "printChart",
                        onclick: function() {
                            this.print();
                        }
                    },
                    separator: {
                        separator: !0
                    },
                    downloadPNG: {
                        textKey: "downloadPNG",
                        onclick: function() {
                            this.exportChart();
                        }
                    },
                    downloadJPEG: {
                        textKey: "downloadJPEG",
                        onclick: function() {
                            this.exportChart({
                                type: "image/jpeg"
                            });
                        }
                    },
                    downloadPDF: {
                        textKey: "downloadPDF",
                        onclick: function() {
                            this.exportChart({
                                type: "application/pdf"
                            });
                        }
                    },
                    downloadSVG: {
                        textKey: "downloadSVG",
                        onclick: function() {
                            this.exportChart({
                                type: "image/svg+xml"
                            });
                        }
                    }
                }
            },
            lang: {
                viewFullscreen: "View in full screen",
                exitFullscreen: "Exit from full screen",
                printChart: "Print chart",
                downloadPNG: "Download PNG image",
                downloadJPEG: "Download JPEG image",
                downloadPDF: "Download PDF document",
                downloadSVG: "Download SVG vector image",
                contextButtonTitle: "Chart context menu"
            },
            navigation: {
                buttonOptions: {
                    symbolSize: 14,
                    symbolX: 14.5,
                    symbolY: 13.5,
                    align: "right",
                    buttonSpacing: 3,
                    height: 28,
                    verticalAlign: "top",
                    width: 28,
                    symbolFill: "#666666",
                    symbolStroke: "#666666",
                    symbolStrokeWidth: 3,
                    theme: {
                        padding: 5
                    }
                },
                menuStyle: {
                    border: "none",
                    borderRadius: "3px",
                    background: "#ffffff",
                    padding: "0.5em"
                },
                menuItemStyle: {
                    background: "none",
                    borderRadius: "3px",
                    color: "#333333",
                    padding: "0.5em",
                    fontSize: t ? "0.9em" : "0.8em",
                    transition: "background 250ms, color 250ms"
                },
                menuItemHoverStyle: {
                    background: "#f2f2f2"
                }
            }
        };
    }), n(t, "Extensions/Exporting/ExportingSymbols.js", [], function() {
        var e;
        return function(e) {
            let t = [];
            function n(e, t, n, i) {
                return [
                    [
                        "M",
                        e,
                        t + 2.5
                    ],
                    [
                        "L",
                        e + n,
                        t + 2.5
                    ],
                    [
                        "M",
                        e,
                        t + i / 2 + .5
                    ],
                    [
                        "L",
                        e + n,
                        t + i / 2 + .5
                    ],
                    [
                        "M",
                        e,
                        t + i - 1.5
                    ],
                    [
                        "L",
                        e + n,
                        t + i - 1.5
                    ]
                ];
            }
            function i(e, t, n, i) {
                let o = i / 3 - 2;
                return [].concat(this.circle(n - o, t, o, o), this.circle(n - o, t + o + 4, o, o), this.circle(n - o, t + 2 * (o + 4), o, o));
            }
            e.compose = function(e) {
                if (-1 === t.indexOf(e)) {
                    t.push(e);
                    let o = e.prototype.symbols;
                    o.menu = n, o.menuball = i.bind(o);
                }
            };
        }(e || (e = {})), e;
    }), n(t, "Extensions/Exporting/Fullscreen.js", [
        t["Core/Renderer/HTML/AST.js"],
        t["Core/Globals.js"],
        t["Core/Utilities.js"]
    ], function(e, t, n) {
        let { composed: i } = t, { addEvent: o, fireEvent: r, pushUnique: s } = n;
        function l() {
            this.fullscreen = new a(this);
        }
        class a {
            static compose(e) {
                s(i, "Fullscreen") && o(e, "beforeRender", l);
            }
            constructor(e){
                this.chart = e, this.isOpen = !1;
                let t = e.renderTo;
                !this.browserProps && ("function" == typeof t.requestFullscreen ? this.browserProps = {
                    fullscreenChange: "fullscreenchange",
                    requestFullscreen: "requestFullscreen",
                    exitFullscreen: "exitFullscreen"
                } : t.mozRequestFullScreen ? this.browserProps = {
                    fullscreenChange: "mozfullscreenchange",
                    requestFullscreen: "mozRequestFullScreen",
                    exitFullscreen: "mozCancelFullScreen"
                } : t.webkitRequestFullScreen ? this.browserProps = {
                    fullscreenChange: "webkitfullscreenchange",
                    requestFullscreen: "webkitRequestFullScreen",
                    exitFullscreen: "webkitExitFullscreen"
                } : t.msRequestFullscreen && (this.browserProps = {
                    fullscreenChange: "MSFullscreenChange",
                    requestFullscreen: "msRequestFullscreen",
                    exitFullscreen: "msExitFullscreen"
                }));
            }
            close() {
                let e = this, t = e.chart, n = t.options.chart;
                r(t, "fullscreenClose", null, function() {
                    e.isOpen && e.browserProps && t.container.ownerDocument instanceof Document && t.container.ownerDocument[e.browserProps.exitFullscreen](), e.unbindFullscreenEvent && (e.unbindFullscreenEvent = e.unbindFullscreenEvent()), t.setSize(e.origWidth, e.origHeight, !1), e.origWidth = void 0, e.origHeight = void 0, n.width = e.origWidthOption, n.height = e.origHeightOption, e.origWidthOption = void 0, e.origHeightOption = void 0, e.isOpen = !1, e.setButtonText();
                });
            }
            open() {
                let e = this, t = e.chart, n = t.options.chart;
                r(t, "fullscreenOpen", null, function() {
                    if (n && (e.origWidthOption = n.width, e.origHeightOption = n.height), e.origWidth = t.chartWidth, e.origHeight = t.chartHeight, e.browserProps) {
                        let n = o(t.container.ownerDocument, e.browserProps.fullscreenChange, function() {
                            e.isOpen ? (e.isOpen = !1, e.close()) : (t.setSize(null, null, !1), e.isOpen = !0, e.setButtonText());
                        }), i = o(t, "destroy", n);
                        e.unbindFullscreenEvent = ()=>{
                            n(), i();
                        };
                        let r = t.renderTo[e.browserProps.requestFullscreen]();
                        r && r.catch(function() {
                            alert("Full screen is not supported inside a frame.");
                        });
                    }
                });
            }
            setButtonText() {
                let t = this.chart, n = t.exportDivElements, i = t.options.exporting, o = i && i.buttons && i.buttons.contextButton.menuItems, r = t.options.lang;
                if (i && i.menuItemDefinitions && r && r.exitFullscreen && r.viewFullscreen && o && n) {
                    let t = n[o.indexOf("viewFullscreen")];
                    t && e.setElementHTML(t, this.isOpen ? r.exitFullscreen : i.menuItemDefinitions.viewFullscreen.text || r.viewFullscreen);
                }
            }
            toggle() {
                this.isOpen ? this.close() : this.open();
            }
        }
        return a;
    }), n(t, "Core/HttpUtilities.js", [
        t["Core/Globals.js"],
        t["Core/Utilities.js"]
    ], function(e, t) {
        let { win: n } = e, { discardElement: i, objectEach: o } = t, r = {
            ajax: function(e) {
                let t = {
                    json: "application/json",
                    xml: "application/xml",
                    text: "text/plain",
                    octet: "application/octet-stream"
                }, n = new XMLHttpRequest;
                function i(t, n) {
                    e.error && e.error(t, n);
                }
                if (!e.url) return !1;
                n.open((e.type || "get").toUpperCase(), e.url, !0), e.headers && e.headers["Content-Type"] || n.setRequestHeader("Content-Type", t[e.dataType || "json"] || t.text), o(e.headers, function(e, t) {
                    n.setRequestHeader(t, e);
                }), e.responseType && (n.responseType = e.responseType), n.onreadystatechange = function() {
                    let t;
                    if (4 === n.readyState) {
                        if (200 === n.status) {
                            if ("blob" !== e.responseType && (t = n.responseText, "json" === e.dataType)) try {
                                t = JSON.parse(t);
                            } catch (e) {
                                if (e instanceof Error) return i(n, e);
                            }
                            return e.success && e.success(t, n);
                        }
                        i(n, n.responseText);
                    }
                }, e.data && "string" != typeof e.data && (e.data = JSON.stringify(e.data)), n.send(e.data);
            },
            getJSON: function(e, t) {
                r.ajax({
                    url: e,
                    success: t,
                    dataType: "json",
                    headers: {
                        "Content-Type": "text/plain"
                    }
                });
            },
            post: function(e, t, r) {
                let s = new n.FormData;
                o(t, function(e, t) {
                    s.append(t, e);
                }), s.append("b64", "true");
                let { filename: l, type: a } = t;
                return n.fetch(e, {
                    method: "POST",
                    body: s,
                    ...r
                }).then((e)=>{
                    e.ok && e.text().then((e)=>{
                        let t = document.createElement("a");
                        t.href = `data:${a};base64,${e}`, t.download = l, t.click(), i(t);
                    });
                });
            }
        };
        return r;
    }), n(t, "Extensions/Exporting/Exporting.js", [
        t["Core/Renderer/HTML/AST.js"],
        t["Core/Chart/Chart.js"],
        t["Core/Chart/ChartNavigationComposition.js"],
        t["Core/Defaults.js"],
        t["Extensions/Exporting/ExportingDefaults.js"],
        t["Extensions/Exporting/ExportingSymbols.js"],
        t["Extensions/Exporting/Fullscreen.js"],
        t["Core/Globals.js"],
        t["Core/HttpUtilities.js"],
        t["Core/Utilities.js"]
    ], function(e, t, n, i, o, r, s, l, a, c) {
        var p;
        let { defaultOptions: u } = i, { doc: h, SVG_NS: d, win: g } = l, { addEvent: f, css: m, createElement: x, discardElement: y, extend: b, find: v, fireEvent: w, isObject: E, merge: C, objectEach: S, pick: F, removeEvent: T, uniqueKey: O } = c;
        return function(t) {
            let i;
            let p = [
                /-/,
                /^(clipPath|cssText|d|height|width)$/,
                /^font$/,
                /[lL]ogical(Width|Height)$/,
                /^parentRule$/,
                /^(cssRules|ownerRules)$/,
                /perspective/,
                /TapHighlightColor/,
                /^transition/,
                /^length$/,
                /^[0-9]+$/
            ], k = [
                "fill",
                "stroke",
                "strokeLinecap",
                "strokeLinejoin",
                "strokeWidth",
                "textAnchor",
                "x",
                "y"
            ];
            t.inlineAllowlist = [];
            let M = [
                "clipPath",
                "defs",
                "desc"
            ];
            function P(e) {
                let t, n;
                let i = this, o = i.renderer, r = C(i.options.navigation.buttonOptions, e), s = r.onclick, l = r.menuItems, a = r.symbolSize || 12;
                if (i.btnCount || (i.btnCount = 0), i.exportDivElements || (i.exportDivElements = [], i.exportSVGElements = []), !1 === r.enabled || !r.theme) return;
                let c = r.theme;
                i.styledMode || (c.fill = F(c.fill, "#ffffff"), c.stroke = F(c.stroke, "none")), s ? n = function(e) {
                    e && e.stopPropagation(), s.call(i, e);
                } : l && (n = function(e) {
                    e && e.stopPropagation(), i.contextMenu(p.menuClassName, l, p.translateX || 0, p.translateY || 0, p.width || 0, p.height || 0, p), p.setState(2);
                }), r.text && r.symbol ? c.paddingLeft = F(c.paddingLeft, 30) : r.text || b(c, {
                    width: r.width,
                    height: r.height,
                    padding: 0
                }), i.styledMode || (c["stroke-linecap"] = "round", c.fill = F(c.fill, "#ffffff"), c.stroke = F(c.stroke, "none"));
                let p = o.button(r.text, 0, 0, n, c, void 0, void 0, void 0, void 0, r.useHTML).addClass(e.className).attr({
                    title: F(i.options.lang[r._titleKey || r.titleKey], "")
                });
                p.menuClassName = e.menuClassName || "highcharts-menu-" + i.btnCount++, r.symbol && (t = o.symbol(r.symbol, r.symbolX - a / 2, r.symbolY - a / 2, a, a, {
                    width: a,
                    height: a
                }).addClass("highcharts-button-symbol").attr({
                    zIndex: 1
                }).add(p), i.styledMode || t.attr({
                    stroke: r.symbolStroke,
                    fill: r.symbolFill,
                    "stroke-width": r.symbolStrokeWidth || 1
                })), p.add(i.exportingGroup).align(b(r, {
                    width: p.width,
                    x: F(r.x, i.buttonOffset)
                }), !0, "spacingBox"), i.buttonOffset += ((p.width || 0) + r.buttonSpacing) * ("right" === r.align ? -1 : 1), i.exportSVGElements.push(p, t);
            }
            function H() {
                if (!this.printReverseInfo) return;
                let { childNodes: e, origDisplay: t, resetParams: n } = this.printReverseInfo;
                this.moveContainers(this.renderTo), [].forEach.call(e, function(e, n) {
                    1 === e.nodeType && (e.style.display = t[n] || "");
                }), this.isPrinting = !1, n && this.setSize.apply(this, n), delete this.printReverseInfo, i = void 0, w(this, "afterPrint");
            }
            function N() {
                let e = h.body, t = this.options.exporting.printMaxWidth, n = {
                    childNodes: e.childNodes,
                    origDisplay: [],
                    resetParams: void 0
                };
                this.isPrinting = !0, this.pointer?.reset(void 0, 0), w(this, "beforePrint"), t && this.chartWidth > t && (n.resetParams = [
                    this.options.chart.width,
                    void 0,
                    !1
                ], this.setSize(t, void 0, !1)), [].forEach.call(n.childNodes, function(e, t) {
                    1 === e.nodeType && (n.origDisplay[t] = e.style.display, e.style.display = "none");
                }), this.moveContainers(e), this.printReverseInfo = n;
            }
            function j(e) {
                e.renderExporting(), f(e, "redraw", e.renderExporting), f(e, "destroy", e.destroyExport);
            }
            function G(t, n, i, o, r, s, l) {
                let a = this, p = a.options.navigation, u = a.chartWidth, d = a.chartHeight, y = "cache-" + t, v = Math.max(r, s), C, S = a[y];
                S || (a.exportContextMenu = a[y] = S = x("div", {
                    className: t
                }, {
                    position: "absolute",
                    zIndex: 1e3,
                    padding: v + "px",
                    pointerEvents: "auto",
                    ...a.renderer.style
                }, a.scrollablePlotArea?.fixedDiv || a.container), C = x("ul", {
                    className: "highcharts-menu"
                }, a.styledMode ? {} : {
                    listStyle: "none",
                    margin: 0,
                    padding: 0
                }, S), a.styledMode || m(C, b({
                    MozBoxShadow: "3px 3px 10px #888",
                    WebkitBoxShadow: "3px 3px 10px #888",
                    boxShadow: "3px 3px 10px #888"
                }, p.menuStyle)), S.hideMenu = function() {
                    m(S, {
                        display: "none"
                    }), l && l.setState(0), a.openMenu = !1, m(a.renderTo, {
                        overflow: "hidden"
                    }), m(a.container, {
                        overflow: "hidden"
                    }), c.clearTimeout(S.hideTimer), w(a, "exportMenuHidden");
                }, a.exportEvents.push(f(S, "mouseleave", function() {
                    S.hideTimer = g.setTimeout(S.hideMenu, 500);
                }), f(S, "mouseenter", function() {
                    c.clearTimeout(S.hideTimer);
                }), f(h, "mouseup", function(e) {
                    a.pointer?.inClass(e.target, t) || S.hideMenu();
                }), f(S, "click", function() {
                    a.openMenu && S.hideMenu();
                })), n.forEach(function(t) {
                    if ("string" == typeof t && (t = a.options.exporting.menuItemDefinitions[t]), E(t, !0)) {
                        let n;
                        t.separator ? n = x("hr", void 0, void 0, C) : ("viewData" === t.textKey && a.isDataTableVisible && (t.textKey = "hideData"), n = x("li", {
                            className: "highcharts-menu-item",
                            onclick: function(e) {
                                e && e.stopPropagation(), S.hideMenu(), "string" != typeof t && t.onclick && t.onclick.apply(a, arguments);
                            }
                        }, void 0, C), e.setElementHTML(n, t.text || a.options.lang[t.textKey]), a.styledMode || (n.onmouseover = function() {
                            m(this, p.menuItemHoverStyle);
                        }, n.onmouseout = function() {
                            m(this, p.menuItemStyle);
                        }, m(n, b({
                            cursor: "pointer"
                        }, p.menuItemStyle || {})))), a.exportDivElements.push(n);
                    }
                }), a.exportDivElements.push(C, S), a.exportMenuWidth = S.offsetWidth, a.exportMenuHeight = S.offsetHeight);
                let F = {
                    display: "block"
                };
                i + a.exportMenuWidth > u ? F.right = u - i - r - v + "px" : F.left = i - v + "px", o + s + a.exportMenuHeight > d && "top" !== l.alignOptions.verticalAlign ? F.bottom = d - o - v + "px" : F.top = o + s - v + "px", m(S, F), m(a.renderTo, {
                    overflow: ""
                }), m(a.container, {
                    overflow: ""
                }), a.openMenu = !0, w(a, "exportMenuShown");
            }
            function D(e) {
                let t;
                let n = e ? e.target : this, i = n.exportSVGElements, o = n.exportDivElements, r = n.exportEvents;
                i && (i.forEach((e, o)=>{
                    e && (e.onclick = e.ontouchstart = null, n[t = "cache-" + e.menuClassName] && delete n[t], i[o] = e.destroy());
                }), i.length = 0), n.exportingGroup && (n.exportingGroup.destroy(), delete n.exportingGroup), o && (o.forEach(function(e, t) {
                    e && (c.clearTimeout(e.hideTimer), T(e, "mouseleave"), o[t] = e.onmouseout = e.onmouseover = e.ontouchstart = e.onclick = null, y(e));
                }), o.length = 0), r && (r.forEach(function(e) {
                    e();
                }), r.length = 0);
            }
            function W(e, t) {
                let n = this.getSVGForExport(e, t);
                e = C(this.options.exporting, e), a.post(e.url, {
                    filename: e.filename ? e.filename.replace(/\//g, "-") : this.getFilename(),
                    type: e.type,
                    width: e.width,
                    scale: e.scale,
                    svg: n
                }, e.fetchOptions);
            }
            function I() {
                return this.styledMode && this.inlineStyles(), this.container.innerHTML;
            }
            function R() {
                let e = this.userOptions.title && this.userOptions.title.text, t = this.options.exporting.filename;
                return t ? t.replace(/\//g, "-") : ("string" == typeof e && (t = e.toLowerCase().replace(/<\/?[^>]+(>|$)/g, "").replace(/[\s_]+/g, "-").replace(/[^a-z0-9\-]/g, "").replace(/^[\-]+/g, "").replace(/[\-]+/g, "-").substr(0, 24).replace(/[\-]+$/g, "")), (!t || t.length < 5) && (t = "chart"), t);
            }
            function L(e) {
                let t, n, i = C(this.options, e);
                i.plotOptions = C(this.userOptions.plotOptions, e && e.plotOptions), i.time = C(this.userOptions.time, e && e.time);
                let o = x("div", null, {
                    position: "absolute",
                    top: "-9999em",
                    width: this.chartWidth + "px",
                    height: this.chartHeight + "px"
                }, h.body), r = this.renderTo.style.width, s = this.renderTo.style.height, l = i.exporting.sourceWidth || i.chart.width || /px$/.test(r) && parseInt(r, 10) || (i.isGantt ? 800 : 600), a = i.exporting.sourceHeight || i.chart.height || /px$/.test(s) && parseInt(s, 10) || 400;
                b(i.chart, {
                    animation: !1,
                    renderTo: o,
                    forExport: !0,
                    renderer: "SVGRenderer",
                    width: l,
                    height: a
                }), i.exporting.enabled = !1, delete i.data, i.series = [], this.series.forEach(function(e) {
                    (n = C(e.userOptions, {
                        animation: !1,
                        enableMouseTracking: !1,
                        showCheckbox: !1,
                        visible: e.visible
                    })).isInternal || i.series.push(n);
                });
                let c = {};
                this.axes.forEach(function(e) {
                    e.userOptions.internalKey || (e.userOptions.internalKey = O()), e.options.isInternal || (c[e.coll] || (c[e.coll] = !0, i[e.coll] = []), i[e.coll].push(C(e.userOptions, {
                        visible: e.visible
                    })));
                }), i.colorAxis = this.userOptions.colorAxis;
                let p = new this.constructor(i, this.callback);
                return e && [
                    "xAxis",
                    "yAxis",
                    "series"
                ].forEach(function(t) {
                    let n = {};
                    e[t] && (n[t] = e[t], p.update(n));
                }), this.axes.forEach(function(e) {
                    let t = v(p.axes, function(t) {
                        return t.options.internalKey === e.userOptions.internalKey;
                    }), n = e.getExtremes(), i = n.userMin, o = n.userMax;
                    t && (void 0 !== i && i !== t.min || void 0 !== o && o !== t.max) && t.setExtremes(i, o, !0, !1);
                }), t = p.getChartHTML(), w(this, "getSVG", {
                    chartCopy: p
                }), t = this.sanitizeSVG(t, i), i = null, p.destroy(), y(o), t;
            }
            function $(e, t) {
                let n = this.options.exporting;
                return this.getSVG(C({
                    chart: {
                        borderRadius: 0
                    }
                }, n.chartOptions, t, {
                    exporting: {
                        sourceWidth: e && e.sourceWidth || n.sourceWidth,
                        sourceHeight: e && e.sourceHeight || n.sourceHeight
                    }
                }));
            }
            function q() {
                let e;
                let n = t.inlineAllowlist, i = {}, o = h.createElement("iframe");
                m(o, {
                    width: "1px",
                    height: "1px",
                    visibility: "hidden"
                }), h.body.appendChild(o);
                let r = o.contentWindow && o.contentWindow.document;
                r && r.body.appendChild(r.createElementNS(d, "svg")), function t(o) {
                    let s, a, c, u, h, d;
                    let f = {};
                    if (r && 1 === o.nodeType && -1 === M.indexOf(o.nodeName)) {
                        if (s = g.getComputedStyle(o, null), a = "svg" === o.nodeName ? {} : g.getComputedStyle(o.parentNode, null), !i[o.nodeName]) {
                            e = r.getElementsByTagName("svg")[0], c = r.createElementNS(o.namespaceURI, o.nodeName), e.appendChild(c);
                            let t = g.getComputedStyle(c, null), n = {};
                            for(let e in t)"string" != typeof t[e] || /^[0-9]+$/.test(e) || (n[e] = t[e]);
                            i[o.nodeName] = n, "text" === o.nodeName && delete i.text.fill, e.removeChild(c);
                        }
                        for(let e in s)(l.isFirefox || l.isMS || l.isSafari || Object.hasOwnProperty.call(s, e)) && function(e, t) {
                            if (u = h = !1, n.length) {
                                for(d = n.length; d-- && !h;)h = n[d].test(t);
                                u = !h;
                            }
                            for("transform" === t && "none" === e && (u = !0), d = p.length; d-- && !u;)u = p[d].test(t) || "function" == typeof e;
                            !u && (a[t] !== e || "svg" === o.nodeName) && i[o.nodeName][t] !== e && (k && -1 === k.indexOf(t) ? f[t] = e : e && o.setAttribute(t.replace(/([A-Z])/g, function(e, t) {
                                return "-" + t.toLowerCase();
                            }), e));
                        }(s[e], e);
                        if (m(o, f), "svg" === o.nodeName && o.setAttribute("stroke-width", "1px"), "text" === o.nodeName) return;
                        [].forEach.call(o.children || o.childNodes, t);
                    }
                }(this.container.querySelector("svg")), e.parentNode.removeChild(e), o.parentNode.removeChild(o);
            }
            function z(e) {
                let { scrollablePlotArea: t } = this;
                (t ? [
                    t.fixedDiv,
                    t.scrollingContainer
                ] : [
                    this.container
                ]).forEach(function(t) {
                    e.appendChild(t);
                });
            }
            function V() {
                let e = this, t = (t, n, i)=>{
                    e.isDirtyExporting = !0, C(!0, e.options[t], n), F(i, !0) && e.redraw();
                };
                e.exporting = {
                    update: function(e, n) {
                        t("exporting", e, n);
                    }
                }, n.compose(e).navigation.addUpdate((e, n)=>{
                    t("navigation", e, n);
                });
            }
            function A() {
                let e = this;
                e.isPrinting || (i = e, l.isSafari || e.beforePrint(), setTimeout(()=>{
                    g.focus(), g.print(), l.isSafari || setTimeout(()=>{
                        e.afterPrint();
                    }, 1e3);
                }, 1));
            }
            function K() {
                let e = this, t = e.options.exporting, n = t.buttons, i = e.isDirtyExporting || !e.exportSVGElements;
                e.buttonOffset = 0, e.isDirtyExporting && e.destroyExport(), i && !1 !== t.enabled && (e.exportEvents = [], e.exportingGroup = e.exportingGroup || e.renderer.g("exporting-group").attr({
                    zIndex: 3
                }).add(), S(n, function(t) {
                    e.addButton(t);
                }), e.isDirtyExporting = !1);
            }
            function U(e, t) {
                let n = e.indexOf("</svg>") + 6, i = e.substr(n);
                return e = e.substr(0, n), t && t.exporting && t.exporting.allowHTML && i && (i = '<foreignObject x="0" y="0" width="' + t.chart.width + '" height="' + t.chart.height + '"><body xmlns="http://www.w3.org/1999/xhtml">' + i.replace(/(<(?:img|br).*?(?=\>))>/g, "$1 />") + "</body></foreignObject>", e = e.replace("</svg>", i + "</svg>")), e = e.replace(/zIndex="[^"]+"/g, "").replace(/symbolName="[^"]+"/g, "").replace(/jQuery[0-9]+="[^"]+"/g, "").replace(/url\(("|&quot;)(.*?)("|&quot;)\;?\)/g, "url($2)").replace(/url\([^#]+#/g, "url(#").replace(/<svg /, '<svg xmlns:xlink="http://www.w3.org/1999/xlink" ').replace(/ (|NS[0-9]+\:)href=/g, " xlink:href=").replace(/\n+/g, " ").replace(/(fill|stroke)="rgba\(([ 0-9]+,[ 0-9]+,[ 0-9]+),([ 0-9\.]+)\)"/g, '$1="rgb($2)" $1-opacity="$3"').replace(/&nbsp;/g, "\xa0").replace(/&shy;/g, "\xad");
            }
            t.compose = function(e, t) {
                r.compose(t), s.compose(e);
                let n = e.prototype;
                n.exportChart || (n.afterPrint = H, n.exportChart = W, n.inlineStyles = q, n.print = A, n.sanitizeSVG = U, n.getChartHTML = I, n.getSVG = L, n.getSVGForExport = $, n.getFilename = R, n.moveContainers = z, n.beforePrint = N, n.contextMenu = G, n.addButton = P, n.destroyExport = D, n.renderExporting = K, n.callbacks.push(j), f(e, "init", V), l.isSafari && g.matchMedia("print").addListener(function(e) {
                    i && (e.matches ? i.beforePrint() : i.afterPrint());
                }), u.exporting = C(o.exporting, u.exporting), u.lang = C(o.lang, u.lang), u.navigation = C(o.navigation, u.navigation));
            };
        }(p || (p = {})), p;
    }), n(t, "masters/modules/exporting.src.js", [
        t["Core/Globals.js"],
        t["Extensions/Exporting/Exporting.js"],
        t["Core/HttpUtilities.js"]
    ], function(e, t, n) {
        return e.HttpUtilities = e.HttpUtilities || n, e.ajax = e.HttpUtilities.ajax, e.getJSON = e.HttpUtilities.getJSON, e.post = e.HttpUtilities.post, t.compose(e.Chart, e.Renderer), e;
    });
});

});

parcelRegister("6v3SG", function(module, exports) {
!/**
 * Highcharts JS v11.4.0 (2024-03-04)
 *
 * Client side exporting module
 *
 * (c) 2015-2024 Torstein Honsi / Oystein Moseng
 *
 * License: www.highcharts.com/license
 */ function(t) {
    (0, module.exports) ? (t.default = t, module.exports = t) : "function" == typeof define && define.amd ? define("highcharts/modules/offline-exporting", [
        "highcharts",
        "highcharts/modules/exporting"
    ], function(e) {
        return t(e), t.Highcharts = e, t;
    }) : t("undefined" != typeof Highcharts ? Highcharts : void 0);
}(function(t) {
    "use strict";
    var e = t ? t._modules : {};
    function o(t, e, o, n) {
        t.hasOwnProperty(e) || (t[e] = n.apply(null, o), "function" == typeof CustomEvent && window.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", {
            detail: {
                path: e,
                module: t[e]
            }
        })));
    }
    o(e, "Extensions/DownloadURL.js", [
        e["Core/Globals.js"]
    ], function(t) {
        let { isSafari: e, win: o, win: { document: n } } = t, i = o.URL || o.webkitURL || o;
        function r(t) {
            let e = t.replace(/filename=.*;/, "").match(/data:([^;]*)(;base64)?,([0-9A-Za-z+/]+)/);
            if (e && e.length > 3 && o.atob && o.ArrayBuffer && o.Uint8Array && o.Blob && i.createObjectURL) {
                let t = o.atob(e[3]), n = new o.ArrayBuffer(t.length), r = new o.Uint8Array(n);
                for(let e = 0; e < r.length; ++e)r[e] = t.charCodeAt(e);
                return i.createObjectURL(new o.Blob([
                    r
                ], {
                    type: e[1]
                }));
            }
        }
        return {
            dataURLtoBlob: r,
            downloadURL: function(t, i) {
                let l = o.navigator, a = n.createElement("a");
                if ("string" != typeof t && !(t instanceof String) && l.msSaveOrOpenBlob) {
                    l.msSaveOrOpenBlob(t, i);
                    return;
                }
                t = "" + t;
                let s = /Edge\/\d+/.test(l.userAgent);
                if ((e && "string" == typeof t && 0 === t.indexOf("data:application/pdf") || s || t.length > 2e6) && !(t = r(t) || "")) throw Error("Failed to convert to blob");
                if (void 0 !== a.download) a.href = t, a.download = i, n.body.appendChild(a), a.click(), n.body.removeChild(a);
                else try {
                    if (!o.open(t, "chart")) throw Error("Failed to open window");
                } catch  {
                    o.location.href = t;
                }
            }
        };
    }), o(e, "Extensions/OfflineExporting/OfflineExportingDefaults.js", [], function() {
        return {
            libURL: "https://code.highcharts.com/11.4.0/lib/",
            menuItemDefinitions: {
                downloadPNG: {
                    textKey: "downloadPNG",
                    onclick: function() {
                        this.exportChartLocal();
                    }
                },
                downloadJPEG: {
                    textKey: "downloadJPEG",
                    onclick: function() {
                        this.exportChartLocal({
                            type: "image/jpeg"
                        });
                    }
                },
                downloadSVG: {
                    textKey: "downloadSVG",
                    onclick: function() {
                        this.exportChartLocal({
                            type: "image/svg+xml"
                        });
                    }
                },
                downloadPDF: {
                    textKey: "downloadPDF",
                    onclick: function() {
                        this.exportChartLocal({
                            type: "application/pdf"
                        });
                    }
                }
            }
        };
    }), o(e, "Extensions/OfflineExporting/OfflineExporting.js", [
        e["Core/Renderer/HTML/AST.js"],
        e["Core/Chart/Chart.js"],
        e["Core/Defaults.js"],
        e["Extensions/DownloadURL.js"],
        e["Extensions/Exporting/Exporting.js"],
        e["Core/Globals.js"],
        e["Core/HttpUtilities.js"],
        e["Extensions/OfflineExporting/OfflineExportingDefaults.js"],
        e["Core/Utilities.js"]
    ], function(t, e, o, n, i, r, l, a, s) {
        var c;
        let { defaultOptions: d } = o, { downloadURL: f } = n, { doc: g, win: h } = r, { ajax: p } = l, { addEvent: u, error: m, extend: y, fireEvent: x, merge: b } = s;
        return t.allowedAttributes.push("data-z-index", "fill-opacity", "filter", "rx", "ry", "stroke-dasharray", "stroke-linejoin", "stroke-opacity", "text-anchor", "transform", "version", "viewBox", "visibility", "xmlns", "xmlns:xlink"), t.allowedTags.push("desc", "clippath", "g"), function(e) {
            function o(t, o) {
                let n = this, l = b(n.options.exporting, t), a = function(t) {
                    !1 === l.fallbackToExportServer ? l.error ? l.error(l, t) : m(28, !0) : n.exportChart(l);
                };
                if (r.isMS && n.styledMode && !i.inlineAllowlist.length && i.inlineAllowlist.push(/^blockSize/, /^border/, /^caretColor/, /^color/, /^columnRule/, /^columnRuleColor/, /^cssFloat/, /^cursor/, /^fill$/, /^fillOpacity/, /^font/, /^inlineSize/, /^length/, /^lineHeight/, /^opacity/, /^outline/, /^parentRule/, /^rx$/, /^ry$/, /^stroke/, /^textAlign/, /^textAnchor/, /^textDecoration/, /^transform/, /^vectorEffect/, /^visibility/, /^x$/, /^y$/), r.isMS && ("application/pdf" === l.type || n.container.getElementsByTagName("image").length && "image/svg+xml" !== l.type) || "application/pdf" === l.type && [].some.call(n.container.getElementsByTagName("image"), function(t) {
                    let e = t.getAttribute("href");
                    return "" !== e && "string" == typeof e && 0 !== e.indexOf("data:");
                })) {
                    a(Error("Image type not supported for this chart/browser."));
                    return;
                }
                n.getSVGForLocalExport(l, o || {}, a, function(t) {
                    t.indexOf("<foreignObject") > -1 && "image/svg+xml" !== l.type && (r.isMS || "application/pdf" === l.type) ? a(Error("Image type not supported for charts with embedded HTML")) : e.downloadSVGLocal(t, y({
                        filename: n.getFilename()
                    }, l), a, ()=>x(n, "exportChartLocalSuccess"));
                });
            }
            function n(t, e) {
                let o = g.getElementsByTagName("head")[0], n = g.createElement("script");
                n.type = "text/javascript", n.src = t, n.onload = e, n.onerror = function() {
                    m("Error loading script " + t);
                }, o.appendChild(n);
            }
            function l(t, o, n, i) {
                let r = this, l = (t)=>r.sanitizeSVG(t, f), a = ()=>{
                    h && m === p && i(l(d.innerHTML));
                }, s = (t, e, o)=>{
                    ++m, o.imageElement.setAttributeNS("http://www.w3.org/1999/xlink", "href", t), a();
                }, c, d, f, g = null, h, p = 0, m = 0;
                r.unbindGetSVG = u(r, "getSVG", (t)=>{
                    f = t.chartCopy.options, p = (h = (d = t.chartCopy.container.cloneNode(!0)) && d.getElementsByTagName("image") || []).length;
                }), r.getSVGForExport(t, o);
                try {
                    if (!h || !h.length) {
                        i(l(d.innerHTML));
                        return;
                    }
                    for(let o = 0; o < h.length; o++)(g = (c = h[o]).getAttributeNS("http://www.w3.org/1999/xlink", "href")) ? e.imageToDataUrl(g, "image/png", {
                        imageElement: c
                    }, t.scale, s, n, n, n) : (m++, c.parentNode.removeChild(c), o--, a());
                } catch (t) {
                    n(t);
                }
                r.unbindGetSVG();
            }
            function s(t, o, n, i, r, l, a, s, c) {
                let d = new h.Image, f, p = ()=>{
                    setTimeout(function() {
                        let e;
                        let l = g.createElement("canvas"), s = l.getContext && l.getContext("2d");
                        try {
                            if (s) {
                                l.height = d.height * i, l.width = d.width * i, s.drawImage(d, 0, 0, l.width, l.height);
                                try {
                                    e = l.toDataURL(o), r(e, o, n, i);
                                } catch (e) {
                                    f(t, o, n, i);
                                }
                            } else a(t, o, n, i);
                        } finally{
                            c && c(t, o, n, i);
                        }
                    }, e.loadEventDeferDelay);
                }, u = ()=>{
                    s(t, o, n, i), c && c(t, o, n, i);
                };
                f = ()=>{
                    d = new h.Image, f = l, d.crossOrigin = "Anonymous", d.onload = p, d.onerror = u, d.src = t;
                }, d.onload = p, d.onerror = u, d.src = t;
            }
            function c(t) {
                let o = h.navigator.userAgent, n = o.indexOf("WebKit") > -1 && 0 > o.indexOf("Chrome");
                try {
                    if (!n && -1 === t.indexOf("<foreignObject")) return e.domurl.createObjectURL(new h.Blob([
                        t
                    ], {
                        type: "image/svg+xml;charset-utf-16"
                    }));
                } catch (t) {}
                return "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(t);
            }
            function w(t, e, o, n) {
                let i = (Number(t.getAttribute("width")) + 2 * e) * o, r = (Number(t.getAttribute("height")) + 2 * e) * o, l = new h.jspdf.jsPDF(r > i ? "p" : "l", "pt", [
                    i,
                    r
                ]);
                [].forEach.call(t.querySelectorAll('*[visibility="hidden"]'), function(t) {
                    t.parentNode.removeChild(t);
                });
                let a = t.querySelectorAll("linearGradient");
                for(let t = 0; t < a.length; t++){
                    let e = a[t].querySelectorAll("stop"), o = 0;
                    for(; o < e.length && "0" === e[o].getAttribute("offset") && "0" === e[o + 1].getAttribute("offset");)e[o].remove(), o++;
                }
                [].forEach.call(t.querySelectorAll("tspan"), (t)=>{
                    "\u200B" === t.textContent && (t.textContent = " ", t.setAttribute("dx", -5));
                }), l.svg(t, {
                    x: 0,
                    y: 0,
                    width: i,
                    height: r,
                    removeInvalid: !0
                }).then(()=>n(l.output("datauristring")));
            }
            e.CanVGRenderer = {}, e.domurl = h.URL || h.webkitURL || h, e.loadEventDeferDelay = r.isMS ? 150 : 0, e.compose = function(t) {
                let e = t.prototype;
                return e.exportChartLocal || (e.getSVGForLocalExport = l, e.exportChartLocal = o, b(!0, d.exporting, a)), t;
            }, e.downloadSVGLocal = function(o, i, r, l) {
                let a = g.createElement("div"), u = i.type || "image/png", m = (i.filename || "chart") + "." + ("image/svg+xml" === u ? "svg" : u.split("/")[1]), y = i.scale || 1, x, b, v, E = i.libURL || d.exporting.libURL, C = !0, L = i.pdfFont;
                E = "/" !== E.slice(-1) ? E + "/" : E;
                let S = (t, e)=>{
                    let o, n;
                    let i = (t, e)=>{
                        h.jspdf.jsPDF.API.events.push([
                            "initialized",
                            function() {
                                this.addFileToVFS(t, e), this.addFont(t, "HighchartsFont", t), this.getFontList().HighchartsFont || this.setFont("HighchartsFont");
                            }
                        ]);
                    };
                    L && (n = t.textContent || "", !/[^\u0000-\u007F\u200B]+/.test(n)) && (L = void 0);
                    let r = [
                        "normal",
                        "italic",
                        "bold",
                        "bolditalic"
                    ], l = ()=>{
                        let t = r.shift();
                        if (!t) return e();
                        let n = L && L[t];
                        n ? p({
                            url: n,
                            responseType: "blob",
                            success: (e, n)=>{
                                let r = new FileReader;
                                r.onloadend = function() {
                                    if ("string" == typeof this.result) {
                                        let e = this.result.split(",")[1];
                                        i(t, e), "normal" === t && (o = e);
                                    }
                                    l();
                                }, r.readAsDataURL(n.response);
                            },
                            error: l
                        }) : (o && i(t, o), l());
                    };
                    l();
                }, j = ()=>{
                    let e, n;
                    t.setElementHTML(a, o);
                    let i = a.getElementsByTagName("text"), s = function(t, e) {
                        let o = t;
                        for(; o && o !== a;){
                            if (o.style[e]) {
                                let n = o.style[e];
                                "fontSize" === e && /em$/.test(n) && (n = Math.round(16 * parseFloat(n)) + "px"), t.style[e] = n;
                                break;
                            }
                            o = o.parentNode;
                        }
                    };
                    [].forEach.call(i, function(t) {
                        for([
                            "fontFamily",
                            "fontSize"
                        ].forEach((e)=>{
                            s(t, e);
                        }), t.style.fontFamily = L && L.normal ? "HighchartsFont" : String(t.style.fontFamily && t.style.fontFamily.split(" ").splice(-1)), e = t.getElementsByTagName("title"), [].forEach.call(e, function(e) {
                            t.removeChild(e);
                        }), n = t.getElementsByClassName("highcharts-text-outline"); n.length > 0;)t.removeChild(n[0]);
                    });
                    let c = a.querySelector("svg");
                    c && S(c, ()=>{
                        w(c, 0, y, (t)=>{
                            try {
                                f(t, m), l && l();
                            } catch (t) {
                                r(t);
                            }
                        });
                    });
                };
                if ("image/svg+xml" === u) try {
                    void 0 !== h.MSBlobBuilder ? ((b = new h.MSBlobBuilder).append(o), x = b.getBlob("image/svg+xml")) : x = c(o), f(x, m), l && l();
                } catch (t) {
                    r(t);
                }
                else "application/pdf" === u ? h.jspdf && h.jspdf.jsPDF ? j() : (C = !0, n(E + "jspdf.js", function() {
                    n(E + "svg2pdf.js", j);
                })) : (x = c(o), v = function() {
                    try {
                        e.domurl.revokeObjectURL(x);
                    } catch (t) {}
                }, s(x, u, {}, y, function(t) {
                    try {
                        f(t, m), l && l();
                    } catch (t) {
                        r(t);
                    }
                }, function() {
                    let t = g.createElement("canvas"), e = t.getContext("2d"), i = o.match(/^<svg[^>]*width\s*=\s*\"?(\d+)\"?[^>]*>/)[1] * y, a = o.match(/^<svg[^>]*height\s*=\s*\"?(\d+)\"?[^>]*>/)[1] * y, s = function() {
                        h.canvg.Canvg.fromString(e, o).start();
                        try {
                            f(h.navigator.msSaveOrOpenBlob ? t.msToBlob() : t.toDataURL(u), m), l && l();
                        } catch (t) {
                            r(t);
                        } finally{
                            v();
                        }
                    };
                    t.width = i, t.height = a, h.canvg ? s() : (C = !0, n(E + "canvg.js", function() {
                        s();
                    }));
                }, r, r, function() {
                    C && v();
                }));
            }, e.getScript = n, e.imageToDataUrl = s, e.svgToDataUrl = c, e.svgToPdf = w;
        }(c || (c = {})), c;
    }), o(e, "masters/modules/offline-exporting.src.js", [
        e["Core/Globals.js"],
        e["Extensions/DownloadURL.js"],
        e["Extensions/OfflineExporting/OfflineExporting.js"]
    ], function(t, e, o) {
        return t.dataURLtoBlob = t.dataURLtoBlob || e.dataURLtoBlob, t.downloadSVGLocal = o.downloadSVGLocal, t.downloadURL = t.downloadURL || e.downloadURL, o.compose(t.Chart), t;
    });
});

});

parcelRegister("hNNPC", function(module, exports) {
!/**
 * Highcharts JS v11.4.0 (2024-03-04)
 *
 * Exporting module
 *
 * (c) 2010-2024 Torstein Honsi
 *
 * License: www.highcharts.com/license
 */ function(t) {
    (0, module.exports) ? (t.default = t, module.exports = t) : "function" == typeof define && define.amd ? define("highcharts/modules/export-data", [
        "highcharts",
        "highcharts/modules/exporting"
    ], function(e) {
        return t(e), t.Highcharts = e, t;
    }) : t("undefined" != typeof Highcharts ? Highcharts : void 0);
}(function(t) {
    "use strict";
    var e = t ? t._modules : {};
    function o(t, e, o, a) {
        t.hasOwnProperty(e) || (t[e] = a.apply(null, o), "function" == typeof CustomEvent && window.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", {
            detail: {
                path: e,
                module: t[e]
            }
        })));
    }
    o(e, "Extensions/DownloadURL.js", [
        e["Core/Globals.js"]
    ], function(t) {
        let { isSafari: e, win: o, win: { document: a } } = t, n = o.URL || o.webkitURL || o;
        function i(t) {
            let e = t.replace(/filename=.*;/, "").match(/data:([^;]*)(;base64)?,([0-9A-Za-z+/]+)/);
            if (e && e.length > 3 && o.atob && o.ArrayBuffer && o.Uint8Array && o.Blob && n.createObjectURL) {
                let t = o.atob(e[3]), a = new o.ArrayBuffer(t.length), i = new o.Uint8Array(a);
                for(let e = 0; e < i.length; ++e)i[e] = t.charCodeAt(e);
                return n.createObjectURL(new o.Blob([
                    i
                ], {
                    type: e[1]
                }));
            }
        }
        return {
            dataURLtoBlob: i,
            downloadURL: function(t, n) {
                let r = o.navigator, s = a.createElement("a");
                if ("string" != typeof t && !(t instanceof String) && r.msSaveOrOpenBlob) {
                    r.msSaveOrOpenBlob(t, n);
                    return;
                }
                t = "" + t;
                let l = /Edge\/\d+/.test(r.userAgent);
                if ((e && "string" == typeof t && 0 === t.indexOf("data:application/pdf") || l || t.length > 2e6) && !(t = i(t) || "")) throw Error("Failed to convert to blob");
                if (void 0 !== s.download) s.href = t, s.download = n, a.body.appendChild(s), s.click(), a.body.removeChild(s);
                else try {
                    if (!o.open(t, "chart")) throw Error("Failed to open window");
                } catch  {
                    o.location.href = t;
                }
            }
        };
    }), o(e, "Extensions/ExportData/ExportDataDefaults.js", [], function() {
        return {
            exporting: {
                csv: {
                    annotations: {
                        itemDelimiter: "; ",
                        join: !1
                    },
                    columnHeaderFormatter: null,
                    dateFormat: "%Y-%m-%d %H:%M:%S",
                    decimalPoint: null,
                    itemDelimiter: null,
                    lineDelimiter: "\n"
                },
                showTable: !1,
                useMultiLevelHeaders: !0,
                useRowspanHeaders: !0,
                showExportInProgress: !0
            },
            lang: {
                downloadCSV: "Download CSV",
                downloadXLS: "Download XLS",
                exportData: {
                    annotationHeader: "Annotations",
                    categoryHeader: "Category",
                    categoryDatetimeHeader: "DateTime"
                },
                viewData: "View data table",
                hideData: "Hide data table",
                exportInProgress: "Exporting..."
            }
        };
    }), o(e, "Extensions/ExportData/ExportData.js", [
        e["Core/Renderer/HTML/AST.js"],
        e["Core/Defaults.js"],
        e["Extensions/DownloadURL.js"],
        e["Extensions/ExportData/ExportDataDefaults.js"],
        e["Core/Globals.js"],
        e["Core/Utilities.js"]
    ], function(t, e, o, a, n, i) {
        let { getOptions: r, setOptions: s } = e, { downloadURL: l } = o, { doc: h, win: c } = n, { addEvent: d, defined: p, extend: u, find: m, fireEvent: g, isNumber: x, pick: f } = i;
        function b(t) {
            let e = !!this.options.exporting?.showExportInProgress, o = c.requestAnimationFrame || setTimeout;
            o(()=>{
                e && this.showLoading(this.options.lang.exportInProgress), o(()=>{
                    try {
                        t.call(this);
                    } finally{
                        e && this.hideLoading();
                    }
                });
            });
        }
        function y() {
            b.call(this, ()=>{
                let t = this.getCSV(!0);
                l(A(t, "text/csv") || "data:text/csv,\uFEFF" + encodeURIComponent(t), this.getFilename() + ".csv");
            });
        }
        function w() {
            b.call(this, ()=>{
                let t = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>Ark1</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><style>td{border:none;font-family: Calibri, sans-serif;} .number{mso-number-format:"0.00";} .text{ mso-number-format:"@";}</style><meta name=ProgId content=Excel.Sheet><meta charset=UTF-8></head><body>' + this.getTable(!0) + "</body></html>";
                l(A(t, "application/vnd.ms-excel") || "data:application/vnd.ms-excel;base64," + c.btoa(unescape(encodeURIComponent(t))), this.getFilename() + ".xls");
            });
        }
        function D(t) {
            let e = "", o = this.getDataRows(), a = this.options.exporting.csv, n = f(a.decimalPoint, "," !== a.itemDelimiter && t ? 1.1.toLocaleString()[1] : "."), i = f(a.itemDelimiter, "," === n ? ";" : ","), r = a.lineDelimiter;
            return o.forEach((t, a)=>{
                let s = "", l = t.length;
                for(; l--;)"string" == typeof (s = t[l]) && (s = `"${s}"`), "number" == typeof s && "." !== n && (s = s.toString().replace(".", n)), t[l] = s;
                t.length = o.length ? o[0].length : 0, e += t.join(i), a < o.length - 1 && (e += r);
            }), e;
        }
        function T(t) {
            let e, o;
            let a = this.hasParallelCoordinates, n = this.time, i = this.options.exporting && this.options.exporting.csv || {}, r = this.xAxis, s = {}, l = [], h = [], c = [], d = this.options.lang.exportData, u = d.categoryHeader, b = d.categoryDatetimeHeader, y = function(e, o, a) {
                if (i.columnHeaderFormatter) {
                    let t = i.columnHeaderFormatter(e, o, a);
                    if (!1 !== t) return t;
                }
                return e ? e.bindAxes ? t ? {
                    columnTitle: a > 1 ? o : e.name,
                    topLevelColumnTitle: e.name
                } : e.name + (a > 1 ? " (" + o + ")" : "") : e.options.title && e.options.title.text || (e.dateTime ? b : u) : u;
            }, w = function(t, e, o) {
                let a = {}, n = {};
                return e.forEach(function(e) {
                    let i = (t.keyToAxis && t.keyToAxis[e] || e) + "Axis", r = x(o) ? t.chart[i][o] : t[i];
                    a[e] = r && r.categories || [], n[e] = r && r.dateTime;
                }), {
                    categoryMap: a,
                    dateTimeValueAxisMap: n
                };
            }, D = function(t, e) {
                let o = t.pointArrayMap || [
                    "y"
                ];
                return t.data.some((t)=>void 0 !== t.y && t.name) && e && !e.categories && "name" !== t.exportKey ? [
                    "x",
                    ...o
                ] : o;
            }, T = [], v, E, L, S = 0, C, A;
            for(C in this.series.forEach(function(e) {
                let o = e.options.keys, l = e.xAxis, d = o || D(e, l), p = d.length, u = !e.requireSorting && {}, g = r.indexOf(l), x = w(e, d), b, v;
                if (!1 !== e.options.includeInDataExport && !e.options.isInternal && !1 !== e.visible) {
                    for(m(T, function(t) {
                        return t[0] === g;
                    }) || T.push([
                        g,
                        S
                    ]), v = 0; v < p;)L = y(e, d[v], d.length), c.push(L.columnTitle || L), t && h.push(L.topLevelColumnTitle || L), v++;
                    b = {
                        chart: e.chart,
                        autoIncrement: e.autoIncrement,
                        options: e.options,
                        pointArrayMap: e.pointArrayMap,
                        index: e.index
                    }, e.options.data.forEach(function(t, o) {
                        let r, h, c;
                        let m = {
                            series: b
                        };
                        a && (x = w(e, d, o)), e.pointClass.prototype.applyOptions.apply(m, [
                            t
                        ]);
                        let y = e.data[o] && e.data[o].name;
                        if (r = (m.x ?? "") + "," + y, v = 0, (!l || "name" === e.exportKey || !a && l && l.hasNames && y) && (r = y), u && (u[r] && (r += "|" + o), u[r] = !0), s[r]) {
                            let t = `${r},${s[r].pointers[e.index]}`, o = r;
                            s[r].pointers[e.index] && (s[t] || (s[t] = [], s[t].xValues = [], s[t].pointers = []), r = t), s[o].pointers[e.index] += 1;
                        } else {
                            s[r] = [], s[r].xValues = [];
                            let t = [];
                            for(let o = 0; o < e.chart.series.length; o++)t[o] = 0;
                            s[r].pointers = t, s[r].pointers[e.index] = 1;
                        }
                        for(s[r].x = m.x, s[r].name = y, s[r].xValues[g] = m.x; v < p;)c = m[h = d[v]], s[r][S + v] = f(x.categoryMap[h][c], x.dateTimeValueAxisMap[h] ? n.dateFormat(i.dateFormat, c) : null, c), v++;
                    }), S += v;
                }
            }), s)Object.hasOwnProperty.call(s, C) && l.push(s[C]);
            for(E = t ? [
                h,
                c
            ] : [
                c
            ], S = T.length; S--;)e = T[S][0], o = T[S][1], v = r[e], l.sort(function(t, o) {
                return t.xValues[e] - o.xValues[e];
            }), A = y(v), E[0].splice(o, 0, A), t && E[1] && E[1].splice(o, 0, A), l.forEach(function(t) {
                let e = t.name;
                v && !p(e) && (v.dateTime ? (t.x instanceof Date && (t.x = t.x.getTime()), e = n.dateFormat(i.dateFormat, t.x)) : e = v.categories ? f(v.names[t.x], v.categories[t.x], t.x) : t.x), t.splice(o, 0, e);
            });
            return g(this, "exportData", {
                dataRows: E = E.concat(l)
            }), E;
        }
        function v(t) {
            let e = (t)=>{
                if (!t.tagName || "#text" === t.tagName) return t.textContent || "";
                let o = t.attributes, a = `<${t.tagName}`;
                return o && Object.keys(o).forEach((t)=>{
                    let e = o[t];
                    a += ` ${t}="${e}"`;
                }), a += ">" + (t.textContent || ""), (t.children || []).forEach((t)=>{
                    a += e(t);
                }), a += `</${t.tagName}>`;
            };
            return e(this.getTableAST(t));
        }
        function E(t) {
            let e = 0, o = [], a = this.options, n = t ? 1.1.toLocaleString()[1] : ".", i = f(a.exporting.useMultiLevelHeaders, !0), r = this.getDataRows(i), s = i ? r.shift() : null, l = r.shift(), h = function(t, e) {
                let o = t.length;
                if (e.length !== o) return !1;
                for(; o--;)if (t[o] !== e[o]) return !1;
                return !0;
            }, c = function(t, e, o, a) {
                let i = f(a, ""), r = "highcharts-text" + (e ? " " + e : "");
                return "number" == typeof i ? (i = i.toString(), "," === n && (i = i.replace(".", n)), r = "highcharts-number") : a || (r = "highcharts-empty"), {
                    tagName: t,
                    attributes: o = u({
                        class: r
                    }, o),
                    textContent: i
                };
            };
            !1 !== a.exporting.tableCaption && o.push({
                tagName: "caption",
                attributes: {
                    class: "highcharts-table-caption"
                },
                textContent: f(a.exporting.tableCaption, a.title.text ? a.title.text : "Chart")
            });
            for(let t = 0, o = r.length; t < o; ++t)r[t].length > e && (e = r[t].length);
            o.push(function(t, e, o) {
                let n = [], r = 0, s = o || e && e.length, l, d = 0, p;
                if (i && t && e && !h(t, e)) {
                    let o = [];
                    for(; r < s; ++r)if ((l = t[r]) === t[r + 1]) ++d;
                    else if (d) o.push(c("th", "highcharts-table-topheading", {
                        scope: "col",
                        colspan: d + 1
                    }, l)), d = 0;
                    else {
                        l === e[r] ? a.exporting.useRowspanHeaders ? (p = 2, delete e[r]) : (p = 1, e[r] = "") : p = 1;
                        let t = c("th", "highcharts-table-topheading", {
                            scope: "col"
                        }, l);
                        p > 1 && t.attributes && (t.attributes.valign = "top", t.attributes.rowspan = p), o.push(t);
                    }
                    n.push({
                        tagName: "tr",
                        children: o
                    });
                }
                if (e) {
                    let t = [];
                    for(r = 0, s = e.length; r < s; ++r)void 0 !== e[r] && t.push(c("th", null, {
                        scope: "col"
                    }, e[r]));
                    n.push({
                        tagName: "tr",
                        children: t
                    });
                }
                return {
                    tagName: "thead",
                    children: n
                };
            }(s, l, Math.max(e, l.length)));
            let d = [];
            r.forEach(function(t) {
                let o = [];
                for(let a = 0; a < e; a++)o.push(c(a ? "td" : "th", null, a ? {} : {
                    scope: "row"
                }, t[a]));
                d.push({
                    tagName: "tr",
                    children: o
                });
            }), o.push({
                tagName: "tbody",
                children: d
            });
            let p = {
                tree: {
                    tagName: "table",
                    id: `highcharts-data-table-${this.index}`,
                    children: o
                }
            };
            return g(this, "aftergetTableAST", p), p.tree;
        }
        function L() {
            this.toggleDataTable(!1);
        }
        function S(e) {
            let o = (e = f(e, !this.isDataTableVisible)) && !this.dataTableDiv;
            if (o && (this.dataTableDiv = h.createElement("div"), this.dataTableDiv.className = "highcharts-data-table", this.renderTo.parentNode.insertBefore(this.dataTableDiv, this.renderTo.nextSibling)), this.dataTableDiv) {
                let a = this.dataTableDiv.style, n = a.display;
                a.display = e ? "block" : "none", e ? (this.dataTableDiv.innerHTML = t.emptyHTML, new t([
                    this.getTableAST()
                ]).addToDOM(this.dataTableDiv), g(this, "afterViewData", {
                    element: this.dataTableDiv,
                    wasHidden: o || n !== a.display
                })) : g(this, "afterHideData");
            }
            this.isDataTableVisible = e;
            let a = this.exportDivElements, n = this.options.exporting, i = n && n.buttons && n.buttons.contextButton.menuItems, r = this.options.lang;
            if (n && n.menuItemDefinitions && r && r.viewData && r.hideData && i && a) {
                let e = a[i.indexOf("viewData")];
                e && t.setElementHTML(e, this.isDataTableVisible ? r.hideData : r.viewData);
            }
        }
        function C() {
            this.toggleDataTable(!0);
        }
        function A(t, e) {
            let o = c.navigator, a = c.URL || c.webkitURL || c;
            try {
                if (o.msSaveOrOpenBlob && c.MSBlobBuilder) {
                    let e = new c.MSBlobBuilder;
                    return e.append(t), e.getBlob("image/svg+xml");
                }
                return a.createObjectURL(new c.Blob([
                    "\uFEFF" + t
                ], {
                    type: e
                }));
            } catch (t) {}
        }
        function R() {
            let t = this, e = t.dataTableDiv, o = (t, e)=>t.children[e].textContent, a = (t, e)=>(a, n)=>{
                    let i, r;
                    return i = o(e ? a : n, t), r = o(e ? n : a, t), "" === i || "" === r || isNaN(i) || isNaN(r) ? i.toString().localeCompare(r) : i - r;
                };
            if (e && t.options.exporting && t.options.exporting.allowTableSorting) {
                let o = e.querySelector("thead tr");
                o && o.childNodes.forEach((o)=>{
                    let n = o.closest("table");
                    o.addEventListener("click", function() {
                        let i = [
                            ...e.querySelectorAll("tr:not(thead tr)")
                        ], r = [
                            ...o.parentNode.children
                        ];
                        i.sort(a(r.indexOf(o), t.ascendingOrderInTable = !t.ascendingOrderInTable)).forEach((t)=>{
                            n.appendChild(t);
                        }), r.forEach((t)=>{
                            [
                                "highcharts-sort-ascending",
                                "highcharts-sort-descending"
                            ].forEach((e)=>{
                                t.classList.contains(e) && t.classList.remove(e);
                            });
                        }), o.classList.add(t.ascendingOrderInTable ? "highcharts-sort-ascending" : "highcharts-sort-descending");
                    });
                });
            }
        }
        function k() {
            this.options && this.options.exporting && this.options.exporting.showTable && !this.options.chart.forExport && this.viewData();
        }
        function H() {
            this.dataTableDiv?.remove();
        }
        return {
            compose: function(t, e) {
                let o = t.prototype;
                if (!o.getCSV) {
                    let n = r().exporting;
                    d(t, "afterViewData", R), d(t, "render", k), d(t, "destroy", H), o.downloadCSV = y, o.downloadXLS = w, o.getCSV = D, o.getDataRows = T, o.getTable = v, o.getTableAST = E, o.hideData = L, o.toggleDataTable = S, o.viewData = C, n && (u(n.menuItemDefinitions, {
                        downloadCSV: {
                            textKey: "downloadCSV",
                            onclick: function() {
                                this.downloadCSV();
                            }
                        },
                        downloadXLS: {
                            textKey: "downloadXLS",
                            onclick: function() {
                                this.downloadXLS();
                            }
                        },
                        viewData: {
                            textKey: "viewData",
                            onclick: function() {
                                b.call(this, this.toggleDataTable);
                            }
                        }
                    }), n.buttons && n.buttons.contextButton.menuItems && n.buttons.contextButton.menuItems.push("separator", "downloadCSV", "downloadXLS", "viewData")), s(a);
                    let { arearange: i, gantt: l, map: h, mapbubble: c, treemap: p, xrange: m } = e.types;
                    i && (i.prototype.keyToAxis = {
                        low: "y",
                        high: "y"
                    }), l && (l.prototype.exportKey = "name", l.prototype.keyToAxis = {
                        start: "x",
                        end: "x"
                    }), h && (h.prototype.exportKey = "name"), c && (c.prototype.exportKey = "name"), p && (p.prototype.exportKey = "name"), m && (m.prototype.keyToAxis = {
                        x2: "x"
                    });
                }
            }
        };
    }), o(e, "masters/modules/export-data.src.js", [
        e["Core/Globals.js"],
        e["Extensions/DownloadURL.js"],
        e["Extensions/ExportData/ExportData.js"]
    ], function(t, e, o) {
        return t.dataURLtoBlob = t.dataURLtoBlob || e.dataURLtoBlob, t.downloadURL = t.downloadURL || e.downloadURL, o.compose(t.Chart, t.Series), t;
    });
});

});

parcelRegister("iMzGG", function(module, exports) {
!/**
 * Highcharts JS v11.4.0 (2024-03-04)
 *
 * Accessibility module
 *
 * (c) 2010-2024 Highsoft AS
 * Author: Oystein Moseng
 *
 * License: www.highcharts.com/license
 */ function(e) {
    (0, module.exports) ? (e.default = e, module.exports = e) : "function" == typeof define && define.amd ? define("highcharts/modules/accessibility", [
        "highcharts"
    ], function(t) {
        return e(t), e.Highcharts = t, e;
    }) : e("undefined" != typeof Highcharts ? Highcharts : void 0);
}(function(e) {
    "use strict";
    var t = e ? e._modules : {};
    function i(e, t, i, s) {
        e.hasOwnProperty(t) || (e[t] = s.apply(null, i), "function" == typeof CustomEvent && window.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", {
            detail: {
                path: t,
                module: e[t]
            }
        })));
    }
    i(t, "Accessibility/Utils/HTMLUtilities.js", [
        t["Core/Globals.js"],
        t["Core/Utilities.js"]
    ], function(e, t) {
        let { doc: i, win: s } = e, { css: n } = t, o = s.EventTarget && new s.EventTarget || "none";
        function r(e) {
            if ("function" == typeof s.MouseEvent) return new s.MouseEvent(e.type, e);
            if (i.createEvent) {
                let t = i.createEvent("MouseEvent");
                if (t.initMouseEvent) return t.initMouseEvent(e.type, e.bubbles, e.cancelable, e.view || s, e.detail, e.screenX, e.screenY, e.clientX, e.clientY, e.ctrlKey, e.altKey, e.shiftKey, e.metaKey, e.button, e.relatedTarget), t;
            }
            return a(e.type);
        }
        function a(e, t, n) {
            let r = t || {
                x: 0,
                y: 0
            };
            if ("function" == typeof s.MouseEvent) return new s.MouseEvent(e, {
                bubbles: !0,
                cancelable: !0,
                composed: !0,
                button: 0,
                buttons: 1,
                relatedTarget: n || o,
                view: s,
                detail: "click" === e ? 1 : 0,
                screenX: r.x,
                screenY: r.y,
                clientX: r.x,
                clientY: r.y
            });
            if (i.createEvent) {
                let t = i.createEvent("MouseEvent");
                if (t.initMouseEvent) return t.initMouseEvent(e, !0, !0, s, "click" === e ? 1 : 0, r.x, r.y, r.x, r.y, !1, !1, !1, !1, 0, null), t;
            }
            return {
                type: e
            };
        }
        return {
            addClass: function(e, t) {
                e.classList ? e.classList.add(t) : 0 > e.className.indexOf(t) && (e.className += " " + t);
            },
            cloneMouseEvent: r,
            cloneTouchEvent: function(e) {
                let t = (e)=>{
                    let t = [];
                    for(let i = 0; i < e.length; ++i){
                        let s = e.item(i);
                        s && t.push(s);
                    }
                    return t;
                };
                if ("function" == typeof s.TouchEvent) {
                    let i = new s.TouchEvent(e.type, {
                        touches: t(e.touches),
                        targetTouches: t(e.targetTouches),
                        changedTouches: t(e.changedTouches),
                        ctrlKey: e.ctrlKey,
                        shiftKey: e.shiftKey,
                        altKey: e.altKey,
                        metaKey: e.metaKey,
                        bubbles: e.bubbles,
                        cancelable: e.cancelable,
                        composed: e.composed,
                        detail: e.detail,
                        view: e.view
                    });
                    return e.defaultPrevented && i.preventDefault(), i;
                }
                let i = r(e);
                return i.touches = e.touches, i.changedTouches = e.changedTouches, i.targetTouches = e.targetTouches, i;
            },
            escapeStringForHTML: function(e) {
                return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;").replace(/\//g, "&#x2F;");
            },
            getElement: function(e) {
                return i.getElementById(e);
            },
            getFakeMouseEvent: a,
            getHeadingTagNameForElement: function(e) {
                let t = (e)=>"h" + Math.min(6, parseInt(e.slice(1), 10) + 1), i = (e)=>/H[1-6]/.test(e), s = (e)=>{
                    let t = e;
                    for(; t = t.previousSibling;){
                        let e = t.tagName || "";
                        if (i(e)) return e;
                    }
                    return "";
                }, n = (e)=>{
                    let o = s(e);
                    if (o) return t(o);
                    let r = e.parentElement;
                    if (!r) return "p";
                    let a = r.tagName;
                    return i(a) ? t(a) : n(r);
                };
                return n(e);
            },
            removeChildNodes: function(e) {
                for(; e.lastChild;)e.removeChild(e.lastChild);
            },
            removeClass: function(e, t) {
                e.classList ? e.classList.remove(t) : e.className = e.className.replace(RegExp(t, "g"), "");
            },
            removeElement: function(e) {
                e && e.parentNode && e.parentNode.removeChild(e);
            },
            reverseChildNodes: function(e) {
                let t = e.childNodes.length;
                for(; t--;)e.appendChild(e.childNodes[t]);
            },
            simulatedEventTarget: o,
            stripHTMLTagsFromString: function(e, t = !1) {
                return "string" == typeof e ? t ? e.replace(/<\/?[^>]+(>|$)/g, "") : e.replace(/<\/?(?!\s)[^>]+(>|$)/g, "") : e;
            },
            visuallyHideElement: function(e) {
                n(e, {
                    position: "absolute",
                    width: "1px",
                    height: "1px",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    clip: "rect(1px, 1px, 1px, 1px)",
                    marginTop: "-3px",
                    "-ms-filter": "progid:DXImageTransform.Microsoft.Alpha(Opacity=1)",
                    filter: "alpha(opacity=1)",
                    opacity: .01
                });
            }
        };
    }), i(t, "Accessibility/A11yI18n.js", [
        t["Core/Templating.js"],
        t["Core/Utilities.js"]
    ], function(e, t) {
        var i;
        let { format: s } = e, { getNestedProperty: n, pick: o } = t;
        return function(e) {
            function t(e, t, i) {
                let r = (e, t)=>{
                    let i = e.slice(t || 0), s = i.indexOf("{"), n = i.indexOf("}");
                    if (s > -1 && n > s) return {
                        statement: i.substring(s + 1, n),
                        begin: t + s + 1,
                        end: t + n
                    };
                }, a = [], l, h, c = 0;
                do l = r(e, c), (h = e.substring(c, l && l.begin - 1)).length && a.push({
                    value: h,
                    type: "constant"
                }), l && a.push({
                    value: l.statement,
                    type: "statement"
                }), c = l ? l.end + 1 : c + 1;
                while (l);
                return a.forEach((e)=>{
                    "statement" === e.type && (e.value = function(e, t) {
                        let i, s;
                        let r = e.indexOf("#each("), a = e.indexOf("#plural("), l = e.indexOf("["), h = e.indexOf("]");
                        if (r > -1) {
                            let o = e.slice(r).indexOf(")") + r, a = e.substring(0, r), l = e.substring(o + 1), h = e.substring(r + 6, o).split(","), c = Number(h[1]), d;
                            if (s = "", i = n(h[0], t)) {
                                d = (c = isNaN(c) ? i.length : c) < 0 ? i.length + c : Math.min(c, i.length);
                                for(let e = 0; e < d; ++e)s += a + i[e] + l;
                            }
                            return s.length ? s : "";
                        }
                        if (a > -1) {
                            var c;
                            let i = e.slice(a).indexOf(")") + a, r = e.substring(a + 8, i).split(",");
                            switch(Number(n(r[0], t))){
                                case 0:
                                    s = o(r[4], r[1]);
                                    break;
                                case 1:
                                    s = o(r[2], r[1]);
                                    break;
                                case 2:
                                    s = o(r[3], r[1]);
                                    break;
                                default:
                                    s = r[1];
                            }
                            return s ? (c = s).trim && c.trim() || c.replace(/^\s+|\s+$/g, "") : "";
                        }
                        if (l > -1) {
                            let s;
                            let o = e.substring(0, l), r = Number(e.substring(l + 1, h));
                            return i = n(o, t), !isNaN(r) && i && (r < 0 ? void 0 === (s = i[i.length + r]) && (s = i[0]) : void 0 === (s = i[r]) && (s = i[i.length - 1])), void 0 !== s ? s : "";
                        }
                        return "{" + e + "}";
                    }(e.value, t));
                }), s(a.reduce((e, t)=>e + t.value, ""), t, i);
            }
            function i(e, i) {
                let s = e.split("."), n = this.options.lang, o = 0;
                for(; o < s.length; ++o)n = n && n[s[o]];
                return "string" == typeof n ? t(n, i, this) : "";
            }
            e.compose = function(e) {
                let t = e.prototype;
                t.langFormat || (t.langFormat = i);
            }, e.i18nFormat = t;
        }(i || (i = {})), i;
    }), i(t, "Accessibility/Utils/ChartUtilities.js", [
        t["Core/Globals.js"],
        t["Accessibility/Utils/HTMLUtilities.js"],
        t["Core/Utilities.js"]
    ], function(e, t, i) {
        let { doc: s } = e, { stripHTMLTagsFromString: n } = t, { defined: o, find: r, fireEvent: a } = i;
        function l(e) {
            if (e.points && e.points.length) {
                let t = r(e.points, (e)=>!!e.graphic);
                return t && t.graphic && t.graphic.element;
            }
        }
        function h(e) {
            let t = l(e);
            return t && t.parentNode || e.graph && e.graph.element || e.group && e.group.element;
        }
        return {
            fireEventOnWrappedOrUnwrappedElement: function e(t, i) {
                let n = i.type, o = t.hcEvents;
                s.createEvent && (t.dispatchEvent || t.fireEvent) ? t.dispatchEvent ? t.dispatchEvent(i) : t.fireEvent(n, i) : o && o[n] ? a(t, n, i) : t.element && e(t.element, i);
            },
            getChartTitle: function(e) {
                return n(e.options.title.text || e.langFormat("accessibility.defaultChartTitle", {
                    chart: e
                }), e.renderer.forExport);
            },
            getAxisDescription: function(e) {
                return e && (e.options.accessibility?.description || e.axisTitle?.textStr || e.options.id || e.categories && "categories" || e.dateTime && "Time" || "values");
            },
            getAxisRangeDescription: function(e) {
                let t = e.options || {};
                return t.accessibility && void 0 !== t.accessibility.rangeDescription ? t.accessibility.rangeDescription : e.categories ? function(e) {
                    let t = e.chart;
                    return e.dataMax && e.dataMin ? t.langFormat("accessibility.axis.rangeCategories", {
                        chart: t,
                        axis: e,
                        numCategories: e.dataMax - e.dataMin + 1
                    }) : "";
                }(e) : e.dateTime && (0 === e.min || 0 === e.dataMin) ? function(e) {
                    let t = e.chart, i = {}, s = e.dataMin || e.min || 0, n = e.dataMax || e.max || 0, o = "Seconds";
                    i.Seconds = (n - s) / 1e3, i.Minutes = i.Seconds / 60, i.Hours = i.Minutes / 60, i.Days = i.Hours / 24, [
                        "Minutes",
                        "Hours",
                        "Days"
                    ].forEach(function(e) {
                        i[e] > 2 && (o = e);
                    });
                    let r = i[o].toFixed("Seconds" !== o && "Minutes" !== o ? 1 : 0);
                    return t.langFormat("accessibility.axis.timeRange" + o, {
                        chart: t,
                        axis: e,
                        range: r.replace(".0", "")
                    });
                }(e) : function(e) {
                    let t = e.chart, i = t.options, s = i && i.accessibility && i.accessibility.screenReaderSection.axisRangeDateFormat || "", n = {
                        min: e.dataMin || e.min || 0,
                        max: e.dataMax || e.max || 0
                    }, o = function(i) {
                        return e.dateTime ? t.time.dateFormat(s, n[i]) : n[i].toString();
                    };
                    return t.langFormat("accessibility.axis.rangeFromTo", {
                        chart: t,
                        axis: e,
                        rangeFrom: o("min"),
                        rangeTo: o("max")
                    });
                }(e);
            },
            getPointFromXY: function(e, t, i) {
                let s = e.length, n;
                for(; s--;)if (n = r(e[s].points || [], function(e) {
                    return e.x === t && e.y === i;
                })) return n;
            },
            getSeriesFirstPointElement: l,
            getSeriesFromName: function(e, t) {
                return t ? (e.series || []).filter(function(e) {
                    return e.name === t;
                }) : e.series;
            },
            getSeriesA11yElement: h,
            unhideChartElementFromAT: function e(t, i) {
                i.setAttribute("aria-hidden", !1), i !== t.renderTo && i.parentNode && i.parentNode !== s.body && (Array.prototype.forEach.call(i.parentNode.childNodes, function(e) {
                    e.hasAttribute("aria-hidden") || e.setAttribute("aria-hidden", !0);
                }), e(t, i.parentNode));
            },
            hideSeriesFromAT: function(e) {
                let t = h(e);
                t && t.setAttribute("aria-hidden", !0);
            },
            scrollAxisToPoint: function(e) {
                let t = e.series.xAxis, i = e.series.yAxis, s = t && t.scrollbar ? t : i, n = s && s.scrollbar;
                if (n && o(n.to) && o(n.from)) {
                    let t = n.to - n.from, i = function(e, t) {
                        if (!o(e.dataMin) || !o(e.dataMax)) return 0;
                        let i = e.toPixels(e.dataMin), s = e.toPixels(e.dataMax), n = "xAxis" === e.coll ? "x" : "y";
                        return (e.toPixels(t[n] || 0) - i) / (s - i);
                    }(s, e);
                    n.updatePosition(i - t / 2, i + t / 2), a(n, "changed", {
                        from: n.from,
                        to: n.to,
                        trigger: "scrollbar",
                        DOMEvent: null
                    });
                }
            }
        };
    }), i(t, "Accessibility/Utils/DOMElementProvider.js", [
        t["Core/Globals.js"],
        t["Accessibility/Utils/HTMLUtilities.js"]
    ], function(e, t) {
        let { doc: i } = e, { removeElement: s } = t;
        return class {
            constructor(){
                this.elements = [];
            }
            createElement() {
                let e = i.createElement.apply(i, arguments);
                return this.elements.push(e), e;
            }
            removeElement(e) {
                s(e), this.elements.splice(this.elements.indexOf(e), 1);
            }
            destroyCreatedElements() {
                this.elements.forEach(function(e) {
                    s(e);
                }), this.elements = [];
            }
        };
    }), i(t, "Accessibility/Utils/EventProvider.js", [
        t["Core/Globals.js"],
        t["Core/Utilities.js"]
    ], function(e, t) {
        let { addEvent: i } = t;
        return class {
            constructor(){
                this.eventRemovers = [];
            }
            addEvent() {
                let t = i.apply(e, arguments);
                return this.eventRemovers.push(t), t;
            }
            removeEvent(e) {
                let t = this.eventRemovers.indexOf(e);
                this.eventRemovers[t](), this.eventRemovers.splice(t, 1);
            }
            removeAddedEvents() {
                this.eventRemovers.forEach((e)=>e()), this.eventRemovers = [];
            }
        };
    }), i(t, "Accessibility/AccessibilityComponent.js", [
        t["Accessibility/Utils/ChartUtilities.js"],
        t["Accessibility/Utils/DOMElementProvider.js"],
        t["Accessibility/Utils/EventProvider.js"],
        t["Accessibility/Utils/HTMLUtilities.js"],
        t["Core/Utilities.js"]
    ], function(e, t, i, s, n) {
        let { fireEventOnWrappedOrUnwrappedElement: o } = e, { getFakeMouseEvent: r } = s, { extend: a } = n;
        class l {
            initBase(e, s) {
                this.chart = e, this.eventProvider = new i, this.domElementProvider = new t, this.proxyProvider = s, this.keyCodes = {
                    left: 37,
                    right: 39,
                    up: 38,
                    down: 40,
                    enter: 13,
                    space: 32,
                    esc: 27,
                    tab: 9,
                    pageUp: 33,
                    pageDown: 34,
                    end: 35,
                    home: 36
                };
            }
            addEvent(e, t, i, s) {
                return this.eventProvider.addEvent(e, t, i, s);
            }
            createElement(e, t) {
                return this.domElementProvider.createElement(e, t);
            }
            fakeClickEvent(e) {
                o(e, r("click"));
            }
            destroyBase() {
                this.domElementProvider.destroyCreatedElements(), this.eventProvider.removeAddedEvents();
            }
        }
        return a(l.prototype, {
            init () {},
            getKeyboardNavigation: function() {},
            onChartUpdate () {},
            onChartRender () {},
            destroy () {}
        }), l;
    }), i(t, "Accessibility/KeyboardNavigationHandler.js", [
        t["Core/Utilities.js"]
    ], function(e) {
        let { find: t } = e;
        return class {
            constructor(e, t){
                this.chart = e, this.keyCodeMap = t.keyCodeMap || [], this.validate = t.validate, this.init = t.init, this.terminate = t.terminate, this.response = {
                    success: 1,
                    prev: 2,
                    next: 3,
                    noHandler: 4,
                    fail: 5
                };
            }
            run(e) {
                let i = e.which || e.keyCode, s = this.response.noHandler, n = t(this.keyCodeMap, function(e) {
                    return e[0].indexOf(i) > -1;
                });
                return n ? s = n[1].call(this, i, e) : 9 === i && (s = this.response[e.shiftKey ? "prev" : "next"]), s;
            }
        };
    }), i(t, "Accessibility/Components/ContainerComponent.js", [
        t["Accessibility/AccessibilityComponent.js"],
        t["Accessibility/KeyboardNavigationHandler.js"],
        t["Accessibility/Utils/ChartUtilities.js"],
        t["Core/Globals.js"],
        t["Accessibility/Utils/HTMLUtilities.js"]
    ], function(e, t, i, s, n) {
        let { unhideChartElementFromAT: o, getChartTitle: r } = i, { doc: a } = s, { stripHTMLTagsFromString: l } = n;
        return class extends e {
            onChartUpdate() {
                this.handleSVGTitleElement(), this.setSVGContainerLabel(), this.setGraphicContainerAttrs(), this.setRenderToAttrs(), this.makeCreditsAccessible();
            }
            handleSVGTitleElement() {
                let e = this.chart, t = "highcharts-title-" + e.index, i = l(e.langFormat("accessibility.svgContainerTitle", {
                    chartTitle: r(e)
                }));
                if (i.length) {
                    let s = this.svgTitleElement = this.svgTitleElement || a.createElementNS("http://www.w3.org/2000/svg", "title");
                    s.textContent = i, s.id = t, e.renderTo.insertBefore(s, e.renderTo.firstChild);
                }
            }
            setSVGContainerLabel() {
                let e = this.chart, t = e.langFormat("accessibility.svgContainerLabel", {
                    chartTitle: r(e)
                });
                e.renderer.box && t.length && e.renderer.box.setAttribute("aria-label", t);
            }
            setGraphicContainerAttrs() {
                let e = this.chart, t = e.langFormat("accessibility.graphicContainerLabel", {
                    chartTitle: r(e)
                });
                t.length && e.container.setAttribute("aria-label", t);
            }
            setRenderToAttrs() {
                let e = this.chart, t = "disabled" !== e.options.accessibility.landmarkVerbosity, i = e.langFormat("accessibility.chartContainerLabel", {
                    title: r(e),
                    chart: e
                });
                i && (e.renderTo.setAttribute("role", t ? "region" : "group"), e.renderTo.setAttribute("aria-label", i));
            }
            makeCreditsAccessible() {
                let e = this.chart, t = e.credits;
                t && (t.textStr && t.element.setAttribute("aria-label", e.langFormat("accessibility.credits", {
                    creditsStr: l(t.textStr, e.renderer.forExport)
                })), o(e, t.element));
            }
            getKeyboardNavigation() {
                let e = this.chart;
                return new t(e, {
                    keyCodeMap: [],
                    validate: function() {
                        return !0;
                    },
                    init: function() {
                        let t = e.accessibility;
                        t && t.keyboardNavigation.tabindexContainer.focus();
                    }
                });
            }
            destroy() {
                this.chart.renderTo.setAttribute("aria-hidden", !0);
            }
        };
    }), i(t, "Accessibility/FocusBorder.js", [
        t["Core/Utilities.js"]
    ], function(e) {
        var t;
        let { addEvent: i, pick: s } = e;
        return function(e) {
            let t = [
                "x",
                "y",
                "transform",
                "width",
                "height",
                "r",
                "d",
                "stroke-width"
            ];
            function n() {
                let e = this.focusElement, t = this.options.accessibility.keyboardNavigation.focusBorder;
                e && (e.removeFocusBorder(), t.enabled && e.addFocusBorder(t.margin, {
                    stroke: t.style.color,
                    strokeWidth: t.style.lineWidth,
                    r: t.style.borderRadius
                }));
            }
            function o(e, t) {
                let s = this.options.accessibility.keyboardNavigation.focusBorder, n = t || e.element;
                n && n.focus && (n.hcEvents && n.hcEvents.focusin || i(n, "focusin", function() {}), n.focus(), s.hideBrowserFocusOutline && (n.style.outline = "none")), this.focusElement && this.focusElement.removeFocusBorder(), this.focusElement = e, this.renderFocusBorder();
            }
            function r(e, i) {
                this.focusBorder && this.removeFocusBorder();
                let n = this.getBBox(), o = s(e, 3), r = this.parentGroup, a = this.scaleX || r && r.scaleX, l = this.scaleY || r && r.scaleY, h = (a ? !l : l) ? Math.abs(a || l || 1) : (Math.abs(a || 1) + Math.abs(l || 1)) / 2;
                n.x += this.translateX ? this.translateX : 0, n.y += this.translateY ? this.translateY : 0;
                let c = n.x - o, d = n.y - o, u = n.width + 2 * o, p = n.height + 2 * o, g = !!this.text;
                if ("text" === this.element.nodeName || g) {
                    let e, t;
                    let i = !!this.rotation, s = g ? {
                        x: i ? 1 : 0,
                        y: 0
                    } : (e = 0, t = 0, "middle" === this.attr("text-anchor") ? e = t = .5 : this.rotation ? e = .25 : t = .75, {
                        x: e,
                        y: t
                    }), r = +this.attr("x"), a = +this.attr("y");
                    if (isNaN(r) || (c = r - n.width * s.x - o), isNaN(a) || (d = a - n.height * s.y - o), g && i) {
                        let e = u;
                        u = p, p = e, isNaN(r) || (c = r - n.height * s.x - o), isNaN(a) || (d = a - n.width * s.y - o);
                    }
                }
                this.focusBorder = this.renderer.rect(c, d, u, p, parseInt((i && i.r || 0).toString(), 10) / h).addClass("highcharts-focus-border").attr({
                    zIndex: 99
                }).add(r), this.renderer.styledMode || this.focusBorder.attr({
                    stroke: i && i.stroke,
                    "stroke-width": (i && i.strokeWidth || 0) / h
                }), function(e, ...i) {
                    e.focusBorderUpdateHooks || (e.focusBorderUpdateHooks = {}, t.forEach((t)=>{
                        let s = t + "Setter", n = e[s] || e._defaultSetter;
                        e.focusBorderUpdateHooks[s] = n, e[s] = function() {
                            let t = n.apply(e, arguments);
                            return e.addFocusBorder.apply(e, i), t;
                        };
                    }));
                }(this, e, i), function(e) {
                    if (e.focusBorderDestroyHook) return;
                    let t = e.destroy;
                    e.destroy = function() {
                        return e.focusBorder && e.focusBorder.destroy && e.focusBorder.destroy(), t.apply(e, arguments);
                    }, e.focusBorderDestroyHook = t;
                }(this);
            }
            function a() {
                var e;
                e = this, e.focusBorderUpdateHooks && (Object.keys(e.focusBorderUpdateHooks).forEach((t)=>{
                    let i = e.focusBorderUpdateHooks[t];
                    i === e._defaultSetter ? delete e[t] : e[t] = i;
                }), delete e.focusBorderUpdateHooks), this.focusBorderDestroyHook && (this.destroy = this.focusBorderDestroyHook, delete this.focusBorderDestroyHook), this.focusBorder && (this.focusBorder.destroy(), delete this.focusBorder);
            }
            e.compose = function(e, t) {
                let i = e.prototype, s = t.prototype;
                i.renderFocusBorder || (i.renderFocusBorder = n, i.setFocusToElement = o), s.addFocusBorder || (s.addFocusBorder = r, s.removeFocusBorder = a);
            };
        }(t || (t = {})), t;
    }), i(t, "Accessibility/Utils/Announcer.js", [
        t["Core/Renderer/HTML/AST.js"],
        t["Accessibility/Utils/DOMElementProvider.js"],
        t["Core/Globals.js"],
        t["Accessibility/Utils/HTMLUtilities.js"],
        t["Core/Utilities.js"]
    ], function(e, t, i, s, n) {
        let { doc: o } = i, { addClass: r, visuallyHideElement: a } = s, { attr: l } = n;
        return class {
            constructor(e, i){
                this.chart = e, this.domElementProvider = new t, this.announceRegion = this.addAnnounceRegion(i);
            }
            destroy() {
                this.domElementProvider.destroyCreatedElements();
            }
            announce(t) {
                e.setElementHTML(this.announceRegion, t), this.clearAnnouncementRegionTimer && clearTimeout(this.clearAnnouncementRegionTimer), this.clearAnnouncementRegionTimer = setTimeout(()=>{
                    this.announceRegion.innerHTML = e.emptyHTML, delete this.clearAnnouncementRegionTimer;
                }, 3e3);
            }
            addAnnounceRegion(e) {
                let t = this.chart.announcerContainer || this.createAnnouncerContainer(), i = this.domElementProvider.createElement("div");
                return l(i, {
                    "aria-hidden": !1,
                    "aria-live": e,
                    "aria-atomic": !0
                }), this.chart.styledMode ? r(i, "highcharts-visually-hidden") : a(i), t.appendChild(i), i;
            }
            createAnnouncerContainer() {
                let e = this.chart, t = o.createElement("div");
                return l(t, {
                    "aria-hidden": !1,
                    class: "highcharts-announcer-container"
                }), t.style.position = "relative", e.renderTo.insertBefore(t, e.renderTo.firstChild), e.announcerContainer = t, t;
            }
        };
    }), i(t, "Accessibility/Components/AnnotationsA11y.js", [
        t["Accessibility/Utils/HTMLUtilities.js"]
    ], function(e) {
        let { escapeStringForHTML: t, stripHTMLTagsFromString: i } = e;
        function s(e) {
            return (e.annotations || []).reduce((e, t)=>(t.options && !1 !== t.options.visible && (e = e.concat(t.labels)), e), []);
        }
        function n(e) {
            return e.options && e.options.accessibility && e.options.accessibility.description || e.graphic && e.graphic.text && e.graphic.text.textStr || "";
        }
        function o(e) {
            let t = e.options && e.options.accessibility && e.options.accessibility.description;
            if (t) return t;
            let i = e.chart, s = n(e), o = e.points, r = (e)=>e.graphic && e.graphic.element && e.graphic.element.getAttribute("aria-label") || "", a = o.filter((e)=>!!e.graphic).map((e)=>{
                let t = e.accessibility && e.accessibility.valueDescription || r(e), i = e && e.series.name || "";
                return (i ? i + ", " : "") + "data point " + t;
            }).filter((e)=>!!e), l = a.length, h = l > 1 ? "MultiplePoints" : l ? "SinglePoint" : "NoPoints", c = {
                annotationText: s,
                annotation: e,
                numPoints: l,
                annotationPoint: a[0],
                additionalAnnotationPoints: a.slice(1)
            };
            return i.langFormat("accessibility.screenReaderSection.annotations.description" + h, c);
        }
        function r(e) {
            return s(e).map((s)=>{
                let n = t(i(o(s), e.renderer.forExport));
                return n ? `<li>${n}</li>` : "";
            });
        }
        return {
            getAnnotationsInfoHTML: function(e) {
                let t = e.annotations;
                if (!(t && t.length)) return "";
                let i = r(e);
                return `<ul style="list-style-type: none">${i.join(" ")}</ul>`;
            },
            getAnnotationLabelDescription: o,
            getAnnotationListItems: r,
            getPointAnnotationTexts: function(e) {
                let t = s(e.series.chart).filter((t)=>t.points.indexOf(e) > -1);
                return t.length ? t.map((e)=>`${n(e)}`) : [];
            }
        };
    }), i(t, "Accessibility/Components/InfoRegionsComponent.js", [
        t["Accessibility/A11yI18n.js"],
        t["Accessibility/AccessibilityComponent.js"],
        t["Accessibility/Utils/Announcer.js"],
        t["Accessibility/Components/AnnotationsA11y.js"],
        t["Core/Renderer/HTML/AST.js"],
        t["Accessibility/Utils/ChartUtilities.js"],
        t["Core/Templating.js"],
        t["Core/Globals.js"],
        t["Accessibility/Utils/HTMLUtilities.js"],
        t["Core/Utilities.js"]
    ], function(e, t, i, s, n, o, r, a, l, h) {
        let { getAnnotationsInfoHTML: c } = s, { getAxisDescription: d, getAxisRangeDescription: u, getChartTitle: p, unhideChartElementFromAT: g } = o, { format: m } = r, { doc: b } = a, { addClass: y, getElement: f, getHeadingTagNameForElement: x, stripHTMLTagsFromString: v, visuallyHideElement: A } = l, { attr: C, pick: w, replaceNested: E } = h;
        function T(e) {
            return E(e, [
                /<([\w\-.:!]+)\b[^<>]*>\s*<\/\1>/g,
                ""
            ]);
        }
        return class extends t {
            constructor(){
                super(...arguments), this.screenReaderSections = {};
            }
            init() {
                let e = this.chart, t = this;
                this.initRegionsDefinitions(), this.addEvent(e, "aftergetTableAST", function(e) {
                    t.onDataTableCreated(e);
                }), this.addEvent(e, "afterViewData", function(e) {
                    e.wasHidden && (t.dataTableDiv = e.element, setTimeout(function() {
                        t.focusDataTable();
                    }, 300));
                }), this.addEvent(e, "afterHideData", function() {
                    t.viewDataTableButton && t.viewDataTableButton.setAttribute("aria-expanded", "false");
                }), this.announcer = new i(e, "assertive");
            }
            initRegionsDefinitions() {
                let e = this, t = this.chart.options.accessibility;
                this.screenReaderSections = {
                    before: {
                        element: null,
                        buildContent: function(i) {
                            let s = t.screenReaderSection.beforeChartFormatter;
                            return s ? s(i) : e.defaultBeforeChartFormatter(i);
                        },
                        insertIntoDOM: function(e, t) {
                            t.renderTo.insertBefore(e, t.renderTo.firstChild);
                        },
                        afterInserted: function() {
                            void 0 !== e.sonifyButtonId && e.initSonifyButton(e.sonifyButtonId), void 0 !== e.dataTableButtonId && e.initDataTableButton(e.dataTableButtonId);
                        }
                    },
                    after: {
                        element: null,
                        buildContent: function(i) {
                            let s = t.screenReaderSection.afterChartFormatter;
                            return s ? s(i) : e.defaultAfterChartFormatter();
                        },
                        insertIntoDOM: function(e, t) {
                            t.renderTo.insertBefore(e, t.container.nextSibling);
                        },
                        afterInserted: function() {
                            e.chart.accessibility && t.keyboardNavigation.enabled && e.chart.accessibility.keyboardNavigation.updateExitAnchor();
                        }
                    }
                };
            }
            onChartRender() {
                let e = this;
                this.linkedDescriptionElement = this.getLinkedDescriptionElement(), this.setLinkedDescriptionAttrs(), Object.keys(this.screenReaderSections).forEach(function(t) {
                    e.updateScreenReaderSection(t);
                });
            }
            getLinkedDescriptionElement() {
                let e = this.chart.options.accessibility.linkedDescription;
                if (!e) return;
                if ("string" != typeof e) return e;
                let t = m(e, this.chart), i = b.querySelectorAll(t);
                if (1 === i.length) return i[0];
            }
            setLinkedDescriptionAttrs() {
                let e = this.linkedDescriptionElement;
                e && (e.setAttribute("aria-hidden", "true"), y(e, "highcharts-linked-description"));
            }
            updateScreenReaderSection(e) {
                let t = this.chart, i = this.screenReaderSections[e], s = i.buildContent(t), o = i.element = i.element || this.createElement("div"), r = o.firstChild || this.createElement("div");
                s ? (this.setScreenReaderSectionAttribs(o, e), n.setElementHTML(r, s), o.appendChild(r), i.insertIntoDOM(o, t), t.styledMode ? y(r, "highcharts-visually-hidden") : A(r), g(t, r), i.afterInserted && i.afterInserted()) : (o.parentNode && o.parentNode.removeChild(o), i.element = null);
            }
            setScreenReaderSectionAttribs(e, t) {
                let i = this.chart, s = i.langFormat("accessibility.screenReaderSection." + t + "RegionLabel", {
                    chart: i,
                    chartTitle: p(i)
                });
                C(e, {
                    id: `highcharts-screen-reader-region-${t}-${i.index}`,
                    "aria-label": s || void 0
                }), e.style.position = "relative", s && e.setAttribute("role", "all" === i.options.accessibility.landmarkVerbosity ? "region" : "group");
            }
            defaultBeforeChartFormatter() {
                let t = this.chart, i = t.options.accessibility.screenReaderSection.beforeChartFormat;
                if (!i) return "";
                let s = this.getAxesDescription(), n = t.sonify && t.options.sonification && t.options.sonification.enabled, o = "highcharts-a11y-sonify-data-btn-" + t.index, r = "hc-linkto-highcharts-data-table-" + t.index, a = c(t), l = t.langFormat("accessibility.screenReaderSection.annotations.heading", {
                    chart: t
                }), h = {
                    headingTagName: x(t.renderTo),
                    chartTitle: p(t),
                    typeDescription: this.getTypeDescriptionText(),
                    chartSubtitle: this.getSubtitleText(),
                    chartLongdesc: this.getLongdescText(),
                    xAxisDescription: s.xAxis,
                    yAxisDescription: s.yAxis,
                    playAsSoundButton: n ? this.getSonifyButtonText(o) : "",
                    viewTableButton: t.getCSV ? this.getDataTableButtonText(r) : "",
                    annotationsTitle: a ? l : "",
                    annotationsList: a
                }, d = e.i18nFormat(i, h, t);
                return this.dataTableButtonId = r, this.sonifyButtonId = o, T(d);
            }
            defaultAfterChartFormatter() {
                let t = this.chart, i = t.options.accessibility.screenReaderSection.afterChartFormat;
                if (!i) return "";
                let s = {
                    endOfChartMarker: this.getEndOfChartMarkerText()
                };
                return T(e.i18nFormat(i, s, t));
            }
            getLinkedDescription() {
                let e = this.linkedDescriptionElement;
                return v(e && e.innerHTML || "", this.chart.renderer.forExport);
            }
            getLongdescText() {
                let e = this.chart.options, t = e.caption, i = t && t.text, s = this.getLinkedDescription();
                return e.accessibility.description || s || i || "";
            }
            getTypeDescriptionText() {
                let e = this.chart;
                return e.types ? e.options.accessibility.typeDescription || function(e, t) {
                    let i = t[0], s = e.series && e.series[0] || {}, n = e.mapView && e.mapView.geoMap && e.mapView.geoMap.title, o = {
                        numSeries: e.series.length,
                        numPoints: s.points && s.points.length,
                        chart: e,
                        mapTitle: n
                    };
                    return i ? "map" === i || "tiledwebmap" === i ? o.mapTitle ? e.langFormat("accessibility.chartTypes.mapTypeDescription", o) : e.langFormat("accessibility.chartTypes.unknownMap", o) : e.types.length > 1 ? e.langFormat("accessibility.chartTypes.combinationChart", o) : function(e, t, i) {
                        let s = t[0], n = e.langFormat("accessibility.seriesTypeDescriptions." + s, i), o = e.series && e.series.length < 2 ? "Single" : "Multiple";
                        return (e.langFormat("accessibility.chartTypes." + s + o, i) || e.langFormat("accessibility.chartTypes.default" + o, i)) + (n ? " " + n : "");
                    }(e, t, o) : e.langFormat("accessibility.chartTypes.emptyChart", o);
                }(e, e.types) : "";
            }
            getDataTableButtonText(e) {
                let t = this.chart;
                return '<button id="' + e + '">' + t.langFormat("accessibility.table.viewAsDataTableButtonText", {
                    chart: t,
                    chartTitle: p(t)
                }) + "</button>";
            }
            getSonifyButtonText(e) {
                let t = this.chart;
                return t.options.sonification && !1 === t.options.sonification.enabled ? "" : '<button id="' + e + '">' + t.langFormat("accessibility.sonification.playAsSoundButtonText", {
                    chart: t,
                    chartTitle: p(t)
                }) + "</button>";
            }
            getSubtitleText() {
                let e = this.chart.options.subtitle;
                return v(e && e.text || "", this.chart.renderer.forExport);
            }
            getEndOfChartMarkerText() {
                let e = f(`highcharts-end-of-chart-marker-${this.chart.index}`);
                if (e) return e.outerHTML;
                let t = this.chart, i = t.langFormat("accessibility.screenReaderSection.endOfChartMarker", {
                    chart: t
                });
                return '<div id="highcharts-end-of-chart-marker-' + t.index + '">' + i + "</div>";
            }
            onDataTableCreated(e) {
                let t = this.chart;
                if (t.options.accessibility.enabled) {
                    this.viewDataTableButton && this.viewDataTableButton.setAttribute("aria-expanded", "true");
                    let i = e.tree.attributes || {};
                    i.tabindex = -1, i.summary = t.langFormat("accessibility.table.tableSummary", {
                        chart: t
                    }), e.tree.attributes = i;
                }
            }
            focusDataTable() {
                let e = this.dataTableDiv, t = e && e.getElementsByTagName("table")[0];
                t && t.focus && t.focus();
            }
            initSonifyButton(e) {
                let t = this.sonifyButton = f(e), i = this.chart, s = (e)=>{
                    t && (t.setAttribute("aria-hidden", "true"), t.setAttribute("aria-label", "")), e.preventDefault(), e.stopPropagation();
                    let s = i.langFormat("accessibility.sonification.playAsSoundClickAnnouncement", {
                        chart: i
                    });
                    this.announcer.announce(s), setTimeout(()=>{
                        t && (t.removeAttribute("aria-hidden"), t.removeAttribute("aria-label")), i.sonify && i.sonify();
                    }, 1e3);
                };
                t && i && (t.setAttribute("tabindex", -1), t.onclick = function(e) {
                    (i.options.accessibility && i.options.accessibility.screenReaderSection.onPlayAsSoundClick || s).call(this, e, i);
                });
            }
            initDataTableButton(e) {
                let t = this.viewDataTableButton = f(e), i = this.chart, s = e.replace("hc-linkto-", "");
                t && (C(t, {
                    tabindex: -1,
                    "aria-expanded": !!f(s)
                }), t.onclick = i.options.accessibility.screenReaderSection.onViewDataTableClick || function() {
                    i.viewData();
                });
            }
            getAxesDescription() {
                let e = this.chart, t = function(t, i) {
                    let s = e[t];
                    return s.length > 1 || s[0] && w(s[0].options.accessibility && s[0].options.accessibility.enabled, i);
                }, i = !!e.types && 0 > e.types.indexOf("map") && 0 > e.types.indexOf("treemap") && 0 > e.types.indexOf("tilemap"), s = !!e.hasCartesianSeries, n = t("xAxis", !e.angular && s && i), o = t("yAxis", s && i), r = {};
                return n && (r.xAxis = this.getAxisDescriptionText("xAxis")), o && (r.yAxis = this.getAxisDescriptionText("yAxis")), r;
            }
            getAxisDescriptionText(e) {
                let t = this.chart, i = t[e];
                return t.langFormat("accessibility.axis." + e + "Description" + (i.length > 1 ? "Plural" : "Singular"), {
                    chart: t,
                    names: i.map(function(e) {
                        return d(e);
                    }),
                    ranges: i.map(function(e) {
                        return u(e);
                    }),
                    numAxes: i.length
                });
            }
            destroy() {
                this.announcer && this.announcer.destroy();
            }
        };
    }), i(t, "Accessibility/Components/MenuComponent.js", [
        t["Core/Utilities.js"],
        t["Accessibility/AccessibilityComponent.js"],
        t["Accessibility/KeyboardNavigationHandler.js"],
        t["Accessibility/Utils/ChartUtilities.js"],
        t["Accessibility/Utils/HTMLUtilities.js"]
    ], function(e, t, i, s, n) {
        let { attr: o } = e, { getChartTitle: r, unhideChartElementFromAT: a } = s, { getFakeMouseEvent: l } = n;
        function h(e) {
            return e.exportSVGElements && e.exportSVGElements[0];
        }
        class c extends t {
            init() {
                let e = this.chart, t = this;
                this.addEvent(e, "exportMenuShown", function() {
                    t.onMenuShown();
                }), this.addEvent(e, "exportMenuHidden", function() {
                    t.onMenuHidden();
                }), this.createProxyGroup();
            }
            onMenuHidden() {
                let e = this.chart.exportContextMenu;
                e && e.setAttribute("aria-hidden", "true"), this.setExportButtonExpandedState("false");
            }
            onMenuShown() {
                let e = this.chart, t = e.exportContextMenu;
                t && (this.addAccessibleContextMenuAttribs(), a(e, t)), this.setExportButtonExpandedState("true");
            }
            setExportButtonExpandedState(e) {
                this.exportButtonProxy && this.exportButtonProxy.innerElement.setAttribute("aria-expanded", e);
            }
            onChartRender() {
                let e = this.chart, t = e.focusElement, i = e.accessibility;
                this.proxyProvider.clearGroup("chartMenu"), this.proxyMenuButton(), this.exportButtonProxy && t && t === e.exportingGroup && (t.focusBorder ? e.setFocusToElement(t, this.exportButtonProxy.innerElement) : i && i.keyboardNavigation.tabindexContainer.focus());
            }
            proxyMenuButton() {
                let e = this.chart, t = this.proxyProvider, i = h(e);
                (function(e) {
                    let t = e.options.exporting, i = h(e);
                    return !!(t && !1 !== t.enabled && t.accessibility && t.accessibility.enabled && i && i.element);
                })(e) && i && (this.exportButtonProxy = t.addProxyElement("chartMenu", {
                    click: i
                }, "button", {
                    "aria-label": e.langFormat("accessibility.exporting.menuButtonLabel", {
                        chart: e,
                        chartTitle: r(e)
                    }),
                    "aria-expanded": !1,
                    title: e.options.lang.contextButtonTitle || null
                }));
            }
            createProxyGroup() {
                this.chart && this.proxyProvider && this.proxyProvider.addGroup("chartMenu");
            }
            addAccessibleContextMenuAttribs() {
                let e = this.chart, t = e.exportDivElements;
                if (t && t.length) {
                    t.forEach((e)=>{
                        e && ("LI" !== e.tagName || e.children && e.children.length ? e.setAttribute("aria-hidden", "true") : e.setAttribute("tabindex", -1));
                    });
                    let i = t[0] && t[0].parentNode;
                    i && o(i, {
                        "aria-hidden": void 0,
                        "aria-label": e.langFormat("accessibility.exporting.chartMenuLabel", {
                            chart: e
                        }),
                        role: "list"
                    });
                }
            }
            getKeyboardNavigation() {
                let e = this.keyCodes, t = this.chart, s = this;
                return new i(t, {
                    keyCodeMap: [
                        [
                            [
                                e.left,
                                e.up
                            ],
                            function() {
                                return s.onKbdPrevious(this);
                            }
                        ],
                        [
                            [
                                e.right,
                                e.down
                            ],
                            function() {
                                return s.onKbdNext(this);
                            }
                        ],
                        [
                            [
                                e.enter,
                                e.space
                            ],
                            function() {
                                return s.onKbdClick(this);
                            }
                        ]
                    ],
                    validate: function() {
                        return !!t.exporting && !1 !== t.options.exporting.enabled && !1 !== t.options.exporting.accessibility.enabled;
                    },
                    init: function() {
                        let e = s.exportButtonProxy, i = s.chart.exportingGroup;
                        e && i && t.setFocusToElement(i, e.innerElement);
                    },
                    terminate: function() {
                        t.hideExportMenu();
                    }
                });
            }
            onKbdPrevious(e) {
                let t = this.chart, i = t.options.accessibility, s = e.response, n = t.highlightedExportItemIx || 0;
                for(; n--;)if (t.highlightExportItem(n)) return s.success;
                return i.keyboardNavigation.wrapAround ? (t.highlightLastExportItem(), s.success) : s.prev;
            }
            onKbdNext(e) {
                let t = this.chart, i = t.options.accessibility, s = e.response;
                for(let e = (t.highlightedExportItemIx || 0) + 1; e < t.exportDivElements.length; ++e)if (t.highlightExportItem(e)) return s.success;
                return i.keyboardNavigation.wrapAround ? (t.highlightExportItem(0), s.success) : s.next;
            }
            onKbdClick(e) {
                let t = this.chart, i = t.exportDivElements[t.highlightedExportItemIx], s = h(t).element;
                return t.openMenu ? this.fakeClickEvent(i) : (this.fakeClickEvent(s), t.highlightExportItem(0)), e.response.success;
            }
        }
        return function(e) {
            function t() {
                let e = h(this);
                if (e) {
                    let t = e.element;
                    t.onclick && t.onclick(l("click"));
                }
            }
            function i() {
                let e = this.exportDivElements;
                e && this.exportContextMenu && this.openMenu && (e.forEach((e)=>{
                    e && "highcharts-menu-item" === e.className && e.onmouseout && e.onmouseout(l("mouseout"));
                }), this.highlightedExportItemIx = 0, this.exportContextMenu.hideMenu(), this.container.focus());
            }
            function s(e) {
                let t = this.exportDivElements && this.exportDivElements[e], i = this.exportDivElements && this.exportDivElements[this.highlightedExportItemIx];
                if (t && "LI" === t.tagName && !(t.children && t.children.length)) {
                    let s = !!(this.renderTo.getElementsByTagName("g")[0] || {}).focus;
                    return t.focus && s && t.focus(), i && i.onmouseout && i.onmouseout(l("mouseout")), t.onmouseover && t.onmouseover(l("mouseover")), this.highlightedExportItemIx = e, !0;
                }
                return !1;
            }
            function n() {
                if (this.exportDivElements) {
                    let e = this.exportDivElements.length;
                    for(; e--;)if (this.highlightExportItem(e)) return !0;
                }
                return !1;
            }
            e.compose = function(e) {
                let o = e.prototype;
                o.hideExportMenu || (o.hideExportMenu = i, o.highlightExportItem = s, o.highlightLastExportItem = n, o.showExportMenu = t);
            };
        }(c || (c = {})), c;
    }), i(t, "Accessibility/KeyboardNavigation.js", [
        t["Core/Globals.js"],
        t["Accessibility/Components/MenuComponent.js"],
        t["Core/Utilities.js"],
        t["Accessibility/Utils/EventProvider.js"],
        t["Accessibility/Utils/HTMLUtilities.js"]
    ], function(e, t, i, s, n) {
        let { doc: o, win: r } = e, { addEvent: a, defined: l, fireEvent: h } = i, { getElement: c, simulatedEventTarget: d } = n;
        class u {
            constructor(e, t){
                this.currentModuleIx = NaN, this.modules = [], this.init(e, t);
            }
            init(e, t) {
                let i = this.eventProvider = new s;
                this.chart = e, this.components = t, this.modules = [], this.currentModuleIx = 0, this.update(), i.addEvent(this.tabindexContainer, "keydown", (e)=>this.onKeydown(e)), i.addEvent(this.tabindexContainer, "focus", (e)=>this.onFocus(e)), [
                    "mouseup",
                    "touchend"
                ].forEach((e)=>i.addEvent(o, e, (e)=>this.onMouseUp(e))), [
                    "mousedown",
                    "touchstart"
                ].forEach((t)=>i.addEvent(e.renderTo, t, ()=>{
                        this.isClickingChart = !0;
                    }));
            }
            update(e) {
                let t = this.chart.options.accessibility, i = t && t.keyboardNavigation, s = this.components;
                this.updateContainerTabindex(), i && i.enabled && e && e.length ? (this.modules = e.reduce(function(e, t) {
                    let i = s[t].getKeyboardNavigation();
                    return e.concat(i);
                }, []), this.updateExitAnchor()) : (this.modules = [], this.currentModuleIx = 0, this.removeExitAnchor());
            }
            updateExitAnchor() {
                let e = c(`highcharts-end-of-chart-marker-${this.chart.index}`);
                this.removeExitAnchor(), e ? (this.makeElementAnExitAnchor(e), this.exitAnchor = e) : this.createExitAnchor();
            }
            move(e) {
                let t = this.modules && this.modules[this.currentModuleIx];
                t && t.terminate && t.terminate(e), this.chart.focusElement && this.chart.focusElement.removeFocusBorder(), this.currentModuleIx += e;
                let i = this.modules && this.modules[this.currentModuleIx];
                if (i) {
                    if (i.validate && !i.validate()) return this.move(e);
                    if (i.init) return i.init(e), !0;
                }
                return this.currentModuleIx = 0, this.exiting = !0, e > 0 ? this.exitAnchor && this.exitAnchor.focus() : this.tabindexContainer.focus(), !1;
            }
            onFocus(e) {
                let t = this.chart, i = e.relatedTarget && t.container.contains(e.relatedTarget), s = t.options.accessibility, n = s && s.keyboardNavigation;
                if (n && n.enabled && !this.exiting && !this.tabbingInBackwards && !this.isClickingChart && !i) {
                    let e = this.getFirstValidModuleIx();
                    null !== e && (this.currentModuleIx = e, this.modules[e].init(1));
                }
                this.keyboardReset = !1, this.exiting = !1;
            }
            onMouseUp(e) {
                if (delete this.isClickingChart, !this.keyboardReset && e.relatedTarget !== d) {
                    let t = this.chart;
                    if (!e.target || !t.container.contains(e.target)) {
                        let e = this.modules && this.modules[this.currentModuleIx || 0];
                        e && e.terminate && e.terminate(), this.currentModuleIx = 0;
                    }
                    t.focusElement && (t.focusElement.removeFocusBorder(), delete t.focusElement), this.keyboardReset = !0;
                }
            }
            onKeydown(e) {
                let t;
                let i = e || r.event, s = this.modules && this.modules.length && this.modules[this.currentModuleIx], n = i.target;
                if ((!n || "INPUT" !== n.nodeName || n.classList.contains("highcharts-a11y-proxy-element")) && (this.keyboardReset = !1, this.exiting = !1, s)) {
                    let e = s.run(i);
                    e === s.response.success ? t = !0 : e === s.response.prev ? t = this.move(-1) : e === s.response.next && (t = this.move(1)), t && (i.preventDefault(), i.stopPropagation());
                }
            }
            updateContainerTabindex() {
                let e;
                let t = this.chart.options.accessibility, i = t && t.keyboardNavigation, s = !(i && !1 === i.enabled), n = this.chart, o = n.container;
                n.renderTo.hasAttribute("tabindex") ? (o.removeAttribute("tabindex"), e = n.renderTo) : e = o, this.tabindexContainer = e;
                let r = e.getAttribute("tabindex");
                s && !r ? e.setAttribute("tabindex", "0") : s || n.container.removeAttribute("tabindex");
            }
            createExitAnchor() {
                let e = this.chart, t = this.exitAnchor = o.createElement("div");
                e.renderTo.appendChild(t), this.makeElementAnExitAnchor(t);
            }
            makeElementAnExitAnchor(e) {
                let t = this.tabindexContainer.getAttribute("tabindex") || 0;
                e.setAttribute("class", "highcharts-exit-anchor"), e.setAttribute("tabindex", t), e.setAttribute("aria-hidden", !1), this.addExitAnchorEventsToEl(e);
            }
            removeExitAnchor() {
                this.exitAnchor && (l(this.exitAnchor.focusEventRemover) && (this.eventProvider.removeEvent(this.exitAnchor.focusEventRemover), delete this.exitAnchor.focusEventRemover), this.exitAnchor.parentNode && this.exitAnchor.parentNode.removeChild(this.exitAnchor), delete this.exitAnchor);
            }
            addExitAnchorEventsToEl(e) {
                let t = this.chart, i = this;
                e.focusEventRemover = this.eventProvider.addEvent(e, "focus", function(e) {
                    let s = e || r.event, n = !(s.relatedTarget && t.container.contains(s.relatedTarget) || i.exiting);
                    if (t.focusElement && delete t.focusElement, n) {
                        if (i.tabbingInBackwards = !0, i.tabindexContainer.focus(), delete i.tabbingInBackwards, s.preventDefault(), i.modules && i.modules.length) {
                            i.currentModuleIx = i.modules.length - 1;
                            let e = i.modules[i.currentModuleIx];
                            e && e.validate && !e.validate() ? i.move(-1) : e && e.init(-1);
                        }
                    } else i.exiting = !1;
                });
            }
            getFirstValidModuleIx() {
                let e = this.modules.length;
                for(let t = 0; t < e; ++t){
                    let e = this.modules[t];
                    if (!e.validate || e.validate()) return t;
                }
                return null;
            }
            destroy() {
                this.removeExitAnchor(), this.eventProvider.removeAddedEvents(), this.chart.container.removeAttribute("tabindex");
            }
        }
        return function(i) {
            function s() {
                let e = this;
                h(this, "dismissPopupContent", {}, function() {
                    e.tooltip && e.tooltip.hide(0), e.hideExportMenu();
                });
            }
            function n(t) {
                27 === (t.which || t.keyCode) && e.charts && e.charts.forEach((e)=>{
                    e && e.dismissPopupContent && e.dismissPopupContent();
                });
            }
            i.compose = function(e) {
                t.compose(e);
                let i = e.prototype;
                return i.dismissPopupContent || (i.dismissPopupContent = s, a(o, "keydown", n)), e;
            };
        }(u || (u = {})), u;
    }), i(t, "Accessibility/Components/LegendComponent.js", [
        t["Core/Animation/AnimationUtilities.js"],
        t["Core/Globals.js"],
        t["Core/Legend/Legend.js"],
        t["Core/Utilities.js"],
        t["Accessibility/AccessibilityComponent.js"],
        t["Accessibility/KeyboardNavigationHandler.js"],
        t["Accessibility/Utils/ChartUtilities.js"],
        t["Accessibility/Utils/HTMLUtilities.js"]
    ], function(e, t, i, s, n, o, r, a) {
        let { animObject: l } = e, { doc: h } = t, { addEvent: c, fireEvent: d, isNumber: u, pick: p, syncTimeout: g } = s, { getChartTitle: m } = r, { stripHTMLTagsFromString: b, addClass: y, removeClass: f } = a;
        function x(e) {
            let t = e.legend && e.legend.allItems, i = e.options.legend.accessibility || {}, s = e.colorAxis && e.colorAxis.some((e)=>!e.dataClasses || !e.dataClasses.length);
            return !!(t && t.length && !s && !1 !== i.enabled);
        }
        function v(e, t) {
            let i = t.legendItem || {};
            for (let s of (t.setState(e ? "hover" : "", !0), [
                "group",
                "label",
                "symbol"
            ])){
                let t = i[s], n = t && t.element || t;
                n && d(n, e ? "mouseover" : "mouseout");
            }
        }
        class A extends n {
            constructor(){
                super(...arguments), this.highlightedLegendItemIx = NaN, this.proxyGroup = null;
            }
            init() {
                let e = this;
                this.recreateProxies(), this.addEvent(i, "afterScroll", function() {
                    this.chart === e.chart && (e.proxyProvider.updateGroupProxyElementPositions("legend"), e.updateLegendItemProxyVisibility(), e.highlightedLegendItemIx > -1 && this.chart.highlightLegendItem(e.highlightedLegendItemIx));
                }), this.addEvent(i, "afterPositionItem", function(t) {
                    this.chart === e.chart && this.chart.renderer && e.updateProxyPositionForItem(t.item);
                }), this.addEvent(i, "afterRender", function() {
                    this.chart === e.chart && this.chart.renderer && e.recreateProxies() && g(()=>e.proxyProvider.updateGroupProxyElementPositions("legend"), l(p(this.chart.renderer.globalAnimation, !0)).duration);
                });
            }
            updateLegendItemProxyVisibility() {
                let e;
                let t = this.chart, i = t.legend, s = i.allItems || [], n = i.currentPage || 1, o = i.clipHeight || 0;
                s.forEach((s)=>{
                    if (s.a11yProxyElement) {
                        let r = i.pages && i.pages.length, a = s.a11yProxyElement.element, l = !1;
                        if (e = s.legendItem || {}, r) {
                            let t = e.pageIx || 0;
                            l = (e.y || 0) + (e.label ? Math.round(e.label.getBBox().height) : 0) - i.pages[t] > o || t !== n - 1;
                        }
                        l ? t.styledMode ? y(a, "highcharts-a11y-invisible") : a.style.visibility = "hidden" : (f(a, "highcharts-a11y-invisible"), a.style.visibility = "");
                    }
                });
            }
            onChartRender() {
                x(this.chart) || this.removeProxies();
            }
            highlightAdjacentLegendPage(e) {
                let t = this.chart, i = t.legend, s = (i.currentPage || 1) + e, n = i.pages || [];
                if (s > 0 && s <= n.length) {
                    let e = 0;
                    for (let n of i.allItems)((n.legendItem || {}).pageIx || 0) + 1 === s && t.highlightLegendItem(e) && (this.highlightedLegendItemIx = e), ++e;
                }
            }
            updateProxyPositionForItem(e) {
                e.a11yProxyElement && e.a11yProxyElement.refreshPosition();
            }
            recreateProxies() {
                let e = h.activeElement, t = this.proxyGroup, i = e && t && t.contains(e);
                return this.removeProxies(), !!x(this.chart) && (this.addLegendProxyGroup(), this.proxyLegendItems(), this.updateLegendItemProxyVisibility(), this.updateLegendTitle(), i && this.chart.highlightLegendItem(this.highlightedLegendItemIx), !0);
            }
            removeProxies() {
                this.proxyProvider.removeGroup("legend");
            }
            updateLegendTitle() {
                let e = this.chart, t = b((e.legend && e.legend.options.title && e.legend.options.title.text || "").replace(/<br ?\/?>/g, " "), e.renderer.forExport), i = e.langFormat("accessibility.legend.legendLabel" + (t ? "" : "NoTitle"), {
                    chart: e,
                    legendTitle: t,
                    chartTitle: m(e)
                });
                this.proxyProvider.updateGroupAttrs("legend", {
                    "aria-label": i
                });
            }
            addLegendProxyGroup() {
                let e = "all" === this.chart.options.accessibility.landmarkVerbosity ? "region" : null;
                this.proxyGroup = this.proxyProvider.addGroup("legend", "ul", {
                    "aria-label": "_placeholder_",
                    role: e
                });
            }
            proxyLegendItems() {
                let e;
                let t = this;
                ((this.chart.legend || {}).allItems || []).forEach((i)=>{
                    (e = i.legendItem || {}).label && e.label.element && t.proxyLegendItem(i);
                });
            }
            proxyLegendItem(e) {
                let t = e.legendItem || {};
                if (!t.label || !t.group) return;
                let i = this.chart.langFormat("accessibility.legend.legendItem", {
                    chart: this.chart,
                    itemName: b(e.name, this.chart.renderer.forExport),
                    item: e
                }), s = {
                    tabindex: -1,
                    "aria-pressed": e.visible,
                    "aria-label": i
                }, n = t.group.div ? t.label : t.group;
                e.a11yProxyElement = this.proxyProvider.addProxyElement("legend", {
                    click: t.label,
                    visual: n.element
                }, "button", s);
            }
            getKeyboardNavigation() {
                let e = this.keyCodes, t = this, i = this.chart;
                return new o(i, {
                    keyCodeMap: [
                        [
                            [
                                e.left,
                                e.right,
                                e.up,
                                e.down
                            ],
                            function(e) {
                                return t.onKbdArrowKey(this, e);
                            }
                        ],
                        [
                            [
                                e.enter,
                                e.space
                            ],
                            function() {
                                return t.onKbdClick(this);
                            }
                        ],
                        [
                            [
                                e.pageDown,
                                e.pageUp
                            ],
                            function(i) {
                                let s = i === e.pageDown ? 1 : -1;
                                return t.highlightAdjacentLegendPage(s), this.response.success;
                            }
                        ]
                    ],
                    validate: function() {
                        return t.shouldHaveLegendNavigation();
                    },
                    init: function() {
                        i.highlightLegendItem(0), t.highlightedLegendItemIx = 0;
                    },
                    terminate: function() {
                        t.highlightedLegendItemIx = -1, i.legend.allItems.forEach((e)=>v(!1, e));
                    }
                });
            }
            onKbdArrowKey(e, t) {
                let { keyCodes: { left: i, up: s }, highlightedLegendItemIx: n, chart: o } = this, r = o.legend.allItems.length, a = o.options.accessibility.keyboardNavigation.wrapAround, l = t === i || t === s ? -1 : 1;
                return o.highlightLegendItem(n + l) ? this.highlightedLegendItemIx += l : a && r > 1 && (this.highlightedLegendItemIx = l > 0 ? 0 : r - 1, o.highlightLegendItem(this.highlightedLegendItemIx)), e.response.success;
            }
            onKbdClick(e) {
                let t = this.chart.legend.allItems[this.highlightedLegendItemIx];
                return t && t.a11yProxyElement && t.a11yProxyElement.click(), e.response.success;
            }
            shouldHaveLegendNavigation() {
                if (!x(this.chart)) return !1;
                let e = this.chart, t = (e.options.legend || {}).accessibility || {};
                return !!(e.legend.display && t.keyboardNavigation && t.keyboardNavigation.enabled);
            }
            destroy() {
                this.removeProxies();
            }
        }
        return function(e) {
            function t(e) {
                let t = this.legend.allItems, i = this.accessibility && this.accessibility.components.legend.highlightedLegendItemIx, s = t[e], n = s?.legendItem || {};
                if (s) {
                    u(i) && t[i] && v(!1, t[i]), function(e, t) {
                        let i = (e.allItems[t].legendItem || {}).pageIx, s = e.currentPage;
                        void 0 !== i && i + 1 !== s && e.scroll(1 + i - s);
                    }(this.legend, e);
                    let o = n.label, r = s.a11yProxyElement && s.a11yProxyElement.element;
                    return o && o.element && r && this.setFocusToElement(o, r), v(!0, s), !0;
                }
                return !1;
            }
            function i(e) {
                let t = this.chart.options.accessibility, i = e.item;
                t.enabled && i && i.a11yProxyElement && i.a11yProxyElement.innerElement.setAttribute("aria-pressed", e.visible ? "true" : "false");
            }
            e.compose = function(e, s) {
                let n = e.prototype;
                n.highlightLegendItem || (n.highlightLegendItem = t, c(s, "afterColorizeItem", i));
            };
        }(A || (A = {})), A;
    }), i(t, "Stock/Navigator/ChartNavigatorComposition.js", [
        t["Core/Globals.js"],
        t["Core/Utilities.js"]
    ], function(e, t) {
        let i;
        let { isTouchDevice: s } = e, { addEvent: n, merge: o, pick: r } = t, a = [];
        function l() {
            this.navigator && this.navigator.setBaseSeries(null, !1);
        }
        function h() {
            let e, t, i;
            let s = this.legend, n = this.navigator;
            if (n) {
                e = s && s.options, t = n.xAxis, i = n.yAxis;
                let { scrollbarHeight: o, scrollButtonSize: a } = n;
                this.inverted ? (n.left = n.opposite ? this.chartWidth - o - n.height : this.spacing[3] + o, n.top = this.plotTop + a) : (n.left = r(t.left, this.plotLeft + a), n.top = n.navigatorOptions.top || this.chartHeight - n.height - o - (this.scrollbar?.options.margin || 0) - this.spacing[2] - (this.rangeSelector && this.extraBottomMargin ? this.rangeSelector.getHeight() : 0) - (e && "bottom" === e.verticalAlign && "proximate" !== e.layout && e.enabled && !e.floating ? s.legendHeight + r(e.margin, 10) : 0) - (this.titleOffset ? this.titleOffset[2] : 0)), t && i && (this.inverted ? t.options.left = i.options.left = n.left : t.options.top = i.options.top = n.top, t.setAxisSize(), i.setAxisSize());
            }
        }
        function c(e) {
            !this.navigator && !this.scroller && (this.options.navigator.enabled || this.options.scrollbar.enabled) && (this.scroller = this.navigator = new i(this), r(e.redraw, !0) && this.redraw(e.animation));
        }
        function d() {
            let e = this.options;
            (e.navigator.enabled || e.scrollbar.enabled) && (this.scroller = this.navigator = new i(this));
        }
        function u() {
            let e = this.options, t = e.navigator, i = e.rangeSelector;
            if ((t && t.enabled || i && i.enabled) && (!s && "x" === this.zooming.type || s && "x" === this.zooming.pinchType)) return !1;
        }
        function p(e) {
            let t = e.navigator;
            if (t && e.xAxis[0]) {
                let i = e.xAxis[0].getExtremes();
                t.render(i.min, i.max);
            }
        }
        function g(e) {
            let t = e.options.navigator || {}, i = e.options.scrollbar || {};
            !this.navigator && !this.scroller && (t.enabled || i.enabled) && (o(!0, this.options.navigator, t), o(!0, this.options.scrollbar, i), delete e.options.navigator, delete e.options.scrollbar);
        }
        return {
            compose: function(e, s) {
                if (t.pushUnique(a, e)) {
                    let t = e.prototype;
                    i = s, t.callbacks.push(p), n(e, "afterAddSeries", l), n(e, "afterSetChartSize", h), n(e, "afterUpdate", c), n(e, "beforeRender", d), n(e, "beforeShowResetZoom", u), n(e, "update", g);
                }
            }
        };
    }), i(t, "Core/Axis/NavigatorAxisComposition.js", [
        t["Core/Globals.js"],
        t["Core/Utilities.js"]
    ], function(e, t) {
        let { isTouchDevice: i } = e, { addEvent: s, correctFloat: n, defined: o, isNumber: r, pick: a } = t;
        function l() {
            this.navigatorAxis || (this.navigatorAxis = new c(this));
        }
        function h(e) {
            let t;
            let s = this.chart, n = s.options, r = n.navigator, a = this.navigatorAxis, l = s.zooming.pinchType, h = n.rangeSelector, c = s.zooming.type;
            if (this.isXAxis && (r?.enabled || h?.enabled)) {
                if ("y" === c && "zoom" === e.trigger) t = !1;
                else if (("zoom" === e.trigger && "xy" === c || i && "xy" === l) && this.options.range) {
                    let t = a.previousZoom;
                    o(e.min) ? a.previousZoom = [
                        this.min,
                        this.max
                    ] : t && (e.min = t[0], e.max = t[1], a.previousZoom = void 0);
                }
            }
            void 0 !== t && e.preventDefault();
        }
        class c {
            static compose(e) {
                e.keepProps.includes("navigatorAxis") || (e.keepProps.push("navigatorAxis"), s(e, "init", l), s(e, "setExtremes", h));
            }
            constructor(e){
                this.axis = e;
            }
            destroy() {
                this.axis = void 0;
            }
            toFixedRange(e, t, i, s) {
                let l = this.axis, h = l.chart, c = a(l.ordinal?.convertOverscroll(l.options.overscroll), 0), d = a(i, l.translate(e, !0, !l.horiz)), u = a(s, l.translate(t, !0, !l.horiz)), p = h && h.fixedRange, g = (l.pointRange || 0) / 2;
                if (o(i) || (d = n(d + g)), o(s) || (u = n(u - g)), p && l.dataMin && l.dataMax) {
                    let e = l.dataMax + c;
                    u >= e && (d = n(e - p), u = n(e)), d <= l.dataMin && (u = n(l.dataMin + p));
                }
                return r(d) && r(u) || (d = u = void 0), {
                    min: d,
                    max: u
                };
            }
        }
        return c;
    }), i(t, "Stock/Navigator/NavigatorDefaults.js", [
        t["Core/Color/Color.js"],
        t["Core/Series/SeriesRegistry.js"]
    ], function(e, t) {
        let { parse: i } = e, { seriesTypes: s } = t;
        return {
            height: 40,
            margin: 25,
            maskInside: !0,
            handles: {
                width: 7,
                height: 15,
                symbols: [
                    "navigator-handle",
                    "navigator-handle"
                ],
                enabled: !0,
                lineWidth: 1,
                backgroundColor: "#f2f2f2",
                borderColor: "#999999"
            },
            maskFill: i("#667aff").setOpacity(.3).get(),
            outlineColor: "#999999",
            outlineWidth: 1,
            series: {
                type: void 0 === s.areaspline ? "line" : "areaspline",
                fillOpacity: .05,
                lineWidth: 1,
                compare: null,
                sonification: {
                    enabled: !1
                },
                dataGrouping: {
                    approximation: "average",
                    enabled: !0,
                    groupPixelWidth: 2,
                    firstAnchor: "firstPoint",
                    anchor: "middle",
                    lastAnchor: "lastPoint",
                    units: [
                        [
                            "millisecond",
                            [
                                1,
                                2,
                                5,
                                10,
                                20,
                                25,
                                50,
                                100,
                                200,
                                500
                            ]
                        ],
                        [
                            "second",
                            [
                                1,
                                2,
                                5,
                                10,
                                15,
                                30
                            ]
                        ],
                        [
                            "minute",
                            [
                                1,
                                2,
                                5,
                                10,
                                15,
                                30
                            ]
                        ],
                        [
                            "hour",
                            [
                                1,
                                2,
                                3,
                                4,
                                6,
                                8,
                                12
                            ]
                        ],
                        [
                            "day",
                            [
                                1,
                                2,
                                3,
                                4
                            ]
                        ],
                        [
                            "week",
                            [
                                1,
                                2,
                                3
                            ]
                        ],
                        [
                            "month",
                            [
                                1,
                                3,
                                6
                            ]
                        ],
                        [
                            "year",
                            null
                        ]
                    ]
                },
                dataLabels: {
                    enabled: !1,
                    zIndex: 2
                },
                id: "highcharts-navigator-series",
                className: "highcharts-navigator-series",
                lineColor: null,
                marker: {
                    enabled: !1
                },
                threshold: null
            },
            xAxis: {
                className: "highcharts-navigator-xaxis",
                tickLength: 0,
                lineWidth: 0,
                gridLineColor: "#e6e6e6",
                gridLineWidth: 1,
                tickPixelInterval: 200,
                labels: {
                    align: "left",
                    style: {
                        color: "#000000",
                        fontSize: "0.7em",
                        opacity: .6,
                        textOutline: "2px contrast"
                    },
                    x: 3,
                    y: -4
                },
                crosshair: !1
            },
            yAxis: {
                className: "highcharts-navigator-yaxis",
                gridLineWidth: 0,
                startOnTick: !1,
                endOnTick: !1,
                minPadding: .1,
                maxPadding: .1,
                labels: {
                    enabled: !1
                },
                crosshair: !1,
                title: {
                    text: null
                },
                tickLength: 0,
                tickWidth: 0
            }
        };
    }), i(t, "Stock/Navigator/NavigatorSymbols.js", [], function() {
        return {
            "navigator-handle": function(e, t, i, s, n = {}) {
                let o = n.width ? n.width / 2 : i, r = Math.round(o / 3) + .5;
                return [
                    [
                        "M",
                        -o - 1,
                        .5
                    ],
                    [
                        "L",
                        o,
                        .5
                    ],
                    [
                        "L",
                        o,
                        (s = n.height || s) + .5
                    ],
                    [
                        "L",
                        -o - 1,
                        s + .5
                    ],
                    [
                        "L",
                        -o - 1,
                        .5
                    ],
                    [
                        "M",
                        -r,
                        4
                    ],
                    [
                        "L",
                        -r,
                        s - 3
                    ],
                    [
                        "M",
                        r - 1,
                        4
                    ],
                    [
                        "L",
                        r - 1,
                        s - 3
                    ]
                ];
            }
        };
    }), i(t, "Stock/Utilities/StockUtilities.js", [
        t["Core/Utilities.js"]
    ], function(e) {
        let { defined: t } = e;
        return {
            setFixedRange: function(e) {
                let i = this.xAxis[0];
                t(i.dataMax) && t(i.dataMin) && e ? this.fixedRange = Math.min(e, i.dataMax - i.dataMin) : this.fixedRange = e;
            }
        };
    }), i(t, "Stock/Navigator/NavigatorComposition.js", [
        t["Core/Defaults.js"],
        t["Core/Globals.js"],
        t["Core/Axis/NavigatorAxisComposition.js"],
        t["Stock/Navigator/NavigatorDefaults.js"],
        t["Stock/Navigator/NavigatorSymbols.js"],
        t["Core/Renderer/RendererRegistry.js"],
        t["Stock/Utilities/StockUtilities.js"],
        t["Core/Utilities.js"]
    ], function(e, t, i, s, n, o, r, a) {
        let { setOptions: l } = e, { composed: h } = t, { getRendererType: c } = o, { setFixedRange: d } = r, { addEvent: u, extend: p, pushUnique: g } = a;
        function m() {
            this.chart.navigator && !this.options.isInternal && this.chart.navigator.setBaseSeries(null, !1);
        }
        return {
            compose: function(e, t, o) {
                i.compose(t), g(h, "Navigator") && (e.prototype.setFixedRange = d, p(c().prototype.symbols, n), u(o, "afterUpdate", m), l({
                    navigator: s
                }));
            }
        };
    }), i(t, "Core/Axis/ScrollbarAxis.js", [
        t["Core/Globals.js"],
        t["Core/Utilities.js"]
    ], function(e, t) {
        var i;
        let { composed: s } = e, { addEvent: n, defined: o, pick: r, pushUnique: a } = t;
        return function(e) {
            let t;
            function i(e) {
                let t = r(e.options && e.options.min, e.min), i = r(e.options && e.options.max, e.max);
                return {
                    axisMin: t,
                    axisMax: i,
                    scrollMin: o(e.dataMin) ? Math.min(t, e.min, e.dataMin, r(e.threshold, 1 / 0)) : t,
                    scrollMax: o(e.dataMax) ? Math.max(i, e.max, e.dataMax, r(e.threshold, -1 / 0)) : i
                };
            }
            function l() {
                let e = this.scrollbar, t = e && !e.options.opposite, i = this.horiz ? 2 : t ? 3 : 1;
                e && (this.chart.scrollbarsOffsets = [
                    0,
                    0
                ], this.chart.axisOffset[i] += e.size + (e.options.margin || 0));
            }
            function h() {
                let e = this;
                e.options && e.options.scrollbar && e.options.scrollbar.enabled && (e.options.scrollbar.vertical = !e.horiz, e.options.startOnTick = e.options.endOnTick = !1, e.scrollbar = new t(e.chart.renderer, e.options.scrollbar, e.chart), n(e.scrollbar, "changed", function(t) {
                    let s, n;
                    let { axisMin: r, axisMax: a, scrollMin: l, scrollMax: h } = i(e), c = h - l;
                    if (o(r) && o(a)) {
                        if (e.horiz && !e.reversed || !e.horiz && e.reversed ? (s = l + c * this.to, n = l + c * this.from) : (s = l + c * (1 - this.from), n = l + c * (1 - this.to)), this.shouldUpdateExtremes(t.DOMType)) {
                            let i = "mousemove" !== t.DOMType && "touchmove" !== t.DOMType && void 0;
                            e.setExtremes(n, s, !0, i, t);
                        } else this.setRange(this.from, this.to);
                    }
                }));
            }
            function c() {
                let e, t, s;
                let { scrollMin: n, scrollMax: r } = i(this), a = this.scrollbar, l = this.axisTitleMargin + (this.titleOffset || 0), h = this.chart.scrollbarsOffsets, c = this.options.margin || 0;
                if (a && h) {
                    if (this.horiz) this.opposite || (h[1] += l), a.position(this.left, this.top + this.height + 2 + h[1] - (this.opposite ? c : 0), this.width, this.height), this.opposite || (h[1] += c), e = 1;
                    else {
                        let t;
                        this.opposite && (h[0] += l), t = a.options.opposite ? this.left + this.width + 2 + h[0] - (this.opposite ? 0 : c) : this.opposite ? 0 : c, a.position(t, this.top, this.width, this.height), this.opposite && (h[0] += c), e = 0;
                    }
                    h[e] += a.size + (a.options.margin || 0), isNaN(n) || isNaN(r) || !o(this.min) || !o(this.max) || this.min === this.max ? a.setRange(0, 1) : (t = (this.min - n) / (r - n), s = (this.max - n) / (r - n), this.horiz && !this.reversed || !this.horiz && this.reversed ? a.setRange(t, s) : a.setRange(1 - s, 1 - t));
                }
            }
            e.compose = function(e, i) {
                a(s, "Axis.Scrollbar") && (t = i, n(e, "afterGetOffset", l), n(e, "afterInit", h), n(e, "afterRender", c));
            };
        }(i || (i = {})), i;
    }), i(t, "Stock/Scrollbar/ScrollbarDefaults.js", [], function() {
        return {
            height: 10,
            barBorderRadius: 5,
            buttonBorderRadius: 0,
            buttonsEnabled: !1,
            liveRedraw: void 0,
            margin: void 0,
            minWidth: 6,
            opposite: !0,
            step: .2,
            zIndex: 3,
            barBackgroundColor: "#cccccc",
            barBorderWidth: 0,
            barBorderColor: "#cccccc",
            buttonArrowColor: "#333333",
            buttonBackgroundColor: "#e6e6e6",
            buttonBorderColor: "#cccccc",
            buttonBorderWidth: 1,
            rifleColor: "none",
            trackBackgroundColor: "rgba(255, 255, 255, 0.001)",
            trackBorderColor: "#cccccc",
            trackBorderRadius: 5,
            trackBorderWidth: 1
        };
    }), i(t, "Stock/Scrollbar/Scrollbar.js", [
        t["Core/Defaults.js"],
        t["Core/Globals.js"],
        t["Core/Axis/ScrollbarAxis.js"],
        t["Stock/Scrollbar/ScrollbarDefaults.js"],
        t["Core/Utilities.js"]
    ], function(e, t, i, s, n) {
        let { defaultOptions: o } = e, { addEvent: r, correctFloat: a, defined: l, destroyObjectProperties: h, fireEvent: c, merge: d, pick: u, removeEvent: p } = n;
        class g {
            static compose(e) {
                i.compose(e, g);
            }
            static swapXY(e, t) {
                return t && e.forEach((e)=>{
                    let t;
                    let i = e.length;
                    for(let s = 0; s < i; s += 2)"number" == typeof (t = e[s + 1]) && (e[s + 1] = e[s + 2], e[s + 2] = t);
                }), e;
            }
            constructor(e, t, i){
                this._events = [], this.chartX = 0, this.chartY = 0, this.from = 0, this.scrollbarButtons = [], this.scrollbarLeft = 0, this.scrollbarStrokeWidth = 1, this.scrollbarTop = 0, this.size = 0, this.to = 0, this.trackBorderWidth = 1, this.x = 0, this.y = 0, this.init(e, t, i);
            }
            addEvents() {
                let e = this.options.inverted ? [
                    1,
                    0
                ] : [
                    0,
                    1
                ], t = this.scrollbarButtons, i = this.scrollbarGroup.element, s = this.track.element, n = this.mouseDownHandler.bind(this), o = this.mouseMoveHandler.bind(this), a = this.mouseUpHandler.bind(this), l = [
                    [
                        t[e[0]].element,
                        "click",
                        this.buttonToMinClick.bind(this)
                    ],
                    [
                        t[e[1]].element,
                        "click",
                        this.buttonToMaxClick.bind(this)
                    ],
                    [
                        s,
                        "click",
                        this.trackClick.bind(this)
                    ],
                    [
                        i,
                        "mousedown",
                        n
                    ],
                    [
                        i.ownerDocument,
                        "mousemove",
                        o
                    ],
                    [
                        i.ownerDocument,
                        "mouseup",
                        a
                    ],
                    [
                        i,
                        "touchstart",
                        n
                    ],
                    [
                        i.ownerDocument,
                        "touchmove",
                        o
                    ],
                    [
                        i.ownerDocument,
                        "touchend",
                        a
                    ]
                ];
                l.forEach(function(e) {
                    r.apply(null, e);
                }), this._events = l;
            }
            buttonToMaxClick(e) {
                let t = (this.to - this.from) * u(this.options.step, .2);
                this.updatePosition(this.from + t, this.to + t), c(this, "changed", {
                    from: this.from,
                    to: this.to,
                    trigger: "scrollbar",
                    DOMEvent: e
                });
            }
            buttonToMinClick(e) {
                let t = a(this.to - this.from) * u(this.options.step, .2);
                this.updatePosition(a(this.from - t), a(this.to - t)), c(this, "changed", {
                    from: this.from,
                    to: this.to,
                    trigger: "scrollbar",
                    DOMEvent: e
                });
            }
            cursorToScrollbarPosition(e) {
                let t = this.options, i = t.minWidth > this.calculatedWidth ? t.minWidth : 0;
                return {
                    chartX: (e.chartX - this.x - this.xOffset) / (this.barWidth - i),
                    chartY: (e.chartY - this.y - this.yOffset) / (this.barWidth - i)
                };
            }
            destroy() {
                let e = this, t = e.chart.scroller;
                e.removeEvents(), [
                    "track",
                    "scrollbarRifles",
                    "scrollbar",
                    "scrollbarGroup",
                    "group"
                ].forEach(function(t) {
                    e[t] && e[t].destroy && (e[t] = e[t].destroy());
                }), t && e === t.scrollbar && (t.scrollbar = null, h(t.scrollbarButtons));
            }
            drawScrollbarButton(e) {
                let t = this.renderer, i = this.scrollbarButtons, s = this.options, n = this.size, o = t.g().add(this.group);
                if (i.push(o), s.buttonsEnabled) {
                    let r = t.rect().addClass("highcharts-scrollbar-button").add(o);
                    this.chart.styledMode || r.attr({
                        stroke: s.buttonBorderColor,
                        "stroke-width": s.buttonBorderWidth,
                        fill: s.buttonBackgroundColor
                    }), r.attr(r.crisp({
                        x: -0.5,
                        y: -0.5,
                        width: n + 1,
                        height: n + 1,
                        r: s.buttonBorderRadius
                    }, r.strokeWidth()));
                    let a = t.path(g.swapXY([
                        [
                            "M",
                            n / 2 + (e ? -1 : 1),
                            n / 2 - 3
                        ],
                        [
                            "L",
                            n / 2 + (e ? -1 : 1),
                            n / 2 + 3
                        ],
                        [
                            "L",
                            n / 2 + (e ? 2 : -2),
                            n / 2
                        ]
                    ], s.vertical)).addClass("highcharts-scrollbar-arrow").add(i[e]);
                    this.chart.styledMode || a.attr({
                        fill: s.buttonArrowColor
                    });
                }
            }
            init(e, t, i) {
                this.scrollbarButtons = [], this.renderer = e, this.userOptions = t, this.options = d(s, o.scrollbar, t), this.options.margin = u(this.options.margin, 10), this.chart = i, this.size = u(this.options.size, this.options.height), t.enabled && (this.render(), this.addEvents());
            }
            mouseDownHandler(e) {
                let t = this.chart.pointer?.normalize(e) || e, i = this.cursorToScrollbarPosition(t);
                this.chartX = i.chartX, this.chartY = i.chartY, this.initPositions = [
                    this.from,
                    this.to
                ], this.grabbedCenter = !0;
            }
            mouseMoveHandler(e) {
                let t;
                let i = this.chart.pointer?.normalize(e) || e, s = this.options.vertical ? "chartY" : "chartX", n = this.initPositions || [];
                this.grabbedCenter && (!e.touches || 0 !== e.touches[0][s]) && (t = this.cursorToScrollbarPosition(i)[s] - this[s], this.hasDragged = !0, this.updatePosition(n[0] + t, n[1] + t), this.hasDragged && c(this, "changed", {
                    from: this.from,
                    to: this.to,
                    trigger: "scrollbar",
                    DOMType: e.type,
                    DOMEvent: e
                }));
            }
            mouseUpHandler(e) {
                this.hasDragged && c(this, "changed", {
                    from: this.from,
                    to: this.to,
                    trigger: "scrollbar",
                    DOMType: e.type,
                    DOMEvent: e
                }), this.grabbedCenter = this.hasDragged = this.chartX = this.chartY = null;
            }
            position(e, t, i, s) {
                let { buttonsEnabled: n, margin: o = 0, vertical: r } = this.options, a = this.rendered ? "animate" : "attr", l = s, h = 0;
                this.group.show(), this.x = e, this.y = t + this.trackBorderWidth, this.width = i, this.height = s, this.xOffset = l, this.yOffset = h, r ? (this.width = this.yOffset = i = h = this.size, this.xOffset = l = 0, this.yOffset = h = n ? this.size : 0, this.barWidth = s - (n ? 2 * i : 0), this.x = e += o) : (this.height = s = this.size, this.xOffset = l = n ? this.size : 0, this.barWidth = i - (n ? 2 * s : 0), this.y = this.y + o), this.group[a]({
                    translateX: e,
                    translateY: this.y
                }), this.track[a]({
                    width: i,
                    height: s
                }), this.scrollbarButtons[1][a]({
                    translateX: r ? 0 : i - l,
                    translateY: r ? s - h : 0
                });
            }
            removeEvents() {
                this._events.forEach(function(e) {
                    p.apply(null, e);
                }), this._events.length = 0;
            }
            render() {
                let e = this.renderer, t = this.options, i = this.size, s = this.chart.styledMode, n = e.g("scrollbar").attr({
                    zIndex: t.zIndex
                }).hide().add();
                this.group = n, this.track = e.rect().addClass("highcharts-scrollbar-track").attr({
                    r: t.trackBorderRadius || 0,
                    height: i,
                    width: i
                }).add(n), s || this.track.attr({
                    fill: t.trackBackgroundColor,
                    stroke: t.trackBorderColor,
                    "stroke-width": t.trackBorderWidth
                });
                let o = this.trackBorderWidth = this.track.strokeWidth();
                this.track.attr({
                    x: -o % 2 / 2,
                    y: -o % 2 / 2
                }), this.scrollbarGroup = e.g().add(n), this.scrollbar = e.rect().addClass("highcharts-scrollbar-thumb").attr({
                    height: i - o,
                    width: i - o,
                    r: t.barBorderRadius || 0
                }).add(this.scrollbarGroup), this.scrollbarRifles = e.path(g.swapXY([
                    [
                        "M",
                        -3,
                        i / 4
                    ],
                    [
                        "L",
                        -3,
                        2 * i / 3
                    ],
                    [
                        "M",
                        0,
                        i / 4
                    ],
                    [
                        "L",
                        0,
                        2 * i / 3
                    ],
                    [
                        "M",
                        3,
                        i / 4
                    ],
                    [
                        "L",
                        3,
                        2 * i / 3
                    ]
                ], t.vertical)).addClass("highcharts-scrollbar-rifles").add(this.scrollbarGroup), s || (this.scrollbar.attr({
                    fill: t.barBackgroundColor,
                    stroke: t.barBorderColor,
                    "stroke-width": t.barBorderWidth
                }), this.scrollbarRifles.attr({
                    stroke: t.rifleColor,
                    "stroke-width": 1
                })), this.scrollbarStrokeWidth = this.scrollbar.strokeWidth(), this.scrollbarGroup.translate(-this.scrollbarStrokeWidth % 2 / 2, -this.scrollbarStrokeWidth % 2 / 2), this.drawScrollbarButton(0), this.drawScrollbarButton(1);
            }
            setRange(e, t) {
                let i, s;
                let n = this.options, o = n.vertical, r = n.minWidth, h = this.barWidth, c = !this.rendered || this.hasDragged || this.chart.navigator && this.chart.navigator.hasDragged ? "attr" : "animate";
                if (!l(h)) return;
                let d = h * Math.min(t, 1);
                i = Math.ceil(h * (e = Math.max(e, 0))), this.calculatedWidth = s = a(d - i), s < r && (i = (h - r + s) * e, s = r);
                let u = Math.floor(i + this.xOffset + this.yOffset), p = s / 2 - .5;
                this.from = e, this.to = t, o ? (this.scrollbarGroup[c]({
                    translateY: u
                }), this.scrollbar[c]({
                    height: s
                }), this.scrollbarRifles[c]({
                    translateY: p
                }), this.scrollbarTop = u, this.scrollbarLeft = 0) : (this.scrollbarGroup[c]({
                    translateX: u
                }), this.scrollbar[c]({
                    width: s
                }), this.scrollbarRifles[c]({
                    translateX: p
                }), this.scrollbarLeft = u, this.scrollbarTop = 0), s <= 12 ? this.scrollbarRifles.hide() : this.scrollbarRifles.show(), !1 === n.showFull && (e <= 0 && t >= 1 ? this.group.hide() : this.group.show()), this.rendered = !0;
            }
            shouldUpdateExtremes(e) {
                return u(this.options.liveRedraw, t.svg && !t.isTouchDevice && !this.chart.boosted) || "mouseup" === e || "touchend" === e || !l(e);
            }
            trackClick(e) {
                let t = this.chart.pointer?.normalize(e) || e, i = this.to - this.from, s = this.y + this.scrollbarTop, n = this.x + this.scrollbarLeft;
                this.options.vertical && t.chartY > s || !this.options.vertical && t.chartX > n ? this.updatePosition(this.from + i, this.to + i) : this.updatePosition(this.from - i, this.to - i), c(this, "changed", {
                    from: this.from,
                    to: this.to,
                    trigger: "scrollbar",
                    DOMEvent: e
                });
            }
            update(e) {
                this.destroy(), this.init(this.chart.renderer, d(!0, this.options, e), this.chart);
            }
            updatePosition(e, t) {
                t > 1 && (e = a(1 - a(t - e)), t = 1), e < 0 && (t = a(t - e), e = 0), this.from = e, this.to = t;
            }
        }
        return g.defaultOptions = s, o.scrollbar = d(!0, g.defaultOptions, o.scrollbar), g;
    }), i(t, "Stock/Navigator/Navigator.js", [
        t["Core/Axis/Axis.js"],
        t["Stock/Navigator/ChartNavigatorComposition.js"],
        t["Core/Defaults.js"],
        t["Core/Globals.js"],
        t["Core/Axis/NavigatorAxisComposition.js"],
        t["Stock/Navigator/NavigatorComposition.js"],
        t["Stock/Scrollbar/Scrollbar.js"],
        t["Core/Utilities.js"]
    ], function(e, t, i, s, n, o, r, a) {
        let { defaultOptions: l } = i, { isTouchDevice: h } = s, { addEvent: c, clamp: d, correctFloat: u, defined: p, destroyObjectProperties: g, erase: m, extend: b, find: y, fireEvent: f, isArray: x, isNumber: v, merge: A, pick: C, removeEvent: w, splat: E } = a;
        function T(e, ...t) {
            let i = [].filter.call(t, v);
            if (i.length) return Math[e].apply(0, i);
        }
        class M {
            static compose(e, i, s) {
                t.compose(e, M), o.compose(e, i, s);
            }
            constructor(e){
                this.scrollbarHeight = 0, this.init(e);
            }
            drawHandle(e, t, i, s) {
                let n = this.navigatorOptions.handles.height;
                this.handles[t][s](i ? {
                    translateX: Math.round(this.left + this.height / 2),
                    translateY: Math.round(this.top + parseInt(e, 10) + .5 - n)
                } : {
                    translateX: Math.round(this.left + parseInt(e, 10)),
                    translateY: Math.round(this.top + this.height / 2 - n / 2 - 1)
                });
            }
            drawOutline(e, t, i, s) {
                let n = this.navigatorOptions.maskInside, o = this.outline.strokeWidth(), r = o / 2, a = o % 2 / 2, l = this.scrollButtonSize, h = this.size, c = this.top, d = this.height, u = c - r, p = c + d, g = this.left, m, b;
                i ? (m = c + t + a, t = c + e + a, b = [
                    [
                        "M",
                        g + d,
                        c - l - a
                    ],
                    [
                        "L",
                        g + d,
                        m
                    ],
                    [
                        "L",
                        g,
                        m
                    ],
                    [
                        "M",
                        g,
                        t
                    ],
                    [
                        "L",
                        g + d,
                        t
                    ],
                    [
                        "L",
                        g + d,
                        c + h + l
                    ]
                ], n && b.push([
                    "M",
                    g + d,
                    m - r
                ], [
                    "L",
                    g + d,
                    t + r
                ])) : (g -= l, e += g + l - a, t += g + l - a, b = [
                    [
                        "M",
                        g,
                        u
                    ],
                    [
                        "L",
                        e,
                        u
                    ],
                    [
                        "L",
                        e,
                        p
                    ],
                    [
                        "M",
                        t,
                        p
                    ],
                    [
                        "L",
                        t,
                        u
                    ],
                    [
                        "L",
                        g + h + 2 * l,
                        c + r
                    ]
                ], n && b.push([
                    "M",
                    e - r,
                    u
                ], [
                    "L",
                    t + r,
                    u
                ])), this.outline[s]({
                    d: b
                });
            }
            drawMasks(e, t, i, s) {
                let n, o, r, a;
                let l = this.left, h = this.top, c = this.height;
                i ? (r = [
                    l,
                    l,
                    l
                ], a = [
                    h,
                    h + e,
                    h + t
                ], o = [
                    c,
                    c,
                    c
                ], n = [
                    e,
                    t - e,
                    this.size - t
                ]) : (r = [
                    l,
                    l + e,
                    l + t
                ], a = [
                    h,
                    h,
                    h
                ], o = [
                    e,
                    t - e,
                    this.size - t
                ], n = [
                    c,
                    c,
                    c
                ]), this.shades.forEach((e, t)=>{
                    e[s]({
                        x: r[t],
                        y: a[t],
                        width: o[t],
                        height: n[t]
                    });
                });
            }
            renderElements() {
                let e = this, t = e.navigatorOptions, i = t.maskInside, s = e.chart, n = s.inverted, o = s.renderer, r = {
                    cursor: n ? "ns-resize" : "ew-resize"
                }, a = e.navigatorGroup = o.g("navigator").attr({
                    zIndex: 8,
                    visibility: "hidden"
                }).add();
                if ([
                    !i,
                    i,
                    !i
                ].forEach((i, n)=>{
                    let l = o.rect().addClass("highcharts-navigator-mask" + (1 === n ? "-inside" : "-outside")).add(a);
                    s.styledMode || (l.attr({
                        fill: i ? t.maskFill : "rgba(0,0,0,0)"
                    }), 1 === n && l.css(r)), e.shades[n] = l;
                }), e.outline = o.path().addClass("highcharts-navigator-outline").add(a), s.styledMode || e.outline.attr({
                    "stroke-width": t.outlineWidth,
                    stroke: t.outlineColor
                }), t.handles && t.handles.enabled) {
                    let i = t.handles, { height: n, width: l } = i;
                    [
                        0,
                        1
                    ].forEach((t)=>{
                        e.handles[t] = o.symbol(i.symbols[t], -l / 2 - 1, 0, l, n, i), s.inverted && e.handles[t].attr({
                            rotation: 90,
                            rotationOriginX: Math.floor(-l / 2),
                            rotationOriginY: (n + l) / 2
                        }), e.handles[t].attr({
                            zIndex: 7 - t
                        }).addClass("highcharts-navigator-handle highcharts-navigator-handle-" + [
                            "left",
                            "right"
                        ][t]).add(a), s.styledMode || e.handles[t].attr({
                            fill: i.backgroundColor,
                            stroke: i.borderColor,
                            "stroke-width": i.lineWidth
                        }).css(r);
                    });
                }
            }
            update(e) {
                (this.series || []).forEach((e)=>{
                    e.baseSeries && delete e.baseSeries.navigatorSeries;
                }), this.destroy(), A(!0, this.chart.options.navigator, e), this.init(this.chart);
            }
            render(e, t, i, s) {
                let n = this.chart, o = this.xAxis, r = o.pointRange || 0, a = o.navigatorAxis.fake ? n.xAxis[0] : o, l = this.navigatorEnabled, h = this.rendered, c = n.inverted, g = n.xAxis[0].minRange, m = n.xAxis[0].options.maxRange, b = this.scrollButtonSize, y, x, A, w = this.scrollbarHeight, E, T;
                if (this.hasDragged && !p(i)) return;
                if (e = u(e - r / 2), t = u(t + r / 2), !v(e) || !v(t)) {
                    if (!h) return;
                    i = 0, s = C(o.width, a.width);
                }
                this.left = C(o.left, n.plotLeft + b + (c ? n.plotWidth : 0));
                let M = this.size = E = C(o.len, (c ? n.plotHeight : n.plotWidth) - 2 * b);
                y = c ? w : E + 2 * b, i = C(i, o.toPixels(e, !0)), s = C(s, o.toPixels(t, !0)), v(i) && Math.abs(i) !== 1 / 0 || (i = 0, s = y);
                let S = o.toValue(i, !0), k = o.toValue(s, !0), P = Math.abs(u(k - S));
                P < g ? this.grabbedLeft ? i = o.toPixels(k - g - r, !0) : this.grabbedRight && (s = o.toPixels(S + g + r, !0)) : p(m) && u(P - r) > m && (this.grabbedLeft ? i = o.toPixels(k - m - r, !0) : this.grabbedRight && (s = o.toPixels(S + m + r, !0))), this.zoomedMax = d(Math.max(i, s), 0, M), this.zoomedMin = d(this.fixedWidth ? this.zoomedMax - this.fixedWidth : Math.min(i, s), 0, M), this.range = this.zoomedMax - this.zoomedMin, M = Math.round(this.zoomedMax);
                let D = Math.round(this.zoomedMin);
                l && (this.navigatorGroup.attr({
                    visibility: "inherit"
                }), T = h && !this.hasDragged ? "animate" : "attr", this.drawMasks(D, M, c, T), this.drawOutline(D, M, c, T), this.navigatorOptions.handles.enabled && (this.drawHandle(D, 0, c, T), this.drawHandle(M, 1, c, T))), this.scrollbar && (c ? (A = this.top - b, x = this.left - w + (l || !a.opposite ? 0 : (a.titleOffset || 0) + a.axisTitleMargin), w = E + 2 * b) : (A = this.top + (l ? this.height : -w), x = this.left - b), this.scrollbar.position(x, A, y, w), this.scrollbar.setRange(this.zoomedMin / (E || 1), this.zoomedMax / (E || 1))), this.rendered = !0, f(this, "afterRender");
            }
            addMouseEvents() {
                let e = this, t = e.chart, i = t.container, s = [], n, o;
                e.mouseMoveHandler = n = function(t) {
                    e.onMouseMove(t);
                }, e.mouseUpHandler = o = function(t) {
                    e.onMouseUp(t);
                }, (s = e.getPartsEvents("mousedown")).push(c(t.renderTo, "mousemove", n), c(i.ownerDocument, "mouseup", o), c(t.renderTo, "touchmove", n), c(i.ownerDocument, "touchend", o)), s.concat(e.getPartsEvents("touchstart")), e.eventsToUnbind = s, e.series && e.series[0] && s.push(c(e.series[0].xAxis, "foundExtremes", function() {
                    t.navigator.modifyNavigatorAxisExtremes();
                }));
            }
            getPartsEvents(e) {
                let t = this, i = [];
                return [
                    "shades",
                    "handles"
                ].forEach(function(s) {
                    t[s].forEach(function(n, o) {
                        i.push(c(n.element, e, function(e) {
                            t[s + "Mousedown"](e, o);
                        }));
                    });
                }), i;
            }
            shadesMousedown(e, t) {
                e = this.chart.pointer?.normalize(e) || e;
                let i = this.chart, s = this.xAxis, n = this.zoomedMin, o = this.size, r = this.range, a = this.left, l = e.chartX, h, c, d, u;
                i.inverted && (l = e.chartY, a = this.top), 1 === t ? (this.grabbedCenter = l, this.fixedWidth = r, this.dragOffset = l - n) : (u = l - a - r / 2, 0 === t ? u = Math.max(0, u) : 2 === t && u + r >= o && (u = o - r, this.reversedExtremes ? (u -= r, c = this.getUnionExtremes().dataMin) : h = this.getUnionExtremes().dataMax), u !== n && (this.fixedWidth = r, p((d = s.navigatorAxis.toFixedRange(u, u + r, c, h)).min) && f(this, "setRange", {
                    min: Math.min(d.min, d.max),
                    max: Math.max(d.min, d.max),
                    redraw: !0,
                    eventArguments: {
                        trigger: "navigator"
                    }
                })));
            }
            handlesMousedown(e, t) {
                e = this.chart.pointer?.normalize(e) || e;
                let i = this.chart, s = i.xAxis[0], n = this.reversedExtremes;
                0 === t ? (this.grabbedLeft = !0, this.otherHandlePos = this.zoomedMax, this.fixedExtreme = n ? s.min : s.max) : (this.grabbedRight = !0, this.otherHandlePos = this.zoomedMin, this.fixedExtreme = n ? s.max : s.min), i.setFixedRange(void 0);
            }
            onMouseMove(e) {
                let t = this, i = t.chart, s = t.navigatorSize, n = t.range, o = t.dragOffset, r = i.inverted, a = t.left, l;
                (!e.touches || 0 !== e.touches[0].pageX) && (l = (e = i.pointer?.normalize(e) || e).chartX, r && (a = t.top, l = e.chartY), t.grabbedLeft ? (t.hasDragged = !0, t.render(0, 0, l - a, t.otherHandlePos)) : t.grabbedRight ? (t.hasDragged = !0, t.render(0, 0, t.otherHandlePos, l - a)) : t.grabbedCenter && (t.hasDragged = !0, l < o ? l = o : l > s + o - n && (l = s + o - n), t.render(0, 0, l - o, l - o + n)), t.hasDragged && t.scrollbar && C(t.scrollbar.options.liveRedraw, !h && !this.chart.boosted) && (e.DOMType = e.type, setTimeout(function() {
                    t.onMouseUp(e);
                }, 0)));
            }
            onMouseUp(e) {
                let t, i, s, n, o, r;
                let a = this.chart, l = this.xAxis, h = this.scrollbar, c = e.DOMEvent || e, d = a.inverted, u = this.rendered && !this.hasDragged ? "animate" : "attr";
                (this.hasDragged && (!h || !h.hasDragged) || "scrollbar" === e.trigger) && (s = this.getUnionExtremes(), this.zoomedMin === this.otherHandlePos ? n = this.fixedExtreme : this.zoomedMax === this.otherHandlePos && (o = this.fixedExtreme), this.zoomedMax === this.size && (o = this.reversedExtremes ? s.dataMin : s.dataMax), 0 === this.zoomedMin && (n = this.reversedExtremes ? s.dataMax : s.dataMin), p((r = l.navigatorAxis.toFixedRange(this.zoomedMin, this.zoomedMax, n, o)).min) && f(this, "setRange", {
                    min: Math.min(r.min, r.max),
                    max: Math.max(r.min, r.max),
                    redraw: !0,
                    animation: !this.hasDragged && null,
                    eventArguments: {
                        trigger: "navigator",
                        triggerOp: "navigator-drag",
                        DOMEvent: c
                    }
                })), "mousemove" !== e.DOMType && "touchmove" !== e.DOMType && (this.grabbedLeft = this.grabbedRight = this.grabbedCenter = this.fixedWidth = this.fixedExtreme = this.otherHandlePos = this.hasDragged = this.dragOffset = null), this.navigatorEnabled && v(this.zoomedMin) && v(this.zoomedMax) && (i = Math.round(this.zoomedMin), t = Math.round(this.zoomedMax), this.shades && this.drawMasks(i, t, d, u), this.outline && this.drawOutline(i, t, d, u), this.navigatorOptions.handles.enabled && Object.keys(this.handles).length === this.handles.length && (this.drawHandle(i, 0, d, u), this.drawHandle(t, 1, d, u)));
            }
            removeEvents() {
                this.eventsToUnbind && (this.eventsToUnbind.forEach(function(e) {
                    e();
                }), this.eventsToUnbind = void 0), this.removeBaseSeriesEvents();
            }
            removeBaseSeriesEvents() {
                let e = this.baseSeries || [];
                this.navigatorEnabled && e[0] && (!1 !== this.navigatorOptions.adaptToUpdatedData && e.forEach(function(e) {
                    w(e, "updatedData", this.updatedDataHandler);
                }, this), e[0].xAxis && w(e[0].xAxis, "foundExtremes", this.modifyBaseAxisExtremes));
            }
            init(t) {
                let i = t.options, s = i.navigator || {}, o = s.enabled, a = i.scrollbar || {}, l = a.enabled, h = o && s.height || 0, d = l && a.height || 0, u = a.buttonsEnabled && d || 0;
                this.handles = [], this.shades = [], this.chart = t, this.setBaseSeries(), this.height = h, this.scrollbarHeight = d, this.scrollButtonSize = u, this.scrollbarEnabled = l, this.navigatorEnabled = o, this.navigatorOptions = s, this.scrollbarOptions = a, this.opposite = C(s.opposite, !!(!o && t.inverted));
                let p = this, g = p.baseSeries, m = t.xAxis.length, b = t.yAxis.length, y = g && g[0] && g[0].xAxis || t.xAxis[0] || {
                    options: {}
                };
                if (t.isDirtyBox = !0, p.navigatorEnabled ? (p.xAxis = new e(t, A({
                    breaks: y.options.breaks,
                    ordinal: y.options.ordinal,
                    overscroll: y.options.overscroll
                }, s.xAxis, {
                    id: "navigator-x-axis",
                    yAxis: "navigator-y-axis",
                    type: "datetime",
                    index: m,
                    isInternal: !0,
                    offset: 0,
                    keepOrdinalPadding: !0,
                    startOnTick: !1,
                    endOnTick: !1,
                    minPadding: 0,
                    maxPadding: 0,
                    zoomEnabled: !1
                }, t.inverted ? {
                    offsets: [
                        u,
                        0,
                        -u,
                        0
                    ],
                    width: h
                } : {
                    offsets: [
                        0,
                        -u,
                        0,
                        u
                    ],
                    height: h
                }), "xAxis"), p.yAxis = new e(t, A(s.yAxis, {
                    id: "navigator-y-axis",
                    alignTicks: !1,
                    offset: 0,
                    index: b,
                    isInternal: !0,
                    reversed: C(s.yAxis && s.yAxis.reversed, t.yAxis[0] && t.yAxis[0].reversed, !1),
                    zoomEnabled: !1
                }, t.inverted ? {
                    width: h
                } : {
                    height: h
                }), "yAxis"), g || s.series.data ? p.updateNavigatorSeries(!1) : 0 === t.series.length && (p.unbindRedraw = c(t, "beforeRedraw", function() {
                    t.series.length > 0 && !p.series && (p.setBaseSeries(), p.unbindRedraw());
                })), p.reversedExtremes = t.inverted && !p.xAxis.reversed || !t.inverted && p.xAxis.reversed, p.renderElements(), p.addMouseEvents()) : (p.xAxis = {
                    chart: t,
                    navigatorAxis: {
                        fake: !0
                    },
                    translate: function(e, i) {
                        let s = t.xAxis[0], n = s.getExtremes(), o = s.len - 2 * u, r = T("min", s.options.min, n.dataMin), a = T("max", s.options.max, n.dataMax) - r;
                        return i ? e * a / o + r : o * (e - r) / a;
                    },
                    toPixels: function(e) {
                        return this.translate(e);
                    },
                    toValue: function(e) {
                        return this.translate(e, !0);
                    }
                }, p.xAxis.navigatorAxis.axis = p.xAxis, p.xAxis.navigatorAxis.toFixedRange = n.prototype.toFixedRange.bind(p.xAxis.navigatorAxis)), t.options.scrollbar.enabled) {
                    let e = A(t.options.scrollbar, {
                        vertical: t.inverted
                    });
                    !v(e.margin) && p.navigatorEnabled && (e.margin = t.inverted ? -3 : 3), t.scrollbar = p.scrollbar = new r(t.renderer, e, t), c(p.scrollbar, "changed", function(e) {
                        let t = p.size, i = t * this.to, s = t * this.from;
                        p.hasDragged = p.scrollbar.hasDragged, p.render(0, 0, s, i), this.shouldUpdateExtremes(e.DOMType) && setTimeout(function() {
                            p.onMouseUp(e);
                        });
                    });
                }
                p.addBaseSeriesEvents(), p.addChartEvents();
            }
            getUnionExtremes(e) {
                let t;
                let i = this.chart.xAxis[0], s = this.xAxis, n = s.options, o = i.options;
                return e && null === i.dataMin || (t = {
                    dataMin: C(n && n.min, T("min", o.min, i.dataMin, s.dataMin, s.min)),
                    dataMax: C(n && n.max, T("max", o.max, i.dataMax, s.dataMax, s.max))
                }), t;
            }
            setBaseSeries(e, t) {
                let i = this.chart, s = this.baseSeries = [];
                e = e || i.options && i.options.navigator.baseSeries || (i.series.length ? y(i.series, (e)=>!e.options.isInternal).index : 0), (i.series || []).forEach((t, i)=>{
                    !t.options.isInternal && (t.options.showInNavigator || (i === e || t.options.id === e) && !1 !== t.options.showInNavigator) && s.push(t);
                }), this.xAxis && !this.xAxis.navigatorAxis.fake && this.updateNavigatorSeries(!0, t);
            }
            updateNavigatorSeries(e, t) {
                let i = this, s = i.chart, n = i.baseSeries, o = {
                    enableMouseTracking: !1,
                    index: null,
                    linkedTo: null,
                    group: "nav",
                    padXAxis: !1,
                    xAxis: "navigator-x-axis",
                    yAxis: "navigator-y-axis",
                    showInLegend: !1,
                    stacking: void 0,
                    isInternal: !0,
                    states: {
                        inactive: {
                            opacity: 1
                        }
                    }
                }, r = i.series = (i.series || []).filter((e)=>{
                    let t = e.baseSeries;
                    return !(0 > n.indexOf(t)) || (t && (w(t, "updatedData", i.updatedDataHandler), delete t.navigatorSeries), e.chart && e.destroy(), !1);
                }), a, h, c = i.navigatorOptions.series, d;
                n && n.length && n.forEach((e)=>{
                    let u = e.navigatorSeries, p = b({
                        color: e.color,
                        visible: e.visible
                    }, x(c) ? l.navigator.series : c);
                    if (u && !1 === i.navigatorOptions.adaptToUpdatedData) return;
                    o.name = "Navigator " + n.length, d = (a = e.options || {}).navigatorOptions || {}, p.dataLabels = E(p.dataLabels), (h = A(a, o, p, d)).pointRange = C(p.pointRange, d.pointRange, l.plotOptions[h.type || "line"].pointRange);
                    let g = d.data || p.data;
                    i.hasNavigatorData = i.hasNavigatorData || !!g, h.data = g || a.data && a.data.slice(0), u && u.options ? u.update(h, t) : (e.navigatorSeries = s.initSeries(h), s.setSortedData(), e.navigatorSeries.baseSeries = e, r.push(e.navigatorSeries));
                }), (c.data && !(n && n.length) || x(c)) && (i.hasNavigatorData = !1, (c = E(c)).forEach((e, t)=>{
                    o.name = "Navigator " + (r.length + 1), (h = A(l.navigator.series, {
                        color: s.series[t] && !s.series[t].options.isInternal && s.series[t].color || s.options.colors[t] || s.options.colors[0]
                    }, o, e)).data = e.data, h.data && (i.hasNavigatorData = !0, r.push(s.initSeries(h)));
                })), e && this.addBaseSeriesEvents();
            }
            addBaseSeriesEvents() {
                let e = this, t = e.baseSeries || [];
                t[0] && t[0].xAxis && t[0].eventsToUnbind.push(c(t[0].xAxis, "foundExtremes", this.modifyBaseAxisExtremes)), t.forEach((t)=>{
                    t.eventsToUnbind.push(c(t, "show", function() {
                        this.navigatorSeries && this.navigatorSeries.setVisible(!0, !1);
                    })), t.eventsToUnbind.push(c(t, "hide", function() {
                        this.navigatorSeries && this.navigatorSeries.setVisible(!1, !1);
                    })), !1 !== this.navigatorOptions.adaptToUpdatedData && t.xAxis && t.eventsToUnbind.push(c(t, "updatedData", this.updatedDataHandler)), t.eventsToUnbind.push(c(t, "remove", function() {
                        this.navigatorSeries && (m(e.series, this.navigatorSeries), p(this.navigatorSeries.options) && this.navigatorSeries.remove(!1), delete this.navigatorSeries);
                    }));
                });
            }
            getBaseSeriesMin(e) {
                return this.baseSeries.reduce(function(e, t) {
                    return Math.min(e, t.xData && t.xData.length ? t.xData[0] : e);
                }, e);
            }
            modifyNavigatorAxisExtremes() {
                let e = this.xAxis;
                if (void 0 !== e.getExtremes) {
                    let t = this.getUnionExtremes(!0);
                    t && (t.dataMin !== e.min || t.dataMax !== e.max) && (e.min = t.dataMin, e.max = t.dataMax);
                }
            }
            modifyBaseAxisExtremes() {
                let e, t;
                let i = this.chart.navigator, s = this.getExtremes(), n = s.min, o = s.max, r = s.dataMin, a = s.dataMax, l = o - n, h = i.stickToMin, c = i.stickToMax, d = C(this.ordinal?.convertOverscroll(this.options.overscroll), 0), u = i.series && i.series[0], p = !!this.setExtremes;
                !(this.eventArgs && "rangeSelectorButton" === this.eventArgs.trigger) && (h && (e = (t = r) + l), c && (e = a + d, h || (t = Math.max(r, e - l, i.getBaseSeriesMin(u && u.xData ? u.xData[0] : -Number.MAX_VALUE)))), p && (h || c) && v(t) && (this.min = this.userMin = t, this.max = this.userMax = e)), i.stickToMin = i.stickToMax = null;
            }
            updatedDataHandler() {
                let e = this.chart.navigator, t = this.navigatorSeries, i = e.reversedExtremes ? 0 === Math.round(e.zoomedMin) : Math.round(e.zoomedMax) >= Math.round(e.size);
                e.stickToMax = C(this.chart.options.navigator && this.chart.options.navigator.stickToMax, i), e.stickToMin = e.shouldStickToMin(this, e), t && !e.hasNavigatorData && (t.options.pointStart = this.xData[0], t.setData(this.options.data, !1, null, !1));
            }
            shouldStickToMin(e, t) {
                let i = t.getBaseSeriesMin(e.xData[0]), s = e.xAxis, n = s.max, o = s.min, r = s.options.range;
                return !!(v(n) && v(o)) && (r && n - i > 0 ? n - i < r : o <= i);
            }
            addChartEvents() {
                this.eventsToUnbind || (this.eventsToUnbind = []), this.eventsToUnbind.push(c(this.chart, "redraw", function() {
                    let e = this.navigator, t = e && (e.baseSeries && e.baseSeries[0] && e.baseSeries[0].xAxis || this.xAxis[0]);
                    t && e.render(t.min, t.max);
                }), c(this.chart, "getMargins", function() {
                    let e = this.navigator, t = e.opposite ? "plotTop" : "marginBottom";
                    this.inverted && (t = e.opposite ? "marginRight" : "plotLeft"), this[t] = (this[t] || 0) + (e.navigatorEnabled || !this.inverted ? e.height + e.scrollbarHeight : 0) + e.navigatorOptions.margin;
                }), c(M, "setRange", function(e) {
                    this.chart.xAxis[0].setExtremes(e.min, e.max, e.redraw, e.animation, e.eventArguments);
                }));
            }
            destroy() {
                this.removeEvents(), this.xAxis && (m(this.chart.xAxis, this.xAxis), m(this.chart.axes, this.xAxis)), this.yAxis && (m(this.chart.yAxis, this.yAxis), m(this.chart.axes, this.yAxis)), (this.series || []).forEach((e)=>{
                    e.destroy && e.destroy();
                }), [
                    "series",
                    "xAxis",
                    "yAxis",
                    "shades",
                    "outline",
                    "scrollbarTrack",
                    "scrollbarRifles",
                    "scrollbarGroup",
                    "scrollbar",
                    "navigatorGroup",
                    "rendered"
                ].forEach((e)=>{
                    this[e] && this[e].destroy && this[e].destroy(), this[e] = null;
                }), [
                    this.handles
                ].forEach((e)=>{
                    g(e);
                });
            }
        }
        return M;
    }), i(t, "Accessibility/Components/NavigatorComponent.js", [
        t["Accessibility/AccessibilityComponent.js"],
        t["Accessibility/Utils/Announcer.js"],
        t["Accessibility/KeyboardNavigationHandler.js"],
        t["Stock/Navigator/Navigator.js"],
        t["Core/Animation/AnimationUtilities.js"],
        t["Core/Templating.js"],
        t["Core/Utilities.js"],
        t["Accessibility/Utils/HTMLUtilities.js"],
        t["Accessibility/Utils/ChartUtilities.js"]
    ], function(e, t, i, s, n, o, r, a, l) {
        let { animObject: h } = n, { format: c } = o, { clamp: d, pick: u, syncTimeout: p } = r, { getFakeMouseEvent: g } = a, { getAxisRangeDescription: m, fireEventOnWrappedOrUnwrappedElement: b } = l;
        return class extends e {
            init() {
                let e = this.chart, i = this;
                this.announcer = new t(e, "polite"), this.addEvent(s, "afterRender", function() {
                    this.chart === i.chart && this.chart.renderer && p(()=>{
                        i.proxyProvider.updateGroupProxyElementPositions("navigator"), i.updateHandleValues();
                    }, h(u(this.chart.renderer.globalAnimation, !0)).duration);
                });
            }
            onChartUpdate() {
                let e = this.chart, t = e.options;
                if (t.navigator.accessibility?.enabled) {
                    let i = t.accessibility.landmarkVerbosity, s = t.lang.accessibility?.navigator.groupLabel;
                    this.proxyProvider.removeGroup("navigator"), this.proxyProvider.addGroup("navigator", "div", {
                        role: "all" === i ? "region" : "group",
                        "aria-label": c(s, {
                            chart: e
                        }, e)
                    });
                    let n = t.lang.accessibility?.navigator.handleLabel;
                    [
                        0,
                        1
                    ].forEach((t)=>{
                        let i = this.getHandleByIx(t);
                        if (i) {
                            let s = this.proxyProvider.addProxyElement("navigator", {
                                click: i
                            }, "input", {
                                type: "range",
                                "aria-label": c(n, {
                                    handleIx: t,
                                    chart: e
                                }, e)
                            });
                            this[t ? "maxHandleProxy" : "minHandleProxy"] = s.innerElement, s.innerElement.style.pointerEvents = "none", s.innerElement.oninput = ()=>this.updateNavigator();
                        }
                    }), this.updateHandleValues();
                } else this.proxyProvider.removeGroup("navigator");
            }
            getNavigatorHandleNavigation(e) {
                let t = this, s = this.chart, n = e ? this.maxHandleProxy : this.minHandleProxy, o = this.keyCodes;
                return new i(s, {
                    keyCodeMap: [
                        [
                            [
                                o.left,
                                o.right,
                                o.up,
                                o.down
                            ],
                            function(i) {
                                if (n) {
                                    let r = i === o.left || i === o.up ? -1 : 1;
                                    n.value = "" + d(parseFloat(n.value) + r, 0, 100), t.updateNavigator(()=>{
                                        let i = t.getHandleByIx(e);
                                        i && s.setFocusToElement(i, n);
                                    });
                                }
                                return this.response.success;
                            }
                        ]
                    ],
                    init: ()=>{
                        s.setFocusToElement(this.getHandleByIx(e), n);
                    },
                    validate: ()=>!!(this.getHandleByIx(e) && n && s.options.navigator.accessibility?.enabled)
                });
            }
            getKeyboardNavigation() {
                return [
                    this.getNavigatorHandleNavigation(0),
                    this.getNavigatorHandleNavigation(1)
                ];
            }
            destroy() {
                this.updateNavigatorThrottleTimer && clearTimeout(this.updateNavigatorThrottleTimer), this.proxyProvider.removeGroup("navigator"), this.announcer && this.announcer.destroy();
            }
            updateHandleValues() {
                let e = this.chart.navigator;
                if (e && this.minHandleProxy && this.maxHandleProxy) {
                    let t = e.size;
                    this.minHandleProxy.value = "" + Math.round(e.zoomedMin / t * 100), this.maxHandleProxy.value = "" + Math.round(e.zoomedMax / t * 100);
                }
            }
            getHandleByIx(e) {
                let t = this.chart.navigator;
                return t && t.handles && t.handles[e];
            }
            updateNavigator(e) {
                this.updateNavigatorThrottleTimer && clearTimeout(this.updateNavigatorThrottleTimer), this.updateNavigatorThrottleTimer = setTimeout(((e)=>{
                    let t = this.chart, { navigator: i, pointer: s } = t;
                    if (i && s && this.minHandleProxy && this.maxHandleProxy) {
                        let n = s.getChartPosition(), o = parseFloat(this.minHandleProxy.value) / 100 * i.size, r = parseFloat(this.maxHandleProxy.value) / 100 * i.size;
                        [
                            [
                                0,
                                "mousedown",
                                i.zoomedMin
                            ],
                            [
                                0,
                                "mousemove",
                                o
                            ],
                            [
                                0,
                                "mouseup",
                                o
                            ],
                            [
                                1,
                                "mousedown",
                                i.zoomedMax
                            ],
                            [
                                1,
                                "mousemove",
                                r
                            ],
                            [
                                1,
                                "mouseup",
                                r
                            ]
                        ].forEach(([e, t, s])=>{
                            let o = this.getHandleByIx(e)?.element;
                            o && b(o, g(t, {
                                x: n.left + i.left + s,
                                y: n.top + i.top
                            }, o));
                        }), e && e();
                        let a = t.options.lang.accessibility?.navigator.changeAnnouncement, l = m(t.xAxis[0]);
                        this.announcer.announce(c(a, {
                            axisRangeDescription: l,
                            chart: t
                        }, t));
                    }
                }).bind(this, e), 20);
            }
        };
    }), i(t, "Accessibility/Components/SeriesComponent/SeriesDescriber.js", [
        t["Accessibility/Components/AnnotationsA11y.js"],
        t["Accessibility/Utils/ChartUtilities.js"],
        t["Core/Templating.js"],
        t["Accessibility/Utils/HTMLUtilities.js"],
        t["Core/Utilities.js"]
    ], function(e, t, i, s, n) {
        let { getPointAnnotationTexts: o } = e, { getAxisDescription: r, getSeriesFirstPointElement: a, getSeriesA11yElement: l, unhideChartElementFromAT: h } = t, { format: c, numberFormat: d } = i, { reverseChildNodes: u, stripHTMLTagsFromString: p } = s, { find: g, isNumber: m, isString: b, pick: y, defined: f } = n;
        function x(e) {
            let t = e.chart.options.accessibility.series.pointDescriptionEnabledThreshold;
            return !!(!1 !== t && e.points && e.points.length >= +t);
        }
        function v(e, t) {
            let i = e.series, s = i.chart, n = s.options.accessibility.point || {}, o = i.options.accessibility && i.options.accessibility.point || {}, r = i.tooltipOptions || {}, a = s.options.lang;
            return m(t) ? d(t, o.valueDecimals || n.valueDecimals || r.valueDecimals || -1, a.decimalPoint, a.accessibility.thousandsSep || a.thousandsSep) : t;
        }
        function A(e, t) {
            let i = e[t];
            return e.chart.langFormat("accessibility.series." + t + "Description", {
                name: r(i),
                series: e
            });
        }
        function C(e) {
            let t = e.series, i = t.chart.series.length > 1 || t.options.name, s = function(e) {
                let t = e.series, i = t.chart, s = t.options.accessibility, n = s && s.point && s.point.valueDescriptionFormat || i.options.accessibility.point.valueDescriptionFormat, o = y(t.xAxis && t.xAxis.options.accessibility && t.xAxis.options.accessibility.enabled, !i.angular && "flowmap" !== t.type), r = o ? function(e) {
                    let t = function(e) {
                        let t = e.series, i = t.chart, s = t.options.accessibility && t.options.accessibility.point || {}, n = i.options.accessibility.point || {}, o = t.xAxis && t.xAxis.dateTime;
                        if (o) {
                            let t = o.getXDateFormat(e.x || 0, i.options.tooltip.dateTimeLabelFormats), r = s.dateFormatter && s.dateFormatter(e) || n.dateFormatter && n.dateFormatter(e) || s.dateFormat || n.dateFormat || t;
                            return i.time.dateFormat(r, e.x || 0, void 0);
                        }
                    }(e), i = (e.series.xAxis || {}).categories && f(e.category) && ("" + e.category).replace("<br/>", " "), s = f(e.id) && 0 > ("" + e.id).indexOf("highcharts-"), n = "x, " + e.x;
                    return e.name || t || i || (s ? e.id : n);
                }(e) : "";
                return c(n, {
                    point: e,
                    index: f(e.index) ? e.index + 1 : "",
                    xDescription: r,
                    value: function(e) {
                        let t = e.series, i = t.chart.options.accessibility.point || {}, s = t.chart.options.accessibility && t.chart.options.accessibility.point || {}, n = t.tooltipOptions || {}, o = s.valuePrefix || i.valuePrefix || n.valuePrefix || "", r = s.valueSuffix || i.valueSuffix || n.valueSuffix || "", a = void 0 !== e.value ? "value" : "y", l = v(e, e[a]);
                        return e.isNull ? t.chart.langFormat("accessibility.series.nullPointValue", {
                            point: e
                        }) : t.pointArrayMap ? function(e, t, i) {
                            let s = t || "", n = i || "", o = function(t) {
                                let i = v(e, y(e[t], e.options[t]));
                                return void 0 !== i ? t + ": " + s + i + n : i;
                            };
                            return e.series.pointArrayMap.reduce(function(e, t) {
                                let i = o(t);
                                return i ? e + (e.length ? ", " : "") + i : e;
                            }, "");
                        }(e, o, r) : o + l + r;
                    }(e),
                    separator: o ? ", " : ""
                }, i);
            }(e), n = e.options && e.options.accessibility && e.options.accessibility.description, r = i ? " " + t.name + "." : "", a = function(e) {
                let t = e.series.chart, i = o(e);
                return i.length ? t.langFormat("accessibility.series.pointAnnotationsDescription", {
                    point: e,
                    annotations: i
                }) : "";
            }(e);
            return e.accessibility = e.accessibility || {}, e.accessibility.valueDescription = s, s + (n ? " " + n : "") + r + (a ? " " + a : "");
        }
        function w(e) {
            let t = e.chart, i = t.types || [], s = function(e) {
                let t = (e.options.accessibility || {}).description;
                return t && e.chart.langFormat("accessibility.series.description", {
                    description: t,
                    series: e
                }) || "";
            }(e), n = function(i) {
                return t[i] && t[i].length > 1 && e[i];
            }, o = e.index + 1, r = A(e, "xAxis"), a = A(e, "yAxis"), l = {
                seriesNumber: o,
                series: e,
                chart: t
            }, h = i.length > 1 ? "Combination" : "", d = t.langFormat("accessibility.series.summary." + e.type + h, l) || t.langFormat("accessibility.series.summary.default" + h, l), u = (n("yAxis") ? " " + a + "." : "") + (n("xAxis") ? " " + r + "." : "");
            return c(y(e.options.accessibility && e.options.accessibility.descriptionFormat, t.options.accessibility.series.descriptionFormat, ""), {
                seriesDescription: d,
                authorDescription: s ? " " + s : "",
                axisDescription: u,
                series: e,
                chart: t,
                seriesNumber: o
            }, void 0);
        }
        return {
            defaultPointDescriptionFormatter: C,
            defaultSeriesDescriptionFormatter: w,
            describeSeries: function(e) {
                let t = e.chart, i = a(e), s = l(e), n = t.is3d && t.is3d();
                s && (s.lastChild !== i || n || u(s), function(e) {
                    let t = function(e) {
                        let t = e.options.accessibility || {};
                        return !x(e) && !t.exposeAsGroupOnly;
                    }(e), i = function(e) {
                        let t = e.chart.options.accessibility.keyboardNavigation.seriesNavigation;
                        return !!(e.points && (e.points.length < +t.pointNavigationEnabledThreshold || !1 === t.pointNavigationEnabledThreshold));
                    }(e), s = e.chart.options.accessibility.point.describeNull;
                    (t || i) && e.points.forEach((i)=>{
                        let n = i.graphic && i.graphic.element || function(e) {
                            let t = e.series, i = t && t.chart, s = t && t.is("sunburst"), n = e.isNull, o = i && i.options.accessibility.point.describeNull;
                            return n && !s && o;
                        }(i) && function(e) {
                            let t = e.series, i = function(e) {
                                let t = e.index;
                                return e.series && e.series.data && f(t) && g(e.series.data, function(e) {
                                    return !!(e && void 0 !== e.index && e.index > t && e.graphic && e.graphic.element);
                                }) || null;
                            }(e), s = i && i.graphic, n = s ? s.parentGroup : t.graph || t.group, o = i ? {
                                x: y(e.plotX, i.plotX, 0),
                                y: y(e.plotY, i.plotY, 0)
                            } : {
                                x: y(e.plotX, 0),
                                y: y(e.plotY, 0)
                            }, r = function(e, t) {
                                let i = e.series.chart.renderer.rect(t.x, t.y, 1, 1);
                                return i.attr({
                                    class: "highcharts-a11y-mock-point",
                                    fill: "none",
                                    opacity: 0,
                                    "fill-opacity": 0,
                                    "stroke-opacity": 0
                                }), i;
                            }(e, o);
                            if (n && n.element) return e.graphic = r, e.hasMockGraphic = !0, r.add(n), n.element.insertBefore(r.element, s ? s.element : null), r.element;
                        }(i), o = i.options && i.options.accessibility && !1 === i.options.accessibility.enabled;
                        if (n) {
                            if (i.isNull && !s) {
                                n.setAttribute("aria-hidden", !0);
                                return;
                            }
                            n.setAttribute("tabindex", "-1"), e.chart.styledMode || (n.style.outline = "none"), t && !o ? function(e, t) {
                                let i = e.series, s = i.options.accessibility?.point || {}, n = i.chart.options.accessibility.point || {}, o = p(b(s.descriptionFormat) && c(s.descriptionFormat, e, i.chart) || s.descriptionFormatter?.(e) || b(n.descriptionFormat) && c(n.descriptionFormat, e, i.chart) || n.descriptionFormatter?.(e) || C(e), i.chart.renderer.forExport);
                                t.setAttribute("role", "img"), t.setAttribute("aria-label", o);
                            }(i, n) : n.setAttribute("aria-hidden", !0);
                        }
                    });
                }(e), h(t, s), function(e) {
                    let t = e.chart, i = t.options.chart, s = i.options3d && i.options3d.enabled, n = t.series.length > 1, o = t.options.accessibility.series.describeSingleSeries, r = (e.options.accessibility || {}).exposeAsGroupOnly;
                    return !(s && n) && (n || o || r || x(e));
                }(e) ? function(e, t) {
                    let i = e.options.accessibility || {}, s = e.chart.options.accessibility, n = s.landmarkVerbosity;
                    i.exposeAsGroupOnly ? t.setAttribute("role", "img") : "all" === n ? t.setAttribute("role", "region") : t.setAttribute("role", "group"), t.setAttribute("tabindex", "-1"), e.chart.styledMode || (t.style.outline = "none"), t.setAttribute("aria-label", p(s.series.descriptionFormatter && s.series.descriptionFormatter(e) || w(e), e.chart.renderer.forExport));
                }(e, s) : s.removeAttribute("aria-label"));
            }
        };
    }), i(t, "Accessibility/Components/SeriesComponent/NewDataAnnouncer.js", [
        t["Core/Globals.js"],
        t["Core/Utilities.js"],
        t["Accessibility/Utils/Announcer.js"],
        t["Accessibility/Utils/ChartUtilities.js"],
        t["Accessibility/Utils/EventProvider.js"],
        t["Accessibility/Components/SeriesComponent/SeriesDescriber.js"]
    ], function(e, t, i, s, n, o) {
        let { composed: r } = e, { addEvent: a, defined: l, pushUnique: h } = t, { getChartTitle: c } = s, { defaultPointDescriptionFormatter: d, defaultSeriesDescriptionFormatter: u } = o;
        function p(e) {
            return !!e.options.accessibility.announceNewData.enabled;
        }
        class g {
            constructor(e){
                this.dirty = {
                    allSeries: {}
                }, this.lastAnnouncementTime = 0, this.chart = e;
            }
            init() {
                let e = this.chart, t = e.options.accessibility.announceNewData.interruptUser ? "assertive" : "polite";
                this.lastAnnouncementTime = 0, this.dirty = {
                    allSeries: {}
                }, this.eventProvider = new n, this.announcer = new i(e, t), this.addEventListeners();
            }
            destroy() {
                this.eventProvider.removeAddedEvents(), this.announcer.destroy();
            }
            addEventListeners() {
                let e = this, t = this.chart, i = this.eventProvider;
                i.addEvent(t, "afterApplyDrilldown", function() {
                    e.lastAnnouncementTime = 0;
                }), i.addEvent(t, "afterAddSeries", function(t) {
                    e.onSeriesAdded(t.series);
                }), i.addEvent(t, "redraw", function() {
                    e.announceDirtyData();
                });
            }
            onSeriesAdded(e) {
                p(this.chart) && (this.dirty.hasDirty = !0, this.dirty.allSeries[e.name + e.index] = e, this.dirty.newSeries = l(this.dirty.newSeries) ? void 0 : e);
            }
            announceDirtyData() {
                let e = this.chart, t = this;
                if (e.options.accessibility.announceNewData && this.dirty.hasDirty) {
                    let e = this.dirty.newPoint;
                    e && (e = function(e) {
                        let t = e.series.data.filter((t)=>e.x === t.x && e.y === t.y);
                        return 1 === t.length ? t[0] : e;
                    }(e)), this.queueAnnouncement(Object.keys(this.dirty.allSeries).map((e)=>t.dirty.allSeries[e]), this.dirty.newSeries, e), this.dirty = {
                        allSeries: {}
                    };
                }
            }
            queueAnnouncement(e, t, i) {
                let s = this.chart.options.accessibility.announceNewData;
                if (s.enabled) {
                    let n = +new Date, o = n - this.lastAnnouncementTime, r = Math.max(0, s.minAnnounceInterval - o), a = function(e, t) {
                        let i = (e || []).concat(t || []).reduce((e, t)=>(e[t.name + t.index] = t, e), {});
                        return Object.keys(i).map((e)=>i[e]);
                    }(this.queuedAnnouncement && this.queuedAnnouncement.series, e), l = this.buildAnnouncementMessage(a, t, i);
                    l && (this.queuedAnnouncement && clearTimeout(this.queuedAnnouncementTimer), this.queuedAnnouncement = {
                        time: n,
                        message: l,
                        series: a
                    }, this.queuedAnnouncementTimer = setTimeout(()=>{
                        this && this.announcer && (this.lastAnnouncementTime = +new Date, this.announcer.announce(this.queuedAnnouncement.message), delete this.queuedAnnouncement, delete this.queuedAnnouncementTimer);
                    }, r));
                }
            }
            buildAnnouncementMessage(t, i, s) {
                let n = this.chart, o = n.options.accessibility.announceNewData;
                if (o.announcementFormatter) {
                    let e = o.announcementFormatter(t, i, s);
                    if (!1 !== e) return e.length ? e : null;
                }
                let r = e.charts && e.charts.length > 1 ? "Multiple" : "Single", a = i ? "newSeriesAnnounce" + r : s ? "newPointAnnounce" + r : "newDataAnnounce", l = c(n);
                return n.langFormat("accessibility.announceNewData." + a, {
                    chartTitle: l,
                    seriesDesc: i ? u(i) : null,
                    pointDesc: s ? d(s) : null,
                    point: s,
                    series: i
                });
            }
        }
        return function(e) {
            function t(e) {
                let t = this.chart, i = t.accessibility?.components.series.newDataAnnouncer;
                i && i.chart === t && p(t) && (i.dirty.newPoint = l(i.dirty.newPoint) ? void 0 : e.point);
            }
            function i() {
                let e = this.chart, t = e.accessibility?.components.series.newDataAnnouncer;
                t && t.chart === e && p(e) && (t.dirty.hasDirty = !0, t.dirty.allSeries[this.name + this.index] = this);
            }
            e.compose = function(e) {
                h(r, "A11y.NDA") && (a(e, "addPoint", t), a(e, "updatedData", i));
            };
        }(g || (g = {})), g;
    }), i(t, "Accessibility/ProxyElement.js", [
        t["Core/Globals.js"],
        t["Core/Utilities.js"],
        t["Accessibility/Utils/EventProvider.js"],
        t["Accessibility/Utils/ChartUtilities.js"],
        t["Accessibility/Utils/HTMLUtilities.js"]
    ], function(e, t, i, s, n) {
        let { doc: o } = e, { attr: r, css: a, merge: l } = t, { fireEventOnWrappedOrUnwrappedElement: h } = s, { cloneMouseEvent: c, cloneTouchEvent: d, getFakeMouseEvent: u, removeElement: p } = n;
        return class {
            constructor(e, t, s = "button", n, r){
                this.chart = e, this.target = t, this.eventProvider = new i;
                let a = this.innerElement = o.createElement(s), l = this.element = n ? o.createElement(n) : a;
                e.styledMode || this.hideElementVisually(a), n && ("li" !== n || e.styledMode || (l.style.listStyle = "none"), l.appendChild(a), this.element = l), this.updateTarget(t, r);
            }
            click() {
                let e = this.getTargetPosition();
                e.x += e.width / 2, e.y += e.height / 2;
                let t = u("click", e);
                h(this.target.click, t);
            }
            updateTarget(e, t) {
                this.target = e, this.updateCSSClassName();
                let i = t || {};
                Object.keys(i).forEach((e)=>{
                    null === i[e] && delete i[e];
                });
                let s = this.getTargetAttr(e.click, "aria-label");
                r(this.innerElement, l(s ? {
                    "aria-label": s
                } : {}, i)), this.eventProvider.removeAddedEvents(), this.addProxyEventsToElement(this.innerElement, e.click), this.refreshPosition();
            }
            refreshPosition() {
                let e = this.getTargetPosition();
                a(this.innerElement, {
                    width: (e.width || 1) + "px",
                    height: (e.height || 1) + "px",
                    left: (Math.round(e.x) || 0) + "px",
                    top: (Math.round(e.y) || 0) + "px"
                });
            }
            remove() {
                this.eventProvider.removeAddedEvents(), p(this.element);
            }
            updateCSSClassName() {
                let e = (e)=>e.indexOf("highcharts-no-tooltip") > -1, t = this.chart.legend, i = t.group && t.group.div, s = e(i && i.className || ""), n = e(this.getTargetAttr(this.target.click, "class") || "");
                this.innerElement.className = s || n ? "highcharts-a11y-proxy-element highcharts-no-tooltip" : "highcharts-a11y-proxy-element";
            }
            addProxyEventsToElement(e, t) {
                [
                    "click",
                    "touchstart",
                    "touchend",
                    "touchcancel",
                    "touchmove",
                    "mouseover",
                    "mouseenter",
                    "mouseleave",
                    "mouseout"
                ].forEach((i)=>{
                    let s = 0 === i.indexOf("touch");
                    this.eventProvider.addEvent(e, i, (e)=>{
                        let i = s ? d(e) : c(e);
                        t && h(t, i), e.stopPropagation(), s || e.preventDefault();
                    }, {
                        passive: !1
                    });
                });
            }
            hideElementVisually(e) {
                a(e, {
                    borderWidth: 0,
                    backgroundColor: "transparent",
                    cursor: "pointer",
                    outline: "none",
                    opacity: .001,
                    filter: "alpha(opacity=1)",
                    zIndex: 999,
                    overflow: "hidden",
                    padding: 0,
                    margin: 0,
                    display: "block",
                    position: "absolute",
                    "-ms-filter": "progid:DXImageTransform.Microsoft.Alpha(Opacity=1)"
                });
            }
            getTargetPosition() {
                let e = this.target.click, t = e.element ? e.element : e, i = this.target.visual || t, s = this.chart.renderTo, n = this.chart.pointer;
                if (s && i?.getBoundingClientRect && n) {
                    let e = i.getBoundingClientRect(), t = n.getChartPosition();
                    return {
                        x: (e.left - t.left) / t.scaleX,
                        y: (e.top - t.top) / t.scaleY,
                        width: e.right / t.scaleX - e.left / t.scaleX,
                        height: e.bottom / t.scaleY - e.top / t.scaleY
                    };
                }
                return {
                    x: 0,
                    y: 0,
                    width: 1,
                    height: 1
                };
            }
            getTargetAttr(e, t) {
                return e.element ? e.element.getAttribute(t) : e.getAttribute(t);
            }
        };
    }), i(t, "Accessibility/ProxyProvider.js", [
        t["Core/Globals.js"],
        t["Core/Utilities.js"],
        t["Accessibility/Utils/ChartUtilities.js"],
        t["Accessibility/Utils/DOMElementProvider.js"],
        t["Accessibility/Utils/HTMLUtilities.js"],
        t["Accessibility/ProxyElement.js"]
    ], function(e, t, i, s, n, o) {
        let { doc: r } = e, { attr: a, css: l } = t, { unhideChartElementFromAT: h } = i, { removeChildNodes: c } = n;
        return class {
            constructor(e){
                this.chart = e, this.domElementProvider = new s, this.groups = {}, this.groupOrder = [], this.beforeChartProxyPosContainer = this.createProxyPosContainer("before"), this.afterChartProxyPosContainer = this.createProxyPosContainer("after"), this.update();
            }
            addProxyElement(e, t, i = "button", s) {
                let n = this.groups[e];
                if (!n) throw Error("ProxyProvider.addProxyElement: Invalid group key " + e);
                let r = "ul" === n.type || "ol" === n.type ? "li" : void 0, a = new o(this.chart, t, i, r, s);
                return n.proxyContainerElement.appendChild(a.element), n.proxyElements.push(a), a;
            }
            addGroup(e, t = "div", i) {
                let s;
                let n = this.groups[e];
                if (n) return n.groupElement;
                let o = this.domElementProvider.createElement(t);
                return i && i.role && "div" !== t ? (s = this.domElementProvider.createElement("div")).appendChild(o) : s = o, s.className = "highcharts-a11y-proxy-group highcharts-a11y-proxy-group-" + e.replace(/\W/g, "-"), this.groups[e] = {
                    proxyContainerElement: o,
                    groupElement: s,
                    type: t,
                    proxyElements: []
                }, a(s, i || {}), "ul" === t && o.setAttribute("role", "list"), this.afterChartProxyPosContainer.appendChild(s), this.updateGroupOrder(this.groupOrder), s;
            }
            updateGroupAttrs(e, t) {
                let i = this.groups[e];
                if (!i) throw Error("ProxyProvider.updateGroupAttrs: Invalid group key " + e);
                a(i.groupElement, t);
            }
            updateGroupOrder(e) {
                if (this.groupOrder = e.slice(), this.isDOMOrderGroupOrder()) return;
                let t = e.indexOf("series"), i = t > -1 ? e.slice(0, t) : e, s = t > -1 ? e.slice(t + 1) : [], n = r.activeElement;
                [
                    "before",
                    "after"
                ].forEach((e)=>{
                    let t = this["before" === e ? "beforeChartProxyPosContainer" : "afterChartProxyPosContainer"];
                    c(t), ("before" === e ? i : s).forEach((e)=>{
                        let i = this.groups[e];
                        i && t.appendChild(i.groupElement);
                    });
                }), (this.beforeChartProxyPosContainer.contains(n) || this.afterChartProxyPosContainer.contains(n)) && n && n.focus && n.focus();
            }
            clearGroup(e) {
                let t = this.groups[e];
                if (!t) throw Error("ProxyProvider.clearGroup: Invalid group key " + e);
                c(t.proxyContainerElement);
            }
            removeGroup(e) {
                let t = this.groups[e];
                t && (this.domElementProvider.removeElement(t.groupElement), t.groupElement !== t.proxyContainerElement && this.domElementProvider.removeElement(t.proxyContainerElement), delete this.groups[e]);
            }
            update() {
                this.updatePosContainerPositions(), this.updateGroupOrder(this.groupOrder), this.updateProxyElementPositions();
            }
            updateProxyElementPositions() {
                Object.keys(this.groups).forEach(this.updateGroupProxyElementPositions.bind(this));
            }
            updateGroupProxyElementPositions(e) {
                let t = this.groups[e];
                t && t.proxyElements.forEach((e)=>e.refreshPosition());
            }
            destroy() {
                this.domElementProvider.destroyCreatedElements();
            }
            createProxyPosContainer(e) {
                let t = this.domElementProvider.createElement("div");
                return t.setAttribute("aria-hidden", "false"), t.className = "highcharts-a11y-proxy-container" + (e ? "-" + e : ""), l(t, {
                    top: "0",
                    left: "0"
                }), this.chart.styledMode || (t.style.whiteSpace = "nowrap", t.style.position = "absolute"), t;
            }
            getCurrentGroupOrderInDOM() {
                let e = (e)=>{
                    let t = Object.keys(this.groups), i = t.length;
                    for(; i--;){
                        let s = t[i], n = this.groups[s];
                        if (n && e === n.groupElement) return s;
                    }
                }, t = (t)=>{
                    let i = [], s = t.children;
                    for(let t = 0; t < s.length; ++t){
                        let n = e(s[t]);
                        n && i.push(n);
                    }
                    return i;
                }, i = t(this.beforeChartProxyPosContainer), s = t(this.afterChartProxyPosContainer);
                return i.push("series"), i.concat(s);
            }
            isDOMOrderGroupOrder() {
                let e = this.getCurrentGroupOrderInDOM(), t = this.groupOrder.filter((e)=>"series" === e || !!this.groups[e]), i = e.length;
                if (i !== t.length) return !1;
                for(; i--;)if (e[i] !== t[i]) return !1;
                return !0;
            }
            updatePosContainerPositions() {
                let e = this.chart;
                if (e.renderer.forExport) return;
                let t = e.renderer.box;
                e.container.insertBefore(this.afterChartProxyPosContainer, t.nextSibling), e.container.insertBefore(this.beforeChartProxyPosContainer, t), h(this.chart, this.afterChartProxyPosContainer), h(this.chart, this.beforeChartProxyPosContainer);
            }
        };
    }), i(t, "Accessibility/Components/RangeSelectorComponent.js", [
        t["Accessibility/AccessibilityComponent.js"],
        t["Accessibility/Utils/Announcer.js"],
        t["Accessibility/Utils/ChartUtilities.js"],
        t["Accessibility/KeyboardNavigationHandler.js"],
        t["Core/Utilities.js"]
    ], function(e, t, i, s, n) {
        let { unhideChartElementFromAT: o, getAxisRangeDescription: r } = i, { addEvent: a, attr: l } = n;
        class h extends e {
            init() {
                let e = this.chart;
                this.announcer = new t(e, "polite");
            }
            onChartUpdate() {
                let e = this.chart, t = this, i = e.rangeSelector;
                i && (this.updateSelectorVisibility(), this.setDropdownAttrs(), i.buttons && i.buttons.length && i.buttons.forEach((e)=>{
                    t.setRangeButtonAttrs(e);
                }), i.maxInput && i.minInput && [
                    "minInput",
                    "maxInput"
                ].forEach(function(s, n) {
                    let r = i[s];
                    r && (o(e, r), t.setRangeInputAttrs(r, "accessibility.rangeSelector." + (n ? "max" : "min") + "InputLabel"));
                }));
            }
            updateSelectorVisibility() {
                let e = this.chart, t = e.rangeSelector, i = t && t.dropdown, s = t && t.buttons || [], n = (e)=>e.setAttribute("aria-hidden", !0);
                t && t.hasVisibleDropdown && i ? (o(e, i), s.forEach((e)=>n(e.element))) : (i && n(i), s.forEach((t)=>o(e, t.element)));
            }
            setDropdownAttrs() {
                let e = this.chart, t = e.rangeSelector && e.rangeSelector.dropdown;
                if (t) {
                    let i = e.langFormat("accessibility.rangeSelector.dropdownLabel", {
                        rangeTitle: e.options.lang.rangeSelectorZoom
                    });
                    t.setAttribute("aria-label", i), t.setAttribute("tabindex", -1);
                }
            }
            setRangeButtonAttrs(e) {
                l(e.element, {
                    tabindex: -1,
                    role: "button"
                });
            }
            setRangeInputAttrs(e, t) {
                let i = this.chart;
                l(e, {
                    tabindex: -1,
                    "aria-label": i.langFormat(t, {
                        chart: i
                    })
                });
            }
            onButtonNavKbdArrowKey(e, t) {
                let i = e.response, s = this.keyCodes, n = this.chart, o = n.options.accessibility.keyboardNavigation.wrapAround, r = t === s.left || t === s.up ? -1 : 1;
                return n.highlightRangeSelectorButton(n.highlightedRangeSelectorItemIx + r) ? i.success : o ? (e.init(r), i.success) : i[r > 0 ? "next" : "prev"];
            }
            onButtonNavKbdClick(e) {
                let t = e.response, i = this.chart;
                return 3 !== i.oldRangeSelectorItemState && this.fakeClickEvent(i.rangeSelector.buttons[i.highlightedRangeSelectorItemIx].element), t.success;
            }
            onAfterBtnClick() {
                let e = this.chart, t = r(e.xAxis[0]), i = e.langFormat("accessibility.rangeSelector.clickButtonAnnouncement", {
                    chart: e,
                    axisRangeDescription: t
                });
                i && this.announcer.announce(i);
            }
            onInputKbdMove(e) {
                let t = this.chart, i = t.rangeSelector, s = t.highlightedInputRangeIx = (t.highlightedInputRangeIx || 0) + e;
                if (s > 1 || s < 0) {
                    if (t.accessibility) return t.accessibility.keyboardNavigation.exiting = !0, t.accessibility.keyboardNavigation.tabindexContainer.focus(), t.accessibility.keyboardNavigation.move(e);
                } else if (i) {
                    let e = i[s ? "maxDateBox" : "minDateBox"], n = i[s ? "maxInput" : "minInput"];
                    e && n && t.setFocusToElement(e, n);
                }
                return !0;
            }
            onInputNavInit(e) {
                let t = this, i = this.chart, s = e > 0 ? 0 : 1, n = i.rangeSelector, o = n && n[s ? "maxDateBox" : "minDateBox"], r = n && n.minInput, l = n && n.maxInput;
                if (i.highlightedInputRangeIx = s, o && r && l) {
                    i.setFocusToElement(o, s ? l : r), this.removeInputKeydownHandler && this.removeInputKeydownHandler();
                    let e = (e)=>{
                        (e.which || e.keyCode) === this.keyCodes.tab && t.onInputKbdMove(e.shiftKey ? -1 : 1) && (e.preventDefault(), e.stopPropagation());
                    }, n = a(r, "keydown", e), h = a(l, "keydown", e);
                    this.removeInputKeydownHandler = ()=>{
                        n(), h();
                    };
                }
            }
            onInputNavTerminate() {
                let e = this.chart.rangeSelector || {};
                e.maxInput && e.hideInput("max"), e.minInput && e.hideInput("min"), this.removeInputKeydownHandler && (this.removeInputKeydownHandler(), delete this.removeInputKeydownHandler);
            }
            initDropdownNav() {
                let e = this.chart, t = e.rangeSelector, i = t && t.dropdown;
                t && i && (e.setFocusToElement(t.buttonGroup, i), this.removeDropdownKeydownHandler && this.removeDropdownKeydownHandler(), this.removeDropdownKeydownHandler = a(i, "keydown", (t)=>{
                    let i = (t.which || t.keyCode) === this.keyCodes.tab, s = e.accessibility;
                    i && (t.preventDefault(), t.stopPropagation(), s && (s.keyboardNavigation.tabindexContainer.focus(), s.keyboardNavigation.move(t.shiftKey ? -1 : 1)));
                }));
            }
            getRangeSelectorButtonNavigation() {
                let e = this.chart, t = this.keyCodes, i = this;
                return new s(e, {
                    keyCodeMap: [
                        [
                            [
                                t.left,
                                t.right,
                                t.up,
                                t.down
                            ],
                            function(e) {
                                return i.onButtonNavKbdArrowKey(this, e);
                            }
                        ],
                        [
                            [
                                t.enter,
                                t.space
                            ],
                            function() {
                                return i.onButtonNavKbdClick(this);
                            }
                        ]
                    ],
                    validate: function() {
                        return !!(e.rangeSelector && e.rangeSelector.buttons && e.rangeSelector.buttons.length);
                    },
                    init: function(t) {
                        let s = e.rangeSelector;
                        if (s && s.hasVisibleDropdown) i.initDropdownNav();
                        else if (s) {
                            let i = s.buttons.length - 1;
                            e.highlightRangeSelectorButton(t > 0 ? 0 : i);
                        }
                    },
                    terminate: function() {
                        i.removeDropdownKeydownHandler && (i.removeDropdownKeydownHandler(), delete i.removeDropdownKeydownHandler);
                    }
                });
            }
            getRangeSelectorInputNavigation() {
                let e = this.chart, t = this;
                return new s(e, {
                    keyCodeMap: [],
                    validate: function() {
                        return !!(e.rangeSelector && e.rangeSelector.inputGroup && "hidden" !== e.rangeSelector.inputGroup.element.style.visibility && !1 !== e.options.rangeSelector.inputEnabled && e.rangeSelector.minInput && e.rangeSelector.maxInput);
                    },
                    init: function(e) {
                        t.onInputNavInit(e);
                    },
                    terminate: function() {
                        t.onInputNavTerminate();
                    }
                });
            }
            getKeyboardNavigation() {
                return [
                    this.getRangeSelectorButtonNavigation(),
                    this.getRangeSelectorInputNavigation()
                ];
            }
            destroy() {
                this.removeDropdownKeydownHandler && this.removeDropdownKeydownHandler(), this.removeInputKeydownHandler && this.removeInputKeydownHandler(), this.announcer && this.announcer.destroy();
            }
        }
        return function(e) {
            function t(e) {
                let t = this.rangeSelector && this.rangeSelector.buttons || [], i = this.highlightedRangeSelectorItemIx, s = this.rangeSelector && this.rangeSelector.selected;
                return void 0 !== i && t[i] && i !== s && t[i].setState(this.oldRangeSelectorItemState || 0), this.highlightedRangeSelectorItemIx = e, !!t[e] && (this.setFocusToElement(t[e].box, t[e].element), e !== s && (this.oldRangeSelectorItemState = t[e].state, t[e].setState(1)), !0);
            }
            function i() {
                let e = this.chart.accessibility;
                if (e && e.components.rangeSelector) return e.components.rangeSelector.onAfterBtnClick();
            }
            e.compose = function(e, s) {
                let n = e.prototype;
                n.highlightRangeSelectorButton || (n.highlightRangeSelectorButton = t, a(s, "afterBtnClick", i));
            };
        }(h || (h = {})), h;
    }), i(t, "Accessibility/Components/SeriesComponent/ForcedMarkers.js", [
        t["Core/Globals.js"],
        t["Core/Utilities.js"]
    ], function(e, t) {
        var i;
        let { composed: s } = e, { addEvent: n, merge: o, pushUnique: r } = t;
        return function(e) {
            function t(e) {
                o(!0, e, {
                    marker: {
                        enabled: !0,
                        states: {
                            normal: {
                                opacity: 0
                            }
                        }
                    }
                });
            }
            function i(e) {
                return e.marker.states && e.marker.states.normal && e.marker.states.normal.opacity;
            }
            function a(e) {
                return !!(e._hasPointMarkers && e.points && e.points.length);
            }
            function l() {
                this.chart.styledMode && (this.markerGroup && this.markerGroup[this.a11yMarkersForced ? "addClass" : "removeClass"]("highcharts-a11y-markers-hidden"), a(this) && this.points.forEach((e)=>{
                    e.graphic && (e.graphic[e.hasForcedA11yMarker ? "addClass" : "removeClass"]("highcharts-a11y-marker-hidden"), e.graphic[!1 === e.hasForcedA11yMarker ? "addClass" : "removeClass"]("highcharts-a11y-marker-visible"));
                }));
            }
            function h(e) {
                this.resetA11yMarkerOptions = o(e.options.marker || {}, this.userOptions.marker || {});
            }
            function c() {
                let e = this.options;
                (function(e) {
                    let t = e.chart.options.accessibility.enabled, i = !1 !== (e.options.accessibility && e.options.accessibility.enabled);
                    return t && i && function(e) {
                        let t = e.chart.options.accessibility;
                        return e.points.length < t.series.pointDescriptionEnabledThreshold || !1 === t.series.pointDescriptionEnabledThreshold;
                    }(e);
                })(this) ? (e.marker && !1 === e.marker.enabled && (this.a11yMarkersForced = !0, t(this.options)), a(this) && function(e) {
                    let s = e.points.length;
                    for(; s--;){
                        let n = e.points[s], r = n.options, a = n.hasForcedA11yMarker;
                        if (delete n.hasForcedA11yMarker, r.marker) {
                            let e = a && 0 === i(r);
                            r.marker.enabled && !e ? (o(!0, r.marker, {
                                states: {
                                    normal: {
                                        opacity: i(r) || 1
                                    }
                                }
                            }), n.hasForcedA11yMarker = !1) : !1 === r.marker.enabled && (t(r), n.hasForcedA11yMarker = !0);
                        }
                    }
                }(this)) : this.a11yMarkersForced && (delete this.a11yMarkersForced, function(e) {
                    let t = e.resetA11yMarkerOptions;
                    if (t) {
                        let i = t.states && t.states.normal && t.states.normal.opacity;
                        e.userOptions && e.userOptions.marker && (e.userOptions.marker.enabled = !0), e.update({
                            marker: {
                                enabled: t.enabled,
                                states: {
                                    normal: {
                                        opacity: i
                                    }
                                }
                            }
                        });
                    }
                }(this), delete this.resetA11yMarkerOptions);
            }
            function d() {
                this.boosted && this.a11yMarkersForced && (o(!0, this.options, {
                    marker: {
                        enabled: !1
                    }
                }), delete this.a11yMarkersForced);
            }
            e.compose = function(e) {
                r(s, "A11y.FM") && (n(e, "afterSetOptions", h), n(e, "render", c), n(e, "afterRender", l), n(e, "renderCanvas", d));
            };
        }(i || (i = {})), i;
    }), i(t, "Accessibility/Components/SeriesComponent/SeriesKeyboardNavigation.js", [
        t["Core/Series/Point.js"],
        t["Core/Series/Series.js"],
        t["Core/Series/SeriesRegistry.js"],
        t["Core/Globals.js"],
        t["Core/Utilities.js"],
        t["Accessibility/KeyboardNavigationHandler.js"],
        t["Accessibility/Utils/EventProvider.js"],
        t["Accessibility/Utils/ChartUtilities.js"]
    ], function(e, t, i, s, n, o, r, a) {
        let { seriesTypes: l } = i, { doc: h } = s, { defined: c, fireEvent: d } = n, { getPointFromXY: u, getSeriesFromName: p, scrollAxisToPoint: g } = a;
        function m(e) {
            let t = e.index, i = e.series.points, s = i.length;
            if (i[t] === e) return t;
            for(; s--;)if (i[s] === e) return s;
        }
        function b(e) {
            let t = e.chart.options.accessibility.keyboardNavigation.seriesNavigation, i = e.options.accessibility || {}, s = i.keyboardNavigation;
            return s && !1 === s.enabled || !1 === i.enabled || !1 === e.options.enableMouseTracking || !e.visible || t.pointNavigationEnabledThreshold && +t.pointNavigationEnabledThreshold <= e.points.length;
        }
        function y(e) {
            let t = e.series.chart.options.accessibility, i = e.options.accessibility && !1 === e.options.accessibility.enabled;
            return e.isNull && t.keyboardNavigation.seriesNavigation.skipNullPoints || !1 === e.visible || !1 === e.isInside || i || b(e.series);
        }
        function f(e) {
            let t = e.series || [], i = t.length;
            for(let e = 0; e < i; ++e)if (!b(t[e])) {
                let i = function(e) {
                    let t = e.points || [], i = t.length;
                    for(let e = 0; e < i; ++e)if (!y(t[e])) return t[e];
                    return null;
                }(t[e]);
                if (i) return i;
            }
            return null;
        }
        function x(e) {
            let t = e.series.length, i = !1;
            for(; t-- && (e.highlightedPoint = e.series[t].points[e.series[t].points.length - 1], !(i = e.series[t].highlightNextValidPoint())););
            return i;
        }
        function v(e) {
            delete e.highlightedPoint;
            let t = f(e);
            return !!t && t.highlight();
        }
        class A {
            constructor(e, t){
                this.keyCodes = t, this.chart = e;
            }
            init() {
                let i = this, s = this.chart, n = this.eventProvider = new r;
                n.addEvent(t, "destroy", function() {
                    return i.onSeriesDestroy(this);
                }), n.addEvent(s, "afterApplyDrilldown", function() {
                    !function(e) {
                        let t = f(e);
                        t && t.highlight(!1);
                    }(this);
                }), n.addEvent(s, "drilldown", function(e) {
                    let t = e.point, s = t.series;
                    i.lastDrilledDownPoint = {
                        x: t.x,
                        y: t.y,
                        seriesName: s ? s.name : ""
                    };
                }), n.addEvent(s, "drillupall", function() {
                    setTimeout(function() {
                        i.onDrillupAll();
                    }, 10);
                }), n.addEvent(e, "afterSetState", function() {
                    let e = this.graphic && this.graphic.element, t = h.activeElement, i = t && t.getAttribute("class"), n = i && i.indexOf("highcharts-a11y-proxy-element") > -1;
                    s.highlightedPoint === this && t !== e && !n && e && e.focus && e.focus();
                });
            }
            onDrillupAll() {
                let e;
                let t = this.lastDrilledDownPoint, i = this.chart, s = t && p(i, t.seriesName);
                t && s && c(t.x) && c(t.y) && (e = u(s, t.x, t.y)), e = e || f(i), i.container && i.container.focus(), e && e.highlight && e.highlight(!1);
            }
            getKeyboardNavigationHandler() {
                let e = this, t = this.keyCodes, i = this.chart, s = i.inverted;
                return new o(i, {
                    keyCodeMap: [
                        [
                            s ? [
                                t.up,
                                t.down
                            ] : [
                                t.left,
                                t.right
                            ],
                            function(t) {
                                return e.onKbdSideways(this, t);
                            }
                        ],
                        [
                            s ? [
                                t.left,
                                t.right
                            ] : [
                                t.up,
                                t.down
                            ],
                            function(t) {
                                return e.onKbdVertical(this, t);
                            }
                        ],
                        [
                            [
                                t.enter,
                                t.space
                            ],
                            function(e, t) {
                                let s = i.highlightedPoint;
                                return s && (t.point = s, d(s.series, "click", t), s.firePointEvent("click")), this.response.success;
                            }
                        ],
                        [
                            [
                                t.home
                            ],
                            function() {
                                return v(i), this.response.success;
                            }
                        ],
                        [
                            [
                                t.end
                            ],
                            function() {
                                return x(i), this.response.success;
                            }
                        ],
                        [
                            [
                                t.pageDown,
                                t.pageUp
                            ],
                            function(e) {
                                return i.highlightAdjacentSeries(e === t.pageDown), this.response.success;
                            }
                        ]
                    ],
                    init: function() {
                        return e.onHandlerInit(this);
                    },
                    validate: function() {
                        return !!f(i);
                    },
                    terminate: function() {
                        return e.onHandlerTerminate();
                    }
                });
            }
            onKbdSideways(e, t) {
                let i = this.keyCodes, s = t === i.right || t === i.down;
                return this.attemptHighlightAdjacentPoint(e, s);
            }
            onHandlerInit(e) {
                let t = this.chart;
                return t.options.accessibility.keyboardNavigation.seriesNavigation.rememberPointFocus && t.highlightedPoint ? t.highlightedPoint.highlight() : v(t), e.response.success;
            }
            onKbdVertical(e, t) {
                let i = this.chart, s = this.keyCodes, n = t === s.down || t === s.right, o = i.options.accessibility.keyboardNavigation.seriesNavigation;
                if (o.mode && "serialize" === o.mode) return this.attemptHighlightAdjacentPoint(e, n);
                let r = i.highlightedPoint && i.highlightedPoint.series.keyboardMoveVertical ? "highlightAdjacentPointVertical" : "highlightAdjacentSeries";
                return i[r](n), e.response.success;
            }
            onHandlerTerminate() {
                let e = this.chart, t = e.options.accessibility.keyboardNavigation;
                e.tooltip && e.tooltip.hide(0);
                let i = e.highlightedPoint && e.highlightedPoint.series;
                i && i.onMouseOut && i.onMouseOut(), e.highlightedPoint && e.highlightedPoint.onMouseOut && e.highlightedPoint.onMouseOut(), t.seriesNavigation.rememberPointFocus || delete e.highlightedPoint;
            }
            attemptHighlightAdjacentPoint(e, t) {
                let i = this.chart, s = i.options.accessibility.keyboardNavigation.wrapAround;
                return i.highlightAdjacentPoint(t) ? e.response.success : s && (t ? v(i) : x(i)) ? e.response.success : e.response[t ? "next" : "prev"];
            }
            onSeriesDestroy(e) {
                let t = this.chart;
                t.highlightedPoint && t.highlightedPoint.series === e && (delete t.highlightedPoint, t.focusElement && t.focusElement.removeFocusBorder());
            }
            destroy() {
                this.eventProvider.removeAddedEvents();
            }
        }
        return function(e) {
            function t(e) {
                let t, i;
                let s = this.series, n = this.highlightedPoint, o = n && m(n) || 0, r = n && n.series.points || [], a = this.series && this.series[this.series.length - 1], l = a && a.points && a.points[a.points.length - 1];
                if (!s[0] || !s[0].points) return !1;
                if (n) {
                    if (t = s[n.series.index + (e ? 1 : -1)], (i = r[o + (e ? 1 : -1)]) || !t || (i = t.points[e ? 0 : t.points.length - 1]), !i) return !1;
                } else i = e ? s[0].points[0] : l;
                return y(i) ? (b(t = i.series) ? this.highlightedPoint = e ? t.points[t.points.length - 1] : t.points[0] : this.highlightedPoint = i, this.highlightAdjacentPoint(e)) : i.highlight();
            }
            function i(e) {
                let t = this.highlightedPoint, i = 1 / 0, s;
                return !!(c(t.plotX) && c(t.plotY)) && (this.series.forEach((n)=>{
                    b(n) || n.points.forEach((o)=>{
                        if (!c(o.plotY) || !c(o.plotX) || o === t) return;
                        let r = o.plotY - t.plotY, a = Math.abs(o.plotX - t.plotX), l = Math.abs(r) * Math.abs(r) + a * a * 4;
                        n.yAxis && n.yAxis.reversed && (r *= -1), !(r <= 0 && e || r >= 0 && !e || l < 5 || y(o)) && l < i && (i = l, s = o);
                    });
                }), !!s && s.highlight());
            }
            function s(e) {
                let t, i, s;
                let n = this.highlightedPoint, o = this.series && this.series[this.series.length - 1], r = o && o.points && o.points[o.points.length - 1];
                return this.highlightedPoint ? !!((t = this.series[n.series.index + (e ? -1 : 1)]) && (i = function(e, t, i, s) {
                    let n = 1 / 0, o, r, a, l = t.points.length, h = (e)=>!(c(e.plotX) && c(e.plotY));
                    if (!h(e)) {
                        for(; l--;)!h(o = t.points[l]) && (a = (e.plotX - o.plotX) * (e.plotX - o.plotX) * 4 + (e.plotY - o.plotY) * (e.plotY - o.plotY) * 1) < n && (n = a, r = l);
                        return c(r) ? t.points[r] : void 0;
                    }
                }(n, t, 0))) && (b(t) ? (i.highlight(), s = this.highlightAdjacentSeries(e)) ? s : (n.highlight(), !1) : (i.highlight(), i.series.highlightNextValidPoint())) : (t = e ? this.series && this.series[0] : o, !!(i = e ? t && t.points && t.points[0] : r) && i.highlight());
            }
            function n(e = !0) {
                let t = this.series.chart, i = t.tooltip?.label?.element;
                !this.isNull && e ? this.onMouseOver() : t.tooltip && t.tooltip.hide(0), g(this), this.graphic && (t.setFocusToElement(this.graphic), !e && t.focusElement && t.focusElement.removeFocusBorder()), t.highlightedPoint = this;
                let s = i?.getBoundingClientRect().top;
                if (i && s && s < 0) {
                    let e = window.scrollY;
                    window.scrollTo({
                        behavior: "smooth",
                        top: e + s
                    });
                }
                return this;
            }
            function o() {
                let e = this.chart.highlightedPoint, t = (e && e.series) === this ? m(e) : 0, i = this.points, s = i.length;
                if (i && s) {
                    for(let e = t; e < s; ++e)if (!y(i[e])) return i[e].highlight();
                    for(let e = t; e >= 0; --e)if (!y(i[e])) return i[e].highlight();
                }
                return !1;
            }
            e.compose = function(e, r, a) {
                let h = e.prototype, c = r.prototype, d = a.prototype;
                h.highlightAdjacentPoint || (h.highlightAdjacentPoint = t, h.highlightAdjacentPointVertical = i, h.highlightAdjacentSeries = s, c.highlight = n, d.keyboardMoveVertical = !0, [
                    "column",
                    "gantt",
                    "pie"
                ].forEach((e)=>{
                    l[e] && (l[e].prototype.keyboardMoveVertical = !1);
                }), d.highlightNextValidPoint = o);
            };
        }(A || (A = {})), A;
    }), i(t, "Accessibility/Components/SeriesComponent/SeriesComponent.js", [
        t["Accessibility/AccessibilityComponent.js"],
        t["Accessibility/Utils/ChartUtilities.js"],
        t["Accessibility/Components/SeriesComponent/ForcedMarkers.js"],
        t["Accessibility/Components/SeriesComponent/NewDataAnnouncer.js"],
        t["Accessibility/Components/SeriesComponent/SeriesDescriber.js"],
        t["Accessibility/Components/SeriesComponent/SeriesKeyboardNavigation.js"]
    ], function(e, t, i, s, n, o) {
        let { hideSeriesFromAT: r } = t, { describeSeries: a } = n;
        return class extends e {
            static compose(e, t, n) {
                s.compose(n), i.compose(n), o.compose(e, t, n);
            }
            init() {
                this.newDataAnnouncer = new s(this.chart), this.newDataAnnouncer.init(), this.keyboardNavigation = new o(this.chart, this.keyCodes), this.keyboardNavigation.init(), this.hideTooltipFromATWhenShown(), this.hideSeriesLabelsFromATWhenShown();
            }
            hideTooltipFromATWhenShown() {
                let e = this;
                this.chart.tooltip && this.addEvent(this.chart.tooltip.constructor, "refresh", function() {
                    this.chart === e.chart && this.label && this.label.element && this.label.element.setAttribute("aria-hidden", !0);
                });
            }
            hideSeriesLabelsFromATWhenShown() {
                this.addEvent(this.chart, "afterDrawSeriesLabels", function() {
                    this.series.forEach(function(e) {
                        e.labelBySeries && e.labelBySeries.attr("aria-hidden", !0);
                    });
                });
            }
            onChartRender() {
                this.chart.series.forEach(function(e) {
                    !1 !== (e.options.accessibility && e.options.accessibility.enabled) && e.visible && 0 !== e.data.length ? a(e) : r(e);
                });
            }
            getKeyboardNavigation() {
                return this.keyboardNavigation.getKeyboardNavigationHandler();
            }
            destroy() {
                this.newDataAnnouncer.destroy(), this.keyboardNavigation.destroy();
            }
        };
    }), i(t, "Accessibility/Components/ZoomComponent.js", [
        t["Accessibility/AccessibilityComponent.js"],
        t["Accessibility/Utils/ChartUtilities.js"],
        t["Accessibility/Utils/HTMLUtilities.js"],
        t["Accessibility/KeyboardNavigationHandler.js"],
        t["Core/Utilities.js"]
    ], function(e, t, i, s, n) {
        let { unhideChartElementFromAT: o } = t, { getFakeMouseEvent: r } = i, { attr: a, pick: l } = n;
        return class extends e {
            constructor(){
                super(...arguments), this.focusedMapNavButtonIx = -1;
            }
            init() {
                let e = this, t = this.chart;
                this.proxyProvider.addGroup("zoom", "div"), [
                    "afterShowResetZoom",
                    "afterApplyDrilldown",
                    "drillupall"
                ].forEach((i)=>{
                    e.addEvent(t, i, function() {
                        e.updateProxyOverlays();
                    });
                });
            }
            onChartUpdate() {
                let e = this.chart, t = this;
                e.mapNavigation && e.mapNavigation.navButtons.forEach((i, s)=>{
                    o(e, i.element), t.setMapNavButtonAttrs(i.element, "accessibility.zoom.mapZoom" + (s ? "Out" : "In"));
                });
            }
            setMapNavButtonAttrs(e, t) {
                let i = this.chart;
                a(e, {
                    tabindex: -1,
                    role: "button",
                    "aria-label": i.langFormat(t, {
                        chart: i
                    })
                });
            }
            onChartRender() {
                this.updateProxyOverlays();
            }
            updateProxyOverlays() {
                let e = this.chart;
                if (this.proxyProvider.clearGroup("zoom"), e.resetZoomButton && this.createZoomProxyButton(e.resetZoomButton, "resetZoomProxyButton", e.langFormat("accessibility.zoom.resetZoomButton", {
                    chart: e
                })), e.drillUpButton && e.breadcrumbs && e.breadcrumbs.list) {
                    let t = e.breadcrumbs.list[e.breadcrumbs.list.length - 1];
                    this.createZoomProxyButton(e.drillUpButton, "drillUpProxyButton", e.langFormat("accessibility.drillUpButton", {
                        chart: e,
                        buttonText: e.breadcrumbs.getButtonText(t)
                    }));
                }
            }
            createZoomProxyButton(e, t, i) {
                this[t] = this.proxyProvider.addProxyElement("zoom", {
                    click: e
                }, "button", {
                    "aria-label": i,
                    tabindex: -1
                });
            }
            getMapZoomNavigation() {
                let e = this.keyCodes, t = this.chart, i = this;
                return new s(t, {
                    keyCodeMap: [
                        [
                            [
                                e.up,
                                e.down,
                                e.left,
                                e.right
                            ],
                            function(e) {
                                return i.onMapKbdArrow(this, e);
                            }
                        ],
                        [
                            [
                                e.tab
                            ],
                            function(e, t) {
                                return i.onMapKbdTab(this, t);
                            }
                        ],
                        [
                            [
                                e.space,
                                e.enter
                            ],
                            function() {
                                return i.onMapKbdClick(this);
                            }
                        ]
                    ],
                    validate: function() {
                        return !!(t.mapView && t.mapNavigation && t.mapNavigation.navButtons.length);
                    },
                    init: function(e) {
                        return i.onMapNavInit(e);
                    }
                });
            }
            onMapKbdArrow(e, t) {
                let i = this.chart, s = this.keyCodes, n = i.container, o = t === s.up || t === s.down, a = t === s.left || t === s.up ? 1 : -1, l = (o ? i.plotHeight : i.plotWidth) / 10 * a, h = 10 * Math.random(), c = {
                    x: n.offsetLeft + i.plotLeft + i.plotWidth / 2 + h,
                    y: n.offsetTop + i.plotTop + i.plotHeight / 2 + h
                }, d = o ? {
                    x: c.x,
                    y: c.y + l
                } : {
                    x: c.x + l,
                    y: c.y
                };
                return [
                    r("mousedown", c),
                    r("mousemove", d),
                    r("mouseup", d)
                ].forEach((e)=>n.dispatchEvent(e)), e.response.success;
            }
            onMapKbdTab(e, t) {
                let i = this.chart, s = e.response, n = t.shiftKey, o = n && !this.focusedMapNavButtonIx || !n && this.focusedMapNavButtonIx;
                if (i.mapNavigation.navButtons[this.focusedMapNavButtonIx].setState(0), o) return i.mapView && i.mapView.zoomBy(), s[n ? "prev" : "next"];
                this.focusedMapNavButtonIx += n ? -1 : 1;
                let r = i.mapNavigation.navButtons[this.focusedMapNavButtonIx];
                return i.setFocusToElement(r.box, r.element), r.setState(2), s.success;
            }
            onMapKbdClick(e) {
                let t = this.chart.mapNavigation.navButtons[this.focusedMapNavButtonIx].element;
                return this.fakeClickEvent(t), e.response.success;
            }
            onMapNavInit(e) {
                let t = this.chart, i = t.mapNavigation.navButtons[0], s = t.mapNavigation.navButtons[1], n = e > 0 ? i : s;
                t.setFocusToElement(n.box, n.element), n.setState(2), this.focusedMapNavButtonIx = e > 0 ? 0 : 1;
            }
            simpleButtonNavigation(e, t, i) {
                let n = this.keyCodes, o = this, r = this.chart;
                return new s(r, {
                    keyCodeMap: [
                        [
                            [
                                n.tab,
                                n.up,
                                n.down,
                                n.left,
                                n.right
                            ],
                            function(e, t) {
                                let i = e === n.tab && t.shiftKey || e === n.left || e === n.up;
                                return this.response[i ? "prev" : "next"];
                            }
                        ],
                        [
                            [
                                n.space,
                                n.enter
                            ],
                            function() {
                                return l(i(this, r), this.response.success);
                            }
                        ]
                    ],
                    validate: function() {
                        return r[e] && r[e].box && o[t].innerElement;
                    },
                    init: function() {
                        r.setFocusToElement(r[e].box, o[t].innerElement);
                    }
                });
            }
            getKeyboardNavigation() {
                return [
                    this.simpleButtonNavigation("resetZoomButton", "resetZoomProxyButton", function(e, t) {
                        t.zoomOut();
                    }),
                    this.simpleButtonNavigation("drillUpButton", "drillUpProxyButton", function(e, t) {
                        return t.drillUp(), e.response.prev;
                    }),
                    this.getMapZoomNavigation()
                ];
            }
        };
    }), i(t, "Accessibility/HighContrastMode.js", [
        t["Core/Globals.js"]
    ], function(e) {
        let { doc: t, isMS: i, win: s } = e;
        return {
            isHighContrastModeActive: function() {
                let e = /(Edg)/.test(s.navigator.userAgent);
                if (s.matchMedia && e) return s.matchMedia("(-ms-high-contrast: active)").matches;
                if (i && s.getComputedStyle) {
                    let e = t.createElement("div");
                    e.style.backgroundImage = "url(data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==)", t.body.appendChild(e);
                    let i = (e.currentStyle || s.getComputedStyle(e)).backgroundImage;
                    return t.body.removeChild(e), "none" === i;
                }
                return s.matchMedia && s.matchMedia("(forced-colors: active)").matches;
            },
            setHighContrastTheme: function(e) {
                e.highContrastModeActive = !0;
                let t = e.options.accessibility.highContrastTheme;
                e.update(t, !1);
                let i = t.colors?.length > 1;
                e.series.forEach(function(e) {
                    let s = t.plotOptions[e.type] || {}, n = i && void 0 !== e.colorIndex ? t.colors[e.colorIndex] : s.color || "window", o = {
                        color: s.color || "windowText",
                        colors: i ? t.colors : [
                            s.color || "windowText"
                        ],
                        borderColor: s.borderColor || "window",
                        fillColor: n
                    };
                    e.update(o, !1), e.points && e.points.forEach(function(e) {
                        e.options && e.options.color && e.update({
                            color: s.color || "windowText",
                            borderColor: s.borderColor || "window"
                        }, !1);
                    });
                }), e.redraw();
            }
        };
    }), i(t, "Accessibility/HighContrastTheme.js", [], function() {
        return {
            chart: {
                backgroundColor: "window"
            },
            title: {
                style: {
                    color: "windowText"
                }
            },
            subtitle: {
                style: {
                    color: "windowText"
                }
            },
            colorAxis: {
                minColor: "windowText",
                maxColor: "windowText",
                stops: [],
                dataClasses: []
            },
            colors: [
                "windowText"
            ],
            xAxis: {
                gridLineColor: "windowText",
                labels: {
                    style: {
                        color: "windowText"
                    }
                },
                lineColor: "windowText",
                minorGridLineColor: "windowText",
                tickColor: "windowText",
                title: {
                    style: {
                        color: "windowText"
                    }
                }
            },
            yAxis: {
                gridLineColor: "windowText",
                labels: {
                    style: {
                        color: "windowText"
                    }
                },
                lineColor: "windowText",
                minorGridLineColor: "windowText",
                tickColor: "windowText",
                title: {
                    style: {
                        color: "windowText"
                    }
                }
            },
            tooltip: {
                backgroundColor: "window",
                borderColor: "windowText",
                style: {
                    color: "windowText"
                }
            },
            plotOptions: {
                series: {
                    lineColor: "windowText",
                    fillColor: "window",
                    borderColor: "windowText",
                    edgeColor: "windowText",
                    borderWidth: 1,
                    dataLabels: {
                        connectorColor: "windowText",
                        color: "windowText",
                        style: {
                            color: "windowText",
                            textOutline: "none"
                        }
                    },
                    marker: {
                        lineColor: "windowText",
                        fillColor: "windowText"
                    }
                },
                pie: {
                    color: "window",
                    colors: [
                        "window"
                    ],
                    borderColor: "windowText",
                    borderWidth: 1
                },
                boxplot: {
                    fillColor: "window"
                },
                candlestick: {
                    lineColor: "windowText",
                    fillColor: "window"
                },
                errorbar: {
                    fillColor: "window"
                }
            },
            legend: {
                backgroundColor: "window",
                itemStyle: {
                    color: "windowText"
                },
                itemHoverStyle: {
                    color: "windowText"
                },
                itemHiddenStyle: {
                    color: "#555"
                },
                title: {
                    style: {
                        color: "windowText"
                    }
                }
            },
            credits: {
                style: {
                    color: "windowText"
                }
            },
            drilldown: {
                activeAxisLabelStyle: {
                    color: "windowText"
                },
                activeDataLabelStyle: {
                    color: "windowText"
                }
            },
            navigation: {
                buttonOptions: {
                    symbolStroke: "windowText",
                    theme: {
                        fill: "window"
                    }
                }
            },
            rangeSelector: {
                buttonTheme: {
                    fill: "window",
                    stroke: "windowText",
                    style: {
                        color: "windowText"
                    },
                    states: {
                        hover: {
                            fill: "window",
                            stroke: "windowText",
                            style: {
                                color: "windowText"
                            }
                        },
                        select: {
                            fill: "#444",
                            stroke: "windowText",
                            style: {
                                color: "windowText"
                            }
                        }
                    }
                },
                inputBoxBorderColor: "windowText",
                inputStyle: {
                    backgroundColor: "window",
                    color: "windowText"
                },
                labelStyle: {
                    color: "windowText"
                }
            },
            navigator: {
                handles: {
                    backgroundColor: "window",
                    borderColor: "windowText"
                },
                outlineColor: "windowText",
                maskFill: "transparent",
                series: {
                    color: "windowText",
                    lineColor: "windowText"
                },
                xAxis: {
                    gridLineColor: "windowText"
                }
            },
            scrollbar: {
                barBackgroundColor: "#444",
                barBorderColor: "windowText",
                buttonArrowColor: "windowText",
                buttonBackgroundColor: "window",
                buttonBorderColor: "windowText",
                rifleColor: "windowText",
                trackBackgroundColor: "window",
                trackBorderColor: "windowText"
            }
        };
    }), i(t, "Accessibility/Options/A11yDefaults.js", [], function() {
        return {
            accessibility: {
                enabled: !0,
                screenReaderSection: {
                    beforeChartFormat: "<{headingTagName}>{chartTitle}</{headingTagName}><div>{typeDescription}</div><div>{chartSubtitle}</div><div>{chartLongdesc}</div><div>{playAsSoundButton}</div><div>{viewTableButton}</div><div>{xAxisDescription}</div><div>{yAxisDescription}</div><div>{annotationsTitle}{annotationsList}</div>",
                    afterChartFormat: "{endOfChartMarker}",
                    axisRangeDateFormat: "%Y-%m-%d %H:%M:%S"
                },
                series: {
                    descriptionFormat: "{seriesDescription}{authorDescription}{axisDescription}",
                    describeSingleSeries: !1,
                    pointDescriptionEnabledThreshold: 200
                },
                point: {
                    valueDescriptionFormat: "{xDescription}{separator}{value}.",
                    describeNull: !0
                },
                landmarkVerbosity: "all",
                linkedDescription: '*[data-highcharts-chart="{index}"] + .highcharts-description',
                highContrastMode: "auto",
                keyboardNavigation: {
                    enabled: !0,
                    focusBorder: {
                        enabled: !0,
                        hideBrowserFocusOutline: !0,
                        style: {
                            color: "#334eff",
                            lineWidth: 2,
                            borderRadius: 3
                        },
                        margin: 2
                    },
                    order: [
                        "series",
                        "zoom",
                        "rangeSelector",
                        "navigator",
                        "legend",
                        "chartMenu"
                    ],
                    wrapAround: !0,
                    seriesNavigation: {
                        skipNullPoints: !0,
                        pointNavigationEnabledThreshold: !1,
                        rememberPointFocus: !1
                    }
                },
                announceNewData: {
                    enabled: !1,
                    minAnnounceInterval: 5e3,
                    interruptUser: !1
                }
            },
            legend: {
                accessibility: {
                    enabled: !0,
                    keyboardNavigation: {
                        enabled: !0
                    }
                }
            },
            exporting: {
                accessibility: {
                    enabled: !0
                }
            },
            navigator: {
                accessibility: {
                    enabled: !0
                }
            }
        };
    }), i(t, "Accessibility/Options/LangDefaults.js", [], function() {
        return {
            accessibility: {
                defaultChartTitle: "Chart",
                chartContainerLabel: "{title}. Highcharts interactive chart.",
                svgContainerLabel: "Interactive chart",
                drillUpButton: "{buttonText}",
                credits: "Chart credits: {creditsStr}",
                thousandsSep: ",",
                svgContainerTitle: "",
                graphicContainerLabel: "",
                screenReaderSection: {
                    beforeRegionLabel: "",
                    afterRegionLabel: "",
                    annotations: {
                        heading: "Chart annotations summary",
                        descriptionSinglePoint: "{annotationText}. Related to {annotationPoint}",
                        descriptionMultiplePoints: "{annotationText}. Related to {annotationPoint}{#each additionalAnnotationPoints}, also related to {this}{/each}",
                        descriptionNoPoints: "{annotationText}"
                    },
                    endOfChartMarker: "End of interactive chart."
                },
                sonification: {
                    playAsSoundButtonText: "Play as sound, {chartTitle}",
                    playAsSoundClickAnnouncement: "Play"
                },
                legend: {
                    legendLabelNoTitle: "Toggle series visibility, {chartTitle}",
                    legendLabel: "Chart legend: {legendTitle}",
                    legendItem: "Show {itemName}"
                },
                zoom: {
                    mapZoomIn: "Zoom chart",
                    mapZoomOut: "Zoom out chart",
                    resetZoomButton: "Reset zoom"
                },
                rangeSelector: {
                    dropdownLabel: "{rangeTitle}",
                    minInputLabel: "Select start date.",
                    maxInputLabel: "Select end date.",
                    clickButtonAnnouncement: "Viewing {axisRangeDescription}"
                },
                navigator: {
                    handleLabel: "{#eq handleIx 0}Start, percent{else}End, percent{/eq}",
                    groupLabel: "Axis zoom",
                    changeAnnouncement: "{axisRangeDescription}"
                },
                table: {
                    viewAsDataTableButtonText: "View as data table, {chartTitle}",
                    tableSummary: "Table representation of chart."
                },
                announceNewData: {
                    newDataAnnounce: "Updated data for chart {chartTitle}",
                    newSeriesAnnounceSingle: "New data series: {seriesDesc}",
                    newPointAnnounceSingle: "New data point: {pointDesc}",
                    newSeriesAnnounceMultiple: "New data series in chart {chartTitle}: {seriesDesc}",
                    newPointAnnounceMultiple: "New data point in chart {chartTitle}: {pointDesc}"
                },
                seriesTypeDescriptions: {
                    boxplot: "Box plot charts are typically used to display groups of statistical data. Each data point in the chart can have up to 5 values: minimum, lower quartile, median, upper quartile, and maximum.",
                    arearange: "Arearange charts are line charts displaying a range between a lower and higher value for each point.",
                    areasplinerange: "These charts are line charts displaying a range between a lower and higher value for each point.",
                    bubble: "Bubble charts are scatter charts where each data point also has a size value.",
                    columnrange: "Columnrange charts are column charts displaying a range between a lower and higher value for each point.",
                    errorbar: "Errorbar series are used to display the variability of the data.",
                    funnel: "Funnel charts are used to display reduction of data in stages.",
                    pyramid: "Pyramid charts consist of a single pyramid with item heights corresponding to each point value.",
                    waterfall: "A waterfall chart is a column chart where each column contributes towards a total end value."
                },
                chartTypes: {
                    emptyChart: "Empty chart",
                    mapTypeDescription: "Map of {mapTitle} with {numSeries} data series.",
                    unknownMap: "Map of unspecified region with {numSeries} data series.",
                    combinationChart: "Combination chart with {numSeries} data series.",
                    defaultSingle: "Chart with {numPoints} data {#eq numPoints 1}point{else}points{/eq}.",
                    defaultMultiple: "Chart with {numSeries} data series.",
                    splineSingle: "Line chart with {numPoints} data {#eq numPoints 1}point{else}points{/eq}.",
                    splineMultiple: "Line chart with {numSeries} lines.",
                    lineSingle: "Line chart with {numPoints} data {#eq numPoints 1}point{else}points{/eq}.",
                    lineMultiple: "Line chart with {numSeries} lines.",
                    columnSingle: "Bar chart with {numPoints} {#eq numPoints 1}bar{else}bars{/eq}.",
                    columnMultiple: "Bar chart with {numSeries} data series.",
                    barSingle: "Bar chart with {numPoints} {#eq numPoints 1}bar{else}bars{/eq}.",
                    barMultiple: "Bar chart with {numSeries} data series.",
                    pieSingle: "Pie chart with {numPoints} {#eq numPoints 1}slice{else}slices{/eq}.",
                    pieMultiple: "Pie chart with {numSeries} pies.",
                    scatterSingle: "Scatter chart with {numPoints} {#eq numPoints 1}point{else}points{/eq}.",
                    scatterMultiple: "Scatter chart with {numSeries} data series.",
                    boxplotSingle: "Boxplot with {numPoints} {#eq numPoints 1}box{else}boxes{/eq}.",
                    boxplotMultiple: "Boxplot with {numSeries} data series.",
                    bubbleSingle: "Bubble chart with {numPoints} {#eq numPoints 1}bubbles{else}bubble{/eq}.",
                    bubbleMultiple: "Bubble chart with {numSeries} data series."
                },
                axis: {
                    xAxisDescriptionSingular: "The chart has 1 X axis displaying {names[0]}. {ranges[0]}",
                    xAxisDescriptionPlural: "The chart has {numAxes} X axes displaying {#each names}{#unless @first},{/unless}{#if @last} and{/if} {this}{/each}.",
                    yAxisDescriptionSingular: "The chart has 1 Y axis displaying {names[0]}. {ranges[0]}",
                    yAxisDescriptionPlural: "The chart has {numAxes} Y axes displaying {#each names}{#unless @first},{/unless}{#if @last} and{/if} {this}{/each}.",
                    timeRangeDays: "Data range: {range} days.",
                    timeRangeHours: "Data range: {range} hours.",
                    timeRangeMinutes: "Data range: {range} minutes.",
                    timeRangeSeconds: "Data range: {range} seconds.",
                    rangeFromTo: "Data ranges from {rangeFrom} to {rangeTo}.",
                    rangeCategories: "Data range: {numCategories} categories."
                },
                exporting: {
                    chartMenuLabel: "Chart menu",
                    menuButtonLabel: "View chart menu, {chartTitle}"
                },
                series: {
                    summary: {
                        default: "{series.name}, series {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.",
                        defaultCombination: "{series.name}, series {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.",
                        line: "{series.name}, line {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.",
                        lineCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Line with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.",
                        spline: "{series.name}, line {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.",
                        splineCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Line with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.",
                        column: "{series.name}, bar series {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}bar{else}bars{/eq}.",
                        columnCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Bar series with {series.points.length} {#eq series.points.length 1}bar{else}bars{/eq}.",
                        bar: "{series.name}, bar series {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}bar{else}bars{/eq}.",
                        barCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Bar series with {series.points.length} {#eq series.points.length 1}bar{else}bars{/eq}.",
                        pie: "{series.name}, pie {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}slice{else}slices{/eq}.",
                        pieCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Pie with {series.points.length} {#eq series.points.length 1}slice{else}slices{/eq}.",
                        scatter: "{series.name}, scatter plot {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}point{else}points{/eq}.",
                        scatterCombination: "{series.name}, series {seriesNumber} of {chart.series.length}, scatter plot with {series.points.length} {#eq series.points.length 1}point{else}points{/eq}.",
                        boxplot: "{series.name}, boxplot {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}box{else}boxes{/eq}.",
                        boxplotCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Boxplot with {series.points.length} {#eq series.points.length 1}box{else}boxes{/eq}.",
                        bubble: "{series.name}, bubble series {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}bubble{else}bubbles{/eq}.",
                        bubbleCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Bubble series with {series.points.length} {#eq series.points.length 1}bubble{else}bubbles{/eq}.",
                        map: "{series.name}, map {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}area{else}areas{/eq}.",
                        mapCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Map with {series.points.length} {#eq series.points.length 1}area{else}areas{/eq}.",
                        mapline: "{series.name}, line {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.",
                        maplineCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Line with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.",
                        mapbubble: "{series.name}, bubble series {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}bubble{else}bubbles{/eq}.",
                        mapbubbleCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Bubble series with {series.points.length} {#eq series.points.length 1}bubble{else}bubbles{/eq}."
                    },
                    description: "{description}",
                    xAxisDescription: "X axis, {name}",
                    yAxisDescription: "Y axis, {name}",
                    nullPointValue: "No value",
                    pointAnnotationsDescription: "{#each annotations}Annotation: {this}{/each}"
                }
            }
        };
    }), i(t, "Accessibility/Options/DeprecatedOptions.js", [
        t["Core/Utilities.js"]
    ], function(e) {
        let { error: t, pick: i } = e;
        function s(e, t, s) {
            let n = e, o, r = 0;
            for(; r < t.length - 1; ++r)n = n[o = t[r]] = i(n[o], {});
            n[t[t.length - 1]] = s;
        }
        function n(e, i, n, o) {
            function r(e, t) {
                return t.reduce(function(e, t) {
                    return e[t];
                }, e);
            }
            let a = r(e.options, i), l = r(e.options, n);
            Object.keys(o).forEach(function(r) {
                let h = a[r];
                void 0 !== h && (s(l, o[r], h), t(32, !1, e, {
                    [i.join(".") + "." + r]: n.join(".") + "." + o[r].join(".")
                }));
            });
        }
        return function(e) {
            (function(e) {
                let i = e.options.chart, s = e.options.accessibility || {};
                [
                    "description",
                    "typeDescription"
                ].forEach(function(n) {
                    i[n] && (s[n] = i[n], t(32, !1, e, {
                        [`chart.${n}`]: `use accessibility.${n}`
                    }));
                });
            })(e), function(e) {
                e.axes.forEach(function(i) {
                    let s = i.options;
                    s && s.description && (s.accessibility = s.accessibility || {}, s.accessibility.description = s.description, t(32, !1, e, {
                        "axis.description": "use axis.accessibility.description"
                    }));
                });
            }(e), e.series && function(e) {
                let i = {
                    description: [
                        "accessibility",
                        "description"
                    ],
                    exposeElementToA11y: [
                        "accessibility",
                        "exposeAsGroupOnly"
                    ],
                    pointDescriptionFormatter: [
                        "accessibility",
                        "point",
                        "descriptionFormatter"
                    ],
                    skipKeyboardNavigation: [
                        "accessibility",
                        "keyboardNavigation",
                        "enabled"
                    ],
                    "accessibility.pointDescriptionFormatter": [
                        "accessibility",
                        "point",
                        "descriptionFormatter"
                    ]
                };
                e.series.forEach(function(n) {
                    Object.keys(i).forEach(function(o) {
                        let r = n.options[o];
                        "accessibility.pointDescriptionFormatter" === o && (r = n.options.accessibility && n.options.accessibility.pointDescriptionFormatter), void 0 !== r && (s(n.options, i[o], "skipKeyboardNavigation" === o ? !r : r), t(32, !1, e, {
                            [`series.${o}`]: "series." + i[o].join(".")
                        }));
                    });
                });
            }(e), n(e, [
                "accessibility"
            ], [
                "accessibility"
            ], {
                pointDateFormat: [
                    "point",
                    "dateFormat"
                ],
                pointDateFormatter: [
                    "point",
                    "dateFormatter"
                ],
                pointDescriptionFormatter: [
                    "point",
                    "descriptionFormatter"
                ],
                pointDescriptionThreshold: [
                    "series",
                    "pointDescriptionEnabledThreshold"
                ],
                pointNavigationThreshold: [
                    "keyboardNavigation",
                    "seriesNavigation",
                    "pointNavigationEnabledThreshold"
                ],
                pointValueDecimals: [
                    "point",
                    "valueDecimals"
                ],
                pointValuePrefix: [
                    "point",
                    "valuePrefix"
                ],
                pointValueSuffix: [
                    "point",
                    "valueSuffix"
                ],
                screenReaderSectionFormatter: [
                    "screenReaderSection",
                    "beforeChartFormatter"
                ],
                describeSingleSeries: [
                    "series",
                    "describeSingleSeries"
                ],
                seriesDescriptionFormatter: [
                    "series",
                    "descriptionFormatter"
                ],
                onTableAnchorClick: [
                    "screenReaderSection",
                    "onViewDataTableClick"
                ],
                axisRangeDateFormat: [
                    "screenReaderSection",
                    "axisRangeDateFormat"
                ]
            }), n(e, [
                "accessibility",
                "keyboardNavigation"
            ], [
                "accessibility",
                "keyboardNavigation",
                "seriesNavigation"
            ], {
                skipNullPoints: [
                    "skipNullPoints"
                ],
                mode: [
                    "mode"
                ]
            }), n(e, [
                "lang",
                "accessibility"
            ], [
                "lang",
                "accessibility"
            ], {
                legendItem: [
                    "legend",
                    "legendItem"
                ],
                legendLabel: [
                    "legend",
                    "legendLabel"
                ],
                mapZoomIn: [
                    "zoom",
                    "mapZoomIn"
                ],
                mapZoomOut: [
                    "zoom",
                    "mapZoomOut"
                ],
                resetZoomButton: [
                    "zoom",
                    "resetZoomButton"
                ],
                screenReaderRegionLabel: [
                    "screenReaderSection",
                    "beforeRegionLabel"
                ],
                rangeSelectorButton: [
                    "rangeSelector",
                    "buttonText"
                ],
                rangeSelectorMaxInput: [
                    "rangeSelector",
                    "maxInputLabel"
                ],
                rangeSelectorMinInput: [
                    "rangeSelector",
                    "minInputLabel"
                ],
                svgContainerEnd: [
                    "screenReaderSection",
                    "endOfChartMarker"
                ],
                viewAsDataTable: [
                    "table",
                    "viewAsDataTableButtonText"
                ],
                tableSummary: [
                    "table",
                    "tableSummary"
                ]
            });
        };
    }), i(t, "Accessibility/Accessibility.js", [
        t["Core/Defaults.js"],
        t["Core/Globals.js"],
        t["Core/Utilities.js"],
        t["Accessibility/Utils/HTMLUtilities.js"],
        t["Accessibility/A11yI18n.js"],
        t["Accessibility/Components/ContainerComponent.js"],
        t["Accessibility/FocusBorder.js"],
        t["Accessibility/Components/InfoRegionsComponent.js"],
        t["Accessibility/KeyboardNavigation.js"],
        t["Accessibility/Components/LegendComponent.js"],
        t["Accessibility/Components/MenuComponent.js"],
        t["Accessibility/Components/NavigatorComponent.js"],
        t["Accessibility/Components/SeriesComponent/NewDataAnnouncer.js"],
        t["Accessibility/ProxyProvider.js"],
        t["Accessibility/Components/RangeSelectorComponent.js"],
        t["Accessibility/Components/SeriesComponent/SeriesComponent.js"],
        t["Accessibility/Components/ZoomComponent.js"],
        t["Accessibility/HighContrastMode.js"],
        t["Accessibility/HighContrastTheme.js"],
        t["Accessibility/Options/A11yDefaults.js"],
        t["Accessibility/Options/LangDefaults.js"],
        t["Accessibility/Options/DeprecatedOptions.js"]
    ], function(e, t, i, s, n, o, r, a, l, h, c, d, u, p, g, m, b, y, f, x, v, A) {
        let { defaultOptions: C } = e, { doc: w } = t, { addEvent: E, extend: T, fireEvent: M, merge: S } = i, { removeElement: k } = s;
        class P {
            constructor(e){
                this.init(e);
            }
            init(e) {
                if (this.chart = e, !w.addEventListener) {
                    this.zombie = !0, this.components = {}, e.renderTo.setAttribute("aria-hidden", !0);
                    return;
                }
                A(e), this.proxyProvider = new p(this.chart), this.initComponents(), this.keyboardNavigation = new l(e, this.components);
            }
            initComponents() {
                let e = this.chart, t = this.proxyProvider, i = e.options.accessibility;
                this.components = {
                    container: new o,
                    infoRegions: new a,
                    legend: new h,
                    chartMenu: new c,
                    rangeSelector: new g,
                    series: new m,
                    zoom: new b,
                    navigator: new d
                }, i.customComponents && T(this.components, i.customComponents);
                let s = this.components;
                this.getComponentOrder().forEach(function(i) {
                    s[i].initBase(e, t), s[i].init();
                });
            }
            getComponentOrder() {
                return this.components ? this.components.series ? [
                    "series"
                ].concat(Object.keys(this.components).filter((e)=>"series" !== e)) : Object.keys(this.components) : [];
            }
            update() {
                let e = this.components, t = this.chart, i = t.options.accessibility;
                M(t, "beforeA11yUpdate"), t.types = this.getChartTypes();
                let s = i.keyboardNavigation.order;
                this.proxyProvider.updateGroupOrder(s), this.getComponentOrder().forEach(function(i) {
                    e[i].onChartUpdate(), M(t, "afterA11yComponentUpdate", {
                        name: i,
                        component: e[i]
                    });
                }), this.keyboardNavigation.update(s), !t.highContrastModeActive && !1 !== i.highContrastMode && (y.isHighContrastModeActive() || !0 === i.highContrastMode) && y.setHighContrastTheme(t), M(t, "afterA11yUpdate", {
                    accessibility: this
                });
            }
            destroy() {
                let e = this.chart || {}, t = this.components;
                Object.keys(t).forEach(function(e) {
                    t[e].destroy(), t[e].destroyBase();
                }), this.proxyProvider && this.proxyProvider.destroy(), e.announcerContainer && k(e.announcerContainer), this.keyboardNavigation && this.keyboardNavigation.destroy(), e.renderTo && e.renderTo.setAttribute("aria-hidden", !0), e.focusElement && e.focusElement.removeFocusBorder();
            }
            getChartTypes() {
                let e = {};
                return this.chart.series.forEach(function(t) {
                    e[t.type] = 1;
                }), Object.keys(e);
            }
        }
        return function(e) {
            function t() {
                this.accessibility && this.accessibility.destroy();
            }
            function i() {
                this.a11yDirty && this.renderTo && (delete this.a11yDirty, this.updateA11yEnabled());
                let e = this.accessibility;
                e && !e.zombie && (e.proxyProvider.updateProxyElementPositions(), e.getComponentOrder().forEach(function(t) {
                    e.components[t].onChartRender();
                }));
            }
            function s(e) {
                let t = e.options.accessibility;
                t && (t.customComponents && (this.options.accessibility.customComponents = t.customComponents, delete t.customComponents), S(!0, this.options.accessibility, t), this.accessibility && this.accessibility.destroy && (this.accessibility.destroy(), delete this.accessibility)), this.a11yDirty = !0;
            }
            function o() {
                let t = this.accessibility, i = this.options.accessibility;
                i && i.enabled ? t && !t.zombie ? t.update() : (this.accessibility = t = new e(this), t && !t.zombie && t.update()) : t ? (t.destroy && t.destroy(), delete this.accessibility) : this.renderTo.setAttribute("aria-hidden", !0);
            }
            function a() {
                this.series.chart.accessibility && (this.series.chart.a11yDirty = !0);
            }
            e.i18nFormat = n.i18nFormat, e.compose = function(e, d, p, b, y, f) {
                l.compose(e), u.compose(b), h.compose(e, d), c.compose(e), m.compose(e, p, b), n.compose(e), r.compose(e, y), f && g.compose(e, f);
                let x = e.prototype;
                x.updateA11yEnabled || (x.updateA11yEnabled = o, E(e, "destroy", t), E(e, "render", i), E(e, "update", s), [
                    "addSeries",
                    "init"
                ].forEach((t)=>{
                    E(e, t, function() {
                        this.a11yDirty = !0;
                    });
                }), [
                    "afterApplyDrilldown",
                    "drillupall"
                ].forEach((t)=>{
                    E(e, t, function() {
                        let e = this.accessibility;
                        e && !e.zombie && e.update();
                    });
                }), E(p, "update", a), [
                    "update",
                    "updatedData",
                    "remove"
                ].forEach((e)=>{
                    E(b, e, function() {
                        this.chart.accessibility && (this.chart.a11yDirty = !0);
                    });
                }));
            };
        }(P || (P = {})), S(!0, C, x, {
            accessibility: {
                highContrastTheme: f
            },
            lang: v
        }), P;
    }), i(t, "masters/modules/accessibility.src.js", [
        t["Core/Globals.js"],
        t["Accessibility/Accessibility.js"],
        t["Accessibility/AccessibilityComponent.js"],
        t["Accessibility/Utils/ChartUtilities.js"],
        t["Accessibility/Utils/HTMLUtilities.js"],
        t["Accessibility/KeyboardNavigationHandler.js"],
        t["Accessibility/Components/SeriesComponent/SeriesDescriber.js"]
    ], function(e, t, i, s, n, o, r) {
        return e.i18nFormat = t.i18nFormat, e.A11yChartUtilities = s, e.A11yHTMLUtilities = n, e.AccessibilityComponent = i, e.KeyboardNavigationHandler = o, e.SeriesAccessibilityDescriber = r, t.compose(e.Chart, e.Legend, e.Point, e.Series, e.SVGElement, e.RangeSelector), e;
    });
});

});

var $e4258fc7f271b870$exports = {};
!/**
 * Highcharts JS v11.4.0 (2024-03-04)
 *
 * (c) 2009-2024 Torstein Honsi
 *
 * License: www.highcharts.com/license
 */ function(t, e) {
    (0, $e4258fc7f271b870$exports) ? (e.default = e, $e4258fc7f271b870$exports = t && t.document ? e(t) : e) : "function" == typeof define && define.amd ? define("highcharts/highcharts", function() {
        return e(t);
    }) : (t.Highcharts && t.Highcharts.error(16, !0), t.Highcharts = e(t));
}("undefined" != typeof window ? window : $e4258fc7f271b870$exports, function(t) {
    "use strict";
    var e = {};
    function i(e, i, s, r) {
        e.hasOwnProperty(i) || (e[i] = r.apply(null, s), "function" == typeof CustomEvent && t.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", {
            detail: {
                path: i,
                module: e[i]
            }
        })));
    }
    return i(e, "Core/Globals.js", [], function() {
        var e, i;
        return (i = e || (e = {})).SVG_NS = "http://www.w3.org/2000/svg", i.product = "Highcharts", i.version = "11.4.0", i.win = void 0 !== t ? t : {}, i.doc = i.win.document, i.svg = i.doc && i.doc.createElementNS && !!i.doc.createElementNS(i.SVG_NS, "svg").createSVGRect, i.userAgent = i.win.navigator && i.win.navigator.userAgent || "", i.isChrome = -1 !== i.userAgent.indexOf("Chrome"), i.isFirefox = -1 !== i.userAgent.indexOf("Firefox"), i.isMS = /(edge|msie|trident)/i.test(i.userAgent) && !i.win.opera, i.isSafari = !i.isChrome && -1 !== i.userAgent.indexOf("Safari"), i.isTouchDevice = /(Mobile|Android|Windows Phone)/.test(i.userAgent), i.isWebKit = -1 !== i.userAgent.indexOf("AppleWebKit"), i.deg2rad = 2 * Math.PI / 360, i.hasBidiBug = i.isFirefox && 4 > parseInt(i.userAgent.split("Firefox/")[1], 10), i.marginNames = [
            "plotTop",
            "marginRight",
            "marginBottom",
            "plotLeft"
        ], i.noop = function() {}, i.supportsPassiveEvents = function() {
            let t = !1;
            if (!i.isMS) {
                let e = Object.defineProperty({}, "passive", {
                    get: function() {
                        t = !0;
                    }
                });
                i.win.addEventListener && i.win.removeEventListener && (i.win.addEventListener("testPassive", i.noop, e), i.win.removeEventListener("testPassive", i.noop, e));
            }
            return t;
        }(), i.charts = [], i.composed = [], i.dateFormats = {}, i.seriesTypes = {}, i.symbolSizes = {}, i.chartCount = 0, e;
    }), i(e, "Core/Utilities.js", [
        e["Core/Globals.js"]
    ], function(t) {
        let e;
        let { charts: i, doc: s, win: r } = t;
        function o(e, i, s, a) {
            let n = i ? "Highcharts error" : "Highcharts warning";
            32 === e && (e = `${n}: Deprecated member`);
            let h = p(e), l = h ? `${n} #${e}: www.highcharts.com/errors/${e}/` : e.toString();
            if (void 0 !== a) {
                let t = "";
                h && (l += "?"), k(a, function(e, i) {
                    t += `
 - ${i}: ${e}`, h && (l += encodeURI(i) + "=" + encodeURI(e));
                }), l += t;
            }
            M(t, "displayError", {
                chart: s,
                code: e,
                message: l,
                params: a
            }, function() {
                if (i) throw Error(l);
                r.console && -1 === o.messages.indexOf(l) && console.warn(l);
            }), o.messages.push(l);
        }
        function a(t, e) {
            return parseInt(t, e || 10);
        }
        function n(t) {
            return "string" == typeof t;
        }
        function h(t) {
            let e = Object.prototype.toString.call(t);
            return "[object Array]" === e || "[object Array Iterator]" === e;
        }
        function l(t, e) {
            return !!t && "object" == typeof t && (!e || !h(t));
        }
        function d(t) {
            return l(t) && "number" == typeof t.nodeType;
        }
        function c(t) {
            let e = t && t.constructor;
            return !!(l(t, !0) && !d(t) && e && e.name && "Object" !== e.name);
        }
        function p(t) {
            return "number" == typeof t && !isNaN(t) && t < 1 / 0 && t > -1 / 0;
        }
        function u(t) {
            return null != t;
        }
        function g(t, e, i) {
            let s;
            let r = n(e) && !u(i), o = (e, i)=>{
                u(e) ? t.setAttribute(i, e) : r ? (s = t.getAttribute(i)) || "class" !== i || (s = t.getAttribute(i + "Name")) : t.removeAttribute(i);
            };
            return n(e) ? o(i, e) : k(e, o), s;
        }
        function f(t) {
            return h(t) ? t : [
                t
            ];
        }
        function m(t, e) {
            let i;
            for(i in t || (t = {}), e)t[i] = e[i];
            return t;
        }
        function x() {
            let t = arguments, e = t.length;
            for(let i = 0; i < e; i++){
                let e = t[i];
                if (null != e) return e;
            }
        }
        function y(t, e) {
            m(t.style, e);
        }
        function b(t) {
            return Math.pow(10, Math.floor(Math.log(t) / Math.LN10));
        }
        function v(t, e) {
            return t > 1e14 ? t : parseFloat(t.toPrecision(e || 14));
        }
        (o || (o = {})).messages = [], Math.easeInOutSine = function(t) {
            return -0.5 * (Math.cos(Math.PI * t) - 1);
        };
        let S = Array.prototype.find ? function(t, e) {
            return t.find(e);
        } : function(t, e) {
            let i;
            let s = t.length;
            for(i = 0; i < s; i++)if (e(t[i], i)) return t[i];
        };
        function k(t, e, i) {
            for(let s in t)Object.hasOwnProperty.call(t, s) && e.call(i || t[s], t[s], s, t);
        }
        function C(t, e, i) {
            function s(e, i) {
                let s = t.removeEventListener;
                s && s.call(t, e, i, !1);
            }
            function r(i) {
                let r, o;
                t.nodeName && (e ? (r = {})[e] = !0 : r = i, k(r, function(t, e) {
                    if (i[e]) for(o = i[e].length; o--;)s(e, i[e][o].fn);
                }));
            }
            let o = "function" == typeof t && t.prototype || t;
            if (Object.hasOwnProperty.call(o, "hcEvents")) {
                let t = o.hcEvents;
                if (e) {
                    let o = t[e] || [];
                    i ? (t[e] = o.filter(function(t) {
                        return i !== t.fn;
                    }), s(e, i)) : (r(t), t[e] = []);
                } else r(t), delete o.hcEvents;
            }
        }
        function M(e, i, r, o) {
            if (r = r || {}, s.createEvent && (e.dispatchEvent || e.fireEvent && e !== t)) {
                let t = s.createEvent("Events");
                t.initEvent(i, !0, !0), r = m(t, r), e.dispatchEvent ? e.dispatchEvent(r) : e.fireEvent(i, r);
            } else if (e.hcEvents) {
                r.target || m(r, {
                    preventDefault: function() {
                        r.defaultPrevented = !0;
                    },
                    target: e,
                    type: i
                });
                let t = [], s = e, o = !1;
                for(; s.hcEvents;)Object.hasOwnProperty.call(s, "hcEvents") && s.hcEvents[i] && (t.length && (o = !0), t.unshift.apply(t, s.hcEvents[i])), s = Object.getPrototypeOf(s);
                o && t.sort((t, e)=>t.order - e.order), t.forEach((t)=>{
                    !1 === t.fn.call(e, r) && r.preventDefault();
                });
            }
            o && !r.defaultPrevented && o.call(e, r);
        }
        k({
            map: "map",
            each: "forEach",
            grep: "filter",
            reduce: "reduce",
            some: "some"
        }, function(e, i) {
            t[i] = function(t) {
                return o(32, !1, void 0, {
                    [`Highcharts.${i}`]: `use Array.${e}`
                }), Array.prototype[e].apply(t, [].slice.call(arguments, 1));
            };
        });
        let w = function() {
            let t = Math.random().toString(36).substring(2, 9) + "-", i = 0;
            return function() {
                return "highcharts-" + (e ? "" : t) + i++;
            };
        }();
        return r.jQuery && (r.jQuery.fn.highcharts = function() {
            let e = [].slice.call(arguments);
            if (this[0]) return e[0] ? (new t[n(e[0]) ? e.shift() : "Chart"](this[0], e[0], e[1]), this) : i[g(this[0], "data-highcharts-chart")];
        }), {
            addEvent: function(e, i, s, r = {}) {
                let o = "function" == typeof e && e.prototype || e;
                Object.hasOwnProperty.call(o, "hcEvents") || (o.hcEvents = {});
                let a = o.hcEvents;
                t.Point && e instanceof t.Point && e.series && e.series.chart && (e.series.chart.runTrackerClick = !0);
                let n = e.addEventListener;
                n && n.call(e, i, s, !!t.supportsPassiveEvents && {
                    passive: void 0 === r.passive ? -1 !== i.indexOf("touch") : r.passive,
                    capture: !1
                }), a[i] || (a[i] = []);
                let h = {
                    fn: s,
                    order: "number" == typeof r.order ? r.order : 1 / 0
                };
                return a[i].push(h), a[i].sort((t, e)=>t.order - e.order), function() {
                    C(e, i, s);
                };
            },
            arrayMax: function(t) {
                let e = t.length, i = t[0];
                for(; e--;)t[e] > i && (i = t[e]);
                return i;
            },
            arrayMin: function(t) {
                let e = t.length, i = t[0];
                for(; e--;)t[e] < i && (i = t[e]);
                return i;
            },
            attr: g,
            clamp: function(t, e, i) {
                return t > e ? t < i ? t : i : e;
            },
            clearTimeout: function(t) {
                u(t) && clearTimeout(t);
            },
            correctFloat: v,
            createElement: function(t, e, i, r, o) {
                let a = s.createElement(t);
                return e && m(a, e), o && y(a, {
                    padding: "0",
                    border: "none",
                    margin: "0"
                }), i && y(a, i), r && r.appendChild(a), a;
            },
            css: y,
            defined: u,
            destroyObjectProperties: function(t, e, i) {
                k(t, function(s, r) {
                    s !== e && s?.destroy && s.destroy(), (s?.destroy || !i) && delete t[r];
                });
            },
            diffObjects: function(t, e, i, s) {
                let r = {};
                return function t(e, r, o, a) {
                    let n = i ? r : e;
                    k(e, function(i, d) {
                        if (!a && s && s.indexOf(d) > -1 && r[d]) {
                            i = f(i), o[d] = [];
                            for(let e = 0; e < Math.max(i.length, r[d].length); e++)r[d][e] && (void 0 === i[e] ? o[d][e] = r[d][e] : (o[d][e] = {}, t(i[e], r[d][e], o[d][e], a + 1)));
                        } else l(i, !0) && !i.nodeType ? (o[d] = h(i) ? [] : {}, t(i, r[d] || {}, o[d], a + 1), 0 !== Object.keys(o[d]).length || "colorAxis" === d && 0 === a || delete o[d]) : (e[d] !== r[d] || d in e && !(d in r)) && "__proto__" !== d && "constructor" !== d && (o[d] = n[d]);
                    });
                }(t, e, r, 0), r;
            },
            discardElement: function(t) {
                t && t.parentElement && t.parentElement.removeChild(t);
            },
            erase: function(t, e) {
                let i = t.length;
                for(; i--;)if (t[i] === e) {
                    t.splice(i, 1);
                    break;
                }
            },
            error: o,
            extend: m,
            extendClass: function(t, e) {
                let i = function() {};
                return i.prototype = new t, m(i.prototype, e), i;
            },
            find: S,
            fireEvent: M,
            getClosestDistance: function(t, e) {
                let i, s, r, o;
                let a = !e;
                return t.forEach((t)=>{
                    if (t.length > 1) for(o = s = t.length - 1; o > 0; o--)(r = t[o] - t[o - 1]) < 0 && !a ? (e?.(), e = void 0) : r && (void 0 === i || r < i) && (i = r);
                }), i;
            },
            getMagnitude: b,
            getNestedProperty: function(t, e) {
                let i = t.split(".");
                for(; i.length && u(e);){
                    let t = i.shift();
                    if (void 0 === t || "__proto__" === t) return;
                    if ("this" === t) {
                        let t;
                        return l(e) && (t = e["@this"]), t ?? e;
                    }
                    let s = e[t];
                    if (!u(s) || "function" == typeof s || "number" == typeof s.nodeType || s === r) return;
                    e = s;
                }
                return e;
            },
            getStyle: function t(e, i, s) {
                let o;
                if ("width" === i) {
                    let i = Math.min(e.offsetWidth, e.scrollWidth), s = e.getBoundingClientRect && e.getBoundingClientRect().width;
                    return s < i && s >= i - 1 && (i = Math.floor(s)), Math.max(0, i - (t(e, "padding-left", !0) || 0) - (t(e, "padding-right", !0) || 0));
                }
                if ("height" === i) return Math.max(0, Math.min(e.offsetHeight, e.scrollHeight) - (t(e, "padding-top", !0) || 0) - (t(e, "padding-bottom", !0) || 0));
                let n = r.getComputedStyle(e, void 0);
                return n && (o = n.getPropertyValue(i), x(s, "opacity" !== i) && (o = a(o))), o;
            },
            inArray: function(t, e, i) {
                return o(32, !1, void 0, {
                    "Highcharts.inArray": "use Array.indexOf"
                }), e.indexOf(t, i);
            },
            insertItem: function(t, e) {
                let i;
                let s = t.options.index, r = e.length;
                for(i = t.options.isInternal ? r : 0; i < r + 1; i++)if (!e[i] || p(s) && s < x(e[i].options.index, e[i]._i) || e[i].options.isInternal) {
                    e.splice(i, 0, t);
                    break;
                }
                return i;
            },
            isArray: h,
            isClass: c,
            isDOMElement: d,
            isFunction: function(t) {
                return "function" == typeof t;
            },
            isNumber: p,
            isObject: l,
            isString: n,
            keys: function(t) {
                return o(32, !1, void 0, {
                    "Highcharts.keys": "use Object.keys"
                }), Object.keys(t);
            },
            merge: function() {
                let t, e = arguments, i = {}, s = function(t, e) {
                    return "object" != typeof t && (t = {}), k(e, function(i, r) {
                        "__proto__" !== r && "constructor" !== r && (!l(i, !0) || c(i) || d(i) ? t[r] = e[r] : t[r] = s(t[r] || {}, i));
                    }), t;
                };
                !0 === e[0] && (i = e[1], e = Array.prototype.slice.call(e, 2));
                let r = e.length;
                for(t = 0; t < r; t++)i = s(i, e[t]);
                return i;
            },
            normalizeTickInterval: function(t, e, i, s, r) {
                let o, a = t;
                i = x(i, b(t));
                let n = t / i;
                for(!e && (e = r ? [
                    1,
                    1.2,
                    1.5,
                    2,
                    2.5,
                    3,
                    4,
                    5,
                    6,
                    8,
                    10
                ] : [
                    1,
                    2,
                    2.5,
                    5,
                    10
                ], !1 === s && (1 === i ? e = e.filter(function(t) {
                    return t % 1 == 0;
                }) : i <= .1 && (e = [
                    1 / i
                ]))), o = 0; o < e.length && (a = e[o], (!r || !(a * i >= t)) && (r || !(n <= (e[o] + (e[o + 1] || e[o])) / 2))); o++);
                return v(a * i, -Math.round(Math.log(.001) / Math.LN10));
            },
            objectEach: k,
            offset: function(t) {
                let e = s.documentElement, i = t.parentElement || t.parentNode ? t.getBoundingClientRect() : {
                    top: 0,
                    left: 0,
                    width: 0,
                    height: 0
                };
                return {
                    top: i.top + (r.pageYOffset || e.scrollTop) - (e.clientTop || 0),
                    left: i.left + (r.pageXOffset || e.scrollLeft) - (e.clientLeft || 0),
                    width: i.width,
                    height: i.height
                };
            },
            pad: function(t, e, i) {
                return Array((e || 2) + 1 - String(t).replace("-", "").length).join(i || "0") + t;
            },
            pick: x,
            pInt: a,
            pushUnique: function(t, e) {
                return 0 > t.indexOf(e) && !!t.push(e);
            },
            relativeLength: function(t, e, i) {
                return /%$/.test(t) ? e * parseFloat(t) / 100 + (i || 0) : parseFloat(t);
            },
            removeEvent: C,
            replaceNested: function(t, ...e) {
                let i, s;
                do for (s of (i = t, e))t = t.replace(s[0], s[1]);
                while (t !== i);
                return t;
            },
            splat: f,
            stableSort: function(t, e) {
                let i, s;
                let r = t.length;
                for(s = 0; s < r; s++)t[s].safeI = s;
                for(t.sort(function(t, s) {
                    return 0 === (i = e(t, s)) ? t.safeI - s.safeI : i;
                }), s = 0; s < r; s++)delete t[s].safeI;
            },
            syncTimeout: function(t, e, i) {
                return e > 0 ? setTimeout(t, e, i) : (t.call(0, i), -1);
            },
            timeUnits: {
                millisecond: 1,
                second: 1e3,
                minute: 6e4,
                hour: 36e5,
                day: 864e5,
                week: 6048e5,
                month: 24192e5,
                year: 314496e5
            },
            uniqueKey: w,
            useSerialIds: function(t) {
                return e = x(t, e);
            },
            wrap: function(t, e, i) {
                let s = t[e];
                t[e] = function() {
                    let t = arguments, e = this;
                    return i.apply(this, [
                        function() {
                            return s.apply(e, arguments.length ? arguments : t);
                        }
                    ].concat([].slice.call(arguments)));
                };
            }
        };
    }), i(e, "Core/Chart/ChartDefaults.js", [], function() {
        return {
            alignThresholds: !1,
            panning: {
                enabled: !1,
                type: "x"
            },
            styledMode: !1,
            borderRadius: 0,
            colorCount: 10,
            allowMutatingData: !0,
            ignoreHiddenSeries: !0,
            spacing: [
                10,
                10,
                15,
                10
            ],
            resetZoomButton: {
                theme: {},
                position: {}
            },
            reflow: !0,
            type: "line",
            zooming: {
                singleTouch: !1,
                resetButton: {
                    theme: {
                        zIndex: 6
                    },
                    position: {
                        align: "right",
                        x: -10,
                        y: 10
                    }
                }
            },
            width: null,
            height: null,
            borderColor: "#334eff",
            backgroundColor: "#ffffff",
            plotBorderColor: "#cccccc"
        };
    }), i(e, "Core/Color/Palettes.js", [], function() {
        return {
            colors: [
                "#2caffe",
                "#544fc5",
                "#00e272",
                "#fe6a35",
                "#6b8abc",
                "#d568fb",
                "#2ee0ca",
                "#fa4b42",
                "#feb56a",
                "#91e8e1"
            ]
        };
    }), i(e, "Core/Time.js", [
        e["Core/Globals.js"],
        e["Core/Utilities.js"]
    ], function(t, e) {
        let { win: i } = t, { defined: s, error: r, extend: o, isNumber: a, isObject: n, merge: h, objectEach: l, pad: d, pick: c, splat: p, timeUnits: u } = e, g = t.isSafari && i.Intl && i.Intl.DateTimeFormat.prototype.formatRange, f = t.isSafari && i.Intl && !i.Intl.DateTimeFormat.prototype.formatRange;
        class m {
            constructor(t){
                this.options = {}, this.useUTC = !1, this.variableTimezone = !1, this.Date = i.Date, this.getTimezoneOffset = this.timezoneOffsetFunction(), this.update(t);
            }
            get(t, e) {
                if (this.variableTimezone || this.timezoneOffset) {
                    let i = e.getTime(), s = i - this.getTimezoneOffset(e);
                    e.setTime(s);
                    let r = e["getUTC" + t]();
                    return e.setTime(i), r;
                }
                return this.useUTC ? e["getUTC" + t]() : e["get" + t]();
            }
            set(t, e, i) {
                if (this.variableTimezone || this.timezoneOffset) {
                    if ("Milliseconds" === t || "Seconds" === t || "Minutes" === t && this.getTimezoneOffset(e) % 36e5 == 0) return e["setUTC" + t](i);
                    let s = this.getTimezoneOffset(e), r = e.getTime() - s;
                    e.setTime(r), e["setUTC" + t](i);
                    let o = this.getTimezoneOffset(e);
                    return r = e.getTime() + o, e.setTime(r);
                }
                return this.useUTC || g && "FullYear" === t ? e["setUTC" + t](i) : e["set" + t](i);
            }
            update(t = {}) {
                let e = c(t.useUTC, !0);
                this.options = t = h(!0, this.options, t), this.Date = t.Date || i.Date || Date, this.useUTC = e, this.timezoneOffset = e && t.timezoneOffset || void 0, this.getTimezoneOffset = this.timezoneOffsetFunction(), this.variableTimezone = e && !!(t.getTimezoneOffset || t.timezone);
            }
            makeTime(t, e, i, s, r, o) {
                let a, n, h;
                return this.useUTC ? (a = this.Date.UTC.apply(0, arguments), n = this.getTimezoneOffset(a), a += n, n !== (h = this.getTimezoneOffset(a)) ? a += h - n : n - 36e5 !== this.getTimezoneOffset(a - 36e5) || f || (a -= 36e5)) : a = new this.Date(t, e, c(i, 1), c(s, 0), c(r, 0), c(o, 0)).getTime(), a;
            }
            timezoneOffsetFunction() {
                let t = this, e = this.options, i = e.getTimezoneOffset;
                return this.useUTC ? e.timezone ? (t)=>{
                    try {
                        let i = `shortOffset,${e.timezone || ""}`, [s, r, o, n, h = 0] = (m.formatCache[i] = m.formatCache[i] || Intl.DateTimeFormat("en", {
                            timeZone: e.timezone,
                            timeZoneName: "shortOffset"
                        })).format(t).split(/(GMT|:)/).map(Number), l = -(36e5 * (o + h / 60));
                        if (a(l)) return l;
                    } catch (t) {
                        r(34);
                    }
                    return 0;
                } : this.useUTC && i ? (t)=>6e4 * i(t.valueOf()) : ()=>6e4 * (t.timezoneOffset || 0) : (t)=>6e4 * new Date(t.toString()).getTimezoneOffset();
            }
            dateFormat(e, i, r) {
                if (!s(i) || isNaN(i)) return t.defaultOptions.lang && t.defaultOptions.lang.invalidDate || "";
                e = c(e, "%Y-%m-%d %H:%M:%S");
                let a = this, n = new this.Date(i), h = this.get("Hours", n), p = this.get("Day", n), u = this.get("Date", n), g = this.get("Month", n), f = this.get("FullYear", n), m = t.defaultOptions.lang, x = m && m.weekdays, y = m && m.shortWeekdays;
                return l(o({
                    a: y ? y[p] : x[p].substr(0, 3),
                    A: x[p],
                    d: d(u),
                    e: d(u, 2, " "),
                    w: p,
                    b: m.shortMonths[g],
                    B: m.months[g],
                    m: d(g + 1),
                    o: g + 1,
                    y: f.toString().substr(2, 2),
                    Y: f,
                    H: d(h),
                    k: h,
                    I: d(h % 12 || 12),
                    l: h % 12 || 12,
                    M: d(this.get("Minutes", n)),
                    p: h < 12 ? "AM" : "PM",
                    P: h < 12 ? "am" : "pm",
                    S: d(this.get("Seconds", n)),
                    L: d(Math.floor(i % 1e3), 3)
                }, t.dateFormats), function(t, s) {
                    for(; -1 !== e.indexOf("%" + s);)e = e.replace("%" + s, "function" == typeof t ? t.call(a, i) : t);
                }), r ? e.substr(0, 1).toUpperCase() + e.substr(1) : e;
            }
            resolveDTLFormat(t) {
                return n(t, !0) ? t : {
                    main: (t = p(t))[0],
                    from: t[1],
                    to: t[2]
                };
            }
            getTimeTicks(t, e, i, r) {
                let a, n, h, l;
                let d = this, p = d.Date, g = [], f = {}, m = new p(e), x = t.unitRange, y = t.count || 1;
                if (r = c(r, 1), s(e)) {
                    d.set("Milliseconds", m, x >= u.second ? 0 : y * Math.floor(d.get("Milliseconds", m) / y)), x >= u.second && d.set("Seconds", m, x >= u.minute ? 0 : y * Math.floor(d.get("Seconds", m) / y)), x >= u.minute && d.set("Minutes", m, x >= u.hour ? 0 : y * Math.floor(d.get("Minutes", m) / y)), x >= u.hour && d.set("Hours", m, x >= u.day ? 0 : y * Math.floor(d.get("Hours", m) / y)), x >= u.day && d.set("Date", m, x >= u.month ? 1 : Math.max(1, y * Math.floor(d.get("Date", m) / y))), x >= u.month && (d.set("Month", m, x >= u.year ? 0 : y * Math.floor(d.get("Month", m) / y)), n = d.get("FullYear", m)), x >= u.year && (n -= n % y, d.set("FullYear", m, n)), x === u.week && (l = d.get("Day", m), d.set("Date", m, d.get("Date", m) - l + r + (l < r ? -7 : 0))), n = d.get("FullYear", m);
                    let t = d.get("Month", m), o = d.get("Date", m), c = d.get("Hours", m);
                    e = m.getTime(), (d.variableTimezone || !d.useUTC) && s(i) && (h = i - e > 4 * u.month || d.getTimezoneOffset(e) !== d.getTimezoneOffset(i));
                    let p = m.getTime();
                    for(a = 1; p < i;)g.push(p), x === u.year ? p = d.makeTime(n + a * y, 0) : x === u.month ? p = d.makeTime(n, t + a * y) : h && (x === u.day || x === u.week) ? p = d.makeTime(n, t, o + a * y * (x === u.day ? 1 : 7)) : h && x === u.hour && y > 1 ? p = d.makeTime(n, t, o, c + a * y) : p += x * y, a++;
                    g.push(p), x <= u.hour && g.length < 1e4 && g.forEach(function(t) {
                        t % 18e5 == 0 && "000000000" === d.dateFormat("%H%M%S%L", t) && (f[t] = "day");
                    });
                }
                return g.info = o(t, {
                    higherRanks: f,
                    totalRange: x * y
                }), g;
            }
            getDateFormat(t, e, i, s) {
                let r = this.dateFormat("%m-%d %H:%M:%S.%L", e), o = "01-01 00:00:00.000", a = {
                    millisecond: 15,
                    second: 12,
                    minute: 9,
                    hour: 6,
                    day: 3
                }, n = "millisecond", h = n;
                for(n in u){
                    if (t === u.week && +this.dateFormat("%w", e) === i && r.substr(6) === o.substr(6)) {
                        n = "week";
                        break;
                    }
                    if (u[n] > t) {
                        n = h;
                        break;
                    }
                    if (a[n] && r.substr(a[n]) !== o.substr(a[n])) break;
                    "week" !== n && (h = n);
                }
                return this.resolveDTLFormat(s[n]).main;
            }
        }
        return m.formatCache = {}, m;
    }), i(e, "Core/Defaults.js", [
        e["Core/Chart/ChartDefaults.js"],
        e["Core/Globals.js"],
        e["Core/Color/Palettes.js"],
        e["Core/Time.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i, s, r) {
        let { isTouchDevice: o, svg: a } = e, { merge: n } = r, h = {
            colors: i.colors,
            symbols: [
                "circle",
                "diamond",
                "square",
                "triangle",
                "triangle-down"
            ],
            lang: {
                loading: "Loading...",
                months: [
                    "January",
                    "February",
                    "March",
                    "April",
                    "May",
                    "June",
                    "July",
                    "August",
                    "September",
                    "October",
                    "November",
                    "December"
                ],
                shortMonths: [
                    "Jan",
                    "Feb",
                    "Mar",
                    "Apr",
                    "May",
                    "Jun",
                    "Jul",
                    "Aug",
                    "Sep",
                    "Oct",
                    "Nov",
                    "Dec"
                ],
                weekdays: [
                    "Sunday",
                    "Monday",
                    "Tuesday",
                    "Wednesday",
                    "Thursday",
                    "Friday",
                    "Saturday"
                ],
                decimalPoint: ".",
                numericSymbols: [
                    "k",
                    "M",
                    "G",
                    "T",
                    "P",
                    "E"
                ],
                resetZoom: "Reset zoom",
                resetZoomTitle: "Reset zoom level 1:1",
                thousandsSep: " "
            },
            global: {},
            time: {
                Date: void 0,
                getTimezoneOffset: void 0,
                timezone: void 0,
                timezoneOffset: 0,
                useUTC: !0
            },
            chart: t,
            title: {
                style: {
                    color: "#333333",
                    fontWeight: "bold"
                },
                text: "Chart title",
                align: "center",
                margin: 15,
                widthAdjust: -44
            },
            subtitle: {
                style: {
                    color: "#666666",
                    fontSize: "0.8em"
                },
                text: "",
                align: "center",
                widthAdjust: -44
            },
            caption: {
                margin: 15,
                style: {
                    color: "#666666",
                    fontSize: "0.8em"
                },
                text: "",
                align: "left",
                verticalAlign: "bottom"
            },
            plotOptions: {},
            legend: {
                enabled: !0,
                align: "center",
                alignColumns: !0,
                className: "highcharts-no-tooltip",
                layout: "horizontal",
                itemMarginBottom: 2,
                itemMarginTop: 2,
                labelFormatter: function() {
                    return this.name;
                },
                borderColor: "#999999",
                borderRadius: 0,
                navigation: {
                    style: {
                        fontSize: "0.8em"
                    },
                    activeColor: "#0022ff",
                    inactiveColor: "#cccccc"
                },
                itemStyle: {
                    color: "#333333",
                    cursor: "pointer",
                    fontSize: "0.8em",
                    textDecoration: "none",
                    textOverflow: "ellipsis"
                },
                itemHoverStyle: {
                    color: "#000000"
                },
                itemHiddenStyle: {
                    color: "#666666",
                    textDecoration: "line-through"
                },
                shadow: !1,
                itemCheckboxStyle: {
                    position: "absolute",
                    width: "13px",
                    height: "13px"
                },
                squareSymbol: !0,
                symbolPadding: 5,
                verticalAlign: "bottom",
                x: 0,
                y: 0,
                title: {
                    style: {
                        fontSize: "0.8em",
                        fontWeight: "bold"
                    }
                }
            },
            loading: {
                labelStyle: {
                    fontWeight: "bold",
                    position: "relative",
                    top: "45%"
                },
                style: {
                    position: "absolute",
                    backgroundColor: "#ffffff",
                    opacity: .5,
                    textAlign: "center"
                }
            },
            tooltip: {
                enabled: !0,
                animation: a,
                borderRadius: 3,
                dateTimeLabelFormats: {
                    millisecond: "%A, %e %b, %H:%M:%S.%L",
                    second: "%A, %e %b, %H:%M:%S",
                    minute: "%A, %e %b, %H:%M",
                    hour: "%A, %e %b, %H:%M",
                    day: "%A, %e %b %Y",
                    week: "Week from %A, %e %b %Y",
                    month: "%B %Y",
                    year: "%Y"
                },
                footerFormat: "",
                headerShape: "callout",
                hideDelay: 500,
                padding: 8,
                shape: "callout",
                shared: !1,
                snap: o ? 25 : 10,
                headerFormat: '<span style="font-size: 0.8em">{point.key}</span><br/>',
                pointFormat: '<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y}</b><br/>',
                backgroundColor: "#ffffff",
                borderWidth: void 0,
                shadow: !0,
                stickOnContact: !1,
                style: {
                    color: "#333333",
                    cursor: "default",
                    fontSize: "0.8em"
                },
                useHTML: !1
            },
            credits: {
                enabled: !0,
                href: "https://www.highcharts.com?credits",
                position: {
                    align: "right",
                    x: -10,
                    verticalAlign: "bottom",
                    y: -5
                },
                style: {
                    cursor: "pointer",
                    color: "#999999",
                    fontSize: "0.6em"
                },
                text: "Highcharts.com"
            }
        };
        h.chart.styledMode = !1;
        let l = new s(h.time);
        return {
            defaultOptions: h,
            defaultTime: l,
            getOptions: function() {
                return h;
            },
            setOptions: function(t) {
                return n(!0, h, t), (t.time || t.global) && (e.time ? e.time.update(n(h.global, h.time, t.global, t.time)) : e.time = l), h;
            }
        };
    }), i(e, "Core/Color/Color.js", [
        e["Core/Globals.js"],
        e["Core/Utilities.js"]
    ], function(t, e) {
        let { isNumber: i, merge: s, pInt: r } = e;
        class o {
            static parse(t) {
                return t ? new o(t) : o.None;
            }
            constructor(e){
                let i, s, r, a;
                this.rgba = [
                    NaN,
                    NaN,
                    NaN,
                    NaN
                ], this.input = e;
                let n = t.Color;
                if (n && n !== o) return new n(e);
                if ("object" == typeof e && void 0 !== e.stops) this.stops = e.stops.map((t)=>new o(t[1]));
                else if ("string" == typeof e) {
                    if (this.input = e = o.names[e.toLowerCase()] || e, "#" === e.charAt(0)) {
                        let t = e.length, i = parseInt(e.substr(1), 16);
                        7 === t ? s = [
                            (16711680 & i) >> 16,
                            (65280 & i) >> 8,
                            255 & i,
                            1
                        ] : 4 === t && (s = [
                            (3840 & i) >> 4 | (3840 & i) >> 8,
                            (240 & i) >> 4 | 240 & i,
                            (15 & i) << 4 | 15 & i,
                            1
                        ]);
                    }
                    if (!s) for(r = o.parsers.length; r-- && !s;)(i = (a = o.parsers[r]).regex.exec(e)) && (s = a.parse(i));
                }
                s && (this.rgba = s);
            }
            get(t) {
                let e = this.input, r = this.rgba;
                if ("object" == typeof e && void 0 !== this.stops) {
                    let i = s(e);
                    return i.stops = [].slice.call(i.stops), this.stops.forEach((e, s)=>{
                        i.stops[s] = [
                            i.stops[s][0],
                            e.get(t)
                        ];
                    }), i;
                }
                return r && i(r[0]) ? "rgb" !== t && (t || 1 !== r[3]) ? "a" === t ? `${r[3]}` : "rgba(" + r.join(",") + ")" : "rgb(" + r[0] + "," + r[1] + "," + r[2] + ")" : e;
            }
            brighten(t) {
                let e = this.rgba;
                if (this.stops) this.stops.forEach(function(e) {
                    e.brighten(t);
                });
                else if (i(t) && 0 !== t) for(let i = 0; i < 3; i++)e[i] += r(255 * t), e[i] < 0 && (e[i] = 0), e[i] > 255 && (e[i] = 255);
                return this;
            }
            setOpacity(t) {
                return this.rgba[3] = t, this;
            }
            tweenTo(t, e) {
                let s = this.rgba, r = t.rgba;
                if (!i(s[0]) || !i(r[0])) return t.input || "none";
                let o = 1 !== r[3] || 1 !== s[3];
                return (o ? "rgba(" : "rgb(") + Math.round(r[0] + (s[0] - r[0]) * (1 - e)) + "," + Math.round(r[1] + (s[1] - r[1]) * (1 - e)) + "," + Math.round(r[2] + (s[2] - r[2]) * (1 - e)) + (o ? "," + (r[3] + (s[3] - r[3]) * (1 - e)) : "") + ")";
            }
        }
        return o.names = {
            white: "#ffffff",
            black: "#000000"
        }, o.parsers = [
            {
                regex: /rgba\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]?(?:\.[0-9]+)?)\s*\)/,
                parse: function(t) {
                    return [
                        r(t[1]),
                        r(t[2]),
                        r(t[3]),
                        parseFloat(t[4], 10)
                    ];
                }
            },
            {
                regex: /rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/,
                parse: function(t) {
                    return [
                        r(t[1]),
                        r(t[2]),
                        r(t[3]),
                        1
                    ];
                }
            }
        ], o.None = new o(""), o;
    }), i(e, "Core/Animation/Fx.js", [
        e["Core/Color/Color.js"],
        e["Core/Globals.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i) {
        let { parse: s } = t, { win: r } = e, { isNumber: o, objectEach: a } = i;
        class n {
            constructor(t, e, i){
                this.pos = NaN, this.options = e, this.elem = t, this.prop = i;
            }
            dSetter() {
                let t = this.paths, e = t && t[0], i = t && t[1], s = this.now || 0, r = [];
                if (1 !== s && e && i) {
                    if (e.length === i.length && s < 1) for(let t = 0; t < i.length; t++){
                        let a = e[t], n = i[t], h = [];
                        for(let t = 0; t < n.length; t++){
                            let e = a[t], i = n[t];
                            o(e) && o(i) && !("A" === n[0] && (4 === t || 5 === t)) ? h[t] = e + s * (i - e) : h[t] = i;
                        }
                        r.push(h);
                    }
                    else r = i;
                } else r = this.toD || [];
                this.elem.attr("d", r, void 0, !0);
            }
            update() {
                let t = this.elem, e = this.prop, i = this.now, s = this.options.step;
                this[e + "Setter"] ? this[e + "Setter"]() : t.attr ? t.element && t.attr(e, i, null, !0) : t.style[e] = i + this.unit, s && s.call(t, i, this);
            }
            run(t, e, i) {
                let s = this, o = s.options, a = function(t) {
                    return !a.stopped && s.step(t);
                }, h = r.requestAnimationFrame || function(t) {
                    setTimeout(t, 13);
                }, l = function() {
                    for(let t = 0; t < n.timers.length; t++)n.timers[t]() || n.timers.splice(t--, 1);
                    n.timers.length && h(l);
                };
                t !== e || this.elem["forceAnimate:" + this.prop] ? (this.startTime = +new Date, this.start = t, this.end = e, this.unit = i, this.now = this.start, this.pos = 0, a.elem = this.elem, a.prop = this.prop, a() && 1 === n.timers.push(a) && h(l)) : (delete o.curAnim[this.prop], o.complete && 0 === Object.keys(o.curAnim).length && o.complete.call(this.elem));
            }
            step(t) {
                let e, i;
                let s = +new Date, r = this.options, o = this.elem, n = r.complete, h = r.duration, l = r.curAnim;
                return o.attr && !o.element ? e = !1 : t || s >= h + this.startTime ? (this.now = this.end, this.pos = 1, this.update(), l[this.prop] = !0, i = !0, a(l, function(t) {
                    !0 !== t && (i = !1);
                }), i && n && n.call(o), e = !1) : (this.pos = r.easing((s - this.startTime) / h), this.now = this.start + (this.end - this.start) * this.pos, this.update(), e = !0), e;
            }
            initPath(t, e, i) {
                let s = t.startX, r = t.endX, a = i.slice(), n = t.isArea, h = n ? 2 : 1, l, d, c, p, u = e && e.slice();
                if (!u) return [
                    a,
                    a
                ];
                function g(t, e) {
                    for(; t.length < d;){
                        let i = t[0], s = e[d - t.length];
                        if (s && "M" === i[0] && ("C" === s[0] ? t[0] = [
                            "C",
                            i[1],
                            i[2],
                            i[1],
                            i[2],
                            i[1],
                            i[2]
                        ] : t[0] = [
                            "L",
                            i[1],
                            i[2]
                        ]), t.unshift(i), n) {
                            let e = t.pop();
                            t.push(t[t.length - 1], e);
                        }
                    }
                }
                function f(t) {
                    for(; t.length < d;){
                        let e = t[Math.floor(t.length / h) - 1].slice();
                        if ("C" === e[0] && (e[1] = e[5], e[2] = e[6]), n) {
                            let i = t[Math.floor(t.length / h)].slice();
                            t.splice(t.length / 2, 0, e, i);
                        } else t.push(e);
                    }
                }
                if (s && r && r.length) {
                    for(c = 0; c < s.length; c++){
                        if (s[c] === r[0]) {
                            l = c;
                            break;
                        }
                        if (s[0] === r[r.length - s.length + c]) {
                            l = c, p = !0;
                            break;
                        }
                        if (s[s.length - 1] === r[r.length - s.length + c]) {
                            l = s.length - c;
                            break;
                        }
                    }
                    void 0 === l && (u = []);
                }
                return u.length && o(l) && (d = a.length + l * h, p ? (g(u, a), f(a)) : (g(a, u), f(u))), [
                    u,
                    a
                ];
            }
            fillSetter() {
                n.prototype.strokeSetter.apply(this, arguments);
            }
            strokeSetter() {
                this.elem.attr(this.prop, s(this.start).tweenTo(s(this.end), this.pos), void 0, !0);
            }
        }
        return n.timers = [], n;
    }), i(e, "Core/Animation/AnimationUtilities.js", [
        e["Core/Animation/Fx.js"],
        e["Core/Utilities.js"]
    ], function(t, e) {
        let { defined: i, getStyle: s, isArray: r, isNumber: o, isObject: a, merge: n, objectEach: h, pick: l } = e;
        function d(t) {
            return a(t) ? n({
                duration: 500,
                defer: 0
            }, t) : {
                duration: t ? 500 : 0,
                defer: 0
            };
        }
        function c(e, i) {
            let s = t.timers.length;
            for(; s--;)t.timers[s].elem !== e || i && i !== t.timers[s].prop || (t.timers[s].stopped = !0);
        }
        return {
            animate: function(e, i, l) {
                let d, p = "", u, g, f;
                a(l) || (f = arguments, l = {
                    duration: f[2],
                    easing: f[3],
                    complete: f[4]
                }), o(l.duration) || (l.duration = 400), l.easing = "function" == typeof l.easing ? l.easing : Math[l.easing] || Math.easeInOutSine, l.curAnim = n(i), h(i, function(o, a) {
                    c(e, a), g = new t(e, l, a), u = void 0, "d" === a && r(i.d) ? (g.paths = g.initPath(e, e.pathArray, i.d), g.toD = i.d, d = 0, u = 1) : e.attr ? d = e.attr(a) : (d = parseFloat(s(e, a)) || 0, "opacity" !== a && (p = "px")), u || (u = o), "string" == typeof u && u.match("px") && (u = u.replace(/px/g, "")), g.run(d, u, p);
                });
            },
            animObject: d,
            getDeferredAnimation: function(t, e, s) {
                let r = d(e), o = s ? [
                    s
                ] : t.series, n = 0, h = 0;
                return o.forEach((t)=>{
                    let s = d(t.options.animation);
                    n = a(e) && i(e.defer) ? r.defer : Math.max(n, s.duration + s.defer), h = Math.min(r.duration, s.duration);
                }), t.renderer.forExport && (n = 0), {
                    defer: Math.max(0, n - h),
                    duration: Math.min(n, h)
                };
            },
            setAnimation: function(t, e) {
                e.renderer.globalAnimation = l(t, e.options.chart.animation, !0);
            },
            stop: c
        };
    }), i(e, "Core/Renderer/HTML/AST.js", [
        e["Core/Globals.js"],
        e["Core/Utilities.js"]
    ], function(t, e) {
        let { SVG_NS: i, win: s } = t, { attr: r, createElement: o, css: a, error: n, isFunction: h, isString: l, objectEach: d, splat: c } = e, { trustedTypes: p } = s, u = p && h(p.createPolicy) && p.createPolicy("highcharts", {
            createHTML: (t)=>t
        }), g = u ? u.createHTML("") : "", f = function() {
            try {
                return !!new DOMParser().parseFromString(g, "text/html");
            } catch (t) {
                return !1;
            }
        }();
        class m {
            static filterUserAttributes(t) {
                return d(t, (e, i)=>{
                    let s = !0;
                    -1 === m.allowedAttributes.indexOf(i) && (s = !1), -1 !== [
                        "background",
                        "dynsrc",
                        "href",
                        "lowsrc",
                        "src"
                    ].indexOf(i) && (s = l(e) && m.allowedReferences.some((t)=>0 === e.indexOf(t))), s || (n(33, !1, void 0, {
                        "Invalid attribute in config": `${i}`
                    }), delete t[i]), l(e) && t[i] && (t[i] = e.replace(/</g, "&lt;"));
                }), t;
            }
            static parseStyle(t) {
                return t.split(";").reduce((t, e)=>{
                    let i = e.split(":").map((t)=>t.trim()), s = i.shift();
                    return s && i.length && (t[s.replace(/-([a-z])/g, (t)=>t[1].toUpperCase())] = i.join(":")), t;
                }, {});
            }
            static setElementHTML(t, e) {
                t.innerHTML = m.emptyHTML, e && new m(e).addToDOM(t);
            }
            constructor(t){
                this.nodes = "string" == typeof t ? this.parseMarkup(t) : t;
            }
            addToDOM(e) {
                return function e(s, o) {
                    let h;
                    return c(s).forEach(function(s) {
                        let l;
                        let c = s.tagName, p = s.textContent ? t.doc.createTextNode(s.textContent) : void 0, u = m.bypassHTMLFiltering;
                        if (c) {
                            if ("#text" === c) l = p;
                            else if (-1 !== m.allowedTags.indexOf(c) || u) {
                                let n = "svg" === c ? i : o.namespaceURI || i, h = t.doc.createElementNS(n, c), g = s.attributes || {};
                                d(s, function(t, e) {
                                    "tagName" !== e && "attributes" !== e && "children" !== e && "style" !== e && "textContent" !== e && (g[e] = t);
                                }), r(h, u ? g : m.filterUserAttributes(g)), s.style && a(h, s.style), p && h.appendChild(p), e(s.children || [], h), l = h;
                            } else n(33, !1, void 0, {
                                "Invalid tagName in config": c
                            });
                        }
                        l && o.appendChild(l), h = l;
                    }), h;
                }(this.nodes, e);
            }
            parseMarkup(t) {
                let e;
                let i = [];
                if (t = t.trim().replace(/ style=(["'])/g, " data-style=$1"), f) e = new DOMParser().parseFromString(u ? u.createHTML(t) : t, "text/html");
                else {
                    let i = o("div");
                    i.innerHTML = t, e = {
                        body: i
                    };
                }
                let s = (t, e)=>{
                    let i = t.nodeName.toLowerCase(), r = {
                        tagName: i
                    };
                    "#text" === i && (r.textContent = t.textContent || "");
                    let o = t.attributes;
                    if (o) {
                        let t = {};
                        [].forEach.call(o, (e)=>{
                            "data-style" === e.name ? r.style = m.parseStyle(e.value) : t[e.name] = e.value;
                        }), r.attributes = t;
                    }
                    if (t.childNodes.length) {
                        let e = [];
                        [].forEach.call(t.childNodes, (t)=>{
                            s(t, e);
                        }), e.length && (r.children = e);
                    }
                    e.push(r);
                };
                return [].forEach.call(e.body.childNodes, (t)=>s(t, i)), i;
            }
        }
        return m.allowedAttributes = [
            "alt",
            "aria-controls",
            "aria-describedby",
            "aria-expanded",
            "aria-haspopup",
            "aria-hidden",
            "aria-label",
            "aria-labelledby",
            "aria-live",
            "aria-pressed",
            "aria-readonly",
            "aria-roledescription",
            "aria-selected",
            "class",
            "clip-path",
            "color",
            "colspan",
            "cx",
            "cy",
            "d",
            "dx",
            "dy",
            "disabled",
            "fill",
            "filterUnits",
            "flood-color",
            "flood-opacity",
            "height",
            "href",
            "id",
            "in",
            "markerHeight",
            "markerWidth",
            "offset",
            "opacity",
            "orient",
            "padding",
            "paddingLeft",
            "paddingRight",
            "patternUnits",
            "r",
            "refX",
            "refY",
            "role",
            "scope",
            "slope",
            "src",
            "startOffset",
            "stdDeviation",
            "stroke",
            "stroke-linecap",
            "stroke-width",
            "style",
            "tableValues",
            "result",
            "rowspan",
            "summary",
            "target",
            "tabindex",
            "text-align",
            "text-anchor",
            "textAnchor",
            "textLength",
            "title",
            "type",
            "valign",
            "width",
            "x",
            "x1",
            "x2",
            "xlink:href",
            "y",
            "y1",
            "y2",
            "zIndex"
        ], m.allowedReferences = [
            "https://",
            "http://",
            "mailto:",
            "/",
            "../",
            "./",
            "#"
        ], m.allowedTags = [
            "a",
            "abbr",
            "b",
            "br",
            "button",
            "caption",
            "circle",
            "clipPath",
            "code",
            "dd",
            "defs",
            "div",
            "dl",
            "dt",
            "em",
            "feComponentTransfer",
            "feDropShadow",
            "feFuncA",
            "feFuncB",
            "feFuncG",
            "feFuncR",
            "feGaussianBlur",
            "feOffset",
            "feMerge",
            "feMergeNode",
            "filter",
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "hr",
            "i",
            "img",
            "li",
            "linearGradient",
            "marker",
            "ol",
            "p",
            "path",
            "pattern",
            "pre",
            "rect",
            "small",
            "span",
            "stop",
            "strong",
            "style",
            "sub",
            "sup",
            "svg",
            "table",
            "text",
            "textPath",
            "thead",
            "title",
            "tbody",
            "tspan",
            "td",
            "th",
            "tr",
            "u",
            "ul",
            "#text"
        ], m.emptyHTML = g, m.bypassHTMLFiltering = !1, m;
    }), i(e, "Core/Templating.js", [
        e["Core/Defaults.js"],
        e["Core/Utilities.js"]
    ], function(t, e) {
        let { defaultOptions: i, defaultTime: s } = t, { extend: r, getNestedProperty: o, isArray: a, isNumber: n, isObject: h, pick: l, pInt: d } = e, c = {
            add: (t, e)=>t + e,
            divide: (t, e)=>0 !== e ? t / e : "",
            eq: (t, e)=>t == e,
            each: function(t) {
                let e = arguments[arguments.length - 1];
                return !!a(t) && t.map((i, s)=>p(e.body, r(h(i) ? i : {
                        "@this": i
                    }, {
                        "@index": s,
                        "@first": 0 === s,
                        "@last": s === t.length - 1
                    }))).join("");
            },
            ge: (t, e)=>t >= e,
            gt: (t, e)=>t > e,
            if: (t)=>!!t,
            le: (t, e)=>t <= e,
            lt: (t, e)=>t < e,
            multiply: (t, e)=>t * e,
            ne: (t, e)=>t != e,
            subtract: (t, e)=>t - e,
            unless: (t)=>!t
        };
        function p(t = "", e, r) {
            let a = /\{([a-zA-Z0-9\:\.\,;\-\/<>%_@"'= #\(\)]+)\}/g, n = /\(([a-zA-Z0-9\:\.\,;\-\/<>%_@"'= ]+)\)/g, h = [], d = /f$/, g = /\.([0-9])/, f = i.lang, m = r && r.time || s, x = r && r.numberFormatter || u, y = (t = "")=>{
                let i;
                return "true" === t || "false" !== t && ((i = Number(t)).toString() === t ? i : o(t, e));
            }, b, v, S = 0, k;
            for(; null !== (b = a.exec(t));){
                let i = n.exec(b[1]);
                i && (b = i, k = !0), v && v.isBlock || (v = {
                    ctx: e,
                    expression: b[1],
                    find: b[0],
                    isBlock: "#" === b[1].charAt(0),
                    start: b.index,
                    startInner: b.index + b[0].length,
                    length: b[0].length
                });
                let s = b[1].split(" ")[0].replace("#", "");
                c[s] && (v.isBlock && s === v.fn && S++, v.fn || (v.fn = s));
                let r = "else" === b[1];
                if (v.isBlock && v.fn && (b[1] === `/${v.fn}` || r)) {
                    if (S) !r && S--;
                    else {
                        let e = v.startInner, i = t.substr(e, b.index - e);
                        void 0 === v.body ? (v.body = i, v.startInner = b.index + b[0].length) : v.elseBody = i, v.find += i + b[0], r || (h.push(v), v = void 0);
                    }
                } else v.isBlock || h.push(v);
                if (i && !v?.isBlock) break;
            }
            return h.forEach((i)=>{
                let s, r;
                let { body: o, elseBody: a, expression: n, fn: h } = i;
                if (h) {
                    let t = [
                        i
                    ], l = n.split(" ");
                    for(r = c[h].length; r--;)t.unshift(y(l[r + 1]));
                    s = c[h].apply(e, t), i.isBlock && "boolean" == typeof s && (s = p(s ? o : a, e));
                } else {
                    let t = n.split(":");
                    if (s = y(t.shift() || ""), t.length && "number" == typeof s) {
                        let e = t.join(":");
                        if (d.test(e)) {
                            let t = parseInt((e.match(g) || [
                                "",
                                "-1"
                            ])[1], 10);
                            null !== s && (s = x(s, t, f.decimalPoint, e.indexOf(",") > -1 ? f.thousandsSep : ""));
                        } else s = m.dateFormat(e, s);
                    }
                }
                t = t.replace(i.find, l(s, ""));
            }), k ? p(t, e, r) : t;
        }
        function u(t, e, s, r) {
            let o, a;
            t = +t || 0, e = +e;
            let h = i.lang, c = (t.toString().split(".")[1] || "").split("e")[0].length, p = t.toString().split("e"), u = e;
            -1 === e ? e = Math.min(c, 20) : n(e) ? e && p[1] && p[1] < 0 && ((a = e + +p[1]) >= 0 ? (p[0] = (+p[0]).toExponential(a).split("e")[0], e = a) : (p[0] = p[0].split(".")[0] || 0, t = e < 20 ? (p[0] * Math.pow(10, p[1])).toFixed(e) : 0, p[1] = 0)) : e = 2;
            let g = (Math.abs(p[1] ? p[0] : t) + Math.pow(10, -Math.max(e, c) - 1)).toFixed(e), f = String(d(g)), m = f.length > 3 ? f.length % 3 : 0;
            return s = l(s, h.decimalPoint), r = l(r, h.thousandsSep), o = (t < 0 ? "-" : "") + (m ? f.substr(0, m) + r : ""), 0 > +p[1] && !u ? o = "0" : o += f.substr(m).replace(/(\d{3})(?=\d)/g, "$1" + r), e && (o += s + g.slice(-e)), p[1] && 0 != +o && (o += "e" + p[1]), o;
        }
        return {
            dateFormat: function(t, e, i) {
                return s.dateFormat(t, e, i);
            },
            format: p,
            helpers: c,
            numberFormat: u
        };
    }), i(e, "Core/Renderer/RendererRegistry.js", [
        e["Core/Globals.js"]
    ], function(t) {
        var e, i;
        let s;
        return (i = e || (e = {})).rendererTypes = {}, i.getRendererType = function(t = s) {
            return i.rendererTypes[t] || i.rendererTypes[s];
        }, i.registerRendererType = function(e, r, o) {
            i.rendererTypes[e] = r, (!s || o) && (s = e, t.Renderer = r);
        }, e;
    }), i(e, "Core/Renderer/RendererUtilities.js", [
        e["Core/Utilities.js"]
    ], function(t) {
        var e;
        let { clamp: i, pick: s, pushUnique: r, stableSort: o } = t;
        return (e || (e = {})).distribute = function t(e, a, n) {
            let h = e, l = h.reducedLen || a, d = (t, e)=>t.target - e.target, c = [], p = e.length, u = [], g = c.push, f, m, x, y = !0, b, v, S = 0, k;
            for(f = p; f--;)S += e[f].size;
            if (S > l) {
                for(o(e, (t, e)=>(e.rank || 0) - (t.rank || 0)), x = (k = e[0].rank === e[e.length - 1].rank) ? p / 2 : -1, m = k ? x : p - 1; x && S > l;)b = e[f = Math.floor(m)], r(u, f) && (S -= b.size), m += x, k && m >= e.length && (x /= 2, m = x);
                u.sort((t, e)=>e - t).forEach((t)=>g.apply(c, e.splice(t, 1)));
            }
            for(o(e, d), e = e.map((t)=>({
                    size: t.size,
                    targets: [
                        t.target
                    ],
                    align: s(t.align, .5)
                })); y;){
                for(f = e.length; f--;)b = e[f], v = (Math.min.apply(0, b.targets) + Math.max.apply(0, b.targets)) / 2, b.pos = i(v - b.size * b.align, 0, a - b.size);
                for(f = e.length, y = !1; f--;)f > 0 && e[f - 1].pos + e[f - 1].size > e[f].pos && (e[f - 1].size += e[f].size, e[f - 1].targets = e[f - 1].targets.concat(e[f].targets), e[f - 1].align = .5, e[f - 1].pos + e[f - 1].size > a && (e[f - 1].pos = a - e[f - 1].size), e.splice(f, 1), y = !0);
            }
            return g.apply(h, c), f = 0, e.some((e)=>{
                let i = 0;
                return (e.targets || []).some(()=>(h[f].pos = e.pos + i, void 0 !== n && Math.abs(h[f].pos - h[f].target) > n) ? (h.slice(0, f + 1).forEach((t)=>delete t.pos), h.reducedLen = (h.reducedLen || a) - .1 * a, h.reducedLen > .1 * a && t(h, a, n), !0) : (i += h[f].size, f++, !1));
            }), o(h, d), h;
        }, e;
    }), i(e, "Core/Renderer/SVG/SVGElement.js", [
        e["Core/Animation/AnimationUtilities.js"],
        e["Core/Color/Color.js"],
        e["Core/Globals.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i, s) {
        let { animate: r, animObject: o, stop: a } = t, { deg2rad: n, doc: h, svg: l, SVG_NS: d, win: c } = i, { addEvent: p, attr: u, createElement: g, css: f, defined: m, erase: x, extend: y, fireEvent: b, isArray: v, isFunction: S, isObject: k, isString: C, merge: M, objectEach: w, pick: T, pInt: A, replaceNested: P, syncTimeout: L, uniqueKey: O } = s;
        class D {
            _defaultGetter(t) {
                let e = T(this[t + "Value"], this[t], this.element ? this.element.getAttribute(t) : null, 0);
                return /^[\-0-9\.]+$/.test(e) && (e = parseFloat(e)), e;
            }
            _defaultSetter(t, e, i) {
                i.setAttribute(e, t);
            }
            add(t) {
                let e;
                let i = this.renderer, s = this.element;
                return t && (this.parentGroup = t), void 0 !== this.textStr && "text" === this.element.nodeName && i.buildText(this), this.added = !0, (!t || t.handleZ || this.zIndex) && (e = this.zIndexSetter()), e || (t ? t.element : i.box).appendChild(s), this.onAdd && this.onAdd(), this;
            }
            addClass(t, e) {
                let i = e ? "" : this.attr("class") || "";
                return (t = (t || "").split(/ /g).reduce(function(t, e) {
                    return -1 === i.indexOf(e) && t.push(e), t;
                }, i ? [
                    i
                ] : []).join(" ")) !== i && this.attr("class", t), this;
            }
            afterSetters() {
                this.doTransform && (this.updateTransform(), this.doTransform = !1);
            }
            align(t, e, i, s = !0) {
                let r, o, a, n, h;
                let l = {}, d = this.renderer, c = d.alignedObjects;
                t ? (this.alignOptions = t, this.alignByTranslate = e, (!i || C(i)) && (this.alignTo = a = i || "renderer", x(c, this), c.push(this), i = void 0)) : (t = this.alignOptions, e = this.alignByTranslate, a = this.alignTo), i = T(i, d[a], d);
                let p = t.align, u = t.verticalAlign;
                return r = (i.x || 0) + (t.x || 0), o = (i.y || 0) + (t.y || 0), "right" === p ? n = 1 : "center" === p && (n = 2), n && (r += (i.width - (t.width || 0)) / n), l[e ? "translateX" : "x"] = Math.round(r), "bottom" === u ? h = 1 : "middle" === u && (h = 2), h && (o += (i.height - (t.height || 0)) / h), l[e ? "translateY" : "y"] = Math.round(o), s && (this[this.placed ? "animate" : "attr"](l), this.placed = !0), this.alignAttr = l, this;
            }
            alignSetter(t) {
                let e = {
                    left: "start",
                    center: "middle",
                    right: "end"
                };
                e[t] && (this.alignValue = t, this.element.setAttribute("text-anchor", e[t]));
            }
            animate(t, e, i) {
                let s = o(T(e, this.renderer.globalAnimation, !0)), a = s.defer;
                return h.hidden && (s.duration = 0), 0 !== s.duration ? (i && (s.complete = i), L(()=>{
                    this.element && r(this, t, s);
                }, a)) : (this.attr(t, void 0, i || s.complete), w(t, function(t, e) {
                    s.step && s.step.call(this, t, {
                        prop: e,
                        pos: 1,
                        elem: this
                    });
                }, this)), this;
            }
            applyTextOutline(t) {
                let e = this.element;
                -1 !== t.indexOf("contrast") && (t = t.replace(/contrast/g, this.renderer.getContrast(e.style.fill)));
                let s = t.split(" "), r = s[s.length - 1], o = s[0];
                if (o && "none" !== o && i.svg) {
                    this.fakeTS = !0, o = o.replace(/(^[\d\.]+)(.*?)$/g, function(t, e, i) {
                        return 2 * Number(e) + i;
                    }), this.removeTextOutline();
                    let t = h.createElementNS(d, "tspan");
                    u(t, {
                        class: "highcharts-text-outline",
                        fill: r,
                        stroke: r,
                        "stroke-width": o,
                        "stroke-linejoin": "round"
                    });
                    let i = e.querySelector("textPath") || e;
                    [].forEach.call(i.childNodes, (e)=>{
                        let i = e.cloneNode(!0);
                        i.removeAttribute && [
                            "fill",
                            "stroke",
                            "stroke-width",
                            "stroke"
                        ].forEach((t)=>i.removeAttribute(t)), t.appendChild(i);
                    });
                    let s = 0;
                    [].forEach.call(i.querySelectorAll("text tspan"), (t)=>{
                        s += Number(t.getAttribute("dy"));
                    });
                    let a = h.createElementNS(d, "tspan");
                    a.textContent = "\u200B", u(a, {
                        x: Number(e.getAttribute("x")),
                        dy: -s
                    }), t.appendChild(a), i.insertBefore(t, i.firstChild);
                }
            }
            attr(t, e, i, s) {
                let r = this.element, o = D.symbolCustomAttribs, n, h, l = this, d;
                return "string" == typeof t && void 0 !== e && (n = t, (t = {})[n] = e), "string" == typeof t ? l = (this[t + "Getter"] || this._defaultGetter).call(this, t, r) : (w(t, function(e, i) {
                    d = !1, s || a(this, i), this.symbolName && -1 !== o.indexOf(i) && (h || (this.symbolAttr(t), h = !0), d = !0), this.rotation && ("x" === i || "y" === i) && (this.doTransform = !0), d || (this[i + "Setter"] || this._defaultSetter).call(this, e, i, r);
                }, this), this.afterSetters()), i && i.call(this), l;
            }
            clip(t) {
                if (t && !t.clipPath) {
                    let e = O() + "-", i = this.renderer.createElement("clipPath").attr({
                        id: e
                    }).add(this.renderer.defs);
                    y(t, {
                        clipPath: i,
                        id: e,
                        count: 0
                    }), t.add(i);
                }
                return this.attr("clip-path", t ? `url(${this.renderer.url}#${t.id})` : "none");
            }
            crisp(t, e) {
                let i = Math.round(e = e || t.strokeWidth || 0) % 2 / 2;
                return t.x = Math.floor(t.x || this.x || 0) + i, t.y = Math.floor(t.y || this.y || 0) + i, t.width = Math.floor((t.width || this.width || 0) - 2 * i), t.height = Math.floor((t.height || this.height || 0) - 2 * i), m(t.strokeWidth) && (t.strokeWidth = e), t;
            }
            complexColor(t, i, s) {
                let r = this.renderer, o, a, n, h, l, d, c, p, u, g, f = [], x;
                b(this.renderer, "complexColor", {
                    args: arguments
                }, function() {
                    if (t.radialGradient ? a = "radialGradient" : t.linearGradient && (a = "linearGradient"), a) {
                        if (n = t[a], l = r.gradients, d = t.stops, u = s.radialReference, v(n) && (t[a] = n = {
                            x1: n[0],
                            y1: n[1],
                            x2: n[2],
                            y2: n[3],
                            gradientUnits: "userSpaceOnUse"
                        }), "radialGradient" === a && u && !m(n.gradientUnits) && (h = n, n = M(n, r.getRadialAttr(u, h), {
                            gradientUnits: "userSpaceOnUse"
                        })), w(n, function(t, e) {
                            "id" !== e && f.push(e, t);
                        }), w(d, function(t) {
                            f.push(t);
                        }), l[f = f.join(",")]) g = l[f].attr("id");
                        else {
                            n.id = g = O();
                            let t = l[f] = r.createElement(a).attr(n).add(r.defs);
                            t.radAttr = h, t.stops = [], d.forEach(function(i) {
                                0 === i[1].indexOf("rgba") ? (c = (o = e.parse(i[1])).get("rgb"), p = o.get("a")) : (c = i[1], p = 1);
                                let s = r.createElement("stop").attr({
                                    offset: i[0],
                                    "stop-color": c,
                                    "stop-opacity": p
                                }).add(t);
                                t.stops.push(s);
                            });
                        }
                        x = "url(" + r.url + "#" + g + ")", s.setAttribute(i, x), s.gradient = f, t.toString = function() {
                            return x;
                        };
                    }
                });
            }
            css(t) {
                let e = this.styles, i = {}, s = this.element, r, o = !e;
                if (e && w(t, function(t, s) {
                    e && e[s] !== t && (i[s] = t, o = !0);
                }), o) {
                    e && (t = y(e, i)), null === t.width || "auto" === t.width ? delete this.textWidth : "text" === s.nodeName.toLowerCase() && t.width && (r = this.textWidth = A(t.width)), y(this.styles, t), r && !l && this.renderer.forExport && delete t.width;
                    let o = M(t);
                    s.namespaceURI === this.SVG_NS && ([
                        "textOutline",
                        "textOverflow",
                        "width"
                    ].forEach((t)=>o && delete o[t]), o.color && (o.fill = o.color)), f(s, o);
                }
                return this.added && ("text" === this.element.nodeName && this.renderer.buildText(this), t.textOutline && this.applyTextOutline(t.textOutline)), this;
            }
            dashstyleSetter(t) {
                let e, i = this["stroke-width"];
                if ("inherit" === i && (i = 1), t = t && t.toLowerCase()) {
                    let s = t.replace("shortdashdotdot", "3,1,1,1,1,1,").replace("shortdashdot", "3,1,1,1").replace("shortdot", "1,1,").replace("shortdash", "3,1,").replace("longdash", "8,3,").replace(/dot/g, "1,3,").replace("dash", "4,3,").replace(/,$/, "").split(",");
                    for(e = s.length; e--;)s[e] = "" + A(s[e]) * T(i, NaN);
                    t = s.join(",").replace(/NaN/g, "none"), this.element.setAttribute("stroke-dasharray", t);
                }
            }
            destroy() {
                let t = this, e = t.element || {}, i = t.renderer, s = e.ownerSVGElement, r = "SPAN" === e.nodeName && t.parentGroup || void 0, o, n;
                if (e.onclick = e.onmouseout = e.onmouseover = e.onmousemove = e.point = null, a(t), t.clipPath && s) {
                    let e = t.clipPath;
                    [].forEach.call(s.querySelectorAll("[clip-path],[CLIP-PATH]"), function(t) {
                        t.getAttribute("clip-path").indexOf(e.element.id) > -1 && t.removeAttribute("clip-path");
                    }), t.clipPath = e.destroy();
                }
                if (t.connector = t.connector?.destroy(), t.stops) {
                    for(n = 0; n < t.stops.length; n++)t.stops[n].destroy();
                    t.stops.length = 0, t.stops = void 0;
                }
                for(t.safeRemoveChild(e); r && r.div && 0 === r.div.childNodes.length;)o = r.parentGroup, t.safeRemoveChild(r.div), delete r.div, r = o;
                t.alignTo && x(i.alignedObjects, t), w(t, function(e, i) {
                    t[i] && t[i].parentGroup === t && t[i].destroy && t[i].destroy(), delete t[i];
                });
            }
            dSetter(t, e, i) {
                v(t) && ("string" == typeof t[0] && (t = this.renderer.pathToSegments(t)), this.pathArray = t, t = t.reduce((t, e, i)=>e && e.join ? (i ? t + " " : "") + e.join(" ") : (e || "").toString(), "")), /(NaN| {2}|^$)/.test(t) && (t = "M 0 0"), this[e] !== t && (i.setAttribute(e, t), this[e] = t);
            }
            fillSetter(t, e, i) {
                "string" == typeof t ? i.setAttribute(e, t) : t && this.complexColor(t, e, i);
            }
            hrefSetter(t, e, i) {
                i.setAttributeNS("http://www.w3.org/1999/xlink", e, t);
            }
            getBBox(t, e) {
                let i, s, r, o;
                let { alignValue: a, element: n, renderer: h, styles: l, textStr: d } = this, { cache: c, cacheKeys: p } = h, u = n.namespaceURI === this.SVG_NS, g = T(e, this.rotation, 0), x = h.styledMode ? n && D.prototype.getStyle.call(n, "font-size") : l.fontSize;
                if (m(d) && (-1 === (o = d.toString()).indexOf("<") && (o = o.replace(/[0-9]/g, "0")), o += [
                    "",
                    h.rootFontSize,
                    x,
                    g,
                    this.textWidth,
                    a,
                    l.textOverflow,
                    l.fontWeight
                ].join(",")), o && !t && (i = c[o]), !i) {
                    if (u || h.forExport) {
                        try {
                            r = this.fakeTS && function(t) {
                                let e = n.querySelector(".highcharts-text-outline");
                                e && f(e, {
                                    display: t
                                });
                            }, S(r) && r("none"), i = n.getBBox ? y({}, n.getBBox()) : {
                                width: n.offsetWidth,
                                height: n.offsetHeight,
                                x: 0,
                                y: 0
                            }, S(r) && r("");
                        } catch (t) {}
                        (!i || i.width < 0) && (i = {
                            x: 0,
                            y: 0,
                            width: 0,
                            height: 0
                        });
                    } else i = this.htmlGetBBox();
                    s = i.height, u && (i.height = s = ({
                        "11px,17": 14,
                        "13px,20": 16
                    })[`${x || ""},${Math.round(s)}`] || s), g && (i = this.getRotatedBox(i, g));
                }
                if (o && ("" === d || i.height > 0)) {
                    for(; p.length > 250;)delete c[p.shift()];
                    c[o] || p.push(o), c[o] = i;
                }
                return i;
            }
            getRotatedBox(t, e) {
                let { x: i, y: s, width: r, height: o } = t, { alignValue: a, translateY: h, rotationOriginX: l = 0, rotationOriginY: d = 0 } = this, c = {
                    right: 1,
                    center: .5
                }[a || 0] || 0, p = Number(this.element.getAttribute("y") || 0) - (h ? 0 : s), u = e * n, g = (e - 90) * n, f = Math.cos(u), m = Math.sin(u), x = r * f, y = r * m, b = Math.cos(g), v = Math.sin(g), [[S, k], [C, M]] = [
                    l,
                    d
                ].map((t)=>[
                        t - t * f,
                        t * m
                    ]), w = i + c * (r - x) + S + M + p * b, T = w + x, A = T - o * b, P = A - x, L = s + p - c * y - k + C + p * v, O = L + y, D = O - o * v, E = D - y, I = Math.min(w, T, A, P), j = Math.min(L, O, D, E), B = Math.max(w, T, A, P) - I, R = Math.max(L, O, D, E) - j;
                return {
                    x: I,
                    y: j,
                    width: B,
                    height: R
                };
            }
            getStyle(t) {
                return c.getComputedStyle(this.element || this, "").getPropertyValue(t);
            }
            hasClass(t) {
                return -1 !== ("" + this.attr("class")).split(" ").indexOf(t);
            }
            hide() {
                return this.attr({
                    visibility: "hidden"
                });
            }
            htmlGetBBox() {
                return {
                    height: 0,
                    width: 0,
                    x: 0,
                    y: 0
                };
            }
            constructor(t, e){
                this.onEvents = {}, this.opacity = 1, this.SVG_NS = d, this.element = "span" === e || "body" === e ? g(e) : h.createElementNS(this.SVG_NS, e), this.renderer = t, this.styles = {}, b(this, "afterInit");
            }
            on(t, e) {
                let { onEvents: i } = this;
                return i[t] && i[t](), i[t] = p(this.element, t, e), this;
            }
            opacitySetter(t, e, i) {
                let s = Number(Number(t).toFixed(3));
                this.opacity = s, i.setAttribute(e, s);
            }
            removeClass(t) {
                return this.attr("class", ("" + this.attr("class")).replace(C(t) ? RegExp(`(^| )${t}( |$)`) : t, " ").replace(/ +/g, " ").trim());
            }
            removeTextOutline() {
                let t = this.element.querySelector("tspan.highcharts-text-outline");
                t && this.safeRemoveChild(t);
            }
            safeRemoveChild(t) {
                let e = t.parentNode;
                e && e.removeChild(t);
            }
            setRadialReference(t) {
                let e = this.element.gradient && this.renderer.gradients[this.element.gradient];
                return this.element.radialReference = t, e && e.radAttr && e.animate(this.renderer.getRadialAttr(t, e.radAttr)), this;
            }
            setTextPath(t, e) {
                e = M(!0, {
                    enabled: !0,
                    attributes: {
                        dy: -5,
                        startOffset: "50%",
                        textAnchor: "middle"
                    }
                }, e);
                let i = this.renderer.url, s = this.text || this, r = s.textPath, { attributes: o, enabled: a } = e;
                if (t = t || r && r.path, r && r.undo(), t && a) {
                    let e = p(s, "afterModifyTree", (e)=>{
                        if (t && a) {
                            let r = t.attr("id");
                            r || t.attr("id", r = O());
                            let a = {
                                x: 0,
                                y: 0
                            };
                            m(o.dx) && (a.dx = o.dx, delete o.dx), m(o.dy) && (a.dy = o.dy, delete o.dy), s.attr(a), this.attr({
                                transform: ""
                            }), this.box && (this.box = this.box.destroy());
                            let n = e.nodes.slice(0);
                            e.nodes.length = 0, e.nodes[0] = {
                                tagName: "textPath",
                                attributes: y(o, {
                                    "text-anchor": o.textAnchor,
                                    href: `${i}#${r}`
                                }),
                                children: n
                            };
                        }
                    });
                    s.textPath = {
                        path: t,
                        undo: e
                    };
                } else s.attr({
                    dx: 0,
                    dy: 0
                }), delete s.textPath;
                return this.added && (s.textCache = "", this.renderer.buildText(s)), this;
            }
            shadow(t) {
                let { renderer: e } = this, i = M(this.parentGroup?.rotation === 90 ? {
                    offsetX: -1,
                    offsetY: -1
                } : {}, k(t) ? t : {}), s = e.shadowDefinition(i);
                return this.attr({
                    filter: t ? `url(${e.url}#${s})` : "none"
                });
            }
            show(t = !0) {
                return this.attr({
                    visibility: t ? "inherit" : "visible"
                });
            }
            "stroke-widthSetter"(t, e, i) {
                this[e] = t, i.setAttribute(e, t);
            }
            strokeWidth() {
                if (!this.renderer.styledMode) return this["stroke-width"] || 0;
                let t = this.getStyle("stroke-width"), e = 0, i;
                return /px$/.test(t) ? e = A(t) : "" !== t && (u(i = h.createElementNS(d, "rect"), {
                    width: t,
                    "stroke-width": 0
                }), this.element.parentNode.appendChild(i), e = i.getBBox().width, i.parentNode.removeChild(i)), e;
            }
            symbolAttr(t) {
                let e = this;
                D.symbolCustomAttribs.forEach(function(i) {
                    e[i] = T(t[i], e[i]);
                }), e.attr({
                    d: e.renderer.symbols[e.symbolName](e.x, e.y, e.width, e.height, e)
                });
            }
            textSetter(t) {
                t !== this.textStr && (delete this.textPxLength, this.textStr = t, this.added && this.renderer.buildText(this));
            }
            titleSetter(t) {
                let e = this.element, i = e.getElementsByTagName("title")[0] || h.createElementNS(this.SVG_NS, "title");
                e.insertBefore ? e.insertBefore(i, e.firstChild) : e.appendChild(i), i.textContent = P(T(t, ""), [
                    /<[^>]*>/g,
                    ""
                ]).replace(/&lt;/g, "<").replace(/&gt;/g, ">");
            }
            toFront() {
                let t = this.element;
                return t.parentNode.appendChild(t), this;
            }
            translate(t, e) {
                return this.attr({
                    translateX: t,
                    translateY: e
                });
            }
            updateTransform(t = "transform") {
                let { element: e, matrix: i, rotation: s = 0, rotationOriginX: r, rotationOriginY: o, scaleX: a, scaleY: n, translateX: h = 0, translateY: l = 0 } = this, d = [
                    "translate(" + h + "," + l + ")"
                ];
                m(i) && d.push("matrix(" + i.join(",") + ")"), s && (d.push("rotate(" + s + " " + T(r, e.getAttribute("x"), 0) + " " + T(o, e.getAttribute("y") || 0) + ")"), this.text?.element.tagName === "SPAN" && this.text.attr({
                    rotation: s,
                    rotationOriginX: (r || 0) - this.padding,
                    rotationOriginY: (o || 0) - this.padding
                })), (m(a) || m(n)) && d.push("scale(" + T(a, 1) + " " + T(n, 1) + ")"), d.length && !(this.text || this).textPath && e.setAttribute(t, d.join(" "));
            }
            visibilitySetter(t, e, i) {
                "inherit" === t ? i.removeAttribute(e) : this[e] !== t && i.setAttribute(e, t), this[e] = t;
            }
            xGetter(t) {
                return "circle" === this.element.nodeName && ("x" === t ? t = "cx" : "y" === t && (t = "cy")), this._defaultGetter(t);
            }
            zIndexSetter(t, e) {
                let i = this.renderer, s = this.parentGroup, r = (s || i).element || i.box, o = this.element, a = r === i.box, n, h, l, d = !1, c, p = this.added, u;
                if (m(t) ? (o.setAttribute("data-z-index", t), t = +t, this[e] === t && (p = !1)) : m(this[e]) && o.removeAttribute("data-z-index"), this[e] = t, p) {
                    for((t = this.zIndex) && s && (s.handleZ = !0), u = (n = r.childNodes).length - 1; u >= 0 && !d; u--)c = !m(l = (h = n[u]).getAttribute("data-z-index")), h !== o && (t < 0 && c && !a && !u ? (r.insertBefore(o, n[u]), d = !0) : (A(l) <= t || c && (!m(t) || t >= 0)) && (r.insertBefore(o, n[u + 1]), d = !0));
                    d || (r.insertBefore(o, n[a ? 3 : 0]), d = !0);
                }
                return d;
            }
        }
        return D.symbolCustomAttribs = [
            "anchorX",
            "anchorY",
            "clockwise",
            "end",
            "height",
            "innerR",
            "r",
            "start",
            "width",
            "x",
            "y"
        ], D.prototype.strokeSetter = D.prototype.fillSetter, D.prototype.yGetter = D.prototype.xGetter, D.prototype.matrixSetter = D.prototype.rotationOriginXSetter = D.prototype.rotationOriginYSetter = D.prototype.rotationSetter = D.prototype.scaleXSetter = D.prototype.scaleYSetter = D.prototype.translateXSetter = D.prototype.translateYSetter = D.prototype.verticalAlignSetter = function(t, e) {
            this[e] = t, this.doTransform = !0;
        }, D;
    }), i(e, "Core/Renderer/SVG/SVGLabel.js", [
        e["Core/Renderer/SVG/SVGElement.js"],
        e["Core/Utilities.js"]
    ], function(t, e) {
        let { defined: i, extend: s, isNumber: r, merge: o, pick: a, removeEvent: n } = e;
        class h extends t {
            constructor(t, e, i, s, r, o, a, n, l, d){
                let c;
                super(t, "g"), this.paddingLeftSetter = this.paddingSetter, this.paddingRightSetter = this.paddingSetter, this.textStr = e, this.x = i, this.y = s, this.anchorX = o, this.anchorY = a, this.baseline = l, this.className = d, this.addClass("button" === d ? "highcharts-no-tooltip" : "highcharts-label"), d && this.addClass("highcharts-" + d), this.text = t.text(void 0, 0, 0, n).attr({
                    zIndex: 1
                }), "string" == typeof r && ((c = /^url\((.*?)\)$/.test(r)) || this.renderer.symbols[r]) && (this.symbolKey = r), this.bBox = h.emptyBBox, this.padding = 3, this.baselineOffset = 0, this.needsBox = t.styledMode || c, this.deferredAttr = {}, this.alignFactor = 0;
            }
            alignSetter(t) {
                let e = {
                    left: 0,
                    center: .5,
                    right: 1
                }[t];
                e !== this.alignFactor && (this.alignFactor = e, this.bBox && r(this.xSetting) && this.attr({
                    x: this.xSetting
                }));
            }
            anchorXSetter(t, e) {
                this.anchorX = t, this.boxAttr(e, Math.round(t) - this.getCrispAdjust() - this.xSetting);
            }
            anchorYSetter(t, e) {
                this.anchorY = t, this.boxAttr(e, t - this.ySetting);
            }
            boxAttr(t, e) {
                this.box ? this.box.attr(t, e) : this.deferredAttr[t] = e;
            }
            css(e) {
                if (e) {
                    let t = {};
                    e = o(e), h.textProps.forEach((i)=>{
                        void 0 !== e[i] && (t[i] = e[i], delete e[i]);
                    }), this.text.css(t), "fontSize" in t || "fontWeight" in t ? this.updateTextPadding() : ("width" in t || "textOverflow" in t) && this.updateBoxSize();
                }
                return t.prototype.css.call(this, e);
            }
            destroy() {
                n(this.element, "mouseenter"), n(this.element, "mouseleave"), this.text && this.text.destroy(), this.box && (this.box = this.box.destroy()), t.prototype.destroy.call(this);
            }
            fillSetter(t, e) {
                t && (this.needsBox = !0), this.fill = t, this.boxAttr(e, t);
            }
            getBBox(t, e) {
                this.textStr && 0 === this.bBox.width && 0 === this.bBox.height && this.updateBoxSize();
                let { padding: i, height: s = 0, translateX: r = 0, translateY: o = 0, width: n = 0 } = this, h = a(this.paddingLeft, i), l = e ?? (this.rotation || 0), d = {
                    width: n,
                    height: s,
                    x: r + this.bBox.x - h,
                    y: o + this.bBox.y - i + this.baselineOffset
                };
                return l && (d = this.getRotatedBox(d, l)), d;
            }
            getCrispAdjust() {
                return this.renderer.styledMode && this.box ? this.box.strokeWidth() % 2 / 2 : (this["stroke-width"] ? parseInt(this["stroke-width"], 10) : 0) % 2 / 2;
            }
            heightSetter(t) {
                this.heightSetting = t;
            }
            onAdd() {
                this.text.add(this), this.attr({
                    text: a(this.textStr, ""),
                    x: this.x || 0,
                    y: this.y || 0
                }), this.box && i(this.anchorX) && this.attr({
                    anchorX: this.anchorX,
                    anchorY: this.anchorY
                });
            }
            paddingSetter(t, e) {
                r(t) ? t !== this[e] && (this[e] = t, this.updateTextPadding()) : this[e] = void 0;
            }
            rSetter(t, e) {
                this.boxAttr(e, t);
            }
            strokeSetter(t, e) {
                this.stroke = t, this.boxAttr(e, t);
            }
            "stroke-widthSetter"(t, e) {
                t && (this.needsBox = !0), this["stroke-width"] = t, this.boxAttr(e, t);
            }
            "text-alignSetter"(t) {
                this.textAlign = t;
            }
            textSetter(t) {
                void 0 !== t && this.text.attr({
                    text: t
                }), this.updateTextPadding();
            }
            updateBoxSize() {
                let t;
                let e = this.text, o = {}, a = this.padding, n = this.bBox = (!r(this.widthSetting) || !r(this.heightSetting) || this.textAlign) && i(e.textStr) ? e.getBBox(void 0, 0) : h.emptyBBox;
                this.width = this.getPaddedWidth(), this.height = (this.heightSetting || n.height || 0) + 2 * a;
                let l = this.renderer.fontMetrics(e);
                if (this.baselineOffset = a + Math.min((this.text.firstLineMetrics || l).b, n.height || 1 / 0), this.heightSetting && (this.baselineOffset += (this.heightSetting - l.h) / 2), this.needsBox && !e.textPath) {
                    if (!this.box) {
                        let t = this.box = this.symbolKey ? this.renderer.symbol(this.symbolKey) : this.renderer.rect();
                        t.addClass(("button" === this.className ? "" : "highcharts-label-box") + (this.className ? " highcharts-" + this.className + "-box" : "")), t.add(this);
                    }
                    t = this.getCrispAdjust(), o.x = t, o.y = (this.baseline ? -this.baselineOffset : 0) + t, o.width = Math.round(this.width), o.height = Math.round(this.height), this.box.attr(s(o, this.deferredAttr)), this.deferredAttr = {};
                }
            }
            updateTextPadding() {
                let t = this.text;
                if (!t.textPath) {
                    this.updateBoxSize();
                    let e = this.baseline ? 0 : this.baselineOffset, s = a(this.paddingLeft, this.padding);
                    i(this.widthSetting) && this.bBox && ("center" === this.textAlign || "right" === this.textAlign) && (s += ({
                        center: .5,
                        right: 1
                    })[this.textAlign] * (this.widthSetting - this.bBox.width)), (s !== t.x || e !== t.y) && (t.attr("x", s), t.hasBoxWidthChanged && (this.bBox = t.getBBox(!0)), void 0 !== e && t.attr("y", e)), t.x = s, t.y = e;
                }
            }
            widthSetter(t) {
                this.widthSetting = r(t) ? t : void 0;
            }
            getPaddedWidth() {
                let t = this.padding, e = a(this.paddingLeft, t), i = a(this.paddingRight, t);
                return (this.widthSetting || this.bBox.width || 0) + e + i;
            }
            xSetter(t) {
                this.x = t, this.alignFactor && (t -= this.alignFactor * this.getPaddedWidth(), this["forceAnimate:x"] = !0), this.xSetting = Math.round(t), this.attr("translateX", this.xSetting);
            }
            ySetter(t) {
                this.ySetting = this.y = Math.round(t), this.attr("translateY", this.ySetting);
            }
        }
        return h.emptyBBox = {
            width: 0,
            height: 0,
            x: 0,
            y: 0
        }, h.textProps = [
            "color",
            "direction",
            "fontFamily",
            "fontSize",
            "fontStyle",
            "fontWeight",
            "lineHeight",
            "textAlign",
            "textDecoration",
            "textOutline",
            "textOverflow",
            "whiteSpace",
            "width"
        ], h;
    }), i(e, "Core/Renderer/SVG/Symbols.js", [
        e["Core/Utilities.js"]
    ], function(t) {
        let { defined: e, isNumber: i, pick: s } = t;
        function r(t, i, r, o, a) {
            let n = [];
            if (a) {
                let h = a.start || 0, l = s(a.r, r), d = s(a.r, o || r), c = .001 > Math.abs((a.end || 0) - h - 2 * Math.PI), p = (a.end || 0) - .001, u = a.innerR, g = s(a.open, c), f = Math.cos(h), m = Math.sin(h), x = Math.cos(p), y = Math.sin(p), b = s(a.longArc, p - h - Math.PI < .001 ? 0 : 1), v = [
                    "A",
                    l,
                    d,
                    0,
                    b,
                    s(a.clockwise, 1),
                    t + l * x,
                    i + d * y
                ];
                v.params = {
                    start: h,
                    end: p,
                    cx: t,
                    cy: i
                }, n.push([
                    "M",
                    t + l * f,
                    i + d * m
                ], v), e(u) && ((v = [
                    "A",
                    u,
                    u,
                    0,
                    b,
                    e(a.clockwise) ? 1 - a.clockwise : 0,
                    t + u * f,
                    i + u * m
                ]).params = {
                    start: p,
                    end: h,
                    cx: t,
                    cy: i
                }, n.push(g ? [
                    "M",
                    t + u * x,
                    i + u * y
                ] : [
                    "L",
                    t + u * x,
                    i + u * y
                ], v)), g || n.push([
                    "Z"
                ]);
            }
            return n;
        }
        function o(t, e, i, s, r) {
            return r && r.r ? a(t, e, i, s, r) : [
                [
                    "M",
                    t,
                    e
                ],
                [
                    "L",
                    t + i,
                    e
                ],
                [
                    "L",
                    t + i,
                    e + s
                ],
                [
                    "L",
                    t,
                    e + s
                ],
                [
                    "Z"
                ]
            ];
        }
        function a(t, e, i, s, r) {
            let o = r?.r || 0;
            return [
                [
                    "M",
                    t + o,
                    e
                ],
                [
                    "L",
                    t + i - o,
                    e
                ],
                [
                    "A",
                    o,
                    o,
                    0,
                    0,
                    1,
                    t + i,
                    e + o
                ],
                [
                    "L",
                    t + i,
                    e + s - o
                ],
                [
                    "A",
                    o,
                    o,
                    0,
                    0,
                    1,
                    t + i - o,
                    e + s
                ],
                [
                    "L",
                    t + o,
                    e + s
                ],
                [
                    "A",
                    o,
                    o,
                    0,
                    0,
                    1,
                    t,
                    e + s - o
                ],
                [
                    "L",
                    t,
                    e + o
                ],
                [
                    "A",
                    o,
                    o,
                    0,
                    0,
                    1,
                    t + o,
                    e
                ],
                [
                    "Z"
                ]
            ];
        }
        return {
            arc: r,
            callout: function(t, e, s, r, o) {
                let n = Math.min(o && o.r || 0, s, r), h = n + 6, l = o && o.anchorX, d = o && o.anchorY || 0, c = a(t, e, s, r, {
                    r: n
                });
                if (!i(l) || l < s && l > 0 && d < r && d > 0) return c;
                if (t + l > s - h) {
                    if (d > e + h && d < e + r - h) c.splice(3, 1, [
                        "L",
                        t + s,
                        d - 6
                    ], [
                        "L",
                        t + s + 6,
                        d
                    ], [
                        "L",
                        t + s,
                        d + 6
                    ], [
                        "L",
                        t + s,
                        e + r - n
                    ]);
                    else if (l < s) {
                        let i = d < e + h, o = i ? e : e + r;
                        c.splice(i ? 2 : 5, 0, [
                            "L",
                            l,
                            d
                        ], [
                            "L",
                            t + s - n,
                            o
                        ]);
                    } else c.splice(3, 1, [
                        "L",
                        t + s,
                        r / 2
                    ], [
                        "L",
                        l,
                        d
                    ], [
                        "L",
                        t + s,
                        r / 2
                    ], [
                        "L",
                        t + s,
                        e + r - n
                    ]);
                } else if (t + l < h) {
                    if (d > e + h && d < e + r - h) c.splice(7, 1, [
                        "L",
                        t,
                        d + 6
                    ], [
                        "L",
                        t - 6,
                        d
                    ], [
                        "L",
                        t,
                        d - 6
                    ], [
                        "L",
                        t,
                        e + n
                    ]);
                    else if (l > 0) {
                        let i = d < e + h, s = i ? e : e + r;
                        c.splice(i ? 1 : 6, 0, [
                            "L",
                            l,
                            d
                        ], [
                            "L",
                            t + n,
                            s
                        ]);
                    } else c.splice(7, 1, [
                        "L",
                        t,
                        r / 2
                    ], [
                        "L",
                        l,
                        d
                    ], [
                        "L",
                        t,
                        r / 2
                    ], [
                        "L",
                        t,
                        e + n
                    ]);
                } else d > r && l < s - h ? c.splice(5, 1, [
                    "L",
                    l + 6,
                    e + r
                ], [
                    "L",
                    l,
                    e + r + 6
                ], [
                    "L",
                    l - 6,
                    e + r
                ], [
                    "L",
                    t + n,
                    e + r
                ]) : d < 0 && l > h && c.splice(1, 1, [
                    "L",
                    l - 6,
                    e
                ], [
                    "L",
                    l,
                    e - 6
                ], [
                    "L",
                    l + 6,
                    e
                ], [
                    "L",
                    s - n,
                    e
                ]);
                return c;
            },
            circle: function(t, e, i, s) {
                return r(t + i / 2, e + s / 2, i / 2, s / 2, {
                    start: .5 * Math.PI,
                    end: 2.5 * Math.PI,
                    open: !1
                });
            },
            diamond: function(t, e, i, s) {
                return [
                    [
                        "M",
                        t + i / 2,
                        e
                    ],
                    [
                        "L",
                        t + i,
                        e + s / 2
                    ],
                    [
                        "L",
                        t + i / 2,
                        e + s
                    ],
                    [
                        "L",
                        t,
                        e + s / 2
                    ],
                    [
                        "Z"
                    ]
                ];
            },
            rect: o,
            roundedRect: a,
            square: o,
            triangle: function(t, e, i, s) {
                return [
                    [
                        "M",
                        t + i / 2,
                        e
                    ],
                    [
                        "L",
                        t + i,
                        e + s
                    ],
                    [
                        "L",
                        t,
                        e + s
                    ],
                    [
                        "Z"
                    ]
                ];
            },
            "triangle-down": function(t, e, i, s) {
                return [
                    [
                        "M",
                        t,
                        e
                    ],
                    [
                        "L",
                        t + i,
                        e
                    ],
                    [
                        "L",
                        t + i / 2,
                        e + s
                    ],
                    [
                        "Z"
                    ]
                ];
            }
        };
    }), i(e, "Core/Renderer/SVG/TextBuilder.js", [
        e["Core/Renderer/HTML/AST.js"],
        e["Core/Globals.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i) {
        let { doc: s, SVG_NS: r, win: o } = e, { attr: a, extend: n, fireEvent: h, isString: l, objectEach: d, pick: c } = i;
        return class {
            constructor(t){
                let e = t.styles;
                this.renderer = t.renderer, this.svgElement = t, this.width = t.textWidth, this.textLineHeight = e && e.lineHeight, this.textOutline = e && e.textOutline, this.ellipsis = !!(e && "ellipsis" === e.textOverflow), this.noWrap = !!(e && "nowrap" === e.whiteSpace);
            }
            buildSVG() {
                let e = this.svgElement, i = e.element, r = e.renderer, o = c(e.textStr, "").toString(), a = -1 !== o.indexOf("<"), n = i.childNodes, h = !e.added && r.box, d = [
                    o,
                    this.ellipsis,
                    this.noWrap,
                    this.textLineHeight,
                    this.textOutline,
                    e.getStyle("font-size"),
                    this.width
                ].join(",");
                if (d !== e.textCache) {
                    e.textCache = d, delete e.actualWidth;
                    for(let t = n.length; t--;)i.removeChild(n[t]);
                    if (a || this.ellipsis || this.width || e.textPath || -1 !== o.indexOf(" ") && (!this.noWrap || /<br.*?>/g.test(o))) {
                        if ("" !== o) {
                            h && h.appendChild(i);
                            let s = new t(o);
                            this.modifyTree(s.nodes), s.addToDOM(i), this.modifyDOM(), this.ellipsis && -1 !== (i.textContent || "").indexOf("\u2026") && e.attr("title", this.unescapeEntities(e.textStr || "", [
                                "&lt;",
                                "&gt;"
                            ])), h && h.removeChild(i);
                        }
                    } else i.appendChild(s.createTextNode(this.unescapeEntities(o)));
                    l(this.textOutline) && e.applyTextOutline && e.applyTextOutline(this.textOutline);
                }
            }
            modifyDOM() {
                let t;
                let e = this.svgElement, i = a(e.element, "x");
                for(e.firstLineMetrics = void 0; t = e.element.firstChild;)if (/^[\s\u200B]*$/.test(t.textContent || " ")) e.element.removeChild(t);
                else break;
                [].forEach.call(e.element.querySelectorAll("tspan.highcharts-br"), (t, s)=>{
                    t.nextSibling && t.previousSibling && (0 === s && 1 === t.previousSibling.nodeType && (e.firstLineMetrics = e.renderer.fontMetrics(t.previousSibling)), a(t, {
                        dy: this.getLineHeight(t.nextSibling),
                        x: i
                    }));
                });
                let n = this.width || 0;
                if (!n) return;
                let h = (t, o)=>{
                    let h = t.textContent || "", l = h.replace(/([^\^])-/g, "$1- ").split(" "), d = !this.noWrap && (l.length > 1 || e.element.childNodes.length > 1), c = this.getLineHeight(o), p = 0, u = e.actualWidth;
                    if (this.ellipsis) h && this.truncate(t, h, void 0, 0, Math.max(0, n - .8 * c), (t, e)=>t.substring(0, e) + "\u2026");
                    else if (d) {
                        let h = [], d = [];
                        for(; o.firstChild && o.firstChild !== t;)d.push(o.firstChild), o.removeChild(o.firstChild);
                        for(; l.length;)l.length && !this.noWrap && p > 0 && (h.push(t.textContent || ""), t.textContent = l.join(" ").replace(/- /g, "-")), this.truncate(t, void 0, l, 0 === p && u || 0, n, (t, e)=>l.slice(0, e).join(" ").replace(/- /g, "-")), u = e.actualWidth, p++;
                        d.forEach((e)=>{
                            o.insertBefore(e, t);
                        }), h.forEach((e)=>{
                            o.insertBefore(s.createTextNode(e), t);
                            let n = s.createElementNS(r, "tspan");
                            n.textContent = "\u200B", a(n, {
                                dy: c,
                                x: i
                            }), o.insertBefore(n, t);
                        });
                    }
                }, l = (t)=>{
                    [].slice.call(t.childNodes).forEach((i)=>{
                        i.nodeType === o.Node.TEXT_NODE ? h(i, t) : (-1 !== i.className.baseVal.indexOf("highcharts-br") && (e.actualWidth = 0), l(i));
                    });
                };
                l(e.element);
            }
            getLineHeight(t) {
                let e = t.nodeType === o.Node.TEXT_NODE ? t.parentElement : t;
                return this.textLineHeight ? parseInt(this.textLineHeight.toString(), 10) : this.renderer.fontMetrics(e || this.svgElement.element).h;
            }
            modifyTree(t) {
                let e = (i, s)=>{
                    let { attributes: r = {}, children: o, style: a = {}, tagName: h } = i, l = this.renderer.styledMode;
                    if ("b" === h || "strong" === h ? l ? r.class = "highcharts-strong" : a.fontWeight = "bold" : ("i" === h || "em" === h) && (l ? r.class = "highcharts-emphasized" : a.fontStyle = "italic"), a && a.color && (a.fill = a.color), "br" === h) {
                        r.class = "highcharts-br", i.textContent = "\u200B";
                        let e = t[s + 1];
                        e && e.textContent && (e.textContent = e.textContent.replace(/^ +/gm, ""));
                    } else "a" === h && o && o.some((t)=>"#text" === t.tagName) && (i.children = [
                        {
                            children: o,
                            tagName: "tspan"
                        }
                    ]);
                    "#text" !== h && "a" !== h && (i.tagName = "tspan"), n(i, {
                        attributes: r,
                        style: a
                    }), o && o.filter((t)=>"#text" !== t.tagName).forEach(e);
                };
                t.forEach(e), h(this.svgElement, "afterModifyTree", {
                    nodes: t
                });
            }
            truncate(t, e, i, s, r, o) {
                let a, n;
                let h = this.svgElement, { rotation: l } = h, d = [], c = i ? 1 : 0, p = (e || i || "").length, u = p, g = function(e, r) {
                    let o = r || e, a = t.parentNode;
                    if (a && void 0 === d[o] && a.getSubStringLength) try {
                        d[o] = s + a.getSubStringLength(0, i ? o + 1 : o);
                    } catch (t) {}
                    return d[o];
                };
                if (h.rotation = 0, s + (n = g(t.textContent.length)) > r) {
                    for(; c <= p;)u = Math.ceil((c + p) / 2), i && (a = o(i, u)), n = g(u, a && a.length - 1), c === p ? c = p + 1 : n > r ? p = u - 1 : c = u;
                    0 === p ? t.textContent = "" : e && p === e.length - 1 || (t.textContent = a || o(e || i, u));
                }
                i && i.splice(0, u), h.actualWidth = n, h.rotation = l;
            }
            unescapeEntities(t, e) {
                return d(this.renderer.escapes, function(i, s) {
                    e && -1 !== e.indexOf(i) || (t = t.toString().replace(RegExp(i, "g"), s));
                }), t;
            }
        };
    }), i(e, "Core/Renderer/SVG/SVGRenderer.js", [
        e["Core/Renderer/HTML/AST.js"],
        e["Core/Color/Color.js"],
        e["Core/Globals.js"],
        e["Core/Renderer/RendererRegistry.js"],
        e["Core/Renderer/SVG/SVGElement.js"],
        e["Core/Renderer/SVG/SVGLabel.js"],
        e["Core/Renderer/SVG/Symbols.js"],
        e["Core/Renderer/SVG/TextBuilder.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i, s, r, o, a, n, h) {
        let l;
        let { charts: d, deg2rad: c, doc: p, isFirefox: u, isMS: g, isWebKit: f, noop: m, SVG_NS: x, symbolSizes: y, win: b } = i, { addEvent: v, attr: S, createElement: k, css: C, defined: M, destroyObjectProperties: w, extend: T, isArray: A, isNumber: P, isObject: L, isString: O, merge: D, pick: E, pInt: I, replaceNested: j, uniqueKey: B } = h;
        class R {
            constructor(t, e, i, s, r, o, a){
                let n, h;
                let l = this.createElement("svg").attr({
                    version: "1.1",
                    class: "highcharts-root"
                }), d = l.element;
                a || l.css(this.getStyle(s || {})), t.appendChild(d), S(t, "dir", "ltr"), -1 === t.innerHTML.indexOf("xmlns") && S(d, "xmlns", this.SVG_NS), this.box = d, this.boxWrapper = l, this.alignedObjects = [], this.url = this.getReferenceURL(), this.createElement("desc").add().element.appendChild(p.createTextNode("Created with Highcharts 11.4.0")), this.defs = this.createElement("defs").add(), this.allowHTML = o, this.forExport = r, this.styledMode = a, this.gradients = {}, this.cache = {}, this.cacheKeys = [], this.imgCount = 0, this.rootFontSize = l.getStyle("font-size"), this.setSize(e, i, !1), u && t.getBoundingClientRect && ((n = function() {
                    C(t, {
                        left: 0,
                        top: 0
                    }), h = t.getBoundingClientRect(), C(t, {
                        left: Math.ceil(h.left) - h.left + "px",
                        top: Math.ceil(h.top) - h.top + "px"
                    });
                })(), this.unSubPixelFix = v(b, "resize", n));
            }
            definition(e) {
                return new t([
                    e
                ]).addToDOM(this.defs.element);
            }
            getReferenceURL() {
                if ((u || f) && p.getElementsByTagName("base").length) {
                    if (!M(l)) {
                        let e = B(), i = new t([
                            {
                                tagName: "svg",
                                attributes: {
                                    width: 8,
                                    height: 8
                                },
                                children: [
                                    {
                                        tagName: "defs",
                                        children: [
                                            {
                                                tagName: "clipPath",
                                                attributes: {
                                                    id: e
                                                },
                                                children: [
                                                    {
                                                        tagName: "rect",
                                                        attributes: {
                                                            width: 4,
                                                            height: 4
                                                        }
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        tagName: "rect",
                                        attributes: {
                                            id: "hitme",
                                            width: 8,
                                            height: 8,
                                            "clip-path": `url(#${e})`,
                                            fill: "rgba(0,0,0,0.001)"
                                        }
                                    }
                                ]
                            }
                        ]).addToDOM(p.body);
                        C(i, {
                            position: "fixed",
                            top: 0,
                            left: 0,
                            zIndex: 9e5
                        });
                        let s = p.elementFromPoint(6, 6);
                        l = "hitme" === (s && s.id), p.body.removeChild(i);
                    }
                    if (l) return j(b.location.href.split("#")[0], [
                        /<[^>]*>/g,
                        ""
                    ], [
                        /([\('\)])/g,
                        "\\$1"
                    ], [
                        / /g,
                        "%20"
                    ]);
                }
                return "";
            }
            getStyle(t) {
                return this.style = T({
                    fontFamily: "Helvetica, Arial, sans-serif",
                    fontSize: "1rem"
                }, t), this.style;
            }
            setStyle(t) {
                this.boxWrapper.css(this.getStyle(t));
            }
            isHidden() {
                return !this.boxWrapper.getBBox().width;
            }
            destroy() {
                let t = this.defs;
                return this.box = null, this.boxWrapper = this.boxWrapper.destroy(), w(this.gradients || {}), this.gradients = null, this.defs = t.destroy(), this.unSubPixelFix && this.unSubPixelFix(), this.alignedObjects = null, null;
            }
            createElement(t) {
                return new this.Element(this, t);
            }
            getRadialAttr(t, e) {
                return {
                    cx: t[0] - t[2] / 2 + (e.cx || 0) * t[2],
                    cy: t[1] - t[2] / 2 + (e.cy || 0) * t[2],
                    r: (e.r || 0) * t[2]
                };
            }
            shadowDefinition(t) {
                let e = [
                    `highcharts-drop-shadow-${this.chartIndex}`,
                    ...Object.keys(t).map((e)=>`${e}-${t[e]}`)
                ].join("-").toLowerCase().replace(/[^a-z0-9\-]/g, ""), i = D({
                    color: "#000000",
                    offsetX: 1,
                    offsetY: 1,
                    opacity: .15,
                    width: 5
                }, t);
                return this.defs.element.querySelector(`#${e}`) || this.definition({
                    tagName: "filter",
                    attributes: {
                        id: e,
                        filterUnits: i.filterUnits
                    },
                    children: [
                        {
                            tagName: "feDropShadow",
                            attributes: {
                                dx: i.offsetX,
                                dy: i.offsetY,
                                "flood-color": i.color,
                                "flood-opacity": Math.min(5 * i.opacity, 1),
                                stdDeviation: i.width / 2
                            }
                        }
                    ]
                }), e;
            }
            buildText(t) {
                new n(t).buildSVG();
            }
            getContrast(t) {
                let i = e.parse(t).rgba.map((t)=>{
                    let e = t / 255;
                    return e <= .03928 ? e / 12.92 : Math.pow((e + .055) / 1.055, 2.4);
                }), s = .2126 * i[0] + .7152 * i[1] + .0722 * i[2];
                return 1.05 / (s + .05) > (s + .05) / .05 ? "#FFFFFF" : "#000000";
            }
            button(e, i, s, r, o = {}, a, n, h, l, d) {
                let c, p, u;
                let f = this.label(e, i, s, l, void 0, void 0, d, void 0, "button"), m = this.styledMode, x = o.states || {}, y = 0;
                o = D(o), delete o.states;
                let b = D({
                    color: "#333333",
                    cursor: "pointer",
                    fontSize: "0.8em",
                    fontWeight: "normal"
                }, o.style);
                delete o.style;
                let S = t.filterUserAttributes(o);
                return f.attr(D({
                    padding: 8,
                    r: 2
                }, S)), m || (S = D({
                    fill: "#f7f7f7",
                    stroke: "#cccccc",
                    "stroke-width": 1
                }, S), c = (a = D(S, {
                    fill: "#e6e6e6"
                }, t.filterUserAttributes(a || x.hover || {}))).style, delete a.style, p = (n = D(S, {
                    fill: "#e6e9ff",
                    style: {
                        color: "#000000",
                        fontWeight: "bold"
                    }
                }, t.filterUserAttributes(n || x.select || {}))).style, delete n.style, u = (h = D(S, {
                    style: {
                        color: "#cccccc"
                    }
                }, t.filterUserAttributes(h || x.disabled || {}))).style, delete h.style), v(f.element, g ? "mouseover" : "mouseenter", function() {
                    3 !== y && f.setState(1);
                }), v(f.element, g ? "mouseout" : "mouseleave", function() {
                    3 !== y && f.setState(y);
                }), f.setState = function(t) {
                    if (1 !== t && (f.state = y = t), f.removeClass(/highcharts-button-(normal|hover|pressed|disabled)/).addClass("highcharts-button-" + [
                        "normal",
                        "hover",
                        "pressed",
                        "disabled"
                    ][t || 0]), !m) {
                        f.attr([
                            S,
                            a,
                            n,
                            h
                        ][t || 0]);
                        let e = [
                            b,
                            c,
                            p,
                            u
                        ][t || 0];
                        L(e) && f.css(e);
                    }
                }, !m && (f.attr(S).css(T({
                    cursor: "default"
                }, b)), d && f.text.css({
                    pointerEvents: "none"
                })), f.on("touchstart", (t)=>t.stopPropagation()).on("click", function(t) {
                    3 !== y && r.call(f, t);
                });
            }
            crispLine(t, e, i = "round") {
                let s = t[0], r = t[1];
                return M(s[1]) && s[1] === r[1] && (s[1] = r[1] = Math[i](s[1]) - e % 2 / 2), M(s[2]) && s[2] === r[2] && (s[2] = r[2] = Math[i](s[2]) + e % 2 / 2), t;
            }
            path(t) {
                let e = this.styledMode ? {} : {
                    fill: "none"
                };
                return A(t) ? e.d = t : L(t) && T(e, t), this.createElement("path").attr(e);
            }
            circle(t, e, i) {
                let s = L(t) ? t : void 0 === t ? {} : {
                    x: t,
                    y: e,
                    r: i
                }, r = this.createElement("circle");
                return r.xSetter = r.ySetter = function(t, e, i) {
                    i.setAttribute("c" + e, t);
                }, r.attr(s);
            }
            arc(t, e, i, s, r, o) {
                let a;
                L(t) ? (e = (a = t).y, i = a.r, s = a.innerR, r = a.start, o = a.end, t = a.x) : a = {
                    innerR: s,
                    start: r,
                    end: o
                };
                let n = this.symbol("arc", t, e, i, i, a);
                return n.r = i, n;
            }
            rect(t, e, i, s, r, o) {
                let a = L(t) ? t : void 0 === t ? {} : {
                    x: t,
                    y: e,
                    r: r,
                    width: Math.max(i || 0, 0),
                    height: Math.max(s || 0, 0)
                }, n = this.createElement("rect");
                return this.styledMode || (void 0 !== o && (a["stroke-width"] = o, T(a, n.crisp(a))), a.fill = "none"), n.rSetter = function(t, e, i) {
                    n.r = t, S(i, {
                        rx: t,
                        ry: t
                    });
                }, n.rGetter = function() {
                    return n.r || 0;
                }, n.attr(a);
            }
            roundedRect(t) {
                return this.symbol("roundedRect").attr(t);
            }
            setSize(t, e, i) {
                this.width = t, this.height = e, this.boxWrapper.animate({
                    width: t,
                    height: e
                }, {
                    step: function() {
                        this.attr({
                            viewBox: "0 0 " + this.attr("width") + " " + this.attr("height")
                        });
                    },
                    duration: E(i, !0) ? void 0 : 0
                }), this.alignElements();
            }
            g(t) {
                let e = this.createElement("g");
                return t ? e.attr({
                    class: "highcharts-" + t
                }) : e;
            }
            image(t, e, i, s, r, o) {
                let a = {
                    preserveAspectRatio: "none"
                };
                P(e) && (a.x = e), P(i) && (a.y = i), P(s) && (a.width = s), P(r) && (a.height = r);
                let n = this.createElement("image").attr(a), h = function(e) {
                    n.attr({
                        href: t
                    }), o.call(n, e);
                };
                if (o) {
                    n.attr({
                        href: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                    });
                    let e = new b.Image;
                    v(e, "load", h), e.src = t, e.complete && h({});
                } else n.attr({
                    href: t
                });
                return n;
            }
            symbol(t, e, i, s, r, o) {
                let a, n, h, l;
                let c = this, u = /^url\((.*?)\)$/, g = u.test(t), f = !g && (this.symbols[t] ? t : "circle"), m = f && this.symbols[f];
                if (m) "number" == typeof e && (n = m.call(this.symbols, Math.round(e || 0), Math.round(i || 0), s || 0, r || 0, o)), a = this.path(n), c.styledMode || a.attr("fill", "none"), T(a, {
                    symbolName: f || void 0,
                    x: e,
                    y: i,
                    width: s,
                    height: r
                }), o && T(a, o);
                else if (g) {
                    h = t.match(u)[1];
                    let s = a = this.image(h);
                    s.imgwidth = E(o && o.width, y[h] && y[h].width), s.imgheight = E(o && o.height, y[h] && y[h].height), l = (t)=>t.attr({
                            width: t.width,
                            height: t.height
                        }), [
                        "width",
                        "height"
                    ].forEach((t)=>{
                        s[`${t}Setter`] = function(t, e) {
                            this[e] = t;
                            let { alignByTranslate: i, element: s, width: r, height: a, imgwidth: n, imgheight: h } = this, l = "width" === e ? n : h, d = 1;
                            o && "within" === o.backgroundSize && r && a && n && h ? (d = Math.min(r / n, a / h), S(s, {
                                width: Math.round(n * d),
                                height: Math.round(h * d)
                            })) : s && l && s.setAttribute(e, l), !i && n && h && this.translate(((r || 0) - n * d) / 2, ((a || 0) - h * d) / 2);
                        };
                    }), M(e) && s.attr({
                        x: e,
                        y: i
                    }), s.isImg = !0, M(s.imgwidth) && M(s.imgheight) ? l(s) : (s.attr({
                        width: 0,
                        height: 0
                    }), k("img", {
                        onload: function() {
                            let t = d[c.chartIndex];
                            0 === this.width && (C(this, {
                                position: "absolute",
                                top: "-999em"
                            }), p.body.appendChild(this)), y[h] = {
                                width: this.width,
                                height: this.height
                            }, s.imgwidth = this.width, s.imgheight = this.height, s.element && l(s), this.parentNode && this.parentNode.removeChild(this), c.imgCount--, c.imgCount || !t || t.hasLoaded || t.onload();
                        },
                        src: h
                    }), this.imgCount++);
                }
                return a;
            }
            clipRect(t, e, i, s) {
                return this.rect(t, e, i, s, 0);
            }
            text(t, e, i, s) {
                let r = {};
                if (s && (this.allowHTML || !this.forExport)) return this.html(t, e, i);
                r.x = Math.round(e || 0), i && (r.y = Math.round(i)), M(t) && (r.text = t);
                let o = this.createElement("text").attr(r);
                return s && (!this.forExport || this.allowHTML) || (o.xSetter = function(t, e, i) {
                    let s = i.getElementsByTagName("tspan"), r = i.getAttribute(e);
                    for(let i = 0, o; i < s.length; i++)(o = s[i]).getAttribute(e) === r && o.setAttribute(e, t);
                    i.setAttribute(e, t);
                }), o;
            }
            fontMetrics(t) {
                let e = I(r.prototype.getStyle.call(t, "font-size") || 0), i = e < 24 ? e + 3 : Math.round(1.2 * e), s = Math.round(.8 * i);
                return {
                    h: i,
                    b: s,
                    f: e
                };
            }
            rotCorr(t, e, i) {
                let s = t;
                return e && i && (s = Math.max(s * Math.cos(e * c), 4)), {
                    x: -t / 3 * Math.sin(e * c),
                    y: s
                };
            }
            pathToSegments(t) {
                let e = [], i = [], s = {
                    A: 8,
                    C: 7,
                    H: 2,
                    L: 3,
                    M: 3,
                    Q: 5,
                    S: 5,
                    T: 3,
                    V: 2
                };
                for(let r = 0; r < t.length; r++)O(i[0]) && P(t[r]) && i.length === s[i[0].toUpperCase()] && t.splice(r, 0, i[0].replace("M", "L").replace("m", "l")), "string" == typeof t[r] && (i.length && e.push(i.slice(0)), i.length = 0), i.push(t[r]);
                return e.push(i.slice(0)), e;
            }
            label(t, e, i, s, r, a, n, h, l) {
                return new o(this, t, e, i, s, r, a, n, h, l);
            }
            alignElements() {
                this.alignedObjects.forEach((t)=>t.align());
            }
        }
        return T(R.prototype, {
            Element: r,
            SVG_NS: x,
            escapes: {
                "&": "&amp;",
                "<": "&lt;",
                ">": "&gt;",
                "'": "&#39;",
                '"': "&quot;"
            },
            symbols: a,
            draw: m
        }), s.registerRendererType("svg", R, !0), R;
    }), i(e, "Core/Renderer/HTML/HTMLElement.js", [
        e["Core/Renderer/HTML/AST.js"],
        e["Core/Globals.js"],
        e["Core/Renderer/SVG/SVGElement.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i, s) {
        let { composed: r } = e, { attr: o, css: a, createElement: n, defined: h, extend: l, pInt: d, pushUnique: c } = s;
        function p(t, e, s) {
            let r = this.div?.style || s.style;
            i.prototype[`${e}Setter`].call(this, t, e, s), r && (r[e] = t);
        }
        let u = (t, e)=>{
            if (!t.div) {
                let s = o(t.element, "class"), r = t.css, a = n("div", s ? {
                    className: s
                } : void 0, {
                    position: "absolute",
                    left: `${t.translateX || 0}px`,
                    top: `${t.translateY || 0}px`,
                    ...t.styles,
                    display: t.display,
                    opacity: t.opacity,
                    visibility: t.visibility
                }, t.parentGroup?.div || e);
                t.classSetter = (t, e, i)=>{
                    i.setAttribute("class", t), a.className = t;
                }, t.translateXSetter = t.translateYSetter = (e, i)=>{
                    t[i] = e, a.style["translateX" === i ? "left" : "top"] = `${e}px`, t.doTransform = !0;
                }, t.opacitySetter = t.visibilitySetter = p, t.css = (e)=>(r.call(t, e), e.cursor && (a.style.cursor = e.cursor), e.pointerEvents && (a.style.pointerEvents = e.pointerEvents), t), t.on = function() {
                    return i.prototype.on.apply({
                        element: a,
                        onEvents: t.onEvents
                    }, arguments), t;
                }, t.div = a;
            }
            return t.div;
        };
        class g extends i {
            static compose(t) {
                c(r, this.compose) && (t.prototype.html = function(t, e, i) {
                    return new g(this, "span").attr({
                        text: t,
                        x: Math.round(e),
                        y: Math.round(i)
                    });
                });
            }
            constructor(t, e){
                super(t, e), this.css({
                    position: "absolute",
                    ...t.styledMode ? {} : {
                        fontFamily: t.style.fontFamily,
                        fontSize: t.style.fontSize
                    }
                }), this.element.style.whiteSpace = "nowrap";
            }
            getSpanCorrection(t, e, i) {
                this.xCorr = -t * i, this.yCorr = -e;
            }
            css(t) {
                let e;
                let { element: i } = this, s = "SPAN" === i.tagName && t && "width" in t, r = s && t.width;
                return s && (delete t.width, this.textWidth = d(r) || void 0, e = !0), t?.textOverflow === "ellipsis" && (t.whiteSpace = "nowrap", t.overflow = "hidden"), l(this.styles, t), a(i, t), e && this.updateTransform(), this;
            }
            htmlGetBBox() {
                let { element: t } = this;
                return {
                    x: t.offsetLeft,
                    y: t.offsetTop,
                    width: t.offsetWidth,
                    height: t.offsetHeight
                };
            }
            updateTransform() {
                if (!this.added) {
                    this.alignOnAdd = !0;
                    return;
                }
                let { element: t, renderer: e, rotation: i, rotationOriginX: s, rotationOriginY: r, styles: o, textAlign: n = "left", textWidth: l, translateX: d = 0, translateY: c = 0, x: p = 0, y: u = 0 } = this, g = o.whiteSpace;
                if (a(t, {
                    marginLeft: `${d}px`,
                    marginTop: `${c}px`
                }), "SPAN" === t.tagName) {
                    let o = [
                        i,
                        n,
                        t.innerHTML,
                        l,
                        this.textAlign
                    ].join(","), d = -(this.parentGroup?.padding * 1) || 0, c, f = !1;
                    if (l !== this.oldTextWidth) {
                        let e = this.textPxLength ? this.textPxLength : (a(t, {
                            width: "",
                            whiteSpace: g || "nowrap"
                        }), t.offsetWidth), s = l || 0;
                        (s > this.oldTextWidth || e > s) && (/[ \-]/.test(t.textContent || t.innerText) || "ellipsis" === t.style.textOverflow) && (a(t, {
                            width: e > s || i ? l + "px" : "auto",
                            display: "block",
                            whiteSpace: g || "normal"
                        }), this.oldTextWidth = l, f = !0);
                    }
                    this.hasBoxWidthChanged = f, o !== this.cTT && (c = e.fontMetrics(t).b, h(i) && (i !== (this.oldRotation || 0) || n !== this.oldAlign) && this.setSpanRotation(i, d, d), this.getSpanCorrection(!h(i) && this.textPxLength || t.offsetWidth, c, {
                        left: 0,
                        center: .5,
                        right: 1
                    }[n]));
                    let { xCorr: m = 0, yCorr: x = 0 } = this, y = (s ?? p) - m - p - d, b = (r ?? u) - x - u - d;
                    a(t, {
                        left: `${p + m}px`,
                        top: `${u + x}px`,
                        transformOrigin: `${y}px ${b}px`
                    }), this.cTT = o, this.oldRotation = i, this.oldAlign = n;
                }
            }
            setSpanRotation(t, e, i) {
                a(this.element, {
                    transform: `rotate(${t}deg)`,
                    transformOrigin: `${e}% ${i}px`
                });
            }
            add(t) {
                let e;
                let i = this.renderer.box.parentNode, s = [];
                if (this.parentGroup = t, t && !(e = t.div)) {
                    let r = t;
                    for(; r;)s.push(r), r = r.parentGroup;
                    for (let t of s.reverse())e = u(t, i);
                }
                return (e || i).appendChild(this.element), this.added = !0, this.alignOnAdd && this.updateTransform(), this;
            }
            textSetter(e) {
                e !== this.textStr && (delete this.bBox, delete this.oldTextWidth, t.setElementHTML(this.element, e ?? ""), this.textStr = e, this.doTransform = !0);
            }
            alignSetter(t) {
                this.alignValue = this.textAlign = t, this.doTransform = !0;
            }
            xSetter(t, e) {
                this[e] = t, this.doTransform = !0;
            }
        }
        let f = g.prototype;
        return f.visibilitySetter = f.opacitySetter = p, f.ySetter = f.rotationSetter = f.rotationOriginXSetter = f.rotationOriginYSetter = f.xSetter, g;
    }), i(e, "Core/Axis/AxisDefaults.js", [], function() {
        var t, e;
        return (e = t || (t = {})).xAxis = {
            alignTicks: !0,
            allowDecimals: void 0,
            panningEnabled: !0,
            zIndex: 2,
            zoomEnabled: !0,
            dateTimeLabelFormats: {
                millisecond: {
                    main: "%H:%M:%S.%L",
                    range: !1
                },
                second: {
                    main: "%H:%M:%S",
                    range: !1
                },
                minute: {
                    main: "%H:%M",
                    range: !1
                },
                hour: {
                    main: "%H:%M",
                    range: !1
                },
                day: {
                    main: "%e %b"
                },
                week: {
                    main: "%e %b"
                },
                month: {
                    main: "%b '%y"
                },
                year: {
                    main: "%Y"
                }
            },
            endOnTick: !1,
            gridLineDashStyle: "Solid",
            gridZIndex: 1,
            labels: {
                autoRotationLimit: 80,
                distance: 15,
                enabled: !0,
                indentation: 10,
                overflow: "justify",
                padding: 5,
                reserveSpace: void 0,
                rotation: void 0,
                staggerLines: 0,
                step: 0,
                useHTML: !1,
                zIndex: 7,
                style: {
                    color: "#333333",
                    cursor: "default",
                    fontSize: "0.8em"
                }
            },
            maxPadding: .01,
            minorGridLineDashStyle: "Solid",
            minorTickLength: 2,
            minorTickPosition: "outside",
            minorTicksPerMajor: 5,
            minPadding: .01,
            offset: void 0,
            reversed: void 0,
            reversedStacks: !1,
            showEmpty: !0,
            showFirstLabel: !0,
            showLastLabel: !0,
            startOfWeek: 1,
            startOnTick: !1,
            tickLength: 10,
            tickPixelInterval: 100,
            tickmarkPlacement: "between",
            tickPosition: "outside",
            title: {
                align: "middle",
                useHTML: !1,
                x: 0,
                y: 0,
                style: {
                    color: "#666666",
                    fontSize: "0.8em"
                }
            },
            type: "linear",
            uniqueNames: !0,
            visible: !0,
            minorGridLineColor: "#f2f2f2",
            minorGridLineWidth: 1,
            minorTickColor: "#999999",
            lineColor: "#333333",
            lineWidth: 1,
            gridLineColor: "#e6e6e6",
            gridLineWidth: void 0,
            tickColor: "#333333"
        }, e.yAxis = {
            reversedStacks: !0,
            endOnTick: !0,
            maxPadding: .05,
            minPadding: .05,
            tickPixelInterval: 72,
            showLastLabel: !0,
            labels: {
                x: void 0
            },
            startOnTick: !0,
            title: {
                text: "Values"
            },
            stackLabels: {
                animation: {},
                allowOverlap: !1,
                enabled: !1,
                crop: !0,
                overflow: "justify",
                formatter: function() {
                    let { numberFormatter: t } = this.axis.chart;
                    return t(this.total || 0, -1);
                },
                style: {
                    color: "#000000",
                    fontSize: "0.7em",
                    fontWeight: "bold",
                    textOutline: "1px contrast"
                }
            },
            gridLineWidth: 1,
            lineWidth: 0
        }, t;
    }), i(e, "Core/Foundation.js", [
        e["Core/Utilities.js"]
    ], function(t) {
        var e;
        let { addEvent: i, isFunction: s, objectEach: r, removeEvent: o } = t;
        return (e || (e = {})).registerEventOptions = function(t, e) {
            t.eventOptions = t.eventOptions || {}, r(e.events, function(e, r) {
                t.eventOptions[r] !== e && (t.eventOptions[r] && (o(t, r, t.eventOptions[r]), delete t.eventOptions[r]), s(e) && (t.eventOptions[r] = e, i(t, r, e, {
                    order: 0
                })));
            });
        }, e;
    }), i(e, "Core/Axis/Tick.js", [
        e["Core/Templating.js"],
        e["Core/Globals.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i) {
        let { deg2rad: s } = e, { clamp: r, correctFloat: o, defined: a, destroyObjectProperties: n, extend: h, fireEvent: l, isNumber: d, merge: c, objectEach: p, pick: u } = i;
        return class {
            constructor(t, e, i, s, r){
                this.isNew = !0, this.isNewLabel = !0, this.axis = t, this.pos = e, this.type = i || "", this.parameters = r || {}, this.tickmarkOffset = this.parameters.tickmarkOffset, this.options = this.parameters.options, l(this, "init"), i || s || this.addLabel();
            }
            addLabel() {
                let e = this, i = e.axis, s = i.options, r = i.chart, n = i.categories, c = i.logarithmic, p = i.names, g = e.pos, f = u(e.options && e.options.labels, s.labels), m = i.tickPositions, x = g === m[0], y = g === m[m.length - 1], b = (!f.step || 1 === f.step) && 1 === i.tickInterval, v = m.info, S = e.label, k, C, M, w = this.parameters.category || (n ? u(n[g], p[g], g) : g);
                c && d(w) && (w = o(c.lin2log(w))), i.dateTime && (v ? k = (C = r.time.resolveDTLFormat(s.dateTimeLabelFormats[!s.grid && v.higherRanks[g] || v.unitName])).main : d(w) && (k = i.dateTime.getXDateFormat(w, s.dateTimeLabelFormats || {}))), e.isFirst = x, e.isLast = y;
                let T = {
                    axis: i,
                    chart: r,
                    dateTimeLabelFormat: k,
                    isFirst: x,
                    isLast: y,
                    pos: g,
                    tick: e,
                    tickPositionInfo: v,
                    value: w
                };
                l(this, "labelFormat", T);
                let A = (e)=>f.formatter ? f.formatter.call(e, e) : f.format ? (e.text = i.defaultLabelFormatter.call(e), t.format(f.format, e, r)) : i.defaultLabelFormatter.call(e), P = A.call(T, T), L = C && C.list;
                L ? e.shortenLabel = function() {
                    for(M = 0; M < L.length; M++)if (h(T, {
                        dateTimeLabelFormat: L[M]
                    }), S.attr({
                        text: A.call(T, T)
                    }), S.getBBox().width < i.getSlotWidth(e) - 2 * f.padding) return;
                    S.attr({
                        text: ""
                    });
                } : e.shortenLabel = void 0, b && i._addedPlotLB && e.moveLabel(P, f), a(S) || e.movedLabel ? S && S.textStr !== P && !b && (!S.textWidth || f.style.width || S.styles.width || S.css({
                    width: null
                }), S.attr({
                    text: P
                }), S.textPxLength = S.getBBox().width) : (e.label = S = e.createLabel(P, f), e.rotation = 0);
            }
            createLabel(t, e, i) {
                let s = this.axis, r = s.chart, o = a(t) && e.enabled ? r.renderer.text(t, i?.x, i?.y, e.useHTML).add(s.labelGroup) : void 0;
                return o && (r.styledMode || o.css(c(e.style)), o.textPxLength = o.getBBox().width), o;
            }
            destroy() {
                n(this, this.axis);
            }
            getPosition(t, e, i, s) {
                let a = this.axis, n = a.chart, h = s && n.oldChartHeight || n.chartHeight, d = {
                    x: t ? o(a.translate(e + i, void 0, void 0, s) + a.transB) : a.left + a.offset + (a.opposite ? (s && n.oldChartWidth || n.chartWidth) - a.right - a.left : 0),
                    y: t ? h - a.bottom + a.offset - (a.opposite ? a.height : 0) : o(h - a.translate(e + i, void 0, void 0, s) - a.transB)
                };
                return d.y = r(d.y, -100000, 1e5), l(this, "afterGetPosition", {
                    pos: d
                }), d;
            }
            getLabelPosition(t, e, i, r, o, n, h, d) {
                let c, p;
                let g = this.axis, f = g.transA, m = g.isLinked && g.linkedParent ? g.linkedParent.reversed : g.reversed, x = g.staggerLines, y = g.tickRotCorr || {
                    x: 0,
                    y: 0
                }, b = r || g.reserveSpaceDefault ? 0 : -g.labelOffset * ("center" === g.labelAlign ? .5 : 1), v = o.distance, S = {};
                return c = 0 === g.side ? i.rotation ? -v : -i.getBBox().height : 2 === g.side ? y.y + v : Math.cos(i.rotation * s) * (y.y - i.getBBox(!1, 0).height / 2), a(o.y) && (c = 0 === g.side && g.horiz ? o.y + c : o.y), t = t + u(o.x, [
                    0,
                    1,
                    0,
                    -1
                ][g.side] * v) + b + y.x - (n && r ? n * f * (m ? -1 : 1) : 0), e = e + c - (n && !r ? n * f * (m ? 1 : -1) : 0), x && (p = h / (d || 1) % x, g.opposite && (p = x - p - 1), e += g.labelOffset / x * p), S.x = t, S.y = Math.round(e), l(this, "afterGetLabelPosition", {
                    pos: S,
                    tickmarkOffset: n,
                    index: h
                }), S;
            }
            getLabelSize() {
                return this.label ? this.label.getBBox()[this.axis.horiz ? "height" : "width"] : 0;
            }
            getMarkPath(t, e, i, s, r, o) {
                return o.crispLine([
                    [
                        "M",
                        t,
                        e
                    ],
                    [
                        "L",
                        t + (r ? 0 : -i),
                        e + (r ? i : 0)
                    ]
                ], s);
            }
            handleOverflow(t) {
                let e = this.axis, i = e.options.labels, r = t.x, o = e.chart.chartWidth, a = e.chart.spacing, n = u(e.labelLeft, Math.min(e.pos, a[3])), h = u(e.labelRight, Math.max(e.isRadial ? 0 : e.pos + e.len, o - a[1])), l = this.label, d = this.rotation, c = {
                    left: 0,
                    center: .5,
                    right: 1
                }[e.labelAlign || l.attr("align")], p = l.getBBox().width, g = e.getSlotWidth(this), f = {}, m = g, x = 1, y, b, v;
                d || "justify" !== i.overflow ? d < 0 && r - c * p < n ? v = Math.round(r / Math.cos(d * s) - n) : d > 0 && r + c * p > h && (v = Math.round((o - r) / Math.cos(d * s))) : (y = r - c * p, b = r + (1 - c) * p, y < n ? m = t.x + m * (1 - c) - n : b > h && (m = h - t.x + m * c, x = -1), (m = Math.min(g, m)) < g && "center" === e.labelAlign && (t.x += x * (g - m - c * (g - Math.min(p, m)))), (p > m || e.autoRotation && (l.styles || {}).width) && (v = m)), v && (this.shortenLabel ? this.shortenLabel() : (f.width = Math.floor(v) + "px", (i.style || {}).textOverflow || (f.textOverflow = "ellipsis"), l.css(f)));
            }
            moveLabel(t, e) {
                let i = this, s = i.label, r = i.axis, o = !1, a;
                s && s.textStr === t ? (i.movedLabel = s, o = !0, delete i.label) : p(r.ticks, function(e) {
                    o || e.isNew || e === i || !e.label || e.label.textStr !== t || (i.movedLabel = e.label, o = !0, e.labelPos = i.movedLabel.xy, delete e.label);
                }), !o && (i.labelPos || s) && (a = i.labelPos || s.xy, i.movedLabel = i.createLabel(t, e, a), i.movedLabel && i.movedLabel.attr({
                    opacity: 0
                }));
            }
            render(t, e, i) {
                let s = this.axis, r = s.horiz, a = this.pos, n = u(this.tickmarkOffset, s.tickmarkOffset), h = this.getPosition(r, a, n, e), d = h.x, c = h.y, p = s.pos, g = p + s.len, f = r && d === g || !r && c === p ? -1 : 1, m = r ? d : c;
                !s.chart.polar && this.isNew && (o(m) < p || m > g) && (i = 0);
                let x = u(i, this.label && this.label.newOpacity, 1);
                i = u(i, 1), this.isActive = !0, this.renderGridLine(e, i, f), this.renderMark(h, i, f), this.renderLabel(h, e, x, t), this.isNew = !1, l(this, "afterRender");
            }
            renderGridLine(t, e, i) {
                let s = this.axis, r = s.options, o = {}, a = this.pos, n = this.type, h = u(this.tickmarkOffset, s.tickmarkOffset), l = s.chart.renderer, d = this.gridLine, c, p = r.gridLineWidth, g = r.gridLineColor, f = r.gridLineDashStyle;
                "minor" === this.type && (p = r.minorGridLineWidth, g = r.minorGridLineColor, f = r.minorGridLineDashStyle), d || (s.chart.styledMode || (o.stroke = g, o["stroke-width"] = p || 0, o.dashstyle = f), n || (o.zIndex = 1), t && (e = 0), this.gridLine = d = l.path().attr(o).addClass("highcharts-" + (n ? n + "-" : "") + "grid-line").add(s.gridGroup)), d && (c = s.getPlotLinePath({
                    value: a + h,
                    lineWidth: d.strokeWidth() * i,
                    force: "pass",
                    old: t,
                    acrossPanes: !1
                })) && d[t || this.isNew ? "attr" : "animate"]({
                    d: c,
                    opacity: e
                });
            }
            renderMark(t, e, i) {
                let s = this.axis, r = s.options, o = s.chart.renderer, a = this.type, n = s.tickSize(a ? a + "Tick" : "tick"), h = t.x, l = t.y, d = u(r["minor" !== a ? "tickWidth" : "minorTickWidth"], !a && s.isXAxis ? 1 : 0), c = r["minor" !== a ? "tickColor" : "minorTickColor"], p = this.mark, g = !p;
                n && (s.opposite && (n[0] = -n[0]), p || (this.mark = p = o.path().addClass("highcharts-" + (a ? a + "-" : "") + "tick").add(s.axisGroup), s.chart.styledMode || p.attr({
                    stroke: c,
                    "stroke-width": d
                })), p[g ? "attr" : "animate"]({
                    d: this.getMarkPath(h, l, n[0], p.strokeWidth() * i, s.horiz, o),
                    opacity: e
                }));
            }
            renderLabel(t, e, i, s) {
                let r = this.axis, o = r.horiz, a = r.options, n = this.label, h = a.labels, l = h.step, c = u(this.tickmarkOffset, r.tickmarkOffset), p = t.x, g = t.y, f = !0;
                n && d(p) && (n.xy = t = this.getLabelPosition(p, g, n, o, h, c, s, l), (!this.isFirst || this.isLast || a.showFirstLabel) && (!this.isLast || this.isFirst || a.showLastLabel) ? !o || h.step || h.rotation || e || 0 === i || this.handleOverflow(t) : f = !1, l && s % l && (f = !1), f && d(t.y) ? (t.opacity = i, n[this.isNewLabel ? "attr" : "animate"](t).show(!0), this.isNewLabel = !1) : (n.hide(), this.isNewLabel = !0));
            }
            replaceMovedLabel() {
                let t = this.label, e = this.axis;
                t && !this.isNew && (t.animate({
                    opacity: 0
                }, void 0, t.destroy), delete this.label), e.isDirty = !0, this.label = this.movedLabel, delete this.movedLabel;
            }
        };
    }), i(e, "Core/Axis/Axis.js", [
        e["Core/Animation/AnimationUtilities.js"],
        e["Core/Axis/AxisDefaults.js"],
        e["Core/Color/Color.js"],
        e["Core/Defaults.js"],
        e["Core/Foundation.js"],
        e["Core/Globals.js"],
        e["Core/Axis/Tick.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i, s, r, o, a, n) {
        let { animObject: h } = t, { xAxis: l, yAxis: d } = e, { defaultOptions: c } = s, { registerEventOptions: p } = r, { deg2rad: u } = o, { arrayMax: g, arrayMin: f, clamp: m, correctFloat: x, defined: y, destroyObjectProperties: b, erase: v, error: S, extend: k, fireEvent: C, getClosestDistance: M, insertItem: w, isArray: T, isNumber: A, isString: P, merge: L, normalizeTickInterval: O, objectEach: D, pick: E, relativeLength: I, removeEvent: j, splat: B, syncTimeout: R } = n, z = (t, e)=>O(e, void 0, void 0, E(t.options.allowDecimals, e < .5 || void 0 !== t.tickAmount), !!t.tickAmount);
        k(c, {
            xAxis: l,
            yAxis: L(l, d)
        });
        class N {
            constructor(t, e, i){
                this.init(t, e, i);
            }
            init(t, e, i = this.coll) {
                let s = "xAxis" === i, r = this.isZAxis || (t.inverted ? !s : s);
                this.chart = t, this.horiz = r, this.isXAxis = s, this.coll = i, C(this, "init", {
                    userOptions: e
                }), this.opposite = E(e.opposite, this.opposite), this.side = E(e.side, this.side, r ? this.opposite ? 0 : 2 : this.opposite ? 1 : 3), this.setOptions(e);
                let o = this.options, a = o.labels, n = o.type;
                this.userOptions = e, this.minPixelPadding = 0, this.reversed = E(o.reversed, this.reversed), this.visible = o.visible, this.zoomEnabled = o.zoomEnabled, this.hasNames = "category" === n || !0 === o.categories, this.categories = T(o.categories) && o.categories || (this.hasNames ? [] : void 0), this.names || (this.names = [], this.names.keys = {}), this.plotLinesAndBandsGroups = {}, this.positiveValuesOnly = !!this.logarithmic, this.isLinked = y(o.linkedTo), this.ticks = {}, this.labelEdge = [], this.minorTicks = {}, this.plotLinesAndBands = [], this.alternateBands = {}, this.len = 0, this.minRange = this.userMinRange = o.minRange || o.maxZoom, this.range = o.range, this.offset = o.offset || 0, this.max = void 0, this.min = void 0;
                let h = E(o.crosshair, B(t.options.tooltip.crosshairs)[s ? 0 : 1]);
                this.crosshair = !0 === h ? {} : h, -1 === t.axes.indexOf(this) && (s ? t.axes.splice(t.xAxis.length, 0, this) : t.axes.push(this), w(this, t[this.coll])), t.orderItems(this.coll), this.series = this.series || [], t.inverted && !this.isZAxis && s && !y(this.reversed) && (this.reversed = !0), this.labelRotation = A(a.rotation) ? a.rotation : void 0, p(this, o), C(this, "afterInit");
            }
            setOptions(t) {
                let e = this.horiz ? {
                    labels: {
                        autoRotation: [
                            -45
                        ]
                    },
                    margin: 15
                } : {
                    title: {
                        rotation: 90 * this.side
                    }
                };
                this.options = L(e, c[this.coll], t), C(this, "afterSetOptions", {
                    userOptions: t
                });
            }
            defaultLabelFormatter() {
                let t = this.axis, { numberFormatter: e } = this.chart, i = A(this.value) ? this.value : NaN, s = t.chart.time, r = t.categories, o = this.dateTimeLabelFormat, a = c.lang, n = a.numericSymbols, h = a.numericSymbolMagnitude || 1e3, l = t.logarithmic ? Math.abs(i) : t.tickInterval, d = n && n.length, p, u;
                if (r) u = `${this.value}`;
                else if (o) u = s.dateFormat(o, i);
                else if (d && n && l >= 1e3) for(; d-- && void 0 === u;)l >= (p = Math.pow(h, d + 1)) && 10 * i % p == 0 && null !== n[d] && 0 !== i && (u = e(i / p, -1) + n[d]);
                return void 0 === u && (u = Math.abs(i) >= 1e4 ? e(i, -1) : e(i, -1, void 0, "")), u;
            }
            getSeriesExtremes() {
                let t;
                let e = this;
                C(this, "getSeriesExtremes", null, function() {
                    e.hasVisibleSeries = !1, e.dataMin = e.dataMax = e.threshold = void 0, e.softThreshold = !e.isXAxis, e.series.forEach((i)=>{
                        if (i.reserveSpace()) {
                            let s = i.options, r, o = s.threshold, a, n;
                            if (e.hasVisibleSeries = !0, e.positiveValuesOnly && 0 >= (o || 0) && (o = void 0), e.isXAxis) (r = i.xData) && r.length && (r = e.logarithmic ? r.filter((t)=>t > 0) : r, a = (t = i.getXExtremes(r)).min, n = t.max, A(a) || a instanceof Date || (r = r.filter(A), a = (t = i.getXExtremes(r)).min, n = t.max), r.length && (e.dataMin = Math.min(E(e.dataMin, a), a), e.dataMax = Math.max(E(e.dataMax, n), n)));
                            else {
                                let t = i.applyExtremes();
                                A(t.dataMin) && (a = t.dataMin, e.dataMin = Math.min(E(e.dataMin, a), a)), A(t.dataMax) && (n = t.dataMax, e.dataMax = Math.max(E(e.dataMax, n), n)), y(o) && (e.threshold = o), (!s.softThreshold || e.positiveValuesOnly) && (e.softThreshold = !1);
                            }
                        }
                    });
                }), C(this, "afterGetSeriesExtremes");
            }
            translate(t, e, i, s, r, o) {
                let a = this.linkedParent || this, n = s && a.old ? a.old.min : a.min;
                if (!A(n)) return NaN;
                let h = a.minPixelPadding, l = (a.isOrdinal || a.brokenAxis?.hasBreaks || a.logarithmic && r) && a.lin2val, d = 1, c = 0, p = s && a.old ? a.old.transA : a.transA, u = 0;
                if (p || (p = a.transA), i && (d *= -1, c = a.len), a.reversed && (d *= -1, c -= d * (a.sector || a.len)), e) u = (t = t * d + c - h) / p + n, l && (u = a.lin2val(u));
                else {
                    l && (t = a.val2lin(t));
                    let e = d * (t - n) * p;
                    u = (a.isRadial ? e : x(e)) + c + d * h + (A(o) ? p * o : 0);
                }
                return u;
            }
            toPixels(t, e) {
                return this.translate(t, !1, !this.horiz, void 0, !0) + (e ? 0 : this.pos);
            }
            toValue(t, e) {
                return this.translate(t - (e ? 0 : this.pos), !0, !this.horiz, void 0, !0);
            }
            getPlotLinePath(t) {
                let e = this, i = e.chart, s = e.left, r = e.top, o = t.old, a = t.value, n = t.lineWidth, h = o && i.oldChartHeight || i.chartHeight, l = o && i.oldChartWidth || i.chartWidth, d = e.transB, c = t.translatedValue, p = t.force, u, g, f, x, y;
                function b(t, e, i) {
                    return "pass" !== p && (t < e || t > i) && (p ? t = m(t, e, i) : y = !0), t;
                }
                let v = {
                    value: a,
                    lineWidth: n,
                    old: o,
                    force: p,
                    acrossPanes: t.acrossPanes,
                    translatedValue: c
                };
                return C(this, "getPlotLinePath", v, function(t) {
                    u = f = Math.round((c = m(c = E(c, e.translate(a, void 0, void 0, o)), -100000, 1e5)) + d), g = x = Math.round(h - c - d), A(c) ? e.horiz ? (g = r, x = h - e.bottom + (i.scrollablePixelsY || 0), u = f = b(u, s, s + e.width)) : (u = s, f = l - e.right + (i.scrollablePixelsX || 0), g = x = b(g, r, r + e.height)) : (y = !0, p = !1), t.path = y && !p ? void 0 : i.renderer.crispLine([
                        [
                            "M",
                            u,
                            g
                        ],
                        [
                            "L",
                            f,
                            x
                        ]
                    ], n || 1);
                }), v.path;
            }
            getLinearTickPositions(t, e, i) {
                let s, r, o;
                let a = x(Math.floor(e / t) * t), n = x(Math.ceil(i / t) * t), h = [];
                if (x(a + t) === a && (o = 20), this.single) return [
                    e
                ];
                for(s = a; s <= n && (h.push(s), (s = x(s + t, o)) !== r);)r = s;
                return h;
            }
            getMinorTickInterval() {
                let { minorTicks: t, minorTickInterval: e } = this.options;
                return !0 === t ? E(e, "auto") : !1 !== t ? e : void 0;
            }
            getMinorTickPositions() {
                let t = this.options, e = this.tickPositions, i = this.minorTickInterval, s = this.pointRangePadding || 0, r = (this.min || 0) - s, o = (this.max || 0) + s, a = o - r, n = [], h;
                if (a && a / i < this.len / 3) {
                    let s = this.logarithmic;
                    if (s) this.paddedTicks.forEach(function(t, e, r) {
                        e && n.push.apply(n, s.getLogTickPositions(i, r[e - 1], r[e], !0));
                    });
                    else if (this.dateTime && "auto" === this.getMinorTickInterval()) n = n.concat(this.getTimeTicks(this.dateTime.normalizeTimeTickInterval(i), r, o, t.startOfWeek));
                    else for(h = r + (e[0] - r) % i; h <= o && h !== n[0]; h += i)n.push(h);
                }
                return 0 !== n.length && this.trimTicks(n), n;
            }
            adjustForMinRange() {
                let t = this.options, e = this.logarithmic, { max: i, min: s, minRange: r } = this, o, a, n, h;
                this.isXAxis && void 0 === r && !e && (r = y(t.min) || y(t.max) || y(t.floor) || y(t.ceiling) ? null : Math.min(5 * (M(this.series.map((t)=>(t.xIncrement ? t.xData?.slice(0, 2) : t.xData) || [])) || 0), this.dataMax - this.dataMin)), A(i) && A(s) && A(r) && i - s < r && (a = this.dataMax - this.dataMin >= r, o = (r - i + s) / 2, n = [
                    s - o,
                    E(t.min, s - o)
                ], a && (n[2] = e ? e.log2lin(this.dataMin) : this.dataMin), h = [
                    (s = g(n)) + r,
                    E(t.max, s + r)
                ], a && (h[2] = e ? e.log2lin(this.dataMax) : this.dataMax), (i = f(h)) - s < r && (n[0] = i - r, n[1] = E(t.min, i - r), s = g(n))), this.minRange = r, this.min = s, this.max = i;
            }
            getClosest() {
                let t, e;
                if (this.categories) e = 1;
                else {
                    let i = [];
                    this.series.forEach(function(t) {
                        let s = t.closestPointRange;
                        t.xData?.length === 1 ? i.push(t.xData[0]) : !t.noSharedTooltip && y(s) && t.reserveSpace() && (e = y(e) ? Math.min(e, s) : s);
                    }), i.length && (i.sort((t, e)=>t - e), t = M([
                        i
                    ]));
                }
                return t && e ? Math.min(t, e) : t || e;
            }
            nameToX(t) {
                let e = T(this.options.categories), i = e ? this.categories : this.names, s = t.options.x, r;
                return t.series.requireSorting = !1, y(s) || (s = this.options.uniqueNames && i ? e ? i.indexOf(t.name) : E(i.keys[t.name], -1) : t.series.autoIncrement()), -1 === s ? !e && i && (r = i.length) : r = s, void 0 !== r ? (this.names[r] = t.name, this.names.keys[t.name] = r) : t.x && (r = t.x), r;
            }
            updateNames() {
                let t = this, e = this.names;
                e.length > 0 && (Object.keys(e.keys).forEach(function(t) {
                    delete e.keys[t];
                }), e.length = 0, this.minRange = this.userMinRange, (this.series || []).forEach((e)=>{
                    e.xIncrement = null, (!e.points || e.isDirtyData) && (t.max = Math.max(t.max, e.xData.length - 1), e.processData(), e.generatePoints()), e.data.forEach(function(i, s) {
                        let r;
                        i?.options && void 0 !== i.name && void 0 !== (r = t.nameToX(i)) && r !== i.x && (i.x = r, e.xData[s] = r);
                    });
                }));
            }
            setAxisTranslation() {
                let t = this, e = t.max - t.min, i = t.linkedParent, s = !!t.categories, r = t.isXAxis, o = t.axisPointRange || 0, a, n = 0, h = 0, l, d = t.transA;
                (r || s || o) && (a = t.getClosest(), i ? (n = i.minPointOffset, h = i.pointRangePadding) : t.series.forEach(function(e) {
                    let i = s ? 1 : r ? E(e.options.pointRange, a, 0) : t.axisPointRange || 0, l = e.options.pointPlacement;
                    if (o = Math.max(o, i), !t.single || s) {
                        let t = e.is("xrange") ? !r : r;
                        n = Math.max(n, t && P(l) ? 0 : i / 2), h = Math.max(h, t && "on" === l ? 0 : i);
                    }
                }), l = t.ordinal && t.ordinal.slope && a ? t.ordinal.slope / a : 1, t.minPointOffset = n *= l, t.pointRangePadding = h *= l, t.pointRange = Math.min(o, t.single && s ? 1 : e), r && a && (t.closestPointRange = a)), t.translationSlope = t.transA = d = t.staticScale || t.len / (e + h || 1), t.transB = t.horiz ? t.left : t.bottom, t.minPixelPadding = d * n, C(this, "afterSetAxisTranslation");
            }
            minFromRange() {
                let { max: t, min: e } = this;
                return A(t) && A(e) && t - e || void 0;
            }
            setTickInterval(t) {
                let { categories: e, chart: i, dataMax: s, dataMin: r, dateTime: o, isXAxis: a, logarithmic: n, options: h, softThreshold: l } = this, d = A(this.threshold) ? this.threshold : void 0, c = this.minRange || 0, { ceiling: p, floor: u, linkedTo: g, softMax: f, softMin: m } = h, b = A(g) && i[this.coll]?.[g], v = h.tickPixelInterval, k = h.maxPadding, M = h.minPadding, w = 0, T, P = A(h.tickInterval) && h.tickInterval >= 0 ? h.tickInterval : void 0, L, O, D, I;
                if (o || e || b || this.getTickAmount(), D = E(this.userMin, h.min), I = E(this.userMax, h.max), b ? (this.linkedParent = b, T = b.getExtremes(), this.min = E(T.min, T.dataMin), this.max = E(T.max, T.dataMax), h.type !== b.options.type && S(11, !0, i)) : (l && y(d) && A(s) && A(r) && (r >= d ? (L = d, M = 0) : s <= d && (O = d, k = 0)), this.min = E(D, L, r), this.max = E(I, O, s)), A(this.max) && A(this.min) && (n && (this.positiveValuesOnly && !t && 0 >= Math.min(this.min, E(r, this.min)) && S(10, !0, i), this.min = x(n.log2lin(this.min), 16), this.max = x(n.log2lin(this.max), 16)), this.range && A(r) && (this.userMin = this.min = D = Math.max(r, this.minFromRange() || 0), this.userMax = I = this.max, this.range = void 0)), C(this, "foundExtremes"), this.adjustForMinRange(), A(this.min) && A(this.max)) {
                    if (!A(this.userMin) && A(m) && m < this.min && (this.min = D = m), !A(this.userMax) && A(f) && f > this.max && (this.max = I = f), e || this.axisPointRange || this.stacking?.usePercentage || b || !(w = this.max - this.min) || (!y(D) && M && (this.min -= w * M), y(I) || !k || (this.max += w * k)), !A(this.userMin) && A(u) && (this.min = Math.max(this.min, u)), !A(this.userMax) && A(p) && (this.max = Math.min(this.max, p)), l && A(r) && A(s)) {
                        let t = d || 0;
                        !y(D) && this.min < t && r >= t ? this.min = h.minRange ? Math.min(t, this.max - c) : t : !y(I) && this.max > t && s <= t && (this.max = h.minRange ? Math.max(t, this.min + c) : t);
                    }
                    !i.polar && this.min > this.max && (y(h.min) ? this.max = this.min : y(h.max) && (this.min = this.max)), w = this.max - this.min;
                }
                if (this.min !== this.max && A(this.min) && A(this.max) ? b && !P && v === b.options.tickPixelInterval ? this.tickInterval = P = b.tickInterval : this.tickInterval = E(P, this.tickAmount ? w / Math.max(this.tickAmount - 1, 1) : void 0, e ? 1 : w * v / Math.max(this.len, v)) : this.tickInterval = 1, a && !t) {
                    let t = this.min !== this.old?.min || this.max !== this.old?.max;
                    this.series.forEach(function(e) {
                        e.forceCrop = e.forceCropping?.(), e.processData(t);
                    }), C(this, "postProcessData", {
                        hasExtremesChanged: t
                    });
                }
                this.setAxisTranslation(), C(this, "initialAxisTranslation"), this.pointRange && !P && (this.tickInterval = Math.max(this.pointRange, this.tickInterval));
                let j = E(h.minTickInterval, o && !this.series.some((t)=>t.noSharedTooltip) ? this.closestPointRange : 0);
                !P && this.tickInterval < j && (this.tickInterval = j), o || n || P || (this.tickInterval = z(this, this.tickInterval)), this.tickAmount || (this.tickInterval = this.unsquish()), this.setTickPositions();
            }
            setTickPositions() {
                let t = this.options, e = t.tickPositions, i = t.tickPositioner, s = this.getMinorTickInterval(), r = !this.isPanning, o = r && t.startOnTick, a = r && t.endOnTick, n = [], h;
                if (this.tickmarkOffset = this.categories && "between" === t.tickmarkPlacement && 1 === this.tickInterval ? .5 : 0, this.minorTickInterval = "auto" === s && this.tickInterval ? this.tickInterval / t.minorTicksPerMajor : s, this.single = this.min === this.max && y(this.min) && !this.tickAmount && (this.min % 1 == 0 || !1 !== t.allowDecimals), e) n = e.slice();
                else if (A(this.min) && A(this.max)) {
                    if (!this.ordinal?.positions && (this.max - this.min) / this.tickInterval > Math.max(2 * this.len, 200)) n = [
                        this.min,
                        this.max
                    ], S(19, !1, this.chart);
                    else if (this.dateTime) n = this.getTimeTicks(this.dateTime.normalizeTimeTickInterval(this.tickInterval, t.units), this.min, this.max, t.startOfWeek, this.ordinal?.positions, this.closestPointRange, !0);
                    else if (this.logarithmic) n = this.logarithmic.getLogTickPositions(this.tickInterval, this.min, this.max);
                    else {
                        let t = this.tickInterval, e = t;
                        for(; e <= 2 * t;)if (n = this.getLinearTickPositions(this.tickInterval, this.min, this.max), this.tickAmount && n.length > this.tickAmount) this.tickInterval = z(this, e *= 1.1);
                        else break;
                    }
                    n.length > this.len && (n = [
                        n[0],
                        n[n.length - 1]
                    ])[0] === n[1] && (n.length = 1), i && (this.tickPositions = n, (h = i.apply(this, [
                        this.min,
                        this.max
                    ])) && (n = h));
                }
                this.tickPositions = n, this.paddedTicks = n.slice(0), this.trimTicks(n, o, a), !this.isLinked && A(this.min) && A(this.max) && (this.single && n.length < 2 && !this.categories && !this.series.some((t)=>t.is("heatmap") && "between" === t.options.pointPlacement) && (this.min -= .5, this.max += .5), e || h || this.adjustTickAmount()), C(this, "afterSetTickPositions");
            }
            trimTicks(t, e, i) {
                let s = t[0], r = t[t.length - 1], o = !this.isOrdinal && this.minPointOffset || 0;
                if (C(this, "trimTicks"), !this.isLinked) {
                    if (e && s !== -1 / 0) this.min = s;
                    else for(; this.min - o > t[0];)t.shift();
                    if (i) this.max = r;
                    else for(; this.max + o < t[t.length - 1];)t.pop();
                    0 === t.length && y(s) && !this.options.tickPositions && t.push((r + s) / 2);
                }
            }
            alignToOthers() {
                let t;
                let e = this, i = e.chart, s = [
                    this
                ], r = e.options, o = i.options.chart, a = "yAxis" === this.coll && o.alignThresholds, n = [];
                if (e.thresholdAlignment = void 0, (!1 !== o.alignTicks && r.alignTicks || a) && !1 !== r.startOnTick && !1 !== r.endOnTick && !e.logarithmic) {
                    let r = (t)=>{
                        let { horiz: e, options: i } = t;
                        return [
                            e ? i.left : i.top,
                            i.width,
                            i.height,
                            i.pane
                        ].join(",");
                    }, o = r(this);
                    i[this.coll].forEach(function(i) {
                        let { series: a } = i;
                        a.length && a.some((t)=>t.visible) && i !== e && r(i) === o && (t = !0, s.push(i));
                    });
                }
                if (t && a) {
                    s.forEach((t)=>{
                        let i = t.getThresholdAlignment(e);
                        A(i) && n.push(i);
                    });
                    let t = n.length > 1 ? n.reduce((t, e)=>t += e, 0) / n.length : void 0;
                    s.forEach((e)=>{
                        e.thresholdAlignment = t;
                    });
                }
                return t;
            }
            getThresholdAlignment(t) {
                if ((!A(this.dataMin) || this !== t && this.series.some((t)=>t.isDirty || t.isDirtyData)) && this.getSeriesExtremes(), A(this.threshold)) {
                    let t = m((this.threshold - (this.dataMin || 0)) / ((this.dataMax || 0) - (this.dataMin || 0)), 0, 1);
                    return this.options.reversed && (t = 1 - t), t;
                }
            }
            getTickAmount() {
                let t = this.options, e = t.tickPixelInterval, i = t.tickAmount;
                y(t.tickInterval) || i || !(this.len < e) || this.isRadial || this.logarithmic || !t.startOnTick || !t.endOnTick || (i = 2), !i && this.alignToOthers() && (i = Math.ceil(this.len / e) + 1), i < 4 && (this.finalTickAmt = i, i = 5), this.tickAmount = i;
            }
            adjustTickAmount() {
                let t = this, { finalTickAmt: e, max: i, min: s, options: r, tickPositions: o, tickAmount: a, thresholdAlignment: n } = t, h = o?.length, l = E(t.threshold, t.softThreshold ? 0 : null), d, c, p = t.tickInterval, u, g = ()=>o.push(x(o[o.length - 1] + p)), f = ()=>o.unshift(x(o[0] - p));
                if (A(n) && (u = n < .5 ? Math.ceil(n * (a - 1)) : Math.floor(n * (a - 1)), r.reversed && (u = a - 1 - u)), t.hasData() && A(s) && A(i)) {
                    let n = ()=>{
                        t.transA *= (h - 1) / (a - 1), t.min = r.startOnTick ? o[0] : Math.min(s, o[0]), t.max = r.endOnTick ? o[o.length - 1] : Math.max(i, o[o.length - 1]);
                    };
                    if (A(u) && A(t.threshold)) {
                        for(; o[u] !== l || o.length !== a || o[0] > s || o[o.length - 1] < i;){
                            for(o.length = 0, o.push(t.threshold); o.length < a;)void 0 === o[u] || o[u] > t.threshold ? f() : g();
                            if (p > 8 * t.tickInterval) break;
                            p *= 2;
                        }
                        n();
                    } else if (h < a) {
                        for(; o.length < a;)o.length % 2 || s === l ? g() : f();
                        n();
                    }
                    if (y(e)) {
                        for(c = d = o.length; c--;)(3 === e && c % 2 == 1 || e <= 2 && c > 0 && c < d - 1) && o.splice(c, 1);
                        t.finalTickAmt = void 0;
                    }
                }
            }
            setScale() {
                let { coll: t, stacking: e } = this, i = !1, s = !1;
                this.series.forEach((t)=>{
                    i = i || t.isDirtyData || t.isDirty, s = s || t.xAxis && t.xAxis.isDirty || !1;
                }), this.setAxisSize();
                let r = this.len !== (this.old && this.old.len);
                r || i || s || this.isLinked || this.forceRedraw || this.userMin !== (this.old && this.old.userMin) || this.userMax !== (this.old && this.old.userMax) || this.alignToOthers() ? (e && "yAxis" === t && e.buildStacks(), this.forceRedraw = !1, this.userMinRange || (this.minRange = void 0), this.getSeriesExtremes(), this.setTickInterval(), e && "xAxis" === t && e.buildStacks(), this.isDirty || (this.isDirty = r || this.min !== this.old?.min || this.max !== this.old?.max)) : e && e.cleanStacks(), i && delete this.allExtremes, C(this, "afterSetScale");
            }
            setExtremes(t, e, i = !0, s, r) {
                this.series.forEach((t)=>{
                    delete t.kdTree;
                }), C(this, "setExtremes", r = k(r, {
                    min: t,
                    max: e
                }), (t)=>{
                    this.userMin = t.min, this.userMax = t.max, this.eventArgs = t, i && this.chart.redraw(s);
                });
            }
            setAxisSize() {
                let t = this.chart, e = this.options, i = e.offsets || [
                    0,
                    0,
                    0,
                    0
                ], s = this.horiz, r = this.width = Math.round(I(E(e.width, t.plotWidth - i[3] + i[1]), t.plotWidth)), o = this.height = Math.round(I(E(e.height, t.plotHeight - i[0] + i[2]), t.plotHeight)), a = this.top = Math.round(I(E(e.top, t.plotTop + i[0]), t.plotHeight, t.plotTop)), n = this.left = Math.round(I(E(e.left, t.plotLeft + i[3]), t.plotWidth, t.plotLeft));
                this.bottom = t.chartHeight - o - a, this.right = t.chartWidth - r - n, this.len = Math.max(s ? r : o, 0), this.pos = s ? n : a;
            }
            getExtremes() {
                let t = this.logarithmic;
                return {
                    min: t ? x(t.lin2log(this.min)) : this.min,
                    max: t ? x(t.lin2log(this.max)) : this.max,
                    dataMin: this.dataMin,
                    dataMax: this.dataMax,
                    userMin: this.userMin,
                    userMax: this.userMax
                };
            }
            getThreshold(t) {
                let e = this.logarithmic, i = e ? e.lin2log(this.min) : this.min, s = e ? e.lin2log(this.max) : this.max;
                return null === t || t === -1 / 0 ? t = i : t === 1 / 0 ? t = s : i > t ? t = i : s < t && (t = s), this.translate(t, 0, 1, 0, 1);
            }
            autoLabelAlign(t) {
                let e = (E(t, 0) - 90 * this.side + 720) % 360, i = {
                    align: "center"
                };
                return C(this, "autoLabelAlign", i, function(t) {
                    e > 15 && e < 165 ? t.align = "right" : e > 195 && e < 345 && (t.align = "left");
                }), i.align;
            }
            tickSize(t) {
                let e = this.options, i = E(e["tick" === t ? "tickWidth" : "minorTickWidth"], "tick" === t && this.isXAxis && !this.categories ? 1 : 0), s = e["tick" === t ? "tickLength" : "minorTickLength"], r;
                i && s && ("inside" === e[t + "Position"] && (s = -s), r = [
                    s,
                    i
                ]);
                let o = {
                    tickSize: r
                };
                return C(this, "afterTickSize", o), o.tickSize;
            }
            labelMetrics() {
                let t = this.chart.renderer, e = this.ticks, i = e[Object.keys(e)[0]] || {};
                return this.chart.renderer.fontMetrics(i.label || i.movedLabel || t.box);
            }
            unsquish() {
                let t = this.options.labels, e = this.horiz, i = this.tickInterval, s = this.len / (((this.categories ? 1 : 0) + this.max - this.min) / i), r = t.rotation, o = this.labelMetrics().h, a = Math.max(this.max - this.min, 0), n = function(t) {
                    let e = t / (s || 1);
                    return (e = e > 1 ? Math.ceil(e) : 1) * i > a && t !== 1 / 0 && s !== 1 / 0 && a && (e = Math.ceil(a / i)), x(e * i);
                }, h = i, l, d = Number.MAX_VALUE, c;
                if (e) {
                    if (!t.staggerLines && (A(r) ? c = [
                        r
                    ] : s < t.autoRotationLimit && (c = t.autoRotation)), c) {
                        let t, e;
                        for (let i of c)(i === r || i && i >= -90 && i <= 90) && (e = (t = n(Math.abs(o / Math.sin(u * i)))) + Math.abs(i / 360)) < d && (d = e, l = i, h = t);
                    }
                } else h = n(.75 * o);
                return this.autoRotation = c, this.labelRotation = E(l, A(r) ? r : 0), t.step ? i : h;
            }
            getSlotWidth(t) {
                let e = this.chart, i = this.horiz, s = this.options.labels, r = Math.max(this.tickPositions.length - (this.categories ? 0 : 1), 1), o = e.margin[3];
                if (t && A(t.slotWidth)) return t.slotWidth;
                if (i && s.step < 2) return s.rotation ? 0 : (this.staggerLines || 1) * this.len / r;
                if (!i) {
                    let t = s.style.width;
                    if (void 0 !== t) return parseInt(String(t), 10);
                    if (o) return o - e.spacing[3];
                }
                return .33 * e.chartWidth;
            }
            renderUnsquish() {
                let t = this.chart, e = t.renderer, i = this.tickPositions, s = this.ticks, r = this.options.labels, o = r.style, a = this.horiz, n = this.getSlotWidth(), h = Math.max(1, Math.round(n - 2 * r.padding)), l = {}, d = this.labelMetrics(), c = o.textOverflow, p, u, g = 0, f, m;
                if (P(r.rotation) || (l.rotation = r.rotation || 0), i.forEach(function(t) {
                    let e = s[t];
                    e.movedLabel && e.replaceMovedLabel(), e && e.label && e.label.textPxLength > g && (g = e.label.textPxLength);
                }), this.maxLabelLength = g, this.autoRotation) g > h && g > d.h ? l.rotation = this.labelRotation : this.labelRotation = 0;
                else if (n && (p = h, !c)) for(u = "clip", m = i.length; !a && m--;)(f = s[i[m]].label) && ("ellipsis" === f.styles.textOverflow ? f.css({
                    textOverflow: "clip"
                }) : f.textPxLength > n && f.css({
                    width: n + "px"
                }), f.getBBox().height > this.len / i.length - (d.h - d.f) && (f.specificTextOverflow = "ellipsis"));
                l.rotation && (p = g > .5 * t.chartHeight ? .33 * t.chartHeight : g, c || (u = "ellipsis")), this.labelAlign = r.align || this.autoLabelAlign(this.labelRotation), this.labelAlign && (l.align = this.labelAlign), i.forEach(function(t) {
                    let e = s[t], i = e && e.label, r = o.width, a = {};
                    i && (i.attr(l), e.shortenLabel ? e.shortenLabel() : p && !r && "nowrap" !== o.whiteSpace && (p < i.textPxLength || "SPAN" === i.element.tagName) ? (a.width = p + "px", c || (a.textOverflow = i.specificTextOverflow || u), i.css(a)) : !i.styles.width || a.width || r || i.css({
                        width: null
                    }), delete i.specificTextOverflow, e.rotation = l.rotation);
                }, this), this.tickRotCorr = e.rotCorr(d.b, this.labelRotation || 0, 0 !== this.side);
            }
            hasData() {
                return this.series.some(function(t) {
                    return t.hasData();
                }) || this.options.showEmpty && y(this.min) && y(this.max);
            }
            addTitle(t) {
                let e;
                let i = this.chart.renderer, s = this.horiz, r = this.opposite, o = this.options.title, a = this.chart.styledMode;
                this.axisTitle || ((e = o.textAlign) || (e = (s ? {
                    low: "left",
                    middle: "center",
                    high: "right"
                } : {
                    low: r ? "right" : "left",
                    middle: "center",
                    high: r ? "left" : "right"
                })[o.align]), this.axisTitle = i.text(o.text || "", 0, 0, o.useHTML).attr({
                    zIndex: 7,
                    rotation: o.rotation || 0,
                    align: e
                }).addClass("highcharts-axis-title"), a || this.axisTitle.css(L(o.style)), this.axisTitle.add(this.axisGroup), this.axisTitle.isNew = !0), a || o.style.width || this.isRadial || this.axisTitle.css({
                    width: this.len + "px"
                }), this.axisTitle[t ? "show" : "hide"](t);
            }
            generateTick(t) {
                let e = this.ticks;
                e[t] ? e[t].addLabel() : e[t] = new a(this, t);
            }
            createGroups() {
                let { axisParent: t, chart: e, coll: i, options: s } = this, r = e.renderer, o = (e, o, a)=>r.g(e).attr({
                        zIndex: a
                    }).addClass(`highcharts-${i.toLowerCase()}${o} ` + (this.isRadial ? `highcharts-radial-axis${o} ` : "") + (s.className || "")).add(t);
                this.axisGroup || (this.gridGroup = o("grid", "-grid", s.gridZIndex), this.axisGroup = o("axis", "", s.zIndex), this.labelGroup = o("axis-labels", "-labels", s.labels.zIndex));
            }
            getOffset() {
                let t = this, { chart: e, horiz: i, options: s, side: r, ticks: o, tickPositions: a, coll: n } = t, h = e.inverted && !t.isZAxis ? [
                    1,
                    0,
                    3,
                    2
                ][r] : r, l = t.hasData(), d = s.title, c = s.labels, p = A(s.crossing), u = e.axisOffset, g = e.clipOffset, f = [
                    -1,
                    1,
                    1,
                    -1
                ][r], m, x = 0, b, v = 0, S = 0, k, M;
                if (t.showAxis = m = l || s.showEmpty, t.staggerLines = t.horiz && c.staggerLines || void 0, t.createGroups(), l || t.isLinked ? (a.forEach(function(e) {
                    t.generateTick(e);
                }), t.renderUnsquish(), t.reserveSpaceDefault = 0 === r || 2 === r || ({
                    1: "left",
                    3: "right"
                })[r] === t.labelAlign, E(c.reserveSpace, !p && null, "center" === t.labelAlign || null, t.reserveSpaceDefault) && a.forEach(function(t) {
                    S = Math.max(o[t].getLabelSize(), S);
                }), t.staggerLines && (S *= t.staggerLines), t.labelOffset = S * (t.opposite ? -1 : 1)) : D(o, function(t, e) {
                    t.destroy(), delete o[e];
                }), d?.text && !1 !== d.enabled && (t.addTitle(m), m && !p && !1 !== d.reserveSpace && (t.titleOffset = x = t.axisTitle.getBBox()[i ? "height" : "width"], v = y(b = d.offset) ? 0 : E(d.margin, i ? 5 : 10))), t.renderLine(), t.offset = f * E(s.offset, u[r] ? u[r] + (s.margin || 0) : 0), t.tickRotCorr = t.tickRotCorr || {
                    x: 0,
                    y: 0
                }, M = 0 === r ? -t.labelMetrics().h : 2 === r ? t.tickRotCorr.y : 0, k = Math.abs(S) + v, S && (k -= M, k += f * (i ? E(c.y, t.tickRotCorr.y + f * c.distance) : E(c.x, f * c.distance))), t.axisTitleMargin = E(b, k), t.getMaxLabelDimensions && (t.maxLabelDimensions = t.getMaxLabelDimensions(o, a)), "colorAxis" !== n) {
                    let e = this.tickSize("tick");
                    u[r] = Math.max(u[r], (t.axisTitleMargin || 0) + x + f * t.offset, k, a && a.length && e ? e[0] + f * t.offset : 0);
                    let i = !t.axisLine || s.offset ? 0 : 2 * Math.floor(t.axisLine.strokeWidth() / 2);
                    g[h] = Math.max(g[h], i);
                }
                C(this, "afterGetOffset");
            }
            getLinePath(t) {
                let e = this.chart, i = this.opposite, s = this.offset, r = this.horiz, o = this.left + (i ? this.width : 0) + s, a = e.chartHeight - this.bottom - (i ? this.height : 0) + s;
                return i && (t *= -1), e.renderer.crispLine([
                    [
                        "M",
                        r ? this.left : o,
                        r ? a : this.top
                    ],
                    [
                        "L",
                        r ? e.chartWidth - this.right : o,
                        r ? a : e.chartHeight - this.bottom
                    ]
                ], t);
            }
            renderLine() {
                this.axisLine || (this.axisLine = this.chart.renderer.path().addClass("highcharts-axis-line").add(this.axisGroup), this.chart.styledMode || this.axisLine.attr({
                    stroke: this.options.lineColor,
                    "stroke-width": this.options.lineWidth,
                    zIndex: 7
                }));
            }
            getTitlePosition(t) {
                let e = this.horiz, i = this.left, s = this.top, r = this.len, o = this.options.title, a = e ? i : s, n = this.opposite, h = this.offset, l = o.x, d = o.y, c = this.chart.renderer.fontMetrics(t), p = t ? Math.max(t.getBBox(!1, 0).height - c.h - 1, 0) : 0, u = {
                    low: a + (e ? 0 : r),
                    middle: a + r / 2,
                    high: a + (e ? r : 0)
                }[o.align], g = (e ? s + this.height : i) + (e ? 1 : -1) * (n ? -1 : 1) * (this.axisTitleMargin || 0) + [
                    -p,
                    p,
                    c.f,
                    -p
                ][this.side], f = {
                    x: e ? u + l : g + (n ? this.width : 0) + h + l,
                    y: e ? g + d - (n ? this.height : 0) + h : u + d
                };
                return C(this, "afterGetTitlePosition", {
                    titlePosition: f
                }), f;
            }
            renderMinorTick(t, e) {
                let i = this.minorTicks;
                i[t] || (i[t] = new a(this, t, "minor")), e && i[t].isNew && i[t].render(null, !0), i[t].render(null, !1, 1);
            }
            renderTick(t, e, i) {
                let s = this.isLinked, r = this.ticks;
                (!s || t >= this.min && t <= this.max || this.grid && this.grid.isColumn) && (r[t] || (r[t] = new a(this, t)), i && r[t].isNew && r[t].render(e, !0, -1), r[t].render(e));
            }
            render() {
                let t, e;
                let i = this, s = i.chart, r = i.logarithmic, n = s.renderer, l = i.options, d = i.isLinked, c = i.tickPositions, p = i.axisTitle, u = i.ticks, g = i.minorTicks, f = i.alternateBands, m = l.stackLabels, x = l.alternateGridColor, y = l.crossing, b = i.tickmarkOffset, v = i.axisLine, S = i.showAxis, k = h(n.globalAnimation);
                if (i.labelEdge.length = 0, i.overlap = !1, [
                    u,
                    g,
                    f
                ].forEach(function(t) {
                    D(t, function(t) {
                        t.isActive = !1;
                    });
                }), A(y)) {
                    let t = this.isXAxis ? s.yAxis[0] : s.xAxis[0], e = [
                        1,
                        -1,
                        -1,
                        1
                    ][this.side];
                    if (t) {
                        let s = t.toPixels(y, !0);
                        i.horiz && (s = t.len - s), i.offset = e * s;
                    }
                }
                if (i.hasData() || d) {
                    let n = i.chart.hasRendered && i.old && A(i.old.min);
                    i.minorTickInterval && !i.categories && i.getMinorTickPositions().forEach(function(t) {
                        i.renderMinorTick(t, n);
                    }), c.length && (c.forEach(function(t, e) {
                        i.renderTick(t, e, n);
                    }), b && (0 === i.min || i.single) && (u[-1] || (u[-1] = new a(i, -1, null, !0)), u[-1].render(-1))), x && c.forEach(function(a, n) {
                        e = void 0 !== c[n + 1] ? c[n + 1] + b : i.max - b, n % 2 == 0 && a < i.max && e <= i.max + (s.polar ? -b : b) && (f[a] || (f[a] = new o.PlotLineOrBand(i, {})), t = a + b, f[a].options = {
                            from: r ? r.lin2log(t) : t,
                            to: r ? r.lin2log(e) : e,
                            color: x,
                            className: "highcharts-alternate-grid"
                        }, f[a].render(), f[a].isActive = !0);
                    }), i._addedPlotLB || (i._addedPlotLB = !0, (l.plotLines || []).concat(l.plotBands || []).forEach(function(t) {
                        i.addPlotBandOrLine(t);
                    }));
                }
                [
                    u,
                    g,
                    f
                ].forEach(function(t) {
                    let e = [], i = k.duration;
                    D(t, function(t, i) {
                        t.isActive || (t.render(i, !1, 0), t.isActive = !1, e.push(i));
                    }), R(function() {
                        let i = e.length;
                        for(; i--;)t[e[i]] && !t[e[i]].isActive && (t[e[i]].destroy(), delete t[e[i]]);
                    }, t !== f && s.hasRendered && i ? i : 0);
                }), v && (v[v.isPlaced ? "animate" : "attr"]({
                    d: this.getLinePath(v.strokeWidth())
                }), v.isPlaced = !0, v[S ? "show" : "hide"](S)), p && S && (p[p.isNew ? "attr" : "animate"](i.getTitlePosition(p)), p.isNew = !1), m && m.enabled && i.stacking && i.stacking.renderStackTotals(), i.old = {
                    len: i.len,
                    max: i.max,
                    min: i.min,
                    transA: i.transA,
                    userMax: i.userMax,
                    userMin: i.userMin
                }, i.isDirty = !1, C(this, "afterRender");
            }
            redraw() {
                this.visible && (this.render(), this.plotLinesAndBands.forEach(function(t) {
                    t.render();
                })), this.series.forEach(function(t) {
                    t.isDirty = !0;
                });
            }
            getKeepProps() {
                return this.keepProps || N.keepProps;
            }
            destroy(t) {
                let e = this, i = e.plotLinesAndBands, s = this.eventOptions;
                if (C(this, "destroy", {
                    keepEvents: t
                }), t || j(e), [
                    e.ticks,
                    e.minorTicks,
                    e.alternateBands
                ].forEach(function(t) {
                    b(t);
                }), i) {
                    let t = i.length;
                    for(; t--;)i[t].destroy();
                }
                for(let t in [
                    "axisLine",
                    "axisTitle",
                    "axisGroup",
                    "gridGroup",
                    "labelGroup",
                    "cross",
                    "scrollbar"
                ].forEach(function(t) {
                    e[t] && (e[t] = e[t].destroy());
                }), e.plotLinesAndBandsGroups)e.plotLinesAndBandsGroups[t] = e.plotLinesAndBandsGroups[t].destroy();
                D(e, function(t, i) {
                    -1 === e.getKeepProps().indexOf(i) && delete e[i];
                }), this.eventOptions = s;
            }
            drawCrosshair(t, e) {
                let s = this.crosshair, r = E(s && s.snap, !0), o = this.chart, a, n, h, l = this.cross, d;
                if (C(this, "drawCrosshair", {
                    e: t,
                    point: e
                }), t || (t = this.cross && this.cross.e), s && !1 !== (y(e) || !r)) {
                    if (r ? y(e) && (n = E("colorAxis" !== this.coll ? e.crosshairPos : null, this.isXAxis ? e.plotX : this.len - e.plotY)) : n = t && (this.horiz ? t.chartX - this.pos : this.len - t.chartY + this.pos), y(n) && (d = {
                        value: e && (this.isXAxis ? e.x : E(e.stackY, e.y)),
                        translatedValue: n
                    }, o.polar && k(d, {
                        isCrosshair: !0,
                        chartX: t && t.chartX,
                        chartY: t && t.chartY,
                        point: e
                    }), a = this.getPlotLinePath(d) || null), !y(a)) {
                        this.hideCrosshair();
                        return;
                    }
                    h = this.categories && !this.isRadial, l || (this.cross = l = o.renderer.path().addClass("highcharts-crosshair highcharts-crosshair-" + (h ? "category " : "thin ") + (s.className || "")).attr({
                        zIndex: E(s.zIndex, 2)
                    }).add(), !o.styledMode && (l.attr({
                        stroke: s.color || (h ? i.parse("#ccd3ff").setOpacity(.25).get() : "#cccccc"),
                        "stroke-width": E(s.width, 1)
                    }).css({
                        "pointer-events": "none"
                    }), s.dashStyle && l.attr({
                        dashstyle: s.dashStyle
                    }))), l.show().attr({
                        d: a
                    }), h && !s.width && l.attr({
                        "stroke-width": this.transA
                    }), this.cross.e = t;
                } else this.hideCrosshair();
                C(this, "afterDrawCrosshair", {
                    e: t,
                    point: e
                });
            }
            hideCrosshair() {
                this.cross && this.cross.hide(), C(this, "afterHideCrosshair");
            }
            update(t, e) {
                let i = this.chart;
                t = L(this.userOptions, t), this.destroy(!0), this.init(i, t), i.isDirtyBox = !0, E(e, !0) && i.redraw();
            }
            remove(t) {
                let e = this.chart, i = this.coll, s = this.series, r = s.length;
                for(; r--;)s[r] && s[r].remove(!1);
                v(e.axes, this), v(e[i] || [], this), e.orderItems(i), this.destroy(), e.isDirtyBox = !0, E(t, !0) && e.redraw();
            }
            setTitle(t, e) {
                this.update({
                    title: t
                }, e);
            }
            setCategories(t, e) {
                this.update({
                    categories: t
                }, e);
            }
        }
        return N.keepProps = [
            "coll",
            "extKey",
            "hcEvents",
            "names",
            "series",
            "userMax",
            "userMin"
        ], N;
    }), i(e, "Core/Axis/DateTimeAxis.js", [
        e["Core/Utilities.js"]
    ], function(t) {
        var e;
        let { addEvent: i, getMagnitude: s, normalizeTickInterval: r, timeUnits: o } = t;
        return function(t) {
            function e() {
                return this.chart.time.getTimeTicks.apply(this.chart.time, arguments);
            }
            function a() {
                if ("datetime" !== this.options.type) {
                    this.dateTime = void 0;
                    return;
                }
                this.dateTime || (this.dateTime = new n(this));
            }
            t.compose = function(t) {
                return t.keepProps.includes("dateTime") || (t.keepProps.push("dateTime"), t.prototype.getTimeTicks = e, i(t, "afterSetOptions", a)), t;
            };
            class n {
                constructor(t){
                    this.axis = t;
                }
                normalizeTimeTickInterval(t, e) {
                    let i = e || [
                        [
                            "millisecond",
                            [
                                1,
                                2,
                                5,
                                10,
                                20,
                                25,
                                50,
                                100,
                                200,
                                500
                            ]
                        ],
                        [
                            "second",
                            [
                                1,
                                2,
                                5,
                                10,
                                15,
                                30
                            ]
                        ],
                        [
                            "minute",
                            [
                                1,
                                2,
                                5,
                                10,
                                15,
                                30
                            ]
                        ],
                        [
                            "hour",
                            [
                                1,
                                2,
                                3,
                                4,
                                6,
                                8,
                                12
                            ]
                        ],
                        [
                            "day",
                            [
                                1,
                                2
                            ]
                        ],
                        [
                            "week",
                            [
                                1,
                                2
                            ]
                        ],
                        [
                            "month",
                            [
                                1,
                                2,
                                3,
                                4,
                                6
                            ]
                        ],
                        [
                            "year",
                            null
                        ]
                    ], a = i[i.length - 1], n = o[a[0]], h = a[1], l;
                    for(l = 0; l < i.length && (n = o[(a = i[l])[0]], h = a[1], !i[l + 1] || !(t <= (n * h[h.length - 1] + o[i[l + 1][0]]) / 2)); l++);
                    n === o.year && t < 5 * n && (h = [
                        1,
                        2,
                        5
                    ]);
                    let d = r(t / n, h, "year" === a[0] ? Math.max(s(t / n), 1) : 1);
                    return {
                        unitRange: n,
                        count: d,
                        unitName: a[0]
                    };
                }
                getXDateFormat(t, e) {
                    let { axis: i } = this, s = i.chart.time;
                    return i.closestPointRange ? s.getDateFormat(i.closestPointRange, t, i.options.startOfWeek, e) || s.resolveDTLFormat(e.year).main : s.resolveDTLFormat(e.day).main;
                }
            }
            t.Additions = n;
        }(e || (e = {})), e;
    }), i(e, "Core/Axis/LogarithmicAxis.js", [
        e["Core/Utilities.js"]
    ], function(t) {
        var e;
        let { addEvent: i, normalizeTickInterval: s, pick: r } = t;
        return function(t) {
            function e(t) {
                let e = t.userOptions, i = this.logarithmic;
                "logarithmic" !== e.type ? this.logarithmic = void 0 : i || (i = this.logarithmic = new a(this));
            }
            function o() {
                let t = this.logarithmic;
                t && (this.lin2val = function(e) {
                    return t.lin2log(e);
                }, this.val2lin = function(e) {
                    return t.log2lin(e);
                });
            }
            t.compose = function(t) {
                return t.keepProps.includes("logarithmic") || (t.keepProps.push("logarithmic"), i(t, "init", e), i(t, "afterInit", o)), t;
            };
            class a {
                constructor(t){
                    this.axis = t;
                }
                getLogTickPositions(t, e, i, o) {
                    let a = this.axis, n = a.len, h = a.options, l = [];
                    if (o || (this.minorAutoInterval = void 0), t >= .5) t = Math.round(t), l = a.getLinearTickPositions(t, e, i);
                    else if (t >= .08) {
                        let s, r, a, n, h, d, c;
                        let p = Math.floor(e);
                        for(s = t > .3 ? [
                            1,
                            2,
                            4
                        ] : t > .15 ? [
                            1,
                            2,
                            4,
                            6,
                            8
                        ] : [
                            1,
                            2,
                            3,
                            4,
                            5,
                            6,
                            7,
                            8,
                            9
                        ], r = p; r < i + 1 && !c; r++)for(a = 0, n = s.length; a < n && !c; a++)(h = this.log2lin(this.lin2log(r) * s[a])) > e && (!o || d <= i) && void 0 !== d && l.push(d), d > i && (c = !0), d = h;
                    } else {
                        let d = this.lin2log(e), c = this.lin2log(i), p = o ? a.getMinorTickInterval() : h.tickInterval, u = h.tickPixelInterval / (o ? 5 : 1), g = o ? n / a.tickPositions.length : n;
                        t = s(t = r("auto" === p ? null : p, this.minorAutoInterval, (c - d) * u / (g || 1))), l = a.getLinearTickPositions(t, d, c).map(this.log2lin), o || (this.minorAutoInterval = t / 5);
                    }
                    return o || (a.tickInterval = t), l;
                }
                lin2log(t) {
                    return Math.pow(10, t);
                }
                log2lin(t) {
                    return Math.log(t) / Math.LN10;
                }
            }
            t.Additions = a;
        }(e || (e = {})), e;
    }), i(e, "Core/Axis/PlotLineOrBand/PlotLineOrBandAxis.js", [
        e["Core/Utilities.js"]
    ], function(t) {
        var e;
        let { erase: i, extend: s, isNumber: r } = t;
        return function(t) {
            let e;
            function o(t) {
                return this.addPlotBandOrLine(t, "plotBands");
            }
            function a(t, i) {
                let s = this.userOptions, r = new e(this, t);
                if (this.visible && (r = r.render()), r) {
                    if (this._addedPlotLB || (this._addedPlotLB = !0, (s.plotLines || []).concat(s.plotBands || []).forEach((t)=>{
                        this.addPlotBandOrLine(t);
                    })), i) {
                        let e = s[i] || [];
                        e.push(t), s[i] = e;
                    }
                    this.plotLinesAndBands.push(r);
                }
                return r;
            }
            function n(t) {
                return this.addPlotBandOrLine(t, "plotLines");
            }
            function h(t, e, i) {
                i = i || this.options;
                let s = this.getPlotLinePath({
                    value: e,
                    force: !0,
                    acrossPanes: i.acrossPanes
                }), o = [], a = this.horiz, n = !r(this.min) || !r(this.max) || t < this.min && e < this.min || t > this.max && e > this.max, h = this.getPlotLinePath({
                    value: t,
                    force: !0,
                    acrossPanes: i.acrossPanes
                }), l, d = 1, c;
                if (h && s) for(n && (c = h.toString() === s.toString(), d = 0), l = 0; l < h.length; l += 2){
                    let t = h[l], e = h[l + 1], i = s[l], r = s[l + 1];
                    ("M" === t[0] || "L" === t[0]) && ("M" === e[0] || "L" === e[0]) && ("M" === i[0] || "L" === i[0]) && ("M" === r[0] || "L" === r[0]) && (a && i[1] === t[1] ? (i[1] += d, r[1] += d) : a || i[2] !== t[2] || (i[2] += d, r[2] += d), o.push([
                        "M",
                        t[1],
                        t[2]
                    ], [
                        "L",
                        e[1],
                        e[2]
                    ], [
                        "L",
                        r[1],
                        r[2]
                    ], [
                        "L",
                        i[1],
                        i[2]
                    ], [
                        "Z"
                    ])), o.isFlat = c;
                }
                return o;
            }
            function l(t) {
                this.removePlotBandOrLine(t);
            }
            function d(t) {
                let e = this.plotLinesAndBands, s = this.options, r = this.userOptions;
                if (e) {
                    let o = e.length;
                    for(; o--;)e[o].id === t && e[o].destroy();
                    [
                        s.plotLines || [],
                        r.plotLines || [],
                        s.plotBands || [],
                        r.plotBands || []
                    ].forEach(function(e) {
                        for(o = e.length; o--;)(e[o] || {}).id === t && i(e, e[o]);
                    });
                }
            }
            function c(t) {
                this.removePlotBandOrLine(t);
            }
            t.compose = function(t, i) {
                let r = i.prototype;
                return r.addPlotBand || (e = t, s(r, {
                    addPlotBand: o,
                    addPlotLine: n,
                    addPlotBandOrLine: a,
                    getPlotBandPath: h,
                    removePlotBand: l,
                    removePlotLine: c,
                    removePlotBandOrLine: d
                })), i;
            };
        }(e || (e = {})), e;
    }), i(e, "Core/Axis/PlotLineOrBand/PlotLineOrBand.js", [
        e["Core/Axis/PlotLineOrBand/PlotLineOrBandAxis.js"],
        e["Core/Utilities.js"]
    ], function(t, e) {
        let { arrayMax: i, arrayMin: s, defined: r, destroyObjectProperties: o, erase: a, fireEvent: n, merge: h, objectEach: l, pick: d } = e;
        class c {
            static compose(e) {
                return t.compose(c, e);
            }
            constructor(t, e){
                this.axis = t, this.options = e, this.id = e.id;
            }
            render() {
                n(this, "render");
                let { axis: t, options: e } = this, { horiz: i, logarithmic: s } = t, { color: o, events: a, zIndex: c = 0 } = e, p = {}, u = t.chart.renderer, g = e.to, f = e.from, m = e.value, x = e.borderWidth, y = e.label, { label: b, svgElem: v } = this, S = [], k, C = r(f) && r(g), M = r(m), w = !v, T = {
                    class: "highcharts-plot-" + (C ? "band " : "line ") + (e.className || "")
                }, A = C ? "bands" : "lines";
                if (!t.chart.styledMode && (M ? (T.stroke = o || "#999999", T["stroke-width"] = d(e.width, 1), e.dashStyle && (T.dashstyle = e.dashStyle)) : C && (T.fill = o || "#e6e9ff", x && (T.stroke = e.borderColor, T["stroke-width"] = x))), p.zIndex = c, A += "-" + c, (k = t.plotLinesAndBandsGroups[A]) || (t.plotLinesAndBandsGroups[A] = k = u.g("plot-" + A).attr(p).add()), v || (this.svgElem = v = u.path().attr(T).add(k)), r(m)) S = t.getPlotLinePath({
                    value: s?.log2lin(m) ?? m,
                    lineWidth: v.strokeWidth(),
                    acrossPanes: e.acrossPanes
                });
                else {
                    if (!(r(f) && r(g))) return;
                    S = t.getPlotBandPath(s?.log2lin(f) ?? f, s?.log2lin(g) ?? g, e);
                }
                return !this.eventsAdded && a && (l(a, (t, e)=>{
                    v?.on(e, (t)=>{
                        a[e].apply(this, [
                            t
                        ]);
                    });
                }), this.eventsAdded = !0), (w || !v.d) && S?.length ? v.attr({
                    d: S
                }) : v && (S ? (v.show(), v.animate({
                    d: S
                })) : v.d && (v.hide(), b && (this.label = b = b.destroy()))), y && (r(y.text) || r(y.formatter)) && S?.length && t.width > 0 && t.height > 0 && !S.isFlat ? (y = h({
                    align: i && C && "center",
                    x: i ? !C && 4 : 10,
                    verticalAlign: !i && C && "middle",
                    y: i ? C ? 16 : 10 : C ? 6 : -4,
                    rotation: i && !C && 90
                }, y), this.renderLabel(y, S, C, c)) : b && b.hide(), this;
            }
            renderLabel(t, e, r, o) {
                let a = this.axis, n = a.chart.renderer, l = this.label;
                l || (this.label = l = n.text(this.getLabelText(t), 0, 0, t.useHTML).attr({
                    align: t.textAlign || t.align,
                    rotation: t.rotation,
                    class: "highcharts-plot-" + (r ? "band" : "line") + "-label" + (t.className || ""),
                    zIndex: o
                }), a.chart.styledMode || l.css(h({
                    fontSize: "0.8em",
                    textOverflow: "ellipsis"
                }, t.style)), l.add());
                let d = e.xBounds || [
                    e[0][1],
                    e[1][1],
                    r ? e[2][1] : e[0][1]
                ], c = e.yBounds || [
                    e[0][2],
                    e[1][2],
                    r ? e[2][2] : e[0][2]
                ], p = s(d), u = s(c);
                if (l.align(t, !1, {
                    x: p,
                    y: u,
                    width: i(d) - p,
                    height: i(c) - u
                }), !l.alignValue || "left" === l.alignValue) {
                    let e = t.clip ? a.width : a.chart.chartWidth;
                    l.css({
                        width: (90 === l.rotation ? a.height - (l.alignAttr.y - a.top) : e - (l.alignAttr.x - a.left)) + "px"
                    });
                }
                l.show(!0);
            }
            getLabelText(t) {
                return r(t.formatter) ? t.formatter.call(this) : t.text;
            }
            destroy() {
                a(this.axis.plotLinesAndBands, this), delete this.axis, o(this);
            }
        }
        return c;
    }), i(e, "Core/Tooltip.js", [
        e["Core/Templating.js"],
        e["Core/Globals.js"],
        e["Core/Renderer/RendererUtilities.js"],
        e["Core/Renderer/RendererRegistry.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i, s, r) {
        var o;
        let { format: a } = t, { composed: n, doc: h, isSafari: l } = e, { distribute: d } = i, { addEvent: c, clamp: p, css: u, discardElement: g, extend: f, fireEvent: m, isArray: x, isNumber: y, isString: b, merge: v, pick: S, pushUnique: k, splat: C, syncTimeout: M } = r;
        class w {
            constructor(t, e, i){
                this.allowShared = !0, this.crosshairs = [], this.distance = 0, this.isHidden = !0, this.isSticky = !1, this.now = {}, this.options = {}, this.outside = !1, this.chart = t, this.init(t, e), this.pointer = i;
            }
            bodyFormatter(t) {
                return t.map(function(t) {
                    let e = t.series.tooltipOptions;
                    return (e[(t.point.formatPrefix || "point") + "Formatter"] || t.point.tooltipFormatter).call(t.point, e[(t.point.formatPrefix || "point") + "Format"] || "");
                });
            }
            cleanSplit(t) {
                this.chart.series.forEach(function(e) {
                    let i = e && e.tt;
                    i && (!i.isActive || t ? e.tt = i.destroy() : i.isActive = !1);
                });
            }
            defaultFormatter(t) {
                let e;
                let i = this.points || C(this);
                return (e = (e = [
                    t.tooltipFooterHeaderFormatter(i[0])
                ]).concat(t.bodyFormatter(i))).push(t.tooltipFooterHeaderFormatter(i[0], !0)), e;
            }
            destroy() {
                this.label && (this.label = this.label.destroy()), this.split && (this.cleanSplit(!0), this.tt && (this.tt = this.tt.destroy())), this.renderer && (this.renderer = this.renderer.destroy(), g(this.container)), r.clearTimeout(this.hideTimer), r.clearTimeout(this.tooltipTimeout);
            }
            getAnchor(t, e) {
                let i;
                let { chart: s, pointer: r } = this, o = s.inverted, a = s.plotTop, n = s.plotLeft;
                if ((t = C(t))[0].series && t[0].series.yAxis && !t[0].series.yAxis.options.reversedStacks && (t = t.slice().reverse()), this.followPointer && e) void 0 === e.chartX && (e = r.normalize(e)), i = [
                    e.chartX - n,
                    e.chartY - a
                ];
                else if (t[0].tooltipPos) i = t[0].tooltipPos;
                else {
                    let s = 0, r = 0;
                    t.forEach(function(t) {
                        let e = t.pos(!0);
                        e && (s += e[0], r += e[1]);
                    }), s /= t.length, r /= t.length, this.shared && t.length > 1 && e && (o ? s = e.chartX : r = e.chartY), i = [
                        s - n,
                        r - a
                    ];
                }
                return i.map(Math.round);
            }
            getClassName(t, e, i) {
                let s = this.options, r = t.series, o = r.options;
                return [
                    s.className,
                    "highcharts-label",
                    i && "highcharts-tooltip-header",
                    e ? "highcharts-tooltip-box" : "highcharts-tooltip",
                    !i && "highcharts-color-" + S(t.colorIndex, r.colorIndex),
                    o && o.className
                ].filter(b).join(" ");
            }
            getLabel() {
                let t = this, i = this.chart.styledMode, r = this.options, o = this.split && this.allowShared, a = this.container, n = this.chart.renderer;
                if (this.label) {
                    let t = !this.label.hasClass("highcharts-label");
                    (!o && t || o && !t) && this.destroy();
                }
                if (!this.label) {
                    if (this.outside) {
                        let t = this.chart.options.chart.style, i = s.getRendererType();
                        this.container = a = e.doc.createElement("div"), a.className = "highcharts-tooltip-container", u(a, {
                            position: "absolute",
                            top: "1px",
                            pointerEvents: "none",
                            zIndex: Math.max(this.options.style.zIndex || 0, (t && t.zIndex || 0) + 3)
                        }), this.renderer = n = new i(a, 0, 0, t, void 0, void 0, n.styledMode);
                    }
                    if (o ? this.label = n.g("tooltip") : (this.label = n.label("", 0, 0, r.shape, void 0, void 0, r.useHTML, void 0, "tooltip").attr({
                        padding: r.padding,
                        r: r.borderRadius
                    }), i || this.label.attr({
                        fill: r.backgroundColor,
                        "stroke-width": r.borderWidth || 0
                    }).css(r.style).css({
                        pointerEvents: r.style.pointerEvents || (this.shouldStickOnContact() ? "auto" : "none")
                    })), t.outside) {
                        let e = this.label, { xSetter: i, ySetter: s } = e;
                        e.xSetter = function(s) {
                            i.call(e, t.distance), a && (a.style.left = s + "px");
                        }, e.ySetter = function(i) {
                            s.call(e, t.distance), a && (a.style.top = i + "px");
                        };
                    }
                    this.label.attr({
                        zIndex: 8
                    }).shadow(r.shadow).add();
                }
                return a && !a.parentElement && e.doc.body.appendChild(a), this.label;
            }
            getPlayingField() {
                let { body: t, documentElement: e } = h, { chart: i, distance: s, outside: r } = this;
                return {
                    width: r ? Math.max(t.scrollWidth, e.scrollWidth, t.offsetWidth, e.offsetWidth, e.clientWidth) - 2 * s : i.chartWidth,
                    height: r ? Math.max(t.scrollHeight, e.scrollHeight, t.offsetHeight, e.offsetHeight, e.clientHeight) : i.chartHeight
                };
            }
            getPosition(t, e, i) {
                let { distance: s, chart: r, outside: o, pointer: a } = this, { inverted: n, plotLeft: h, plotTop: l, polar: d } = r, { plotX: c = 0, plotY: p = 0 } = i, u = {}, g = n && i.h || 0, { height: f, width: m } = this.getPlayingField(), x = a.getChartPosition(), y = (t)=>t * x.scaleX, b = (t)=>t * x.scaleY, v = (i)=>{
                    let a = "x" === i;
                    return [
                        i,
                        a ? m : f,
                        a ? t : e
                    ].concat(o ? [
                        a ? y(t) : b(e),
                        a ? x.left - s + y(c + h) : x.top - s + b(p + l),
                        0,
                        a ? m : f
                    ] : [
                        a ? t : e,
                        a ? c + h : p + l,
                        a ? h : l,
                        a ? h + r.plotWidth : l + r.plotHeight
                    ]);
                }, k = v("y"), C = v("x"), M, w = !!i.negative;
                !d && r.hoverSeries?.yAxis?.reversed && (w = !w);
                let T = !this.followPointer && S(i.ttBelow, !d && !n === w), A = function(t, e, i, r, a, n, h) {
                    let l = o ? "y" === t ? b(s) : y(s) : s, d = (i - r) / 2, c = r < a - s, p = a + s + r < e, f = a - l - i + d, m = a + l - d;
                    if (T && p) u[t] = m;
                    else if (!T && c) u[t] = f;
                    else if (c) u[t] = Math.min(h - r, f - g < 0 ? f : f - g);
                    else {
                        if (!p) return !1;
                        u[t] = Math.max(n, m + g + i > e ? m : m + g);
                    }
                }, P = function(t, e, i, r, o) {
                    if (o < s || o > e - s) return !1;
                    o < i / 2 ? u[t] = 1 : o > e - r / 2 ? u[t] = e - r - 2 : u[t] = o - i / 2;
                }, L = function(t) {
                    [k, C] = [
                        C,
                        k
                    ], M = t;
                }, O = ()=>{
                    !1 !== A.apply(0, k) ? !1 !== P.apply(0, C) || M || (L(!0), O()) : M ? u.x = u.y = 0 : (L(!0), O());
                };
                return (n && !d || this.len > 1) && L(), O(), u;
            }
            hide(t) {
                let e = this;
                r.clearTimeout(this.hideTimer), t = S(t, this.options.hideDelay), this.isHidden || (this.hideTimer = M(function() {
                    let i = e.getLabel();
                    e.getLabel().animate({
                        opacity: 0
                    }, {
                        duration: t ? 150 : t,
                        complete: ()=>{
                            i.hide(), e.container && e.container.remove();
                        }
                    }), e.isHidden = !0;
                }, t));
            }
            init(t, e) {
                this.chart = t, this.options = e, this.crosshairs = [], this.now = {
                    x: 0,
                    y: 0
                }, this.isHidden = !0, this.split = e.split && !t.inverted && !t.polar, this.shared = e.shared || this.split, this.outside = S(e.outside, !!(t.scrollablePixelsX || t.scrollablePixelsY));
            }
            shouldStickOnContact(t) {
                return !!(!this.followPointer && this.options.stickOnContact && (!t || this.pointer.inClass(t.target, "highcharts-tooltip")));
            }
            move(t, e, i, s) {
                let o = this, a = o.now, n = !1 !== o.options.animation && !o.isHidden && (Math.abs(t - a.x) > 1 || Math.abs(e - a.y) > 1), h = o.followPointer || o.len > 1;
                f(a, {
                    x: n ? (2 * a.x + t) / 3 : t,
                    y: n ? (a.y + e) / 2 : e,
                    anchorX: h ? void 0 : n ? (2 * a.anchorX + i) / 3 : i,
                    anchorY: h ? void 0 : n ? (a.anchorY + s) / 2 : s
                }), o.getLabel().attr(a), o.drawTracker(), n && (r.clearTimeout(this.tooltipTimeout), this.tooltipTimeout = setTimeout(function() {
                    o && o.move(t, e, i, s);
                }, 32));
            }
            refresh(t, e) {
                let { chart: i, options: s, pointer: o, shared: n } = this, h = C(t), l = h[0], d = [], c = s.format, p = s.formatter || this.defaultFormatter, u = i.styledMode, g = {};
                if (!s.enabled || !l.series) return;
                r.clearTimeout(this.hideTimer), this.allowShared = !(!x(t) && t.series && t.series.noSharedTooltip), this.followPointer = !this.split && l.series.tooltipOptions.followPointer;
                let f = this.getAnchor(t, e), y = f[0], v = f[1];
                n && this.allowShared ? (o.applyInactiveState(h), h.forEach(function(t) {
                    t.setState("hover"), d.push(t.getLabelConfig());
                }), (g = l.getLabelConfig()).points = d) : g = l.getLabelConfig(), this.len = d.length;
                let k = b(c) ? a(c, g, i) : p.call(g, this), M = l.series;
                if (this.distance = S(M.tooltipOptions.distance, 16), !1 === k) this.hide();
                else {
                    if (this.split && this.allowShared) this.renderSplit(k, h);
                    else {
                        let t = y, r = v;
                        if (e && o.isDirectTouch && (t = e.chartX - i.plotLeft, r = e.chartY - i.plotTop), i.polar || !1 === M.options.clip || h.some((e)=>o.isDirectTouch || e.series.shouldShowTooltip(t, r))) {
                            let t = this.getLabel();
                            (!s.style.width || u) && t.css({
                                width: (this.outside ? this.getPlayingField() : i.spacingBox).width + "px"
                            }), t.attr({
                                text: k && k.join ? k.join("") : k
                            }), t.addClass(this.getClassName(l), !0), u || t.attr({
                                stroke: s.borderColor || l.color || M.color || "#666666"
                            }), this.updatePosition({
                                plotX: y,
                                plotY: v,
                                negative: l.negative,
                                ttBelow: l.ttBelow,
                                h: f[2] || 0
                            });
                        } else {
                            this.hide();
                            return;
                        }
                    }
                    this.isHidden && this.label && this.label.attr({
                        opacity: 1
                    }).show(), this.isHidden = !1;
                }
                m(this, "refresh");
            }
            renderSplit(t, e) {
                let i = this, { chart: s, chart: { chartWidth: r, chartHeight: o, plotHeight: a, plotLeft: n, plotTop: c, scrollablePixelsY: u = 0, scrollablePixelsX: g, styledMode: m }, distance: x, options: y, options: { positioner: v }, pointer: k } = i, { scrollLeft: C = 0, scrollTop: M = 0 } = s.scrollablePlotArea?.scrollingContainer || {}, w = i.outside && "number" != typeof g ? h.documentElement.getBoundingClientRect() : {
                    left: C,
                    right: C + r,
                    top: M,
                    bottom: M + o
                }, T = i.getLabel(), A = this.renderer || s.renderer, P = !!(s.xAxis[0] && s.xAxis[0].opposite), { left: L, top: O } = k.getChartPosition(), D = c + M, E = 0, I = a - u;
                function j(t, e, s, r, o = !0) {
                    let a, n;
                    return s ? (a = P ? 0 : I, n = p(t - r / 2, w.left, w.right - r - (i.outside ? L : 0))) : (a = e - D, n = p(n = o ? t - r - x : t + x, o ? n : w.left, w.right)), {
                        x: n,
                        y: a
                    };
                }
                b(t) && (t = [
                    !1,
                    t
                ]);
                let B = t.slice(0, e.length + 1).reduce(function(t, s, r) {
                    if (!1 !== s && "" !== s) {
                        let o = e[r - 1] || {
                            isHeader: !0,
                            plotX: e[0].plotX,
                            plotY: a,
                            series: {}
                        }, h = o.isHeader, l = h ? i : o.series, d = l.tt = function(t, e, s) {
                            let r = t, { isHeader: o, series: a } = e;
                            if (!r) {
                                let t = {
                                    padding: y.padding,
                                    r: y.borderRadius
                                };
                                m || (t.fill = y.backgroundColor, t["stroke-width"] = y.borderWidth ?? 1), r = A.label("", 0, 0, y[o ? "headerShape" : "shape"], void 0, void 0, y.useHTML).addClass(i.getClassName(e, !0, o)).attr(t).add(T);
                            }
                            return r.isActive = !0, r.attr({
                                text: s
                            }), m || r.css(y.style).attr({
                                stroke: y.borderColor || e.color || a.color || "#333333"
                            }), r;
                        }(l.tt, o, s.toString()), u = d.getBBox(), g = u.width + d.strokeWidth();
                        h && (E = u.height, I += E, P && (D -= E));
                        let { anchorX: f, anchorY: b } = function(t) {
                            let e, i;
                            let { isHeader: s, plotX: r = 0, plotY: o = 0, series: h } = t;
                            if (s) e = Math.max(n + r, n), i = c + a / 2;
                            else {
                                let { xAxis: t, yAxis: s } = h;
                                e = t.pos + p(r, -x, t.len + x), h.shouldShowTooltip(0, s.pos - c + o, {
                                    ignoreX: !0
                                }) && (i = s.pos + o);
                            }
                            return {
                                anchorX: e = p(e, w.left - x, w.right + x),
                                anchorY: i
                            };
                        }(o);
                        if ("number" == typeof b) {
                            let e = u.height + 1, s = v ? v.call(i, g, e, o) : j(f, b, h, g);
                            t.push({
                                align: v ? 0 : void 0,
                                anchorX: f,
                                anchorY: b,
                                boxWidth: g,
                                point: o,
                                rank: S(s.rank, h ? 1 : 0),
                                size: e,
                                target: s.y,
                                tt: d,
                                x: s.x
                            });
                        } else d.isActive = !1;
                    }
                    return t;
                }, []);
                !v && B.some((t)=>{
                    let { outside: e } = i, s = (e ? L : 0) + t.anchorX;
                    return s < w.left && s + t.boxWidth < w.right || s < L - w.left + t.boxWidth && w.right - s > s;
                }) && (B = B.map((t)=>{
                    let { x: e, y: i } = j(t.anchorX, t.anchorY, t.point.isHeader, t.boxWidth, !1);
                    return f(t, {
                        target: i,
                        x: e
                    });
                })), i.cleanSplit(), d(B, I);
                let R = {
                    left: L,
                    right: L
                };
                B.forEach(function(t) {
                    let { x: e, boxWidth: s, isHeader: r } = t;
                    !r && (i.outside && L + e < R.left && (R.left = L + e), !r && i.outside && R.left + s > R.right && (R.right = L + e));
                }), B.forEach(function(t) {
                    let { x: e, anchorX: s, anchorY: r, pos: o, point: { isHeader: a } } = t, n = {
                        visibility: void 0 === o ? "hidden" : "inherit",
                        x: e,
                        y: (o || 0) + D,
                        anchorX: s,
                        anchorY: r
                    };
                    if (i.outside && e < s) {
                        let t = L - R.left;
                        t > 0 && (a || (n.x = e + t, n.anchorX = s + t), a && (n.x = (R.right - R.left) / 2, n.anchorX = s + t));
                    }
                    t.tt.attr(n);
                });
                let { container: z, outside: N, renderer: W } = i;
                if (N && z && W) {
                    let { width: t, height: e, x: i, y: s } = T.getBBox();
                    W.setSize(t + i, e + s, !1), z.style.left = R.left + "px", z.style.top = O + "px";
                }
                l && T.attr({
                    opacity: 1 === T.opacity ? .999 : 1
                });
            }
            drawTracker() {
                if (!this.shouldStickOnContact()) {
                    this.tracker && (this.tracker = this.tracker.destroy());
                    return;
                }
                let t = this.chart, e = this.label, i = this.shared ? t.hoverPoints : t.hoverPoint;
                if (!e || !i) return;
                let s = {
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0
                }, r = this.getAnchor(i), o = e.getBBox();
                r[0] += t.plotLeft - (e.translateX || 0), r[1] += t.plotTop - (e.translateY || 0), s.x = Math.min(0, r[0]), s.y = Math.min(0, r[1]), s.width = r[0] < 0 ? Math.max(Math.abs(r[0]), o.width - r[0]) : Math.max(Math.abs(r[0]), o.width), s.height = r[1] < 0 ? Math.max(Math.abs(r[1]), o.height - Math.abs(r[1])) : Math.max(Math.abs(r[1]), o.height), this.tracker ? this.tracker.attr(s) : (this.tracker = e.renderer.rect(s).addClass("highcharts-tracker").add(e), t.styledMode || this.tracker.attr({
                    fill: "rgba(0,0,0,0)"
                }));
            }
            styledModeFormat(t) {
                return t.replace('style="font-size: 0.8em"', 'class="highcharts-header"').replace(/style="color:{(point|series)\.color}"/g, 'class="highcharts-color-{$1.colorIndex} {series.options.className} {point.options.className}"');
            }
            tooltipFooterHeaderFormatter(t, e) {
                let i = t.series, s = i.tooltipOptions, r = i.xAxis, o = r && r.dateTime, n = {
                    isFooter: e,
                    labelConfig: t
                }, h = s.xDateFormat, l = s[e ? "footerFormat" : "headerFormat"];
                return m(this, "headerFormatter", n, function(e) {
                    o && !h && y(t.key) && (h = o.getXDateFormat(t.key, s.dateTimeLabelFormats)), o && h && (t.point && t.point.tooltipDateKeys || [
                        "key"
                    ]).forEach(function(t) {
                        l = l.replace("{point." + t + "}", "{point." + t + ":" + h + "}");
                    }), i.chart.styledMode && (l = this.styledModeFormat(l)), e.text = a(l, {
                        point: t,
                        series: i
                    }, this.chart);
                }), n.text;
            }
            update(t) {
                this.destroy(), this.init(this.chart, v(!0, this.options, t));
            }
            updatePosition(t) {
                let { chart: e, container: i, distance: s, options: r, pointer: o, renderer: a } = this, { height: n = 0, width: h = 0 } = this.getLabel(), { left: l, top: d, scaleX: c, scaleY: p } = o.getChartPosition(), g = (r.positioner || this.getPosition).call(this, h, n, t), f = (t.plotX || 0) + e.plotLeft, m = (t.plotY || 0) + e.plotTop, x;
                a && i && (r.positioner && (g.x += l - s, g.y += d - s), x = (r.borderWidth || 0) + 2 * s + 2, a.setSize(h + x, n + x, !1), (1 !== c || 1 !== p) && (u(i, {
                    transform: `scale(${c}, ${p})`
                }), f *= c, m *= p), f += l - g.x, m += d - g.y), this.move(Math.round(g.x), Math.round(g.y || 0), f, m);
            }
        }
        return (o = w || (w = {})).compose = function(t) {
            k(n, "Core.Tooltip") && c(t, "afterInit", function() {
                let t = this.chart;
                t.options.tooltip && (t.tooltip = new o(t, t.options.tooltip, this));
            });
        }, w;
    }), i(e, "Core/Series/Point.js", [
        e["Core/Renderer/HTML/AST.js"],
        e["Core/Animation/AnimationUtilities.js"],
        e["Core/Defaults.js"],
        e["Core/Templating.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i, s, r) {
        let { animObject: o } = e, { defaultOptions: a } = i, { format: n } = s, { addEvent: h, erase: l, extend: d, fireEvent: c, getNestedProperty: p, isArray: u, isFunction: g, isNumber: f, isObject: m, pick: x, syncTimeout: y, removeEvent: b, uniqueKey: v } = r;
        class S {
            animateBeforeDestroy() {
                let t = this, e = {
                    x: t.startXPos,
                    opacity: 0
                }, i = t.getGraphicalProps();
                i.singular.forEach(function(i) {
                    t[i] = t[i].animate("dataLabel" === i ? {
                        x: t[i].startXPos,
                        y: t[i].startYPos,
                        opacity: 0
                    } : e);
                }), i.plural.forEach(function(e) {
                    t[e].forEach(function(e) {
                        e.element && e.animate(d({
                            x: t.startXPos
                        }, e.startYPos ? {
                            x: e.startXPos,
                            y: e.startYPos
                        } : {}));
                    });
                });
            }
            applyOptions(t, e) {
                let i = this.series, s = i.options.pointValKey || i.pointValKey;
                return d(this, t = S.prototype.optionsToObject.call(this, t)), this.options = this.options ? d(this.options, t) : t, t.group && delete this.group, t.dataLabels && delete this.dataLabels, s && (this.y = S.prototype.getNestedProperty.call(this, s)), this.selected && (this.state = "select"), "name" in this && void 0 === e && i.xAxis && i.xAxis.hasNames && (this.x = i.xAxis.nameToX(this)), void 0 === this.x && i ? void 0 === e ? this.x = i.autoIncrement() : this.x = e : f(t.x) && i.options.relativeXValue && (this.x = i.autoIncrement(t.x)), this.isNull = this.isValid && !this.isValid(), this.formatPrefix = this.isNull ? "null" : "point", this;
            }
            destroy() {
                if (!this.destroyed) {
                    let t = this, e = t.series, i = e.chart, s = e.options.dataSorting, r = i.hoverPoints, a = o(t.series.chart.renderer.globalAnimation), n = ()=>{
                        for(let e in (t.graphic || t.graphics || t.dataLabel || t.dataLabels) && (b(t), t.destroyElements()), t)delete t[e];
                    };
                    t.legendItem && i.legend.destroyItem(t), r && (t.setState(), l(r, t), r.length || (i.hoverPoints = null)), t === i.hoverPoint && t.onMouseOut(), s && s.enabled ? (this.animateBeforeDestroy(), y(n, a.duration)) : n(), i.pointCount--;
                }
                this.destroyed = !0;
            }
            destroyElements(t) {
                let e = this, i = e.getGraphicalProps(t);
                i.singular.forEach(function(t) {
                    e[t] = e[t].destroy();
                }), i.plural.forEach(function(t) {
                    e[t].forEach(function(t) {
                        t && t.element && t.destroy();
                    }), delete e[t];
                });
            }
            firePointEvent(t, e, i) {
                let s = this, r = this.series.options;
                s.manageEvent(t), "click" === t && r.allowPointSelect && (i = function(t) {
                    !s.destroyed && s.select && s.select(null, t.ctrlKey || t.metaKey || t.shiftKey);
                }), c(s, t, e, i);
            }
            getClassName() {
                return "highcharts-point" + (this.selected ? " highcharts-point-select" : "") + (this.negative ? " highcharts-negative" : "") + (this.isNull ? " highcharts-null-point" : "") + (void 0 !== this.colorIndex ? " highcharts-color-" + this.colorIndex : "") + (this.options.className ? " " + this.options.className : "") + (this.zone && this.zone.className ? " " + this.zone.className.replace("highcharts-negative", "") : "");
            }
            getGraphicalProps(t) {
                let e, i;
                let s = this, r = [], o = {
                    singular: [],
                    plural: []
                };
                for((t = t || {
                    graphic: 1,
                    dataLabel: 1
                }).graphic && r.push("graphic", "connector"), t.dataLabel && r.push("dataLabel", "dataLabelPath", "dataLabelUpper"), i = r.length; i--;)s[e = r[i]] && o.singular.push(e);
                return [
                    "graphic",
                    "dataLabel"
                ].forEach(function(e) {
                    let i = e + "s";
                    t[e] && s[i] && o.plural.push(i);
                }), o;
            }
            getLabelConfig() {
                return {
                    x: this.category,
                    y: this.y,
                    color: this.color,
                    colorIndex: this.colorIndex,
                    key: this.name || this.category,
                    series: this.series,
                    point: this,
                    percentage: this.percentage,
                    total: this.total || this.stackTotal
                };
            }
            getNestedProperty(t) {
                return t ? 0 === t.indexOf("custom.") ? p(t, this.options) : this[t] : void 0;
            }
            getZone() {
                let t = this.series, e = t.zones, i = t.zoneAxis || "y", s, r = 0;
                for(s = e[0]; this[i] >= s.value;)s = e[++r];
                return this.nonZonedColor || (this.nonZonedColor = this.color), s && s.color && !this.options.color ? this.color = s.color : this.color = this.nonZonedColor, s;
            }
            hasNewShapeType() {
                return (this.graphic && (this.graphic.symbolName || this.graphic.element.nodeName)) !== this.shapeType;
            }
            constructor(t, e, i){
                this.formatPrefix = "point", this.visible = !0, this.series = t, this.applyOptions(e, i), this.id ?? (this.id = v()), this.resolveColor(), t.chart.pointCount++, c(this, "afterInit");
            }
            isValid() {
                return (f(this.x) || this.x instanceof Date) && f(this.y);
            }
            optionsToObject(t) {
                let e = this.series, i = e.options.keys, s = i || e.pointArrayMap || [
                    "y"
                ], r = s.length, o = {}, a, n = 0, h = 0;
                if (f(t) || null === t) o[s[0]] = t;
                else if (u(t)) for(!i && t.length > r && ("string" == (a = typeof t[0]) ? o.name = t[0] : "number" === a && (o.x = t[0]), n++); h < r;)i && void 0 === t[n] || (s[h].indexOf(".") > 0 ? S.prototype.setNestedProperty(o, t[n], s[h]) : o[s[h]] = t[n]), n++, h++;
                else "object" == typeof t && (o = t, t.dataLabels && (e.hasDataLabels = ()=>!0), t.marker && (e._hasPointMarkers = !0));
                return o;
            }
            pos(t, e = this.plotY) {
                if (!this.destroyed) {
                    let { plotX: i, series: s } = this, { chart: r, xAxis: o, yAxis: a } = s, n = 0, h = 0;
                    if (f(i) && f(e)) return t && (n = o ? o.pos : r.plotLeft, h = a ? a.pos : r.plotTop), r.inverted && o && a ? [
                        a.len - e + h,
                        o.len - i + n
                    ] : [
                        i + n,
                        e + h
                    ];
                }
            }
            resolveColor() {
                let t = this.series, e = t.chart.options.chart, i = t.chart.styledMode, s, r, o = e.colorCount, a;
                delete this.nonZonedColor, t.options.colorByPoint ? (i || (s = (r = t.options.colors || t.chart.options.colors)[t.colorCounter], o = r.length), a = t.colorCounter, t.colorCounter++, t.colorCounter === o && (t.colorCounter = 0)) : (i || (s = t.color), a = t.colorIndex), this.colorIndex = x(this.options.colorIndex, a), this.color = x(this.options.color, s);
            }
            setNestedProperty(t, e, i) {
                return i.split(".").reduce(function(t, i, s, r) {
                    let o = r.length - 1 === s;
                    return t[i] = o ? e : m(t[i], !0) ? t[i] : {}, t[i];
                }, t), t;
            }
            shouldDraw() {
                return !this.isNull;
            }
            tooltipFormatter(t) {
                let e = this.series, i = e.tooltipOptions, s = x(i.valueDecimals, ""), r = i.valuePrefix || "", o = i.valueSuffix || "";
                return e.chart.styledMode && (t = e.chart.tooltip.styledModeFormat(t)), (e.pointArrayMap || [
                    "y"
                ]).forEach(function(e) {
                    e = "{point." + e, (r || o) && (t = t.replace(RegExp(e + "}", "g"), r + e + "}" + o)), t = t.replace(RegExp(e + "}", "g"), e + ":,." + s + "f}");
                }), n(t, {
                    point: this,
                    series: this.series
                }, e.chart);
            }
            update(t, e, i, s) {
                let r;
                let o = this, a = o.series, n = o.graphic, h = a.chart, l = a.options;
                function d() {
                    o.applyOptions(t);
                    let s = n && o.hasMockGraphic, d = null === o.y ? !s : s;
                    n && d && (o.graphic = n.destroy(), delete o.hasMockGraphic), m(t, !0) && (n && n.element && t && t.marker && void 0 !== t.marker.symbol && (o.graphic = n.destroy()), t?.dataLabels && o.dataLabel && (o.dataLabel = o.dataLabel.destroy())), r = o.index, a.updateParallelArrays(o, r), l.data[r] = m(l.data[r], !0) || m(t, !0) ? o.options : x(t, l.data[r]), a.isDirty = a.isDirtyData = !0, !a.fixedBox && a.hasCartesianSeries && (h.isDirtyBox = !0), "point" === l.legendType && (h.isDirtyLegend = !0), e && h.redraw(i);
                }
                e = x(e, !0), !1 === s ? d() : o.firePointEvent("update", {
                    options: t
                }, d);
            }
            remove(t, e) {
                this.series.removePoint(this.series.data.indexOf(this), t, e);
            }
            select(t, e) {
                let i = this, s = i.series, r = s.chart;
                t = x(t, !i.selected), this.selectedStaging = t, i.firePointEvent(t ? "select" : "unselect", {
                    accumulate: e
                }, function() {
                    i.selected = i.options.selected = t, s.options.data[s.data.indexOf(i)] = i.options, i.setState(t && "select"), e || r.getSelectedPoints().forEach(function(t) {
                        let e = t.series;
                        t.selected && t !== i && (t.selected = t.options.selected = !1, e.options.data[e.data.indexOf(t)] = t.options, t.setState(r.hoverPoints && e.options.inactiveOtherPoints ? "inactive" : ""), t.firePointEvent("unselect"));
                    });
                }), delete this.selectedStaging;
            }
            onMouseOver(t) {
                let { inverted: e, pointer: i } = this.series.chart;
                i && (t = t ? i.normalize(t) : i.getChartCoordinatesFromPoint(this, e), i.runPointActions(t, this));
            }
            onMouseOut() {
                let t = this.series.chart;
                this.firePointEvent("mouseOut"), this.series.options.inactiveOtherPoints || (t.hoverPoints || []).forEach(function(t) {
                    t.setState();
                }), t.hoverPoints = t.hoverPoint = null;
            }
            manageEvent(t) {
                let e = this.series.options.point || {}, i = e.events?.[t];
                g(i) && (!this.hcEvents?.[t] || this.hcEvents?.[t]?.map((t)=>t.fn).indexOf(i) === -1) ? (h(this, t, i), this.hasImportedEvents = !0) : this.hasImportedEvents && !i && this.hcEvents?.[t] && (b(this, t), delete this.hcEvents[t], Object.keys(this.hcEvents) || (this.hasImportedEvents = !1));
            }
            setState(e, i) {
                let s = this.series, r = this.state, o = s.options.states[e || "normal"] || {}, n = a.plotOptions[s.type].marker && s.options.marker, h = n && !1 === n.enabled, l = n && n.states && n.states[e || "normal"] || {}, p = !1 === l.enabled, u = this.marker || {}, g = s.chart, m = n && s.markerAttribs, y = s.halo, b, v, S, k = s.stateMarkerGraphic, C;
                if ((e = e || "") === this.state && !i || this.selected && "select" !== e || !1 === o.enabled || e && (p || h && !1 === l.enabled) || e && u.states && u.states[e] && !1 === u.states[e].enabled) return;
                if (this.state = e, m && (b = s.markerAttribs(this, e)), this.graphic && !this.hasMockGraphic) {
                    if (r && this.graphic.removeClass("highcharts-point-" + r), e && this.graphic.addClass("highcharts-point-" + e), !g.styledMode) {
                        v = s.pointAttribs(this, e), S = x(g.options.chart.animation, o.animation);
                        let t = v.opacity;
                        s.options.inactiveOtherPoints && f(t) && (this.dataLabels || []).forEach(function(e) {
                            e && !e.hasClass("highcharts-data-label-hidden") && (e.animate({
                                opacity: t
                            }, S), e.connector && e.connector.animate({
                                opacity: t
                            }, S));
                        }), this.graphic.animate(v, S);
                    }
                    b && this.graphic.animate(b, x(g.options.chart.animation, l.animation, n.animation)), k && k.hide();
                } else e && l && (C = u.symbol || s.symbol, k && k.currentSymbol !== C && (k = k.destroy()), b && (k ? k[i ? "animate" : "attr"]({
                    x: b.x,
                    y: b.y
                }) : C && (s.stateMarkerGraphic = k = g.renderer.symbol(C, b.x, b.y, b.width, b.height).add(s.markerGroup), k.currentSymbol = C)), !g.styledMode && k && "inactive" !== this.state && k.attr(s.pointAttribs(this, e))), k && (k[e && this.isInside ? "show" : "hide"](), k.element.point = this, k.addClass(this.getClassName(), !0));
                let M = o.halo, w = this.graphic || k, T = w && w.visibility || "inherit";
                M && M.size && w && "hidden" !== T && !this.isCluster ? (y || (s.halo = y = g.renderer.path().add(w.parentGroup)), y.show()[i ? "animate" : "attr"]({
                    d: this.haloPath(M.size)
                }), y.attr({
                    class: "highcharts-halo highcharts-color-" + x(this.colorIndex, s.colorIndex) + (this.className ? " " + this.className : ""),
                    visibility: T,
                    zIndex: -1
                }), y.point = this, g.styledMode || y.attr(d({
                    fill: this.color || s.color,
                    "fill-opacity": M.opacity
                }, t.filterUserAttributes(M.attributes || {})))) : y && y.point && y.point.haloPath && y.animate({
                    d: y.point.haloPath(0)
                }, null, y.hide), c(this, "afterSetState", {
                    state: e
                });
            }
            haloPath(t) {
                let e = this.pos();
                return e ? this.series.chart.renderer.symbols.circle(Math.floor(e[0]) - t, e[1] - t, 2 * t, 2 * t) : [];
            }
        }
        return S;
    }), i(e, "Core/Pointer.js", [
        e["Core/Color/Color.js"],
        e["Core/Globals.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i) {
        var s;
        let { parse: r } = t, { charts: o, composed: a } = e, { addEvent: n, attr: h, css: l, extend: d, find: c, fireEvent: p, isNumber: u, isObject: g, objectEach: f, offset: m, pick: x, pushUnique: y, splat: b } = i;
        class v {
            applyInactiveState(t) {
                let e = [], i;
                (t || []).forEach(function(t) {
                    i = t.series, e.push(i), i.linkedParent && e.push(i.linkedParent), i.linkedSeries && (e = e.concat(i.linkedSeries)), i.navigatorSeries && e.push(i.navigatorSeries);
                }), this.chart.series.forEach(function(t) {
                    -1 === e.indexOf(t) ? t.setState("inactive", !0) : t.options.inactiveOtherPoints && t.setAllPointsToState("inactive");
                });
            }
            destroy() {
                let t = this;
                this.eventsToUnbind.forEach((t)=>t()), this.eventsToUnbind = [], !e.chartCount && (v.unbindDocumentMouseUp && (v.unbindDocumentMouseUp = v.unbindDocumentMouseUp()), v.unbindDocumentTouchEnd && (v.unbindDocumentTouchEnd = v.unbindDocumentTouchEnd())), clearInterval(t.tooltipTimeout), f(t, function(e, i) {
                    t[i] = void 0;
                });
            }
            getSelectionMarkerAttrs(t, e) {
                let i = {
                    args: {
                        chartX: t,
                        chartY: e
                    },
                    attrs: {},
                    shapeType: "rect"
                };
                return p(this, "getSelectionMarkerAttrs", i, (i)=>{
                    let s;
                    let { chart: r, zoomHor: o, zoomVert: a } = this, { mouseDownX: n = 0, mouseDownY: h = 0 } = r, l = i.attrs;
                    l.x = r.plotLeft, l.y = r.plotTop, l.width = o ? 1 : r.plotWidth, l.height = a ? 1 : r.plotHeight, o && (s = t - n, l.width = Math.max(1, Math.abs(s)), l.x = (s > 0 ? 0 : s) + n), a && (s = e - h, l.height = Math.max(1, Math.abs(s)), l.y = (s > 0 ? 0 : s) + h);
                }), i;
            }
            drag(t) {
                let { chart: e } = this, { mouseDownX: i = 0, mouseDownY: s = 0 } = e, { panning: o, panKey: a, selectionMarkerFill: n } = e.options.chart, h = e.plotLeft, l = e.plotTop, d = e.plotWidth, c = e.plotHeight, p = g(o) ? o.enabled : o, u = a && t[`${a}Key`], f = t.chartX, m = t.chartY, x, y = this.selectionMarker;
                if ((!y || !y.touch) && (f < h ? f = h : f > h + d && (f = h + d), m < l ? m = l : m > l + c && (m = l + c), this.hasDragged = Math.sqrt(Math.pow(i - f, 2) + Math.pow(s - m, 2)), this.hasDragged > 10)) {
                    x = e.isInsidePlot(i - h, s - l, {
                        visiblePlotOnly: !0
                    });
                    let { shapeType: a, attrs: d } = this.getSelectionMarkerAttrs(f, m);
                    (e.hasCartesianSeries || e.mapView) && this.hasZoom && x && !u && !y && (this.selectionMarker = y = e.renderer[a](), y.attr({
                        class: "highcharts-selection-marker",
                        zIndex: 7
                    }).add(), e.styledMode || y.attr({
                        fill: n || r("#334eff").setOpacity(.25).get()
                    })), y && y.attr(d), x && !y && p && e.pan(t, o);
                }
            }
            dragStart(t) {
                let e = this.chart;
                e.mouseIsDown = t.type, e.cancelClick = !1, e.mouseDownX = t.chartX, e.mouseDownY = t.chartY;
            }
            getSelectionBox(t) {
                let e = {
                    args: {
                        marker: t
                    },
                    result: t.getBBox()
                };
                return p(this, "getSelectionBox", e), e.result;
            }
            drop(t) {
                let e;
                let { chart: i, selectionMarker: s } = this;
                for (let t of i.axes)t.isPanning && (t.isPanning = !1, (t.options.startOnTick || t.options.endOnTick || t.series.some((t)=>t.boosted)) && (t.forceRedraw = !0, t.setExtremes(t.userMin, t.userMax, !1), e = !0));
                if (e && i.redraw(), s && t) {
                    if (this.hasDragged) {
                        let e = this.getSelectionBox(s);
                        i.transform({
                            axes: i.axes.filter((t)=>t.zoomEnabled && ("xAxis" === t.coll && this.zoomX || "yAxis" === t.coll && this.zoomY)),
                            selection: {
                                originalEvent: t,
                                xAxis: [],
                                yAxis: [],
                                ...e
                            },
                            from: e
                        });
                    }
                    u(i.index) && (this.selectionMarker = s.destroy());
                }
                i && u(i.index) && (l(i.container, {
                    cursor: i._cursor
                }), i.cancelClick = this.hasDragged > 10, i.mouseIsDown = !1, this.hasDragged = 0, this.pinchDown = []);
            }
            findNearestKDPoint(t, e, i) {
                let s;
                return t.forEach(function(t) {
                    let r = !(t.noSharedTooltip && e) && 0 > t.options.findNearestPointBy.indexOf("y"), o = t.searchPoint(i, r);
                    g(o, !0) && o.series && (!g(s, !0) || function(t, i) {
                        let s = t.distX - i.distX, r = t.dist - i.dist, o = i.series.group?.zIndex - t.series.group?.zIndex;
                        return 0 !== s && e ? s : 0 !== r ? r : 0 !== o ? o : t.series.index > i.series.index ? -1 : 1;
                    }(s, o) > 0) && (s = o);
                }), s;
            }
            getChartCoordinatesFromPoint(t, e) {
                let { xAxis: i, yAxis: s } = t.series, r = t.shapeArgs;
                if (i && s) {
                    let o = t.clientX ?? t.plotX ?? 0, a = t.plotY || 0;
                    return t.isNode && r && u(r.x) && u(r.y) && (o = r.x, a = r.y), e ? {
                        chartX: s.len + s.pos - a,
                        chartY: i.len + i.pos - o
                    } : {
                        chartX: o + i.pos,
                        chartY: a + s.pos
                    };
                }
                if (r && r.x && r.y) return {
                    chartX: r.x,
                    chartY: r.y
                };
            }
            getChartPosition() {
                if (this.chartPosition) return this.chartPosition;
                let { container: t } = this.chart, e = m(t);
                this.chartPosition = {
                    left: e.left,
                    top: e.top,
                    scaleX: 1,
                    scaleY: 1
                };
                let { offsetHeight: i, offsetWidth: s } = t;
                return s > 2 && i > 2 && (this.chartPosition.scaleX = e.width / s, this.chartPosition.scaleY = e.height / i), this.chartPosition;
            }
            getCoordinates(t) {
                let e = {
                    xAxis: [],
                    yAxis: []
                };
                for (let i of this.chart.axes)e[i.isXAxis ? "xAxis" : "yAxis"].push({
                    axis: i,
                    value: i.toValue(t[i.horiz ? "chartX" : "chartY"])
                });
                return e;
            }
            getHoverData(t, e, i, s, r, o) {
                let a = [], n = function(t) {
                    return t.visible && !(!r && t.directTouch) && x(t.options.enableMouseTracking, !0);
                }, h = e, l, d = {
                    chartX: o ? o.chartX : void 0,
                    chartY: o ? o.chartY : void 0,
                    shared: r
                };
                p(this, "beforeGetHoverData", d), l = h && !h.stickyTracking ? [
                    h
                ] : i.filter((t)=>t.stickyTracking && (d.filter || n)(t));
                let u = s && t || !o ? t : this.findNearestKDPoint(l, r, o);
                return h = u && u.series, u && (r && !h.noSharedTooltip ? (l = i.filter(function(t) {
                    return d.filter ? d.filter(t) : n(t) && !t.noSharedTooltip;
                })).forEach(function(t) {
                    let e = c(t.points, function(t) {
                        return t.x === u.x && !t.isNull;
                    });
                    g(e) && (t.boosted && t.boost && (e = t.boost.getPoint(e)), a.push(e));
                }) : a.push(u)), p(this, "afterGetHoverData", d = {
                    hoverPoint: u
                }), {
                    hoverPoint: d.hoverPoint,
                    hoverSeries: h,
                    hoverPoints: a
                };
            }
            getPointFromEvent(t) {
                let e = t.target, i;
                for(; e && !i;)i = e.point, e = e.parentNode;
                return i;
            }
            onTrackerMouseOut(t) {
                let e = this.chart, i = t.relatedTarget, s = e.hoverSeries;
                this.isDirectTouch = !1, !s || !i || s.stickyTracking || this.inClass(i, "highcharts-tooltip") || this.inClass(i, "highcharts-series-" + s.index) && this.inClass(i, "highcharts-tracker") || s.onMouseOut();
            }
            inClass(t, e) {
                let i = t, s;
                for(; i;){
                    if (s = h(i, "class")) {
                        if (-1 !== s.indexOf(e)) return !0;
                        if (-1 !== s.indexOf("highcharts-container")) return !1;
                    }
                    i = i.parentElement;
                }
            }
            constructor(t, e){
                this.hasDragged = 0, this.eventsToUnbind = [], this.options = e, this.chart = t, this.runChartClick = !!e.chart.events?.click, this.pinchDown = [], this.setDOMEvents(), p(this, "afterInit");
            }
            normalize(t, e) {
                let i = t.touches, s = i ? i.length ? i.item(0) : x(i.changedTouches, t.changedTouches)[0] : t;
                e || (e = this.getChartPosition());
                let r = s.pageX - e.left, o = s.pageY - e.top;
                return d(t, {
                    chartX: Math.round(r /= e.scaleX),
                    chartY: Math.round(o /= e.scaleY)
                });
            }
            onContainerClick(t) {
                let e = this.chart, i = e.hoverPoint, s = this.normalize(t), r = e.plotLeft, o = e.plotTop;
                !e.cancelClick && (i && this.inClass(s.target, "highcharts-tracker") ? (p(i.series, "click", d(s, {
                    point: i
                })), e.hoverPoint && i.firePointEvent("click", s)) : (d(s, this.getCoordinates(s)), e.isInsidePlot(s.chartX - r, s.chartY - o, {
                    visiblePlotOnly: !0
                }) && p(e, "click", s)));
            }
            onContainerMouseDown(t) {
                let i = (1 & (t.buttons || t.button)) == 1;
                t = this.normalize(t), e.isFirefox && 0 !== t.button && this.onContainerMouseMove(t), (void 0 === t.button || i) && (this.zoomOption(t), i && t.preventDefault?.(), this.dragStart(t));
            }
            onContainerMouseLeave(t) {
                let { pointer: e } = o[x(v.hoverChartIndex, -1)] || {};
                t = this.normalize(t), this.onContainerMouseMove(t), e && t.relatedTarget && !this.inClass(t.relatedTarget, "highcharts-tooltip") && (e.reset(), e.chartPosition = void 0);
            }
            onContainerMouseEnter() {
                delete this.chartPosition;
            }
            onContainerMouseMove(t) {
                let e = this.chart, i = e.tooltip, s = this.normalize(t);
                this.setHoverChartIndex(t), ("mousedown" === e.mouseIsDown || this.touchSelect(s)) && this.drag(s), !e.openMenu && (this.inClass(s.target, "highcharts-tracker") || e.isInsidePlot(s.chartX - e.plotLeft, s.chartY - e.plotTop, {
                    visiblePlotOnly: !0
                })) && !(i && i.shouldStickOnContact(s)) && (this.inClass(s.target, "highcharts-no-tooltip") ? this.reset(!1, 0) : this.runPointActions(s));
            }
            onDocumentTouchEnd(t) {
                this.onDocumentMouseUp(t);
            }
            onContainerTouchMove(t) {
                this.touchSelect(t) ? this.onContainerMouseMove(t) : this.touch(t);
            }
            onContainerTouchStart(t) {
                this.touchSelect(t) ? this.onContainerMouseDown(t) : (this.zoomOption(t), this.touch(t, !0));
            }
            onDocumentMouseMove(t) {
                let e = this.chart, i = e.tooltip, s = this.chartPosition, r = this.normalize(t, s);
                !s || e.isInsidePlot(r.chartX - e.plotLeft, r.chartY - e.plotTop, {
                    visiblePlotOnly: !0
                }) || i && i.shouldStickOnContact(r) || this.inClass(r.target, "highcharts-tracker") || this.reset();
            }
            onDocumentMouseUp(t) {
                o[x(v.hoverChartIndex, -1)]?.pointer?.drop(t);
            }
            pinch(t) {
                let e = this, { chart: i, hasZoom: s, lastTouches: r } = e, o = [].map.call(t.touches || [], (t)=>e.normalize(t)), a = o.length, n = 1 === a && (e.inClass(t.target, "highcharts-tracker") && i.runTrackerClick || e.runChartClick), h = i.tooltip, l = 1 === a && x(h?.options.followTouchMove, !0);
                a > 1 ? e.initiated = !0 : l && (e.initiated = !1), s && e.initiated && !n && !1 !== t.cancelable && t.preventDefault(), "touchstart" === t.type ? (e.pinchDown = o, e.res = !0) : l ? this.runPointActions(e.normalize(t)) : r && (p(i, "touchpan", {
                    originalEvent: t,
                    touches: o
                }, ()=>{
                    let e = (t)=>{
                        let e = t[0], i = t[1] || e;
                        return {
                            x: e.chartX,
                            y: e.chartY,
                            width: i.chartX - e.chartX,
                            height: i.chartY - e.chartY
                        };
                    };
                    i.transform({
                        axes: i.axes.filter((t)=>t.zoomEnabled && (this.zoomHor && t.horiz || this.zoomVert && !t.horiz)),
                        to: e(o),
                        from: e(r),
                        trigger: t.type
                    });
                }), e.res && (e.res = !1, this.reset(!1, 0))), e.lastTouches = o;
            }
            reset(t, e) {
                let i = this.chart, s = i.hoverSeries, r = i.hoverPoint, o = i.hoverPoints, a = i.tooltip, n = a && a.shared ? o : r;
                t && n && b(n).forEach(function(e) {
                    e.series.isCartesian && void 0 === e.plotX && (t = !1);
                }), t ? a && n && b(n).length && (a.refresh(n), a.shared && o ? o.forEach(function(t) {
                    t.setState(t.state, !0), t.series.isCartesian && (t.series.xAxis.crosshair && t.series.xAxis.drawCrosshair(null, t), t.series.yAxis.crosshair && t.series.yAxis.drawCrosshair(null, t));
                }) : r && (r.setState(r.state, !0), i.axes.forEach(function(t) {
                    t.crosshair && r.series[t.coll] === t && t.drawCrosshair(null, r);
                }))) : (r && r.onMouseOut(), o && o.forEach(function(t) {
                    t.setState();
                }), s && s.onMouseOut(), a && a.hide(e), this.unDocMouseMove && (this.unDocMouseMove = this.unDocMouseMove()), i.axes.forEach(function(t) {
                    t.hideCrosshair();
                }), i.hoverPoints = i.hoverPoint = void 0);
            }
            runPointActions(t, e, i) {
                let s = this.chart, r = s.series, a = s.tooltip && s.tooltip.options.enabled ? s.tooltip : void 0, h = !!a && a.shared, l = e || s.hoverPoint, d = l && l.series || s.hoverSeries, p = (!t || "touchmove" !== t.type) && (!!e || d && d.directTouch && this.isDirectTouch), u = this.getHoverData(l, d, r, p, h, t);
                l = u.hoverPoint, d = u.hoverSeries;
                let g = u.hoverPoints, f = d && d.tooltipOptions.followPointer && !d.tooltipOptions.split, m = h && d && !d.noSharedTooltip;
                if (l && (i || l !== s.hoverPoint || a && a.isHidden)) {
                    if ((s.hoverPoints || []).forEach(function(t) {
                        -1 === g.indexOf(t) && t.setState();
                    }), s.hoverSeries !== d && d.onMouseOver(), this.applyInactiveState(g), (g || []).forEach(function(t) {
                        t.setState("hover");
                    }), s.hoverPoint && s.hoverPoint.firePointEvent("mouseOut"), !l.series) return;
                    s.hoverPoints = g, s.hoverPoint = l, l.firePointEvent("mouseOver", void 0, ()=>{
                        a && l && a.refresh(m ? g : l, t);
                    });
                } else if (f && a && !a.isHidden) {
                    let e = a.getAnchor([
                        {}
                    ], t);
                    s.isInsidePlot(e[0], e[1], {
                        visiblePlotOnly: !0
                    }) && a.updatePosition({
                        plotX: e[0],
                        plotY: e[1]
                    });
                }
                this.unDocMouseMove || (this.unDocMouseMove = n(s.container.ownerDocument, "mousemove", (t)=>o[v.hoverChartIndex ?? -1]?.pointer?.onDocumentMouseMove(t)), this.eventsToUnbind.push(this.unDocMouseMove)), s.axes.forEach(function(e) {
                    let i;
                    let r = x((e.crosshair || {}).snap, !0);
                    !r || (i = s.hoverPoint) && i.series[e.coll] === e || (i = c(g, (t)=>t.series && t.series[e.coll] === e)), i || !r ? e.drawCrosshair(t, i) : e.hideCrosshair();
                });
            }
            setDOMEvents() {
                let t = this.chart.container, e = t.ownerDocument;
                t.onmousedown = this.onContainerMouseDown.bind(this), t.onmousemove = this.onContainerMouseMove.bind(this), t.onclick = this.onContainerClick.bind(this), this.eventsToUnbind.push(n(t, "mouseenter", this.onContainerMouseEnter.bind(this)), n(t, "mouseleave", this.onContainerMouseLeave.bind(this))), v.unbindDocumentMouseUp || (v.unbindDocumentMouseUp = n(e, "mouseup", this.onDocumentMouseUp.bind(this)));
                let i = this.chart.renderTo.parentElement;
                for(; i && "BODY" !== i.tagName;)this.eventsToUnbind.push(n(i, "scroll", ()=>{
                    delete this.chartPosition;
                })), i = i.parentElement;
                this.eventsToUnbind.push(n(t, "touchstart", this.onContainerTouchStart.bind(this), {
                    passive: !1
                }), n(t, "touchmove", this.onContainerTouchMove.bind(this), {
                    passive: !1
                })), v.unbindDocumentTouchEnd || (v.unbindDocumentTouchEnd = n(e, "touchend", this.onDocumentTouchEnd.bind(this), {
                    passive: !1
                }));
            }
            setHoverChartIndex(t) {
                let i = this.chart, s = e.charts[x(v.hoverChartIndex, -1)];
                s && s !== i && s.pointer?.onContainerMouseLeave(t || {
                    relatedTarget: i.container
                }), s && s.mouseIsDown || (v.hoverChartIndex = i.index);
            }
            touch(t, e) {
                let i;
                let { chart: s, pinchDown: r = [] } = this;
                this.setHoverChartIndex(), 1 === t.touches.length ? (t = this.normalize(t), s.isInsidePlot(t.chartX - s.plotLeft, t.chartY - s.plotTop, {
                    visiblePlotOnly: !0
                }) && !s.openMenu ? (e && this.runPointActions(t), "touchmove" === t.type && (i = !!r[0] && Math.pow(r[0].chartX - t.chartX, 2) + Math.pow(r[0].chartY - t.chartY, 2) >= 16), x(i, !0) && this.pinch(t)) : e && this.reset()) : 2 === t.touches.length && this.pinch(t);
            }
            touchSelect(t) {
                return !!(this.chart.zooming.singleTouch && t.touches && 1 === t.touches.length);
            }
            zoomOption(t) {
                let e = this.chart, i = e.inverted, s = e.zooming.type || "", r, o;
                /touch/.test(t.type) && (s = x(e.zooming.pinchType, s)), this.zoomX = r = /x/.test(s), this.zoomY = o = /y/.test(s), this.zoomHor = r && !i || o && i, this.zoomVert = o && !i || r && i, this.hasZoom = r || o;
            }
        }
        return (s = v || (v = {})).compose = function(t) {
            y(a, "Core.Pointer") && n(t, "beforeRender", function() {
                this.pointer = new s(this, this.options);
            });
        }, v;
    }), i(e, "Core/Legend/Legend.js", [
        e["Core/Animation/AnimationUtilities.js"],
        e["Core/Templating.js"],
        e["Core/Globals.js"],
        e["Core/Series/Point.js"],
        e["Core/Renderer/RendererUtilities.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i, s, r, o) {
        var a;
        let { animObject: n, setAnimation: h } = t, { format: l } = e, { composed: d, marginNames: c } = i, { distribute: p } = r, { addEvent: u, createElement: g, css: f, defined: m, discardElement: x, find: y, fireEvent: b, isNumber: v, merge: S, pick: k, pushUnique: C, relativeLength: M, stableSort: w, syncTimeout: T } = o;
        class A {
            constructor(t, e){
                this.allItems = [], this.initialItemY = 0, this.itemHeight = 0, this.itemMarginBottom = 0, this.itemMarginTop = 0, this.itemX = 0, this.itemY = 0, this.lastItemY = 0, this.lastLineHeight = 0, this.legendHeight = 0, this.legendWidth = 0, this.maxItemWidth = 0, this.maxLegendWidth = 0, this.offsetWidth = 0, this.padding = 0, this.pages = [], this.symbolHeight = 0, this.symbolWidth = 0, this.titleHeight = 0, this.totalItemWidth = 0, this.widthOption = 0, this.chart = t, this.setOptions(e), e.enabled && (this.render(), u(this.chart, "endResize", function() {
                    this.legend.positionCheckboxes();
                })), u(this.chart, "render", ()=>{
                    this.options.enabled && this.proximate && (this.proximatePositions(), this.positionItems());
                });
            }
            setOptions(t) {
                let e = k(t.padding, 8);
                this.options = t, this.chart.styledMode || (this.itemStyle = t.itemStyle, this.itemHiddenStyle = S(this.itemStyle, t.itemHiddenStyle)), this.itemMarginTop = t.itemMarginTop, this.itemMarginBottom = t.itemMarginBottom, this.padding = e, this.initialItemY = e - 5, this.symbolWidth = k(t.symbolWidth, 16), this.pages = [], this.proximate = "proximate" === t.layout && !this.chart.inverted, this.baseline = void 0;
            }
            update(t, e) {
                let i = this.chart;
                this.setOptions(S(!0, this.options, t)), this.destroy(), i.isDirtyLegend = i.isDirtyBox = !0, k(e, !0) && i.redraw(), b(this, "afterUpdate", {
                    redraw: e
                });
            }
            colorizeItem(t, e) {
                let { area: i, group: s, label: r, line: o, symbol: a } = t.legendItem || {};
                if (s?.[e ? "removeClass" : "addClass"]("highcharts-legend-item-hidden"), !this.chart.styledMode) {
                    let { itemHiddenStyle: s = {} } = this, n = s.color, { fillColor: h, fillOpacity: l, lineColor: d, marker: c } = t.options, p = (t)=>(!e && (t.fill && (t.fill = n), t.stroke && (t.stroke = n)), t);
                    r?.css(S(e ? this.itemStyle : s)), o?.attr(p({
                        stroke: d || t.color
                    })), a && a.attr(p(c && a.isMarker ? t.pointAttribs() : {
                        fill: t.color
                    })), i?.attr(p({
                        fill: h || t.color,
                        "fill-opacity": h ? 1 : l ?? .75
                    }));
                }
                b(this, "afterColorizeItem", {
                    item: t,
                    visible: e
                });
            }
            positionItems() {
                this.allItems.forEach(this.positionItem, this), this.chart.isResizing || this.positionCheckboxes();
            }
            positionItem(t) {
                let { group: e, x: i = 0, y: s = 0 } = t.legendItem || {}, r = this.options, o = r.symbolPadding, a = !r.rtl, n = t.checkbox;
                if (e && e.element) {
                    let r = {
                        translateX: a ? i : this.legendWidth - i - 2 * o - 4,
                        translateY: s
                    };
                    e[m(e.translateY) ? "animate" : "attr"](r, void 0, ()=>{
                        b(this, "afterPositionItem", {
                            item: t
                        });
                    });
                }
                n && (n.x = i, n.y = s);
            }
            destroyItem(t) {
                let e = t.checkbox, i = t.legendItem || {};
                for (let t of [
                    "group",
                    "label",
                    "line",
                    "symbol"
                ])i[t] && (i[t] = i[t].destroy());
                e && x(e), t.legendItem = void 0;
            }
            destroy() {
                for (let t of this.getAllItems())this.destroyItem(t);
                for (let t of [
                    "clipRect",
                    "up",
                    "down",
                    "pager",
                    "nav",
                    "box",
                    "title",
                    "group"
                ])this[t] && (this[t] = this[t].destroy());
                this.display = null;
            }
            positionCheckboxes() {
                let t;
                let e = this.group && this.group.alignAttr, i = this.clipHeight || this.legendHeight, s = this.titleHeight;
                e && (t = e.translateY, this.allItems.forEach(function(r) {
                    let o;
                    let a = r.checkbox;
                    a && (o = t + s + a.y + (this.scrollOffset || 0) + 3, f(a, {
                        left: e.translateX + r.checkboxOffset + a.x - 20 + "px",
                        top: o + "px",
                        display: this.proximate || o > t - 6 && o < t + i - 6 ? "" : "none"
                    }));
                }, this));
            }
            renderTitle() {
                let t = this.options, e = this.padding, i = t.title, s, r = 0;
                i.text && (this.title || (this.title = this.chart.renderer.label(i.text, e - 3, e - 4, void 0, void 0, void 0, t.useHTML, void 0, "legend-title").attr({
                    zIndex: 1
                }), this.chart.styledMode || this.title.css(i.style), this.title.add(this.group)), i.width || this.title.css({
                    width: this.maxLegendWidth + "px"
                }), r = (s = this.title.getBBox()).height, this.offsetWidth = s.width, this.contentGroup.attr({
                    translateY: r
                })), this.titleHeight = r;
            }
            setText(t) {
                let e = this.options;
                t.legendItem.label.attr({
                    text: e.labelFormat ? l(e.labelFormat, t, this.chart) : e.labelFormatter.call(t)
                });
            }
            renderItem(t) {
                let e = t.legendItem = t.legendItem || {}, i = this.chart, s = i.renderer, r = this.options, o = "horizontal" === r.layout, a = this.symbolWidth, n = r.symbolPadding || 0, h = this.itemStyle, l = this.itemHiddenStyle, d = o ? k(r.itemDistance, 20) : 0, c = !r.rtl, p = !t.series, u = !p && t.series.drawLegendSymbol ? t.series : t, g = u.options, f = !!this.createCheckboxForItem && g && g.showCheckbox, m = r.useHTML, x = t.options.className, y = e.label, b = a + n + d + (f ? 20 : 0);
                !y && (e.group = s.g("legend-item").addClass("highcharts-" + u.type + "-series highcharts-color-" + t.colorIndex + (x ? " " + x : "") + (p ? " highcharts-series-" + t.index : "")).attr({
                    zIndex: 1
                }).add(this.scrollGroup), e.label = y = s.text("", c ? a + n : -n, this.baseline || 0, m), i.styledMode || y.css(S(t.visible ? h : l)), y.attr({
                    align: c ? "left" : "right",
                    zIndex: 2
                }).add(e.group), !this.baseline && (this.fontMetrics = s.fontMetrics(y), this.baseline = this.fontMetrics.f + 3 + this.itemMarginTop, y.attr("y", this.baseline), this.symbolHeight = k(r.symbolHeight, this.fontMetrics.f), r.squareSymbol && (this.symbolWidth = k(r.symbolWidth, Math.max(this.symbolHeight, 16)), b = this.symbolWidth + n + d + (f ? 20 : 0), c && y.attr("x", this.symbolWidth + n))), u.drawLegendSymbol(this, t), this.setItemEvents && this.setItemEvents(t, y, m)), f && !t.checkbox && this.createCheckboxForItem && this.createCheckboxForItem(t), this.colorizeItem(t, t.visible), (i.styledMode || !h.width) && y.css({
                    width: (r.itemWidth || this.widthOption || i.spacingBox.width) - b + "px"
                }), this.setText(t);
                let v = y.getBBox(), C = this.fontMetrics && this.fontMetrics.h || 0;
                t.itemWidth = t.checkboxOffset = r.itemWidth || e.labelWidth || v.width + b, this.maxItemWidth = Math.max(this.maxItemWidth, t.itemWidth), this.totalItemWidth += t.itemWidth, this.itemHeight = t.itemHeight = Math.round(e.labelHeight || (v.height > 1.5 * C ? v.height : C));
            }
            layoutItem(t) {
                let e = this.options, i = this.padding, s = "horizontal" === e.layout, r = t.itemHeight, o = this.itemMarginBottom, a = this.itemMarginTop, n = s ? k(e.itemDistance, 20) : 0, h = this.maxLegendWidth, l = e.alignColumns && this.totalItemWidth > h ? this.maxItemWidth : t.itemWidth, d = t.legendItem || {};
                s && this.itemX - i + l > h && (this.itemX = i, this.lastLineHeight && (this.itemY += a + this.lastLineHeight + o), this.lastLineHeight = 0), this.lastItemY = a + this.itemY + o, this.lastLineHeight = Math.max(r, this.lastLineHeight), d.x = this.itemX, d.y = this.itemY, s ? this.itemX += l : (this.itemY += a + r + o, this.lastLineHeight = r), this.offsetWidth = this.widthOption || Math.max((s ? this.itemX - i - (t.checkbox ? 0 : n) : l) + i, this.offsetWidth);
            }
            getAllItems() {
                let t = [];
                return this.chart.series.forEach(function(e) {
                    let i = e && e.options;
                    e && k(i.showInLegend, !m(i.linkedTo) && void 0, !0) && (t = t.concat((e.legendItem || {}).labels || ("point" === i.legendType ? e.data : e)));
                }), b(this, "afterGetAllItems", {
                    allItems: t
                }), t;
            }
            getAlignment() {
                let t = this.options;
                return this.proximate ? t.align.charAt(0) + "tv" : t.floating ? "" : t.align.charAt(0) + t.verticalAlign.charAt(0) + t.layout.charAt(0);
            }
            adjustMargins(t, e) {
                let i = this.chart, s = this.options, r = this.getAlignment();
                r && [
                    /(lth|ct|rth)/,
                    /(rtv|rm|rbv)/,
                    /(rbh|cb|lbh)/,
                    /(lbv|lm|ltv)/
                ].forEach(function(o, a) {
                    o.test(r) && !m(t[a]) && (i[c[a]] = Math.max(i[c[a]], i.legend[(a + 1) % 2 ? "legendHeight" : "legendWidth"] + [
                        1,
                        -1,
                        -1,
                        1
                    ][a] * s[a % 2 ? "x" : "y"] + k(s.margin, 12) + e[a] + (i.titleOffset[a] || 0)));
                });
            }
            proximatePositions() {
                let t;
                let e = this.chart, i = [], s = "left" === this.options.align;
                for (let r of (this.allItems.forEach(function(t) {
                    let r, o, a = s, n, h;
                    t.yAxis && (t.xAxis.options.reversed && (a = !a), t.points && (r = y(a ? t.points : t.points.slice(0).reverse(), function(t) {
                        return v(t.plotY);
                    })), o = this.itemMarginTop + t.legendItem.label.getBBox().height + this.itemMarginBottom, h = t.yAxis.top - e.plotTop, n = t.visible ? (r ? r.plotY : t.yAxis.height) + (h - .3 * o) : h + t.yAxis.height, i.push({
                        target: n,
                        size: o,
                        item: t
                    }));
                }, this), p(i, e.plotHeight)))t = r.item.legendItem || {}, v(r.pos) && (t.y = e.plotTop - e.spacing[0] + r.pos);
            }
            render() {
                let t = this.chart, e = t.renderer, i = this.options, s = this.padding, r = this.getAllItems(), o, a, n, h = this.group, l, d = this.box;
                this.itemX = s, this.itemY = this.initialItemY, this.offsetWidth = 0, this.lastItemY = 0, this.widthOption = M(i.width, t.spacingBox.width - s), l = t.spacingBox.width - 2 * s - i.x, [
                    "rm",
                    "lm"
                ].indexOf(this.getAlignment().substring(0, 2)) > -1 && (l /= 2), this.maxLegendWidth = this.widthOption || l, h || (this.group = h = e.g("legend").addClass(i.className || "").attr({
                    zIndex: 7
                }).add(), this.contentGroup = e.g().attr({
                    zIndex: 1
                }).add(h), this.scrollGroup = e.g().add(this.contentGroup)), this.renderTitle(), w(r, (t, e)=>(t.options && t.options.legendIndex || 0) - (e.options && e.options.legendIndex || 0)), i.reversed && r.reverse(), this.allItems = r, this.display = o = !!r.length, this.lastLineHeight = 0, this.maxItemWidth = 0, this.totalItemWidth = 0, this.itemHeight = 0, r.forEach(this.renderItem, this), r.forEach(this.layoutItem, this), a = (this.widthOption || this.offsetWidth) + s, n = this.lastItemY + this.lastLineHeight + this.titleHeight, n = this.handleOverflow(n) + s, d || (this.box = d = e.rect().addClass("highcharts-legend-box").attr({
                    r: i.borderRadius
                }).add(h)), t.styledMode || d.attr({
                    stroke: i.borderColor,
                    "stroke-width": i.borderWidth || 0,
                    fill: i.backgroundColor || "none"
                }).shadow(i.shadow), a > 0 && n > 0 && d[d.placed ? "animate" : "attr"](d.crisp.call({}, {
                    x: 0,
                    y: 0,
                    width: a,
                    height: n
                }, d.strokeWidth())), h[o ? "show" : "hide"](), t.styledMode && "none" === h.getStyle("display") && (a = n = 0), this.legendWidth = a, this.legendHeight = n, o && this.align(), this.proximate || this.positionItems(), b(this, "afterRender");
            }
            align(t = this.chart.spacingBox) {
                let e = this.chart, i = this.options, s = t.y;
                /(lth|ct|rth)/.test(this.getAlignment()) && e.titleOffset[0] > 0 ? s += e.titleOffset[0] : /(lbh|cb|rbh)/.test(this.getAlignment()) && e.titleOffset[2] > 0 && (s -= e.titleOffset[2]), s !== t.y && (t = S(t, {
                    y: s
                })), e.hasRendered || (this.group.placed = !1), this.group.align(S(i, {
                    width: this.legendWidth,
                    height: this.legendHeight,
                    verticalAlign: this.proximate ? "top" : i.verticalAlign
                }), !0, t);
            }
            handleOverflow(t) {
                let e = this, i = this.chart, s = i.renderer, r = this.options, o = r.y, a = "top" === r.verticalAlign, n = this.padding, h = r.maxHeight, l = r.navigation, d = k(l.animation, !0), c = l.arrowSize || 12, p = this.pages, u = this.allItems, g = function(t) {
                    "number" == typeof t ? S.attr({
                        height: t
                    }) : S && (e.clipRect = S.destroy(), e.contentGroup.clip()), e.contentGroup.div && (e.contentGroup.div.style.clip = t ? "rect(" + n + "px,9999px," + (n + t) + "px,0)" : "auto");
                }, f = function(t) {
                    return e[t] = s.circle(0, 0, 1.3 * c).translate(c / 2, c / 2).add(v), i.styledMode || e[t].attr("fill", "rgba(0,0,0,0.0001)"), e[t];
                }, m, x, y, b = i.spacingBox.height + (a ? -o : o) - n, v = this.nav, S = this.clipRect;
                return "horizontal" !== r.layout || "middle" === r.verticalAlign || r.floating || (b /= 2), h && (b = Math.min(b, h)), p.length = 0, t && b > 0 && t > b && !1 !== l.enabled ? (this.clipHeight = m = Math.max(b - 20 - this.titleHeight - n, 0), this.currentPage = k(this.currentPage, 1), this.fullHeight = t, u.forEach((t, e)=>{
                    let i = (y = t.legendItem || {}).y || 0, s = Math.round(y.label.getBBox().height), r = p.length;
                    (!r || i - p[r - 1] > m && (x || i) !== p[r - 1]) && (p.push(x || i), r++), y.pageIx = r - 1, x && ((u[e - 1].legendItem || {}).pageIx = r - 1), e === u.length - 1 && i + s - p[r - 1] > m && i > p[r - 1] && (p.push(i), y.pageIx = r), i !== x && (x = i);
                }), S || (S = e.clipRect = s.clipRect(0, n - 2, 9999, 0), e.contentGroup.clip(S)), g(m), v || (this.nav = v = s.g().attr({
                    zIndex: 1
                }).add(this.group), this.up = s.symbol("triangle", 0, 0, c, c).add(v), f("upTracker").on("click", function() {
                    e.scroll(-1, d);
                }), this.pager = s.text("", 15, 10).addClass("highcharts-legend-navigation"), !i.styledMode && l.style && this.pager.css(l.style), this.pager.add(v), this.down = s.symbol("triangle-down", 0, 0, c, c).add(v), f("downTracker").on("click", function() {
                    e.scroll(1, d);
                })), e.scroll(0), t = b) : v && (g(), this.nav = v.destroy(), this.scrollGroup.attr({
                    translateY: 1
                }), this.clipHeight = 0), t;
            }
            scroll(t, e) {
                let i = this.chart, s = this.pages, r = s.length, o = this.clipHeight, a = this.options.navigation, l = this.pager, d = this.padding, c = this.currentPage + t;
                c > r && (c = r), c > 0 && (void 0 !== e && h(e, i), this.nav.attr({
                    translateX: d,
                    translateY: o + this.padding + 7 + this.titleHeight,
                    visibility: "inherit"
                }), [
                    this.up,
                    this.upTracker
                ].forEach(function(t) {
                    t.attr({
                        class: 1 === c ? "highcharts-legend-nav-inactive" : "highcharts-legend-nav-active"
                    });
                }), l.attr({
                    text: c + "/" + r
                }), [
                    this.down,
                    this.downTracker
                ].forEach(function(t) {
                    t.attr({
                        x: 18 + this.pager.getBBox().width,
                        class: c === r ? "highcharts-legend-nav-inactive" : "highcharts-legend-nav-active"
                    });
                }, this), i.styledMode || (this.up.attr({
                    fill: 1 === c ? a.inactiveColor : a.activeColor
                }), this.upTracker.css({
                    cursor: 1 === c ? "default" : "pointer"
                }), this.down.attr({
                    fill: c === r ? a.inactiveColor : a.activeColor
                }), this.downTracker.css({
                    cursor: c === r ? "default" : "pointer"
                })), this.scrollOffset = -s[c - 1] + this.initialItemY, this.scrollGroup.animate({
                    translateY: this.scrollOffset
                }), this.currentPage = c, this.positionCheckboxes(), T(()=>{
                    b(this, "afterScroll", {
                        currentPage: c
                    });
                }, n(k(e, i.renderer.globalAnimation, !0)).duration));
            }
            setItemEvents(t, e, i) {
                let r = this, o = t.legendItem || {}, a = r.chart.renderer.boxWrapper, n = t instanceof s, h = "highcharts-legend-" + (n ? "point" : "series") + "-active", l = r.chart.styledMode, d = i ? [
                    e,
                    o.symbol
                ] : [
                    o.group
                ], c = (e)=>{
                    r.allItems.forEach((i)=>{
                        t !== i && [
                            i
                        ].concat(i.linkedSeries || []).forEach((t)=>{
                            t.setState(e, !n);
                        });
                    });
                };
                for (let i of d)i && i.on("mouseover", function() {
                    t.visible && c("inactive"), t.setState("hover"), t.visible && a.addClass(h), l || e.css(r.options.itemHoverStyle);
                }).on("mouseout", function() {
                    r.chart.styledMode || e.css(S(t.visible ? r.itemStyle : r.itemHiddenStyle)), c(""), a.removeClass(h), t.setState();
                }).on("click", function(e) {
                    let i = "legendItemClick", s = function() {
                        t.setVisible && t.setVisible(), c(t.visible ? "inactive" : "");
                    };
                    a.removeClass(h), e = {
                        browserEvent: e
                    }, t.firePointEvent ? t.firePointEvent(i, e, s) : b(t, i, e, s);
                });
            }
            createCheckboxForItem(t) {
                t.checkbox = g("input", {
                    type: "checkbox",
                    className: "highcharts-legend-checkbox",
                    checked: t.selected,
                    defaultChecked: t.selected
                }, this.options.itemCheckboxStyle, this.chart.container), u(t.checkbox, "click", function(e) {
                    let i = e.target;
                    b(t.series || t, "checkboxClick", {
                        checked: i.checked,
                        item: t
                    }, function() {
                        t.select();
                    });
                });
            }
        }
        return (a = A || (A = {})).compose = function(t) {
            C(d, "Core.Legend") && u(t, "beforeMargins", function() {
                this.legend = new a(this, this.options.legend);
            });
        }, A;
    }), i(e, "Core/Legend/LegendSymbol.js", [
        e["Core/Utilities.js"]
    ], function(t) {
        var e;
        let { extend: i, merge: s, pick: r } = t;
        return function(t) {
            function e(t, e, o) {
                let a = this.legendItem = this.legendItem || {}, { chart: n, options: h } = this, { baseline: l = 0, symbolWidth: d, symbolHeight: c } = t, p = this.symbol || "circle", u = c / 2, g = n.renderer, f = a.group, m = l - Math.round(c * (o ? .4 : .3)), x = {}, y, b = h.marker, v = 0;
                if (n.styledMode || (x["stroke-width"] = Math.min(h.lineWidth || 0, 24), h.dashStyle ? x.dashstyle = h.dashStyle : "square" === h.linecap || (x["stroke-linecap"] = "round")), a.line = g.path().addClass("highcharts-graph").attr(x).add(f), o && (a.area = g.path().addClass("highcharts-area").add(f)), x["stroke-linecap"] && (v = Math.min(a.line.strokeWidth(), d) / 2), d) {
                    let t = [
                        [
                            "M",
                            v,
                            m
                        ],
                        [
                            "L",
                            d - v,
                            m
                        ]
                    ];
                    a.line.attr({
                        d: t
                    }), a.area?.attr({
                        d: [
                            ...t,
                            [
                                "L",
                                d - v,
                                l
                            ],
                            [
                                "L",
                                v,
                                l
                            ]
                        ]
                    });
                }
                if (b && !1 !== b.enabled && d) {
                    let t = Math.min(r(b.radius, u), u);
                    0 === p.indexOf("url") && (b = s(b, {
                        width: c,
                        height: c
                    }), t = 0), a.symbol = y = g.symbol(p, d / 2 - t, m - t, 2 * t, 2 * t, i({
                        context: "legend"
                    }, b)).addClass("highcharts-point").add(f), y.isMarker = !0;
                }
            }
            t.areaMarker = function(t, i) {
                e.call(this, t, i, !0);
            }, t.lineMarker = e, t.rectangle = function(t, e) {
                let i = e.legendItem || {}, s = t.options, o = t.symbolHeight, a = s.squareSymbol, n = a ? o : t.symbolWidth;
                i.symbol = this.chart.renderer.rect(a ? (t.symbolWidth - o) / 2 : 0, t.baseline - o + 1, n, o, r(t.options.symbolRadius, o / 2)).addClass("highcharts-point").attr({
                    zIndex: 3
                }).add(i.group);
            };
        }(e || (e = {})), e;
    }), i(e, "Core/Series/SeriesDefaults.js", [], function() {
        return {
            lineWidth: 2,
            allowPointSelect: !1,
            crisp: !0,
            showCheckbox: !1,
            animation: {
                duration: 1e3
            },
            enableMouseTracking: !0,
            events: {},
            marker: {
                enabledThreshold: 2,
                lineColor: "#ffffff",
                lineWidth: 0,
                radius: 4,
                states: {
                    normal: {
                        animation: !0
                    },
                    hover: {
                        animation: {
                            duration: 150
                        },
                        enabled: !0,
                        radiusPlus: 2,
                        lineWidthPlus: 1
                    },
                    select: {
                        fillColor: "#cccccc",
                        lineColor: "#000000",
                        lineWidth: 2
                    }
                }
            },
            point: {
                events: {}
            },
            dataLabels: {
                animation: {},
                align: "center",
                borderWidth: 0,
                defer: !0,
                formatter: function() {
                    let { numberFormatter: t } = this.series.chart;
                    return "number" != typeof this.y ? "" : t(this.y, -1);
                },
                padding: 5,
                style: {
                    fontSize: "0.7em",
                    fontWeight: "bold",
                    color: "contrast",
                    textOutline: "1px contrast"
                },
                verticalAlign: "bottom",
                x: 0,
                y: 0
            },
            cropThreshold: 300,
            opacity: 1,
            pointRange: 0,
            softThreshold: !0,
            states: {
                normal: {
                    animation: !0
                },
                hover: {
                    animation: {
                        duration: 150
                    },
                    lineWidthPlus: 1,
                    marker: {},
                    halo: {
                        size: 10,
                        opacity: .25
                    }
                },
                select: {
                    animation: {
                        duration: 0
                    }
                },
                inactive: {
                    animation: {
                        duration: 150
                    },
                    opacity: .2
                }
            },
            stickyTracking: !0,
            turboThreshold: 1e3,
            findNearestPointBy: "x"
        };
    }), i(e, "Core/Series/SeriesRegistry.js", [
        e["Core/Globals.js"],
        e["Core/Defaults.js"],
        e["Core/Series/Point.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i, s) {
        var r;
        let { defaultOptions: o } = e, { extend: a, extendClass: n, merge: h } = s;
        return function(e) {
            function s(t, s) {
                let r = o.plotOptions || {}, a = s.defaultOptions, n = s.prototype;
                return n.type = t, n.pointClass || (n.pointClass = i), !e.seriesTypes[t] && (a && (r[t] = a), e.seriesTypes[t] = s, !0);
            }
            e.seriesTypes = t.seriesTypes, e.registerSeriesType = s, e.seriesType = function(t, r, l, d, c) {
                let p = o.plotOptions || {};
                if (r = r || "", p[t] = h(p[r], l), delete e.seriesTypes[t], s(t, n(e.seriesTypes[r] || function() {}, d)), e.seriesTypes[t].prototype.type = t, c) {
                    class s extends i {
                    }
                    a(s.prototype, c), e.seriesTypes[t].prototype.pointClass = s;
                }
                return e.seriesTypes[t];
            };
        }(r || (r = {})), r;
    }), i(e, "Core/Series/Series.js", [
        e["Core/Animation/AnimationUtilities.js"],
        e["Core/Defaults.js"],
        e["Core/Foundation.js"],
        e["Core/Globals.js"],
        e["Core/Legend/LegendSymbol.js"],
        e["Core/Series/Point.js"],
        e["Core/Series/SeriesDefaults.js"],
        e["Core/Series/SeriesRegistry.js"],
        e["Core/Renderer/SVG/SVGElement.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i, s, r, o, a, n, h, l) {
        let { animObject: d, setAnimation: c } = t, { defaultOptions: p } = e, { registerEventOptions: u } = i, { svg: g, win: f } = s, { seriesTypes: m } = n, { arrayMax: x, arrayMin: y, clamp: b, correctFloat: v, defined: S, destroyObjectProperties: k, diffObjects: C, erase: M, error: w, extend: T, find: A, fireEvent: P, getClosestDistance: L, getNestedProperty: O, insertItem: D, isArray: E, isNumber: I, isString: j, merge: B, objectEach: R, pick: z, removeEvent: N, splat: W, syncTimeout: G } = l;
        class H {
            constructor(){
                this.zoneAxis = "y";
            }
            init(t, e) {
                let i;
                P(this, "init", {
                    options: e
                });
                let s = this, r = t.series;
                this.eventsToUnbind = [], s.chart = t, s.options = s.setOptions(e);
                let o = s.options, a = !1 !== o.visible;
                s.linkedSeries = [], s.bindAxes(), T(s, {
                    name: o.name,
                    state: "",
                    visible: a,
                    selected: !0 === o.selected
                }), u(this, o);
                let n = o.events;
                (n && n.click || o.point && o.point.events && o.point.events.click || o.allowPointSelect) && (t.runTrackerClick = !0), s.getColor(), s.getSymbol(), s.parallelArrays.forEach(function(t) {
                    s[t + "Data"] || (s[t + "Data"] = []);
                }), s.isCartesian && (t.hasCartesianSeries = !0), r.length && (i = r[r.length - 1]), s._i = z(i && i._i, -1) + 1, s.opacity = s.options.opacity, t.orderItems("series", D(this, r)), o.dataSorting && o.dataSorting.enabled ? s.setDataSortingOptions() : s.points || s.data || s.setData(o.data, !1), P(this, "afterInit");
            }
            is(t) {
                return m[t] && this instanceof m[t];
            }
            bindAxes() {
                let t;
                let e = this, i = e.options, s = e.chart;
                P(this, "bindAxes", null, function() {
                    (e.axisTypes || []).forEach(function(r) {
                        s[r].forEach(function(s) {
                            t = s.options, (z(i[r], 0) === s.index || void 0 !== i[r] && i[r] === t.id) && (D(e, s.series), e[r] = s, s.isDirty = !0);
                        }), e[r] || e.optionalAxis === r || w(18, !0, s);
                    });
                }), P(this, "afterBindAxes");
            }
            updateParallelArrays(t, e, i) {
                let s = t.series, r = I(e) ? function(i) {
                    let r = "y" === i && s.toYData ? s.toYData(t) : t[i];
                    s[i + "Data"][e] = r;
                } : function(t) {
                    Array.prototype[e].apply(s[t + "Data"], i);
                };
                s.parallelArrays.forEach(r);
            }
            hasData() {
                return this.visible && void 0 !== this.dataMax && void 0 !== this.dataMin || this.visible && this.yData && this.yData.length > 0;
            }
            hasMarkerChanged(t, e) {
                let i = t.marker, s = e.marker || {};
                return i && (s.enabled && !i.enabled || s.symbol !== i.symbol || s.height !== i.height || s.width !== i.width);
            }
            autoIncrement(t) {
                let e = this.options, i = e.pointIntervalUnit, s = e.relativeXValue, r = this.chart.time, o = this.xIncrement, a, n;
                return (o = z(o, e.pointStart, 0), this.pointInterval = n = z(this.pointInterval, e.pointInterval, 1), s && I(t) && (n *= t), i && (a = new r.Date(o), "day" === i ? r.set("Date", a, r.get("Date", a) + n) : "month" === i ? r.set("Month", a, r.get("Month", a) + n) : "year" === i && r.set("FullYear", a, r.get("FullYear", a) + n), n = a.getTime() - o), s && I(t)) ? o + n : (this.xIncrement = o + n, o);
            }
            setDataSortingOptions() {
                let t = this.options;
                T(this, {
                    requireSorting: !1,
                    sorted: !1,
                    enabledDataSorting: !0,
                    allowDG: !1
                }), S(t.pointRange) || (t.pointRange = 1);
            }
            setOptions(t) {
                let e;
                let i = this.chart, s = i.options.plotOptions, r = i.userOptions || {}, o = B(t), a = i.styledMode, n = {
                    plotOptions: s,
                    userOptions: o
                };
                P(this, "setOptions", n);
                let h = n.plotOptions[this.type], l = r.plotOptions || {}, d = l.series || {}, c = p.plotOptions[this.type] || {}, u = l[this.type] || {};
                this.userOptions = n.userOptions;
                let g = B(h, s.series, u, o);
                this.tooltipOptions = B(p.tooltip, p.plotOptions.series?.tooltip, c?.tooltip, i.userOptions.tooltip, l.series?.tooltip, u.tooltip, o.tooltip), this.stickyTracking = z(o.stickyTracking, u.stickyTracking, d.stickyTracking, !!this.tooltipOptions.shared && !this.noSharedTooltip || g.stickyTracking), null === h.marker && delete g.marker, this.zoneAxis = g.zoneAxis || "y";
                let f = this.zones = (g.zones || []).map((t)=>({
                        ...t
                    }));
                return (g.negativeColor || g.negativeFillColor) && !g.zones && (e = {
                    value: g[this.zoneAxis + "Threshold"] || g.threshold || 0,
                    className: "highcharts-negative"
                }, a || (e.color = g.negativeColor, e.fillColor = g.negativeFillColor), f.push(e)), f.length && S(f[f.length - 1].value) && f.push(a ? {} : {
                    color: this.color,
                    fillColor: this.fillColor
                }), P(this, "afterSetOptions", {
                    options: g
                }), g;
            }
            getName() {
                return z(this.options.name, "Series " + (this.index + 1));
            }
            getCyclic(t, e, i) {
                let s, r;
                let o = this.chart, a = `${t}Index`, n = `${t}Counter`, h = i?.length || o.options.chart.colorCount;
                !e && (S(r = z("color" === t ? this.options.colorIndex : void 0, this[a])) ? s = r : (o.series.length || (o[n] = 0), s = o[n] % h, o[n] += 1), i && (e = i[s])), void 0 !== s && (this[a] = s), this[t] = e;
            }
            getColor() {
                this.chart.styledMode ? this.getCyclic("color") : this.options.colorByPoint ? this.color = "#cccccc" : this.getCyclic("color", this.options.color || p.plotOptions[this.type].color, this.chart.options.colors);
            }
            getPointsCollection() {
                return (this.hasGroupedData ? this.points : this.data) || [];
            }
            getSymbol() {
                let t = this.options.marker;
                this.getCyclic("symbol", t.symbol, this.chart.options.symbols);
            }
            findPointIndex(t, e) {
                let i, s, r;
                let a = t.id, n = t.x, h = this.points, l = this.options.dataSorting;
                if (a) {
                    let t = this.chart.get(a);
                    t instanceof o && (i = t);
                } else if (this.linkedParent || this.enabledDataSorting || this.options.relativeXValue) {
                    let e = (e)=>!e.touched && e.index === t.index;
                    if (l && l.matchByName ? e = (e)=>!e.touched && e.name === t.name : this.options.relativeXValue && (e = (e)=>!e.touched && e.options.x === t.x), !(i = A(h, e))) return;
                }
                return i && void 0 !== (r = i && i.index) && (s = !0), void 0 === r && I(n) && (r = this.xData.indexOf(n, e)), -1 !== r && void 0 !== r && this.cropped && (r = r >= this.cropStart ? r - this.cropStart : r), !s && I(r) && h[r] && h[r].touched && (r = void 0), r;
            }
            updateData(t, e) {
                let i = this.options, s = i.dataSorting, r = this.points, o = [], a = this.requireSorting, n = t.length === r.length, h, l, d, c, p = !0;
                if (this.xIncrement = null, t.forEach(function(t, e) {
                    let l;
                    let d = S(t) && this.pointClass.prototype.optionsToObject.call({
                        series: this
                    }, t) || {}, p = d.x;
                    d.id || I(p) ? (-1 === (l = this.findPointIndex(d, c)) || void 0 === l ? o.push(t) : r[l] && t !== i.data[l] ? (r[l].update(t, !1, null, !1), r[l].touched = !0, a && (c = l + 1)) : r[l] && (r[l].touched = !0), (!n || e !== l || s && s.enabled || this.hasDerivedData) && (h = !0)) : o.push(t);
                }, this), h) for(l = r.length; l--;)(d = r[l]) && !d.touched && d.remove && d.remove(!1, e);
                else !n || s && s.enabled ? p = !1 : (t.forEach(function(t, e) {
                    t === r[e].y || r[e].destroyed || r[e].update(t, !1, null, !1);
                }), o.length = 0);
                return r.forEach(function(t) {
                    t && (t.touched = !1);
                }), !!p && (o.forEach(function(t) {
                    this.addPoint(t, !1, null, null, !1);
                }, this), null === this.xIncrement && this.xData && this.xData.length && (this.xIncrement = x(this.xData), this.autoIncrement()), !0);
            }
            setData(t, e = !0, i, s) {
                let r = this, o = r.points, a = o && o.length || 0, n = r.options, h = r.chart, l = n.dataSorting, d = r.xAxis, c = n.turboThreshold, p = this.xData, u = this.yData, g = r.pointArrayMap, f = g && g.length, m = n.keys, x, y, b, v = 0, S = 1, k = null, C;
                h.options.chart.allowMutatingData || (n.data && delete r.options.data, r.userOptions.data && delete r.userOptions.data, C = B(!0, t));
                let M = (t = C || t || []).length;
                if (l && l.enabled && (t = this.sortData(t)), h.options.chart.allowMutatingData && !1 !== s && M && a && !r.cropped && !r.hasGroupedData && r.visible && !r.boosted && (b = this.updateData(t, i)), !b) {
                    if (r.xIncrement = null, r.colorCounter = 0, this.parallelArrays.forEach(function(t) {
                        r[t + "Data"].length = 0;
                    }), c && M > c) {
                        if (I(k = r.getFirstValidPoint(t))) for(x = 0; x < M; x++)p[x] = this.autoIncrement(), u[x] = t[x];
                        else if (E(k)) {
                            if (f) {
                                if (k.length === f) for(x = 0; x < M; x++)p[x] = this.autoIncrement(), u[x] = t[x];
                                else for(x = 0; x < M; x++)y = t[x], p[x] = y[0], u[x] = y.slice(1, f + 1);
                            } else if (m && (v = m.indexOf("x"), S = m.indexOf("y"), v = v >= 0 ? v : 0, S = S >= 0 ? S : 1), 1 === k.length && (S = 0), v === S) for(x = 0; x < M; x++)p[x] = this.autoIncrement(), u[x] = t[x][S];
                            else for(x = 0; x < M; x++)y = t[x], p[x] = y[v], u[x] = y[S];
                        } else w(12, !1, h);
                    } else for(x = 0; x < M; x++)y = {
                        series: r
                    }, r.pointClass.prototype.applyOptions.apply(y, [
                        t[x]
                    ]), r.updateParallelArrays(y, x);
                    for(u && j(u[0]) && w(14, !0, h), r.data = [], r.options.data = r.userOptions.data = t, x = a; x--;)o[x]?.destroy();
                    d && (d.minRange = d.userMinRange), r.isDirty = h.isDirtyBox = !0, r.isDirtyData = !!o, i = !1;
                }
                "point" === n.legendType && (this.processData(), this.generatePoints()), e && h.redraw(i);
            }
            sortData(t) {
                let e = this, i = e.options.dataSorting.sortKey || "y", s = function(t, e) {
                    return S(e) && t.pointClass.prototype.optionsToObject.call({
                        series: t
                    }, e) || {};
                };
                return t.forEach(function(i, r) {
                    t[r] = s(e, i), t[r].index = r;
                }, this), t.concat().sort((t, e)=>{
                    let s = O(i, t), r = O(i, e);
                    return r < s ? -1 : r > s ? 1 : 0;
                }).forEach(function(t, e) {
                    t.x = e;
                }, this), e.linkedSeries && e.linkedSeries.forEach(function(e) {
                    let i = e.options, r = i.data;
                    i.dataSorting && i.dataSorting.enabled || !r || (r.forEach(function(i, o) {
                        r[o] = s(e, i), t[o] && (r[o].x = t[o].x, r[o].index = o);
                    }), e.setData(r, !1));
                }), t;
            }
            getProcessedData(t) {
                let e = this, i = e.xAxis, s = e.options, r = s.cropThreshold, o = t || e.getExtremesFromAll || s.getExtremesFromAll, a = i?.logarithmic, n = e.isCartesian, h, l, d = 0, c, p, u, g = e.xData, f = e.yData, m = !1, x = g.length;
                i && (p = (c = i.getExtremes()).min, u = c.max, m = !!(i.categories && !i.names.length)), n && e.sorted && !o && (!r || x > r || e.forceCrop) && (g[x - 1] < p || g[0] > u ? (g = [], f = []) : e.yData && (g[0] < p || g[x - 1] > u) && (g = (h = this.cropData(e.xData, e.yData, p, u)).xData, f = h.yData, d = h.start, l = !0));
                let y = L([
                    a ? g.map(a.log2lin) : g
                ], ()=>e.requireSorting && !m && w(15, !1, e.chart));
                return {
                    xData: g,
                    yData: f,
                    cropped: l,
                    cropStart: d,
                    closestPointRange: y
                };
            }
            processData(t) {
                let e = this.xAxis;
                if (this.isCartesian && !this.isDirty && !e.isDirty && !this.yAxis.isDirty && !t) return !1;
                let i = this.getProcessedData();
                this.cropped = i.cropped, this.cropStart = i.cropStart, this.processedXData = i.xData, this.processedYData = i.yData, this.closestPointRange = this.basePointRange = i.closestPointRange, P(this, "afterProcessData");
            }
            cropData(t, e, i, s) {
                let r = t.length, o, a, n = 0, h = r;
                for(o = 0; o < r; o++)if (t[o] >= i) {
                    n = Math.max(0, o - 1);
                    break;
                }
                for(a = o; a < r; a++)if (t[a] > s) {
                    h = a + 1;
                    break;
                }
                return {
                    xData: t.slice(n, h),
                    yData: e.slice(n, h),
                    start: n,
                    end: h
                };
            }
            generatePoints() {
                let t = this.options, e = this.processedData || t.data, i = this.processedXData, s = this.processedYData, r = this.pointClass, o = i.length, a = this.cropStart || 0, n = this.hasGroupedData, h = t.keys, l = [], d = t.dataGrouping && t.dataGrouping.groupAll ? a : 0, c, p, u, g, f = this.data;
                if (!f && !n) {
                    let t = [];
                    t.length = e.length, f = this.data = t;
                }
                for(h && n && (this.options.keys = !1), g = 0; g < o; g++)p = a + g, n ? ((u = new r(this, [
                    i[g]
                ].concat(W(s[g])))).dataGroup = this.groupMap[d + g], u.dataGroup.options && (u.options = u.dataGroup.options, T(u, u.dataGroup.options), delete u.dataLabels)) : (u = f[p]) || void 0 === e[p] || (f[p] = u = new r(this, e[p], i[g])), u && (u.index = n ? d + g : p, l[g] = u);
                if (this.options.keys = h, f && (o !== (c = f.length) || n)) for(g = 0; g < c; g++)g !== a || n || (g += o), f[g] && (f[g].destroyElements(), f[g].plotX = void 0);
                this.data = f, this.points = l, P(this, "afterGeneratePoints");
            }
            getXExtremes(t) {
                return {
                    min: y(t),
                    max: x(t)
                };
            }
            getExtremes(t, e) {
                let i = this.xAxis, s = this.yAxis, r = this.processedXData || this.xData, o = [], a = this.requireSorting && !this.is("column") ? 1 : 0, n = !!s && s.positiveValuesOnly, h, l, d, c, p, u, g, f = 0, m = 0, b = 0, v = (t = t || this.stackedYData || this.processedYData || []).length;
                for(i && (f = (h = i.getExtremes()).min, m = h.max), u = 0; u < v; u++)if (c = r[u], l = (I(p = t[u]) || E(p)) && ((I(p) ? p > 0 : p.length) || !n), d = e || this.getExtremesFromAll || this.options.getExtremesFromAll || this.cropped || !i || (r[u + a] || c) >= f && (r[u - a] || c) <= m, l && d) {
                    if (g = p.length) for(; g--;)I(p[g]) && (o[b++] = p[g]);
                    else o[b++] = p;
                }
                let S = {
                    activeYData: o,
                    dataMin: y(o),
                    dataMax: x(o)
                };
                return P(this, "afterGetExtremes", {
                    dataExtremes: S
                }), S;
            }
            applyExtremes() {
                let t = this.getExtremes();
                return this.dataMin = t.dataMin, this.dataMax = t.dataMax, t;
            }
            getFirstValidPoint(t) {
                let e = t.length, i = 0, s = null;
                for(; null === s && i < e;)s = t[i], i++;
                return s;
            }
            translate() {
                this.processedXData || this.processData(), this.generatePoints();
                let t = this.options, e = t.stacking, i = this.xAxis, s = i.categories, r = this.enabledDataSorting, o = this.yAxis, a = this.points, n = a.length, h = this.pointPlacementToXValue(), l = !!h, d = t.threshold, c = t.startFromThreshold ? d : 0, p, u, g, f, m = Number.MAX_VALUE;
                function x(t) {
                    return b(t, -100000, 1e5);
                }
                for(p = 0; p < n; p++){
                    let t;
                    let n = a[p], y = n.x, b, k, C = n.y, M = n.low, w = e && o.stacking?.stacks[(this.negStacks && C < (c ? 0 : d) ? "-" : "") + this.stackKey];
                    u = i.translate(y, !1, !1, !1, !0, h), n.plotX = I(u) ? v(x(u)) : void 0, e && this.visible && w && w[y] && (f = this.getStackIndicator(f, y, this.index), !n.isNull && f.key && (k = (b = w[y]).points[f.key]), b && E(k) && (M = k[0], C = k[1], M === c && f.key === w[y].base && (M = z(I(d) ? d : o.min)), o.positiveValuesOnly && S(M) && M <= 0 && (M = void 0), n.total = n.stackTotal = z(b.total), n.percentage = S(n.y) && b.total ? n.y / b.total * 100 : void 0, n.stackY = C, this.irregularWidths || b.setOffset(this.pointXOffset || 0, this.barW || 0, void 0, void 0, void 0, this.xAxis))), n.yBottom = S(M) ? x(o.translate(M, !1, !0, !1, !0)) : void 0, this.dataModify && (C = this.dataModify.modifyValue(C, p)), I(C) && void 0 !== n.plotX && (t = I(t = o.translate(C, !1, !0, !1, !0)) ? x(t) : void 0), n.plotY = t, n.isInside = this.isPointInside(n), n.clientX = l ? v(i.translate(y, !1, !1, !1, !0, h)) : u, n.negative = (n.y || 0) < (d || 0), n.category = z(s && s[n.x], n.x), n.isNull || !1 === n.visible || (void 0 !== g && (m = Math.min(m, Math.abs(u - g))), g = u), n.zone = this.zones.length ? n.getZone() : void 0, !n.graphic && this.group && r && (n.isNew = !0);
                }
                this.closestPointRangePx = m, P(this, "afterTranslate");
            }
            getValidPoints(t, e, i) {
                let s = this.chart;
                return (t || this.points || []).filter(function(t) {
                    let { plotX: r, plotY: o } = t;
                    return !!((i || !t.isNull && I(o)) && (!e || s.isInsidePlot(r, o, {
                        inverted: s.inverted
                    }))) && !1 !== t.visible;
                });
            }
            getClipBox() {
                let { chart: t, xAxis: e, yAxis: i } = this, { x: s, y: r, width: o, height: a } = B(t.clipBox);
                return e && e.len !== t.plotSizeX && (o = e.len), i && i.len !== t.plotSizeY && (a = i.len), t.inverted && !this.invertible && ([o, a] = [
                    a,
                    o
                ]), {
                    x: s,
                    y: r,
                    width: o,
                    height: a
                };
            }
            getSharedClipKey() {
                return this.sharedClipKey = (this.options.xAxis || 0) + "," + (this.options.yAxis || 0), this.sharedClipKey;
            }
            setClip() {
                let { chart: t, group: e, markerGroup: i } = this, s = t.sharedClips, r = t.renderer, o = this.getClipBox(), a = this.getSharedClipKey(), n = s[a];
                n ? n.animate(o) : s[a] = n = r.clipRect(o), e && e.clip(!1 === this.options.clip ? void 0 : n), i && i.clip();
            }
            animate(t) {
                let { chart: e, group: i, markerGroup: s } = this, r = e.inverted, o = d(this.options.animation), a = [
                    this.getSharedClipKey(),
                    o.duration,
                    o.easing,
                    o.defer
                ].join(","), n = e.sharedClips[a], h = e.sharedClips[a + "m"];
                if (t && i) {
                    let t = this.getClipBox();
                    if (n) n.attr("height", t.height);
                    else {
                        t.width = 0, r && (t.x = e.plotHeight), n = e.renderer.clipRect(t), e.sharedClips[a] = n;
                        let i = {
                            x: -99,
                            y: -99,
                            width: r ? e.plotWidth + 199 : 99,
                            height: r ? 99 : e.plotHeight + 199
                        };
                        h = e.renderer.clipRect(i), e.sharedClips[a + "m"] = h;
                    }
                    i.clip(n), s?.clip(h);
                } else if (n && !n.hasClass("highcharts-animating")) {
                    let t = this.getClipBox(), i = o.step;
                    (s?.element.childNodes.length || e.series.length > 1) && (o.step = function(t, e) {
                        i && i.apply(e, arguments), "width" === e.prop && h?.element && h.attr(r ? "height" : "width", t + 99);
                    }), n.addClass("highcharts-animating").animate(t, o);
                }
            }
            afterAnimate() {
                this.setClip(), R(this.chart.sharedClips, (t, e, i)=>{
                    t && !this.chart.container.querySelector(`[clip-path="url(#${t.id})"]`) && (t.destroy(), delete i[e]);
                }), this.finishedAnimating = !0, P(this, "afterAnimate");
            }
            drawPoints(t = this.points) {
                let e, i, s, r, o, a, n;
                let h = this.chart, l = h.styledMode, { colorAxis: d, options: c } = this, p = c.marker, u = this[this.specialGroup || "markerGroup"], g = this.xAxis, f = z(p.enabled, !g || !!g.isRadial || null, this.closestPointRangePx >= p.enabledThreshold * p.radius);
                if (!1 !== p.enabled || this._hasPointMarkers) for(e = 0; e < t.length; e++)if (r = (s = (i = t[e]).graphic) ? "animate" : "attr", o = i.marker || {}, a = !!i.marker, (f && void 0 === o.enabled || o.enabled) && !i.isNull && !1 !== i.visible) {
                    let t = z(o.symbol, this.symbol, "rect");
                    n = this.markerAttribs(i, i.selected && "select"), this.enabledDataSorting && (i.startXPos = g.reversed ? -(n.width || 0) : g.width);
                    let e = !1 !== i.isInside;
                    if (!s && e && ((n.width || 0) > 0 || i.hasImage) && (i.graphic = s = h.renderer.symbol(t, n.x, n.y, n.width, n.height, a ? o : p).add(u), this.enabledDataSorting && h.hasRendered && (s.attr({
                        x: i.startXPos
                    }), r = "animate")), s && "animate" === r && s[e ? "show" : "hide"](e).animate(n), s) {
                        let t = this.pointAttribs(i, l || !i.selected ? void 0 : "select");
                        l ? d && s.css({
                            fill: t.fill
                        }) : s[r](t);
                    }
                    s && s.addClass(i.getClassName(), !0);
                } else s && (i.graphic = s.destroy());
            }
            markerAttribs(t, e) {
                let i = this.options, s = i.marker, r = t.marker || {}, o = r.symbol || s.symbol, a = {}, n, h, l = z(r.radius, s && s.radius);
                e && (n = s.states[e], l = z((h = r.states && r.states[e]) && h.radius, n && n.radius, l && l + (n && n.radiusPlus || 0))), t.hasImage = o && 0 === o.indexOf("url"), t.hasImage && (l = 0);
                let d = t.pos();
                return I(l) && d && (a.x = d[0] - l, a.y = d[1] - l, i.crisp && (a.x = Math.floor(a.x))), l && (a.width = a.height = 2 * l), a;
            }
            pointAttribs(t, e) {
                let i = this.options.marker, s = t && t.options, r = s && s.marker || {}, o = s && s.color, a = t && t.color, n = t && t.zone && t.zone.color, h, l, d = this.color, c, p, u = z(r.lineWidth, i.lineWidth), g = 1;
                return d = o || n || a || d, c = r.fillColor || i.fillColor || d, p = r.lineColor || i.lineColor || d, e = e || "normal", h = i.states[e] || {}, u = z((l = r.states && r.states[e] || {}).lineWidth, h.lineWidth, u + z(l.lineWidthPlus, h.lineWidthPlus, 0)), c = l.fillColor || h.fillColor || c, {
                    stroke: p = l.lineColor || h.lineColor || p,
                    "stroke-width": u,
                    fill: c,
                    opacity: g = z(l.opacity, h.opacity, g)
                };
            }
            destroy(t) {
                let e, i, s;
                let r = this, o = r.chart, a = /AppleWebKit\/533/.test(f.navigator.userAgent), n = r.data || [];
                for(P(r, "destroy", {
                    keepEventsForUpdate: t
                }), this.removeEvents(t), (r.axisTypes || []).forEach(function(t) {
                    (s = r[t]) && s.series && (M(s.series, r), s.isDirty = s.forceRedraw = !0);
                }), r.legendItem && r.chart.legend.destroyItem(r), e = n.length; e--;)(i = n[e]) && i.destroy && i.destroy();
                for (let t of r.zones)k(t, void 0, !0);
                l.clearTimeout(r.animationTimeout), R(r, function(t, e) {
                    t instanceof h && !t.survive && t[a && "group" === e ? "hide" : "destroy"]();
                }), o.hoverSeries === r && (o.hoverSeries = void 0), M(o.series, r), o.orderItems("series"), R(r, function(e, i) {
                    t && "hcEvents" === i || delete r[i];
                });
            }
            applyZones() {
                let { area: t, chart: e, graph: i, zones: s, points: r, xAxis: o, yAxis: a, zoneAxis: n } = this, { inverted: h, renderer: l } = e, d = this[`${n}Axis`], { isXAxis: c, len: p = 0 } = d || {}, u = (i?.strokeWidth() || 0) / 2 + 1, g = (t, e = 0, i = 0)=>{
                    h && (i = p - i);
                    let { translated: s = 0, lineClip: r } = t, o = i - s;
                    r?.push([
                        "L",
                        e,
                        Math.abs(o) < u ? i - u * (o <= 0 ? -1 : 1) : s
                    ]);
                };
                if (s.length && (i || t) && d && I(d.min)) {
                    let e = d.getExtremes().max, u = (t)=>{
                        t.forEach((e, i)=>{
                            ("M" === e[0] || "L" === e[0]) && (t[i] = [
                                e[0],
                                c ? p - e[1] : e[1],
                                c ? e[2] : p - e[2]
                            ]);
                        });
                    };
                    if (s.forEach((t)=>{
                        t.lineClip = [], t.translated = b(d.toPixels(z(t.value, e), !0) || 0, 0, p);
                    }), i && !this.showLine && i.hide(), t && t.hide(), "y" === n && r.length < o.len) for (let t of r){
                        let { plotX: e, plotY: i, zone: r } = t, o = r && s[s.indexOf(r) - 1];
                        r && g(r, e, i), o && g(o, e, i);
                    }
                    let f = [], m = d.toPixels(d.getExtremes().min, !0);
                    s.forEach((e)=>{
                        let s = e.lineClip || [], r = Math.round(e.translated || 0);
                        o.reversed && s.reverse();
                        let { clip: n, simpleClip: d } = e, p = 0, g = 0, x = o.len, y = a.len;
                        c ? (p = r, x = m) : (g = r, y = m);
                        let b = [
                            [
                                "M",
                                p,
                                g
                            ],
                            [
                                "L",
                                x,
                                g
                            ],
                            [
                                "L",
                                x,
                                y
                            ],
                            [
                                "L",
                                p,
                                y
                            ],
                            [
                                "Z"
                            ]
                        ], v = [
                            b[0],
                            ...s,
                            b[1],
                            b[2],
                            ...f,
                            b[3],
                            b[4]
                        ];
                        f = s.reverse(), m = r, h && (u(v), t && u(b)), n ? (n.animate({
                            d: v
                        }), d?.animate({
                            d: b
                        })) : (n = e.clip = l.path(v), t && (d = e.simpleClip = l.path(b))), i && e.graph?.clip(n), t && e.area?.clip(d);
                    });
                } else this.visible && (i && i.show(), t && t.show());
            }
            plotGroup(t, e, i, s, r) {
                let o = this[t], a = !o, n = {
                    visibility: i,
                    zIndex: s || .1
                };
                return S(this.opacity) && !this.chart.styledMode && "inactive" !== this.state && (n.opacity = this.opacity), o || (this[t] = o = this.chart.renderer.g().add(r)), o.addClass("highcharts-" + e + " highcharts-series-" + this.index + " highcharts-" + this.type + "-series " + (S(this.colorIndex) ? "highcharts-color-" + this.colorIndex + " " : "") + (this.options.className || "") + (o.hasClass("highcharts-tracker") ? " highcharts-tracker" : ""), !0), o.attr(n)[a ? "attr" : "animate"](this.getPlotBox(e)), o;
            }
            getPlotBox(t) {
                let e = this.xAxis, i = this.yAxis, s = this.chart, r = s.inverted && !s.polar && e && this.invertible && "series" === t;
                return s.inverted && (e = i, i = this.xAxis), {
                    translateX: e ? e.left : s.plotLeft,
                    translateY: i ? i.top : s.plotTop,
                    rotation: r ? 90 : 0,
                    rotationOriginX: r ? (e.len - i.len) / 2 : 0,
                    rotationOriginY: r ? (e.len + i.len) / 2 : 0,
                    scaleX: r ? -1 : 1,
                    scaleY: 1
                };
            }
            removeEvents(t) {
                let { eventsToUnbind: e } = this;
                t || N(this), e.length && (e.forEach((t)=>{
                    t();
                }), e.length = 0);
            }
            render() {
                let t = this, { chart: e, options: i, hasRendered: s } = t, r = d(i.animation), o = t.visible ? "inherit" : "hidden", a = i.zIndex, n = e.seriesGroup, h = t.finishedAnimating ? 0 : r.duration;
                P(this, "render"), t.plotGroup("group", "series", o, a, n), t.markerGroup = t.plotGroup("markerGroup", "markers", o, a, n), !1 !== i.clip && t.setClip(), h && t.animate?.(!0), t.drawGraph && (t.drawGraph(), t.applyZones()), t.visible && t.drawPoints(), t.drawDataLabels?.(), t.redrawPoints?.(), i.enableMouseTracking && t.drawTracker?.(), h && t.animate?.(), s || (h && r.defer && (h += r.defer), t.animationTimeout = G(()=>{
                    t.afterAnimate();
                }, h || 0)), t.isDirty = !1, t.hasRendered = !0, P(t, "afterRender");
            }
            redraw() {
                let t = this.isDirty || this.isDirtyData;
                this.translate(), this.render(), t && delete this.kdTree;
            }
            reserveSpace() {
                return this.visible || !this.chart.options.chart.ignoreHiddenSeries;
            }
            searchPoint(t, e) {
                let { xAxis: i, yAxis: s } = this, r = this.chart.inverted;
                return this.searchKDTree({
                    clientX: r ? i.len - t.chartY + i.pos : t.chartX - i.pos,
                    plotY: r ? s.len - t.chartX + s.pos : t.chartY - s.pos
                }, e, t);
            }
            buildKDTree(t) {
                this.buildingKdTree = !0;
                let e = this, i = e.options.findNearestPointBy.indexOf("y") > -1 ? 2 : 1;
                delete e.kdTree, G(function() {
                    e.kdTree = function t(i, s, r) {
                        let o, a;
                        let n = i?.length;
                        if (n) return o = e.kdAxisArray[s % r], i.sort((t, e)=>(t[o] || 0) - (e[o] || 0)), {
                            point: i[a = Math.floor(n / 2)],
                            left: t(i.slice(0, a), s + 1, r),
                            right: t(i.slice(a + 1), s + 1, r)
                        };
                    }(e.getValidPoints(void 0, !e.directTouch), i, i), e.buildingKdTree = !1;
                }, e.options.kdNow || t?.type === "touchstart" ? 0 : 1);
            }
            searchKDTree(t, e, i) {
                let s = this, [r, o] = this.kdAxisArray, a = e ? "distX" : "dist", n = (s.options.findNearestPointBy || "").indexOf("y") > -1 ? 2 : 1, h = !!s.isBubble;
                if (this.kdTree || this.buildingKdTree || this.buildKDTree(i), this.kdTree) return function t(e, i, n, l) {
                    let d = i.point, c = s.kdAxisArray[n % l], p, u, g = d;
                    !function(t, e) {
                        let i = t[r], s = e[r], a = S(i) && S(s) ? i - s : null, n = t[o], l = e[o], d = S(n) && S(l) ? n - l : 0, c = h && e.marker?.radius || 0;
                        e.dist = Math.sqrt((a && a * a || 0) + d * d) - c, e.distX = S(a) ? Math.abs(a) - c : Number.MAX_VALUE;
                    }(e, d);
                    let f = (e[c] || 0) - (d[c] || 0) + (h && d.marker?.radius || 0), m = f < 0 ? "left" : "right", x = f < 0 ? "right" : "left";
                    return i[m] && (g = (p = t(e, i[m], n + 1, l))[a] < g[a] ? p : d), i[x] && Math.sqrt(f * f) < g[a] && (g = (u = t(e, i[x], n + 1, l))[a] < g[a] ? u : g), g;
                }(t, this.kdTree, n, n);
            }
            pointPlacementToXValue() {
                let { options: t, xAxis: e } = this, i = t.pointPlacement;
                return "between" === i && (i = e.reversed ? -0.5 : .5), I(i) ? i * (t.pointRange || e.pointRange) : 0;
            }
            isPointInside(t) {
                let { chart: e, xAxis: i, yAxis: s } = this, { plotX: r = -1, plotY: o = -1 } = t;
                return o >= 0 && o <= (s ? s.len : e.plotHeight) && r >= 0 && r <= (i ? i.len : e.plotWidth);
            }
            drawTracker() {
                let t = this, e = t.options, i = e.trackByArea, s = [].concat((i ? t.areaPath : t.graphPath) || []), r = t.chart, o = r.pointer, a = r.renderer, n = r.options.tooltip?.snap || 0, h = ()=>{
                    e.enableMouseTracking && r.hoverSeries !== t && t.onMouseOver();
                }, l = "rgba(192,192,192," + (g ? 1e-4 : .002) + ")", d = t.tracker;
                d ? d.attr({
                    d: s
                }) : t.graph && (t.tracker = d = a.path(s).attr({
                    visibility: t.visible ? "inherit" : "hidden",
                    zIndex: 2
                }).addClass(i ? "highcharts-tracker-area" : "highcharts-tracker-line").add(t.group), r.styledMode || d.attr({
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    stroke: l,
                    fill: i ? l : "none",
                    "stroke-width": t.graph.strokeWidth() + (i ? 0 : 2 * n)
                }), [
                    t.tracker,
                    t.markerGroup,
                    t.dataLabelsGroup
                ].forEach((t)=>{
                    t && (t.addClass("highcharts-tracker").on("mouseover", h).on("mouseout", (t)=>{
                        o?.onTrackerMouseOut(t);
                    }), e.cursor && !r.styledMode && t.css({
                        cursor: e.cursor
                    }), t.on("touchstart", h));
                })), P(this, "afterDrawTracker");
            }
            addPoint(t, e, i, s, r) {
                let o, a;
                let n = this.options, h = this.data, l = this.chart, d = this.xAxis, c = d && d.hasNames && d.names, p = n.data, u = this.xData;
                e = z(e, !0);
                let g = {
                    series: this
                };
                this.pointClass.prototype.applyOptions.apply(g, [
                    t
                ]);
                let f = g.x;
                if (a = u.length, this.requireSorting && f < u[a - 1]) for(o = !0; a && u[a - 1] > f;)a--;
                this.updateParallelArrays(g, "splice", [
                    a,
                    0,
                    0
                ]), this.updateParallelArrays(g, a), c && g.name && (c[f] = g.name), p.splice(a, 0, t), (o || this.processedData) && (this.data.splice(a, 0, null), this.processData()), "point" === n.legendType && this.generatePoints(), i && (h[0] && h[0].remove ? h[0].remove(!1) : (h.shift(), this.updateParallelArrays(g, "shift"), p.shift())), !1 !== r && P(this, "addPoint", {
                    point: g
                }), this.isDirty = !0, this.isDirtyData = !0, e && l.redraw(s);
            }
            removePoint(t, e, i) {
                let s = this, r = s.data, o = r[t], a = s.points, n = s.chart, h = function() {
                    a && a.length === r.length && a.splice(t, 1), r.splice(t, 1), s.options.data.splice(t, 1), s.updateParallelArrays(o || {
                        series: s
                    }, "splice", [
                        t,
                        1
                    ]), o && o.destroy(), s.isDirty = !0, s.isDirtyData = !0, e && n.redraw();
                };
                c(i, n), e = z(e, !0), o ? o.firePointEvent("remove", null, h) : h();
            }
            remove(t, e, i, s) {
                let r = this, o = r.chart;
                function a() {
                    r.destroy(s), o.isDirtyLegend = o.isDirtyBox = !0, o.linkSeries(s), z(t, !0) && o.redraw(e);
                }
                !1 !== i ? P(r, "remove", null, a) : a();
            }
            update(t, e) {
                P(this, "update", {
                    options: t = C(t, this.userOptions)
                });
                let i = this, s = i.chart, r = i.userOptions, o = i.initialType || i.type, a = s.options.plotOptions, n = m[o].prototype, h = i.finishedAnimating && {
                    animation: !1
                }, l = {}, d, c, p = [
                    "colorIndex",
                    "eventOptions",
                    "navigatorSeries",
                    "symbolIndex",
                    "baseSeries"
                ], u = t.type || r.type || s.options.chart.type, g = !(this.hasDerivedData || u && u !== this.type || void 0 !== t.pointStart || void 0 !== t.pointInterval || void 0 !== t.relativeXValue || t.joinBy || t.mapData || [
                    "dataGrouping",
                    "pointStart",
                    "pointInterval",
                    "pointIntervalUnit",
                    "keys"
                ].some((t)=>i.hasOptionChanged(t)));
                u = u || o, g && (p.push("data", "isDirtyData", "isDirtyCanvas", "points", "processedData", "processedXData", "processedYData", "xIncrement", "cropped", "_hasPointMarkers", "hasDataLabels", "nodes", "layout", "level", "mapMap", "mapData", "minY", "maxY", "minX", "maxX", "transformGroups"), !1 !== t.visible && p.push("area", "graph"), i.parallelArrays.forEach(function(t) {
                    p.push(t + "Data");
                }), t.data && (t.dataSorting && T(i.options.dataSorting, t.dataSorting), this.setData(t.data, !1))), t = B(r, {
                    index: void 0 === r.index ? i.index : r.index,
                    pointStart: a?.series?.pointStart ?? r.pointStart ?? i.xData?.[0]
                }, !g && {
                    data: i.options.data
                }, t, h), g && t.data && (t.data = i.options.data), (p = [
                    "group",
                    "markerGroup",
                    "dataLabelsGroup",
                    "transformGroup"
                ].concat(p)).forEach(function(t) {
                    p[t] = i[t], delete i[t];
                });
                let f = !1;
                if (m[u]) {
                    if (f = u !== i.type, i.remove(!1, !1, !1, !0), f) {
                        if (s.propFromSeries(), Object.setPrototypeOf) Object.setPrototypeOf(i, m[u].prototype);
                        else {
                            let t = Object.hasOwnProperty.call(i, "hcEvents") && i.hcEvents;
                            for(c in n)i[c] = void 0;
                            T(i, m[u].prototype), t ? i.hcEvents = t : delete i.hcEvents;
                        }
                    }
                } else w(17, !0, s, {
                    missingModuleFor: u
                });
                if (p.forEach(function(t) {
                    i[t] = p[t];
                }), i.init(s, t), g && this.points) for (let t of (!1 === (d = i.options).visible ? (l.graphic = 1, l.dataLabel = 1) : (this.hasMarkerChanged(d, r) && (l.graphic = 1), i.hasDataLabels?.() || (l.dataLabel = 1)), this.points))t && t.series && (t.resolveColor(), Object.keys(l).length && t.destroyElements(l), !1 === d.showInLegend && t.legendItem && s.legend.destroyItem(t));
                i.initialType = o, s.linkSeries(), s.setSortedData(), f && i.linkedSeries.length && (i.isDirtyData = !0), P(this, "afterUpdate"), z(e, !0) && s.redraw(!!g && void 0);
            }
            setName(t) {
                this.name = this.options.name = this.userOptions.name = t, this.chart.isDirtyLegend = !0;
            }
            hasOptionChanged(t) {
                let e = this.chart, i = this.options[t], s = e.options.plotOptions, r = this.userOptions[t], o = z(s?.[this.type]?.[t], s?.series?.[t]);
                return r && !S(o) ? i !== r : i !== z(o, i);
            }
            onMouseOver() {
                let t = this.chart, e = t.hoverSeries, i = t.pointer;
                i?.setHoverChartIndex(), e && e !== this && e.onMouseOut(), this.options.events.mouseOver && P(this, "mouseOver"), this.setState("hover"), t.hoverSeries = this;
            }
            onMouseOut() {
                let t = this.options, e = this.chart, i = e.tooltip, s = e.hoverPoint;
                e.hoverSeries = null, s && s.onMouseOut(), this && t.events.mouseOut && P(this, "mouseOut"), i && !this.stickyTracking && (!i.shared || this.noSharedTooltip) && i.hide(), e.series.forEach(function(t) {
                    t.setState("", !0);
                });
            }
            setState(t, e) {
                let i = this, s = i.options, r = i.graph, o = s.inactiveOtherPoints, a = s.states, n = z(a[t || "normal"] && a[t || "normal"].animation, i.chart.options.chart.animation), h = s.lineWidth, l = s.opacity;
                if (t = t || "", i.state !== t && ([
                    i.group,
                    i.markerGroup,
                    i.dataLabelsGroup
                ].forEach(function(e) {
                    e && (i.state && e.removeClass("highcharts-series-" + i.state), t && e.addClass("highcharts-series-" + t));
                }), i.state = t, !i.chart.styledMode)) {
                    if (a[t] && !1 === a[t].enabled) return;
                    if (t && (h = a[t].lineWidth || h + (a[t].lineWidthPlus || 0), l = z(a[t].opacity, l)), r && !r.dashstyle && I(h)) for (let t of [
                        r,
                        ...this.zones.map((t)=>t.graph)
                    ])t?.animate({
                        "stroke-width": h
                    }, n);
                    o || [
                        i.group,
                        i.markerGroup,
                        i.dataLabelsGroup,
                        i.labelBySeries
                    ].forEach(function(t) {
                        t && t.animate({
                            opacity: l
                        }, n);
                    });
                }
                e && o && i.points && i.setAllPointsToState(t || void 0);
            }
            setAllPointsToState(t) {
                this.points.forEach(function(e) {
                    e.setState && e.setState(t);
                });
            }
            setVisible(t, e) {
                let i = this, s = i.chart, r = s.options.chart.ignoreHiddenSeries, o = i.visible;
                i.visible = t = i.options.visible = i.userOptions.visible = void 0 === t ? !o : t;
                let a = t ? "show" : "hide";
                [
                    "group",
                    "dataLabelsGroup",
                    "markerGroup",
                    "tracker",
                    "tt"
                ].forEach((t)=>{
                    i[t]?.[a]();
                }), (s.hoverSeries === i || s.hoverPoint?.series === i) && i.onMouseOut(), i.legendItem && s.legend.colorizeItem(i, t), i.isDirty = !0, i.options.stacking && s.series.forEach((t)=>{
                    t.options.stacking && t.visible && (t.isDirty = !0);
                }), i.linkedSeries.forEach((e)=>{
                    e.setVisible(t, !1);
                }), r && (s.isDirtyBox = !0), P(i, a), !1 !== e && s.redraw();
            }
            show() {
                this.setVisible(!0);
            }
            hide() {
                this.setVisible(!1);
            }
            select(t) {
                this.selected = t = this.options.selected = void 0 === t ? !this.selected : t, this.checkbox && (this.checkbox.checked = t), P(this, t ? "select" : "unselect");
            }
            shouldShowTooltip(t, e, i = {}) {
                return i.series = this, i.visiblePlotOnly = !0, this.chart.isInsidePlot(t, e, i);
            }
            drawLegendSymbol(t, e) {
                r[this.options.legendSymbol || "rectangle"]?.call(this, t, e);
            }
        }
        return H.defaultOptions = a, H.types = n.seriesTypes, H.registerType = n.registerSeriesType, T(H.prototype, {
            axisTypes: [
                "xAxis",
                "yAxis"
            ],
            coll: "series",
            colorCounter: 0,
            directTouch: !1,
            invertible: !0,
            isCartesian: !0,
            kdAxisArray: [
                "clientX",
                "plotY"
            ],
            parallelArrays: [
                "x",
                "y"
            ],
            pointClass: o,
            requireSorting: !0,
            sorted: !0
        }), n.series = H, H;
    }), i(e, "Core/Chart/Chart.js", [
        e["Core/Animation/AnimationUtilities.js"],
        e["Core/Axis/Axis.js"],
        e["Core/Defaults.js"],
        e["Core/Templating.js"],
        e["Core/Foundation.js"],
        e["Core/Globals.js"],
        e["Core/Renderer/RendererRegistry.js"],
        e["Core/Series/Series.js"],
        e["Core/Series/SeriesRegistry.js"],
        e["Core/Renderer/SVG/SVGRenderer.js"],
        e["Core/Time.js"],
        e["Core/Utilities.js"],
        e["Core/Renderer/HTML/AST.js"],
        e["Core/Axis/Tick.js"]
    ], function(t, e, i, s, r, o, a, n, h, l, d, c, p, u) {
        let { animate: g, animObject: f, setAnimation: m } = t, { defaultOptions: x, defaultTime: y } = i, { numberFormat: b } = s, { registerEventOptions: v } = r, { charts: S, doc: k, marginNames: C, svg: M, win: w } = o, { seriesTypes: T } = h, { addEvent: A, attr: P, createElement: L, css: O, defined: D, diffObjects: E, discardElement: I, erase: j, error: B, extend: R, find: z, fireEvent: N, getStyle: W, isArray: G, isNumber: H, isObject: X, isString: F, merge: Y, objectEach: U, pick: V, pInt: $, relativeLength: Z, removeEvent: _, splat: q, syncTimeout: K, uniqueKey: J } = c;
        class Q {
            static chart(t, e, i) {
                return new Q(t, e, i);
            }
            constructor(t, e, i){
                this.sharedClips = {};
                let s = [
                    ...arguments
                ];
                (F(t) || t.nodeName) && (this.renderTo = s.shift()), this.init(s[0], s[1]);
            }
            setZoomOptions() {
                let t = this.options.chart, e = t.zooming;
                this.zooming = {
                    ...e,
                    type: V(t.zoomType, e.type),
                    key: V(t.zoomKey, e.key),
                    pinchType: V(t.pinchType, e.pinchType),
                    singleTouch: V(t.zoomBySingleTouch, e.singleTouch, !1),
                    resetButton: Y(e.resetButton, t.resetZoomButton)
                };
            }
            init(t, e) {
                N(this, "init", {
                    args: arguments
                }, function() {
                    let i = Y(x, t), s = i.chart;
                    this.userOptions = R({}, t), this.margin = [], this.spacing = [], this.labelCollectors = [], this.callback = e, this.isResizing = 0, this.options = i, this.axes = [], this.series = [], this.time = t.time && Object.keys(t.time).length ? new d(t.time) : o.time, this.numberFormatter = s.numberFormatter || b, this.styledMode = s.styledMode, this.hasCartesianSeries = s.showAxes, this.index = S.length, S.push(this), o.chartCount++, v(this, s), this.xAxis = [], this.yAxis = [], this.pointCount = this.colorCounter = this.symbolCounter = 0, this.setZoomOptions(), N(this, "afterInit"), this.firstRender();
                });
            }
            initSeries(t) {
                let e = this.options.chart, i = t.type || e.type, s = T[i];
                s || B(17, !0, this, {
                    missingModuleFor: i
                });
                let r = new s;
                return "function" == typeof r.init && r.init(this, t), r;
            }
            setSortedData() {
                this.getSeriesOrderByLinks().forEach(function(t) {
                    t.points || t.data || !t.enabledDataSorting || t.setData(t.options.data, !1);
                });
            }
            getSeriesOrderByLinks() {
                return this.series.concat().sort(function(t, e) {
                    return t.linkedSeries.length || e.linkedSeries.length ? e.linkedSeries.length - t.linkedSeries.length : 0;
                });
            }
            orderItems(t, e = 0) {
                let i = this[t], s = this.options[t] = q(this.options[t]).slice(), r = this.userOptions[t] = this.userOptions[t] ? q(this.userOptions[t]).slice() : [];
                if (this.hasRendered && (s.splice(e), r.splice(e)), i) for(let t = e, o = i.length; t < o; ++t){
                    let e = i[t];
                    e && (e.index = t, e instanceof n && (e.name = e.getName()), e.options.isInternal || (s[t] = e.options, r[t] = e.userOptions));
                }
            }
            isInsidePlot(t, e, i = {}) {
                let { inverted: s, plotBox: r, plotLeft: o, plotTop: a, scrollablePlotBox: n } = this, { scrollLeft: h = 0, scrollTop: l = 0 } = i.visiblePlotOnly && this.scrollablePlotArea?.scrollingContainer || {}, d = i.series, c = i.visiblePlotOnly && n || r, p = i.inverted ? e : t, u = i.inverted ? t : e, g = {
                    x: p,
                    y: u,
                    isInsidePlot: !0,
                    options: i
                };
                if (!i.ignoreX) {
                    let t = d && (s && !this.polar ? d.yAxis : d.xAxis) || {
                        pos: o,
                        len: 1 / 0
                    }, e = i.paneCoordinates ? t.pos + p : o + p;
                    e >= Math.max(h + o, t.pos) && e <= Math.min(h + o + c.width, t.pos + t.len) || (g.isInsidePlot = !1);
                }
                if (!i.ignoreY && g.isInsidePlot) {
                    let t = !s && i.axis && !i.axis.isXAxis && i.axis || d && (s ? d.xAxis : d.yAxis) || {
                        pos: a,
                        len: 1 / 0
                    }, e = i.paneCoordinates ? t.pos + u : a + u;
                    e >= Math.max(l + a, t.pos) && e <= Math.min(l + a + c.height, t.pos + t.len) || (g.isInsidePlot = !1);
                }
                return N(this, "afterIsInsidePlot", g), g.isInsidePlot;
            }
            redraw(t) {
                N(this, "beforeRedraw");
                let e = this.hasCartesianSeries ? this.axes : this.colorAxis || [], i = this.series, s = this.pointer, r = this.legend, o = this.userOptions.legend, a = this.renderer, n = a.isHidden(), h = [], l, d, c, p = this.isDirtyBox, u = this.isDirtyLegend, g;
                for(a.rootFontSize = a.boxWrapper.getStyle("font-size"), this.setResponsive && this.setResponsive(!1), m(!!this.hasRendered && t, this), n && this.temporaryDisplay(), this.layOutTitles(!1), c = i.length; c--;)if (((g = i[c]).options.stacking || g.options.centerInCategory) && (d = !0, g.isDirty)) {
                    l = !0;
                    break;
                }
                if (l) for(c = i.length; c--;)(g = i[c]).options.stacking && (g.isDirty = !0);
                i.forEach(function(t) {
                    t.isDirty && ("point" === t.options.legendType ? ("function" == typeof t.updateTotals && t.updateTotals(), u = !0) : o && (o.labelFormatter || o.labelFormat) && (u = !0)), t.isDirtyData && N(t, "updatedData");
                }), u && r && r.options.enabled && (r.render(), this.isDirtyLegend = !1), d && this.getStacks(), e.forEach(function(t) {
                    t.updateNames(), t.setScale();
                }), this.getMargins(), e.forEach(function(t) {
                    t.isDirty && (p = !0);
                }), e.forEach(function(t) {
                    let e = t.min + "," + t.max;
                    t.extKey !== e && (t.extKey = e, h.push(function() {
                        N(t, "afterSetExtremes", R(t.eventArgs, t.getExtremes())), delete t.eventArgs;
                    })), (p || d) && t.redraw();
                }), p && this.drawChartBox(), N(this, "predraw"), i.forEach(function(t) {
                    (p || t.isDirty) && t.visible && t.redraw(), t.isDirtyData = !1;
                }), s && s.reset(!0), a.draw(), N(this, "redraw"), N(this, "render"), n && this.temporaryDisplay(!0), h.forEach(function(t) {
                    t.call();
                });
            }
            get(t) {
                let e = this.series;
                function i(e) {
                    return e.id === t || e.options && e.options.id === t;
                }
                let s = z(this.axes, i) || z(this.series, i);
                for(let t = 0; !s && t < e.length; t++)s = z(e[t].points || [], i);
                return s;
            }
            getAxes() {
                let t = this.userOptions;
                for (let i of (N(this, "getAxes"), [
                    "xAxis",
                    "yAxis"
                ]))for (let s of t[i] = q(t[i] || {}))new e(this, s, i);
                N(this, "afterGetAxes");
            }
            getSelectedPoints() {
                return this.series.reduce((t, e)=>(e.getPointsCollection().forEach((e)=>{
                        V(e.selectedStaging, e.selected) && t.push(e);
                    }), t), []);
            }
            getSelectedSeries() {
                return this.series.filter(function(t) {
                    return t.selected;
                });
            }
            setTitle(t, e, i) {
                this.applyDescription("title", t), this.applyDescription("subtitle", e), this.applyDescription("caption", void 0), this.layOutTitles(i);
            }
            applyDescription(t, e) {
                let i = this, s = this.options[t] = Y(this.options[t], e), r = this[t];
                r && e && (this[t] = r = r.destroy()), s && !r && ((r = this.renderer.text(s.text, 0, 0, s.useHTML).attr({
                    align: s.align,
                    class: "highcharts-" + t,
                    zIndex: s.zIndex || 4
                }).add()).update = function(e, s) {
                    i.applyDescription(t, e), i.layOutTitles(s);
                }, this.styledMode || r.css(R("title" === t ? {
                    fontSize: this.options.isStock ? "1em" : "1.2em"
                } : {}, s.style)), this[t] = r);
            }
            layOutTitles(t = !0) {
                let e = [
                    0,
                    0,
                    0
                ], i = this.renderer, s = this.spacingBox;
                [
                    "title",
                    "subtitle",
                    "caption"
                ].forEach(function(t) {
                    let r = this[t], o = this.options[t], a = o.verticalAlign || "top", n = "title" === t ? "top" === a ? -3 : 0 : "top" === a ? e[0] + 2 : 0;
                    if (r) {
                        r.css({
                            width: (o.width || s.width + (o.widthAdjust || 0)) + "px"
                        });
                        let t = i.fontMetrics(r).b, h = Math.round(r.getBBox(o.useHTML).height);
                        r.align(R({
                            y: "bottom" === a ? t : n + t,
                            height: h
                        }, o), !1, "spacingBox"), o.floating || ("top" === a ? e[0] = Math.ceil(e[0] + h) : "bottom" === a && (e[2] = Math.ceil(e[2] + h)));
                    }
                }, this), e[0] && "top" === (this.options.title.verticalAlign || "top") && (e[0] += this.options.title.margin), e[2] && "bottom" === this.options.caption.verticalAlign && (e[2] += this.options.caption.margin);
                let r = !this.titleOffset || this.titleOffset.join(",") !== e.join(",");
                this.titleOffset = e, N(this, "afterLayOutTitles"), !this.isDirtyBox && r && (this.isDirtyBox = this.isDirtyLegend = r, this.hasRendered && t && this.isDirtyBox && this.redraw());
            }
            getContainerBox() {
                return {
                    width: W(this.renderTo, "width", !0) || 0,
                    height: W(this.renderTo, "height", !0) || 0
                };
            }
            getChartSize() {
                let t = this.options.chart, e = t.width, i = t.height, s = this.getContainerBox();
                this.chartWidth = Math.max(0, e || s.width || 600), this.chartHeight = Math.max(0, Z(i, this.chartWidth) || (s.height > 1 ? s.height : 400)), this.containerBox = s;
            }
            temporaryDisplay(t) {
                let e = this.renderTo, i;
                if (t) for(; e && e.style;)e.hcOrigStyle && (O(e, e.hcOrigStyle), delete e.hcOrigStyle), e.hcOrigDetached && (k.body.removeChild(e), e.hcOrigDetached = !1), e = e.parentNode;
                else for(; e && e.style && (k.body.contains(e) || e.parentNode || (e.hcOrigDetached = !0, k.body.appendChild(e)), ("none" === W(e, "display", !1) || e.hcOricDetached) && (e.hcOrigStyle = {
                    display: e.style.display,
                    height: e.style.height,
                    overflow: e.style.overflow
                }, i = {
                    display: "block",
                    overflow: "hidden"
                }, e !== this.renderTo && (i.height = 0), O(e, i), e.offsetWidth || e.style.setProperty("display", "block", "important")), (e = e.parentNode) !== k.body););
            }
            setClassName(t) {
                this.container.className = "highcharts-container " + (t || "");
            }
            getContainer() {
                let t = this.options, e = t.chart, i = "data-highcharts-chart", s = J(), r, o = this.renderTo;
                o || (this.renderTo = o = e.renderTo), F(o) && (this.renderTo = o = k.getElementById(o)), o || B(13, !0, this);
                let n = $(P(o, i));
                H(n) && S[n] && S[n].hasRendered && S[n].destroy(), P(o, i, this.index), o.innerHTML = p.emptyHTML, e.skipClone || o.offsetWidth || this.temporaryDisplay(), this.getChartSize();
                let h = this.chartHeight, d = this.chartWidth;
                O(o, {
                    overflow: "hidden"
                }), this.styledMode || (r = R({
                    position: "relative",
                    overflow: "hidden",
                    width: d + "px",
                    height: h + "px",
                    textAlign: "left",
                    lineHeight: "normal",
                    zIndex: 0,
                    "-webkit-tap-highlight-color": "rgba(0,0,0,0)",
                    userSelect: "none",
                    "touch-action": "manipulation",
                    outline: "none"
                }, e.style || {}));
                let c = L("div", {
                    id: s
                }, r, o);
                this.container = c, this.getChartSize(), d === this.chartWidth || (d = this.chartWidth, this.styledMode || O(c, {
                    width: V(e.style?.width, d + "px")
                })), this.containerBox = this.getContainerBox(), this._cursor = c.style.cursor;
                let u = e.renderer || !M ? a.getRendererType(e.renderer) : l;
                if (this.renderer = new u(c, d, h, void 0, e.forExport, t.exporting && t.exporting.allowHTML, this.styledMode), m(void 0, this), this.setClassName(e.className), this.styledMode) for(let e in t.defs)this.renderer.definition(t.defs[e]);
                else this.renderer.setStyle(e.style);
                this.renderer.chartIndex = this.index, N(this, "afterGetContainer");
            }
            getMargins(t) {
                let { spacing: e, margin: i, titleOffset: s } = this;
                this.resetMargins(), s[0] && !D(i[0]) && (this.plotTop = Math.max(this.plotTop, s[0] + e[0])), s[2] && !D(i[2]) && (this.marginBottom = Math.max(this.marginBottom, s[2] + e[2])), this.legend && this.legend.display && this.legend.adjustMargins(i, e), N(this, "getMargins"), t || this.getAxisMargins();
            }
            getAxisMargins() {
                let t = this, e = t.axisOffset = [
                    0,
                    0,
                    0,
                    0
                ], i = t.colorAxis, s = t.margin, r = function(t) {
                    t.forEach(function(t) {
                        t.visible && t.getOffset();
                    });
                };
                t.hasCartesianSeries ? r(t.axes) : i && i.length && r(i), C.forEach(function(i, r) {
                    D(s[r]) || (t[i] += e[r]);
                }), t.setChartSize();
            }
            getOptions() {
                return E(this.userOptions, x);
            }
            reflow(t) {
                let e = this, i = e.containerBox, s = e.getContainerBox();
                delete e.pointer?.chartPosition, !e.isPrinting && !e.isResizing && i && s.width && ((s.width !== i.width || s.height !== i.height) && (c.clearTimeout(e.reflowTimeout), e.reflowTimeout = K(function() {
                    e.container && e.setSize(void 0, void 0, !1);
                }, t ? 100 : 0)), e.containerBox = s);
            }
            setReflow() {
                let t = this, e = (e)=>{
                    t.options?.chart.reflow && t.hasLoaded && t.reflow(e);
                };
                if ("function" == typeof ResizeObserver) new ResizeObserver(e).observe(t.renderTo);
                else {
                    let t = A(w, "resize", e);
                    A(this, "destroy", t);
                }
            }
            setSize(t, e, i) {
                let s = this, r = s.renderer;
                s.isResizing += 1, m(i, s);
                let o = r.globalAnimation;
                s.oldChartHeight = s.chartHeight, s.oldChartWidth = s.chartWidth, void 0 !== t && (s.options.chart.width = t), void 0 !== e && (s.options.chart.height = e), s.getChartSize();
                let { chartWidth: a, chartHeight: n, scrollablePixelsX: h = 0, scrollablePixelsY: l = 0 } = s;
                (s.isDirtyBox || a !== s.oldChartWidth || n !== s.oldChartHeight) && (s.styledMode || (o ? g : O)(s.container, {
                    width: `${a + h}px`,
                    height: `${n + l}px`
                }, o), s.setChartSize(!0), r.setSize(a, n, o), s.axes.forEach(function(t) {
                    t.isDirty = !0, t.setScale();
                }), s.isDirtyLegend = !0, s.isDirtyBox = !0, s.layOutTitles(), s.getMargins(), s.redraw(o), s.oldChartHeight = void 0, N(s, "resize"), setTimeout(()=>{
                    s && N(s, "endResize", void 0, ()=>{
                        s.isResizing -= 1;
                    });
                }, f(o).duration));
            }
            setChartSize(t) {
                let e, i, s, r;
                let o = this.inverted, a = this.renderer, n = this.chartWidth, h = this.chartHeight, l = this.options.chart, d = this.spacing, c = this.clipOffset;
                this.plotLeft = e = Math.round(this.plotLeft), this.plotTop = i = Math.round(this.plotTop), this.plotWidth = s = Math.max(0, Math.round(n - e - this.marginRight)), this.plotHeight = r = Math.max(0, Math.round(h - i - this.marginBottom)), this.plotSizeX = o ? r : s, this.plotSizeY = o ? s : r, this.plotBorderWidth = l.plotBorderWidth || 0, this.spacingBox = a.spacingBox = {
                    x: d[3],
                    y: d[0],
                    width: n - d[3] - d[1],
                    height: h - d[0] - d[2]
                }, this.plotBox = a.plotBox = {
                    x: e,
                    y: i,
                    width: s,
                    height: r
                };
                let p = 2 * Math.floor(this.plotBorderWidth / 2), u = Math.ceil(Math.max(p, c[3]) / 2), g = Math.ceil(Math.max(p, c[0]) / 2);
                this.clipBox = {
                    x: u,
                    y: g,
                    width: Math.floor(this.plotSizeX - Math.max(p, c[1]) / 2 - u),
                    height: Math.max(0, Math.floor(this.plotSizeY - Math.max(p, c[2]) / 2 - g))
                }, t || (this.axes.forEach(function(t) {
                    t.setAxisSize(), t.setAxisTranslation();
                }), a.alignElements()), N(this, "afterSetChartSize", {
                    skipAxes: t
                });
            }
            resetMargins() {
                N(this, "resetMargins");
                let t = this, e = t.options.chart;
                [
                    "margin",
                    "spacing"
                ].forEach(function(i) {
                    let s = e[i], r = X(s) ? s : [
                        s,
                        s,
                        s,
                        s
                    ];
                    [
                        "Top",
                        "Right",
                        "Bottom",
                        "Left"
                    ].forEach(function(s, o) {
                        t[i][o] = V(e[i + s], r[o]);
                    });
                }), C.forEach(function(e, i) {
                    t[e] = V(t.margin[i], t.spacing[i]);
                }), t.axisOffset = [
                    0,
                    0,
                    0,
                    0
                ], t.clipOffset = [
                    0,
                    0,
                    0,
                    0
                ];
            }
            drawChartBox() {
                let t = this.options.chart, e = this.renderer, i = this.chartWidth, s = this.chartHeight, r = this.styledMode, o = this.plotBGImage, a = t.backgroundColor, n = t.plotBackgroundColor, h = t.plotBackgroundImage, l = this.plotLeft, d = this.plotTop, c = this.plotWidth, p = this.plotHeight, u = this.plotBox, g = this.clipRect, f = this.clipBox, m = this.chartBackground, x = this.plotBackground, y = this.plotBorder, b, v, S, k = "animate";
                m || (this.chartBackground = m = e.rect().addClass("highcharts-background").add(), k = "attr"), r ? b = v = m.strokeWidth() : (v = (b = t.borderWidth || 0) + (t.shadow ? 8 : 0), S = {
                    fill: a || "none"
                }, (b || m["stroke-width"]) && (S.stroke = t.borderColor, S["stroke-width"] = b), m.attr(S).shadow(t.shadow)), m[k]({
                    x: v / 2,
                    y: v / 2,
                    width: i - v - b % 2,
                    height: s - v - b % 2,
                    r: t.borderRadius
                }), k = "animate", x || (k = "attr", this.plotBackground = x = e.rect().addClass("highcharts-plot-background").add()), x[k](u), !r && (x.attr({
                    fill: n || "none"
                }).shadow(t.plotShadow), h && (o ? (h !== o.attr("href") && o.attr("href", h), o.animate(u)) : this.plotBGImage = e.image(h, l, d, c, p).add())), g ? g.animate({
                    width: f.width,
                    height: f.height
                }) : this.clipRect = e.clipRect(f), k = "animate", y || (k = "attr", this.plotBorder = y = e.rect().addClass("highcharts-plot-border").attr({
                    zIndex: 1
                }).add()), r || y.attr({
                    stroke: t.plotBorderColor,
                    "stroke-width": t.plotBorderWidth || 0,
                    fill: "none"
                }), y[k](y.crisp({
                    x: l,
                    y: d,
                    width: c,
                    height: p
                }, -y.strokeWidth())), this.isDirtyBox = !1, N(this, "afterDrawChartBox");
            }
            propFromSeries() {
                let t, e, i;
                let s = this, r = s.options.chart, o = s.options.series;
                [
                    "inverted",
                    "angular",
                    "polar"
                ].forEach(function(a) {
                    for(e = T[r.type], i = r[a] || e && e.prototype[a], t = o && o.length; !i && t--;)(e = T[o[t].type]) && e.prototype[a] && (i = !0);
                    s[a] = i;
                });
            }
            linkSeries(t) {
                let e = this, i = e.series;
                i.forEach(function(t) {
                    t.linkedSeries.length = 0;
                }), i.forEach(function(t) {
                    let { linkedTo: i } = t.options;
                    if (F(i)) {
                        let s;
                        (s = ":previous" === i ? e.series[t.index - 1] : e.get(i)) && s.linkedParent !== t && (s.linkedSeries.push(t), t.linkedParent = s, s.enabledDataSorting && t.setDataSortingOptions(), t.visible = V(t.options.visible, s.options.visible, t.visible));
                    }
                }), N(this, "afterLinkSeries", {
                    isUpdating: t
                });
            }
            renderSeries() {
                this.series.forEach(function(t) {
                    t.translate(), t.render();
                });
            }
            render() {
                let t = this.axes, e = this.colorAxis, i = this.renderer, s = this.options.chart.axisLayoutRuns || 2, r = (t)=>{
                    t.forEach((t)=>{
                        t.visible && t.render();
                    });
                }, o = 0, a = !0, n, h = 0;
                for (let e of (this.setTitle(), N(this, "beforeMargins"), this.getStacks?.(), this.getMargins(!0), this.setChartSize(), t)){
                    let { options: t } = e, { labels: i } = t;
                    if (e.horiz && e.visible && i.enabled && e.series.length && "colorAxis" !== e.coll && !this.polar) {
                        o = t.tickLength, e.createGroups();
                        let s = new u(e, 0, "", !0), r = s.createLabel("x", i);
                        if (s.destroy(), r && V(i.reserveSpace, !H(t.crossing)) && (o = r.getBBox().height + i.distance + Math.max(t.offset || 0, 0)), o) {
                            r?.destroy();
                            break;
                        }
                    }
                }
                for(this.plotHeight = Math.max(this.plotHeight - o, 0); (a || n || s > 1) && h < s;){
                    let e = this.plotWidth, i = this.plotHeight;
                    for (let e of t)0 === h ? e.setScale() : (e.horiz && a || !e.horiz && n) && e.setTickInterval(!0);
                    0 === h ? this.getAxisMargins() : this.getMargins(), a = e / this.plotWidth > (h ? 1 : 1.1), n = i / this.plotHeight > (h ? 1 : 1.05), h++;
                }
                this.drawChartBox(), this.hasCartesianSeries ? r(t) : e && e.length && r(e), this.seriesGroup || (this.seriesGroup = i.g("series-group").attr({
                    zIndex: 3
                }).shadow(this.options.chart.seriesGroupShadow).add()), this.renderSeries(), this.addCredits(), this.setResponsive && this.setResponsive(), this.hasRendered = !0;
            }
            addCredits(t) {
                let e = this, i = Y(!0, this.options.credits, t);
                i.enabled && !this.credits && (this.credits = this.renderer.text(i.text + (this.mapCredits || ""), 0, 0).addClass("highcharts-credits").on("click", function() {
                    i.href && (w.location.href = i.href);
                }).attr({
                    align: i.position.align,
                    zIndex: 8
                }), e.styledMode || this.credits.css(i.style), this.credits.add().align(i.position), this.credits.update = function(t) {
                    e.credits = e.credits.destroy(), e.addCredits(t);
                });
            }
            destroy() {
                let t;
                let e = this, i = e.axes, s = e.series, r = e.container, a = r && r.parentNode;
                for(N(e, "destroy"), e.renderer.forExport ? j(S, e) : S[e.index] = void 0, o.chartCount--, e.renderTo.removeAttribute("data-highcharts-chart"), _(e), t = i.length; t--;)i[t] = i[t].destroy();
                for(this.scroller && this.scroller.destroy && this.scroller.destroy(), t = s.length; t--;)s[t] = s[t].destroy();
                [
                    "title",
                    "subtitle",
                    "chartBackground",
                    "plotBackground",
                    "plotBGImage",
                    "plotBorder",
                    "seriesGroup",
                    "clipRect",
                    "credits",
                    "pointer",
                    "rangeSelector",
                    "legend",
                    "resetZoomButton",
                    "tooltip",
                    "renderer"
                ].forEach(function(t) {
                    let i = e[t];
                    i && i.destroy && (e[t] = i.destroy());
                }), r && (r.innerHTML = p.emptyHTML, _(r), a && I(r)), U(e, function(t, i) {
                    delete e[i];
                });
            }
            firstRender() {
                let t = this, e = t.options;
                t.getContainer(), t.resetMargins(), t.setChartSize(), t.propFromSeries(), t.getAxes();
                let i = G(e.series) ? e.series : [];
                e.series = [], i.forEach(function(e) {
                    t.initSeries(e);
                }), t.linkSeries(), t.setSortedData(), N(t, "beforeRender"), t.render(), t.pointer?.getChartPosition(), t.renderer.imgCount || t.hasLoaded || t.onload(), t.temporaryDisplay(!0);
            }
            onload() {
                this.callbacks.concat([
                    this.callback
                ]).forEach(function(t) {
                    t && void 0 !== this.index && t.apply(this, [
                        this
                    ]);
                }, this), N(this, "load"), N(this, "render"), D(this.index) && this.setReflow(), this.warnIfA11yModuleNotLoaded(), this.hasLoaded = !0;
            }
            warnIfA11yModuleNotLoaded() {
                let { options: t, title: e } = this;
                !t || this.accessibility || (this.renderer.boxWrapper.attr({
                    role: "img",
                    "aria-label": (e && e.element.textContent || "").replace(/</g, "&lt;")
                }), t.accessibility && !1 === t.accessibility.enabled || B('Highcharts warning: Consider including the "accessibility.js" module to make your chart more usable for people with disabilities. Set the "accessibility.enabled" option to false to remove this warning. See https://www.highcharts.com/docs/accessibility/accessibility-module.', !1, this));
            }
            addSeries(t, e, i) {
                let s;
                let r = this;
                return t && (e = V(e, !0), N(r, "addSeries", {
                    options: t
                }, function() {
                    s = r.initSeries(t), r.isDirtyLegend = !0, r.linkSeries(), s.enabledDataSorting && s.setData(t.data, !1), N(r, "afterAddSeries", {
                        series: s
                    }), e && r.redraw(i);
                })), s;
            }
            addAxis(t, e, i, s) {
                return this.createAxis(e ? "xAxis" : "yAxis", {
                    axis: t,
                    redraw: i,
                    animation: s
                });
            }
            addColorAxis(t, e, i) {
                return this.createAxis("colorAxis", {
                    axis: t,
                    redraw: e,
                    animation: i
                });
            }
            createAxis(t, i) {
                let s = new e(this, i.axis, t);
                return V(i.redraw, !0) && this.redraw(i.animation), s;
            }
            showLoading(t) {
                let e = this, i = e.options, s = i.loading, r = function() {
                    o && O(o, {
                        left: e.plotLeft + "px",
                        top: e.plotTop + "px",
                        width: e.plotWidth + "px",
                        height: e.plotHeight + "px"
                    });
                }, o = e.loadingDiv, a = e.loadingSpan;
                o || (e.loadingDiv = o = L("div", {
                    className: "highcharts-loading highcharts-loading-hidden"
                }, null, e.container)), a || (e.loadingSpan = a = L("span", {
                    className: "highcharts-loading-inner"
                }, null, o), A(e, "redraw", r)), o.className = "highcharts-loading", p.setElementHTML(a, V(t, i.lang.loading, "")), e.styledMode || (O(o, R(s.style, {
                    zIndex: 10
                })), O(a, s.labelStyle), e.loadingShown || (O(o, {
                    opacity: 0,
                    display: ""
                }), g(o, {
                    opacity: s.style.opacity || .5
                }, {
                    duration: s.showDuration || 0
                }))), e.loadingShown = !0, r();
            }
            hideLoading() {
                let t = this.options, e = this.loadingDiv;
                e && (e.className = "highcharts-loading highcharts-loading-hidden", this.styledMode || g(e, {
                    opacity: 0
                }, {
                    duration: t.loading.hideDuration || 100,
                    complete: function() {
                        O(e, {
                            display: "none"
                        });
                    }
                })), this.loadingShown = !1;
            }
            update(t, e, i, s) {
                let r, o, a;
                let n = this, h = {
                    credits: "addCredits",
                    title: "setTitle",
                    subtitle: "setSubtitle",
                    caption: "setCaption"
                }, l = t.isResponsiveOptions, c = [];
                N(n, "update", {
                    options: t
                }), l || n.setResponsive(!1, !0), t = E(t, n.options), n.userOptions = Y(n.userOptions, t);
                let p = t.chart;
                p && (Y(!0, n.options.chart, p), this.setZoomOptions(), "className" in p && n.setClassName(p.className), ("inverted" in p || "polar" in p || "type" in p) && (n.propFromSeries(), r = !0), "alignTicks" in p && (r = !0), "events" in p && v(this, p), U(p, function(t, e) {
                    -1 !== n.propsRequireUpdateSeries.indexOf("chart." + e) && (o = !0), -1 !== n.propsRequireDirtyBox.indexOf(e) && (n.isDirtyBox = !0), -1 === n.propsRequireReflow.indexOf(e) || (n.isDirtyBox = !0, l || (a = !0));
                }), !n.styledMode && p.style && n.renderer.setStyle(n.options.chart.style || {})), !n.styledMode && t.colors && (this.options.colors = t.colors), t.time && (this.time === y && (this.time = new d(t.time)), Y(!0, n.options.time, t.time)), U(t, function(e, i) {
                    n[i] && "function" == typeof n[i].update ? n[i].update(e, !1) : "function" == typeof n[h[i]] ? n[h[i]](e) : "colors" !== i && -1 === n.collectionsWithUpdate.indexOf(i) && Y(!0, n.options[i], t[i]), "chart" !== i && -1 !== n.propsRequireUpdateSeries.indexOf(i) && (o = !0);
                }), this.collectionsWithUpdate.forEach(function(e) {
                    t[e] && (q(t[e]).forEach(function(t, s) {
                        let r;
                        let o = D(t.id);
                        o && (r = n.get(t.id)), !r && n[e] && (r = n[e][V(t.index, s)]) && (o && D(r.options.id) || r.options.isInternal) && (r = void 0), r && r.coll === e && (r.update(t, !1), i && (r.touched = !0)), !r && i && n.collectionsWithInit[e] && (n.collectionsWithInit[e][0].apply(n, [
                            t
                        ].concat(n.collectionsWithInit[e][1] || []).concat([
                            !1
                        ])).touched = !0);
                    }), i && n[e].forEach(function(t) {
                        t.touched || t.options.isInternal ? delete t.touched : c.push(t);
                    }));
                }), c.forEach(function(t) {
                    t.chart && t.remove && t.remove(!1);
                }), r && n.axes.forEach(function(t) {
                    t.update({}, !1);
                }), o && n.getSeriesOrderByLinks().forEach(function(t) {
                    t.chart && t.update({}, !1);
                }, this);
                let u = p && p.width, g = p && (F(p.height) ? Z(p.height, u || n.chartWidth) : p.height);
                a || H(u) && u !== n.chartWidth || H(g) && g !== n.chartHeight ? n.setSize(u, g, s) : V(e, !0) && n.redraw(s), N(n, "afterUpdate", {
                    options: t,
                    redraw: e,
                    animation: s
                });
            }
            setSubtitle(t, e) {
                this.applyDescription("subtitle", t), this.layOutTitles(e);
            }
            setCaption(t, e) {
                this.applyDescription("caption", t), this.layOutTitles(e);
            }
            showResetZoom() {
                let t = this, e = x.lang, i = t.zooming.resetButton, s = i.theme, r = "chart" === i.relativeTo || "spacingBox" === i.relativeTo ? null : "plotBox";
                function o() {
                    t.zoomOut();
                }
                N(this, "beforeShowResetZoom", null, function() {
                    t.resetZoomButton = t.renderer.button(e.resetZoom, null, null, o, s).attr({
                        align: i.position.align,
                        title: e.resetZoomTitle
                    }).addClass("highcharts-reset-zoom").add().align(i.position, !1, r);
                }), N(this, "afterShowResetZoom");
            }
            zoomOut() {
                N(this, "selection", {
                    resetSelection: !0
                }, ()=>this.transform({
                        reset: !0,
                        trigger: "zoom"
                    }));
            }
            pan(t, e) {
                let i = this, s = "object" == typeof e ? e : {
                    enabled: e,
                    type: "x"
                }, r = s.type, o = r && i[({
                    x: "xAxis",
                    xy: "axes",
                    y: "yAxis"
                })[r]].filter((t)=>t.options.panningEnabled && !t.options.isInternal), a = i.options.chart;
                a?.panning && (a.panning = s), N(this, "pan", {
                    originalEvent: t
                }, ()=>{
                    i.transform({
                        axes: o,
                        event: t,
                        to: {
                            x: t.chartX - (i.mouseDownX || 0),
                            y: t.chartY - (i.mouseDownY || 0)
                        },
                        trigger: "pan"
                    }), O(i.container, {
                        cursor: "move"
                    });
                });
            }
            transform(t) {
                let { axes: e = this.axes, event: i, from: s = {}, reset: r, selection: o, to: a = {}, trigger: n } = t, { inverted: h, resetZoomButton: l } = this, d = !1, c;
                for (let t of (this.hoverPoints?.forEach((t)=>t.setState()), e)){
                    let { horiz: e, len: l, minPointOffset: p = 0, options: u, reversed: g } = t, f = e ? "width" : "height", m = e ? "x" : "y", x = a[f] || t.len, y = s[f] || t.len, b = 10 > Math.abs(x) ? 1 : x / y, v = (s[m] || 0) + y / 2 - t.pos, S = v - ((a[m] ?? t.pos) + x / 2 - t.pos) / b, k = g && !h || !g && h ? -1 : 1;
                    if (!r && (v < 0 || v > t.len)) continue;
                    let C = t.toValue(S, !0) + p * k, M = t.toValue(S + l / b, !0) - (p * k || 0), w = t.allExtremes;
                    if (C > M && ([C, M] = [
                        M,
                        C
                    ]), 1 === b && !r && "yAxis" === t.coll && !w) {
                        for (let e of t.series){
                            let t = e.getExtremes(e.getProcessedData(!0).yData, !0);
                            w ?? (w = {
                                dataMin: Number.MAX_VALUE,
                                dataMax: -Number.MAX_VALUE
                            }), H(t.dataMin) && H(t.dataMax) && (w.dataMin = Math.min(t.dataMin, w.dataMin), w.dataMax = Math.max(t.dataMax, w.dataMax));
                        }
                        t.allExtremes = w;
                    }
                    let { dataMin: T, dataMax: A, min: P, max: L } = R(t.getExtremes(), w || {}), O = T ?? u.min, E = A ?? u.max, I = M - C, j = t.categories ? 0 : Math.min(I, E - O), B = O - j * (D(u.min) ? 0 : u.minPadding), z = E + j * (D(u.max) ? 0 : u.maxPadding), N = t.allowZoomOutside || 1 === b || "zoom" !== n && b > 1, W = Math.min(u.min ?? B, B, N ? P : B), G = Math.max(u.max ?? z, z, N ? L : z);
                    (!t.isOrdinal || 1 !== b || r) && (C < W && (C = W, b >= 1 && (M = C + I)), M > G && (M = G, b >= 1 && (C = M - I)), (r || t.series.length && (C !== P || M !== L) && C >= W && M <= G) && (o ? o[t.coll].push({
                        axis: t,
                        min: C,
                        max: M
                    }) : (t.isPanning = "zoom" !== n, t.setExtremes(r ? void 0 : C, r ? void 0 : M, !1, !1, {
                        move: S,
                        trigger: n,
                        scale: b
                    }), !r && (C > W || M < G) && "mousewheel" !== n && (c = !0)), d = !0), i && (this[e ? "mouseDownX" : "mouseDownY"] = i[e ? "chartX" : "chartY"]));
                }
                return d && (o ? N(this, "selection", o, ()=>{
                    delete t.selection, t.trigger = "zoom", this.transform(t);
                }) : (c && !l ? this.showResetZoom() : !c && l && (this.resetZoomButton = l.destroy()), this.redraw("zoom" === n && (this.options.chart.animation ?? this.pointCount < 100)))), d;
            }
        }
        return R(Q.prototype, {
            callbacks: [],
            collectionsWithInit: {
                xAxis: [
                    Q.prototype.addAxis,
                    [
                        !0
                    ]
                ],
                yAxis: [
                    Q.prototype.addAxis,
                    [
                        !1
                    ]
                ],
                series: [
                    Q.prototype.addSeries
                ]
            },
            collectionsWithUpdate: [
                "xAxis",
                "yAxis",
                "series"
            ],
            propsRequireDirtyBox: [
                "backgroundColor",
                "borderColor",
                "borderWidth",
                "borderRadius",
                "plotBackgroundColor",
                "plotBackgroundImage",
                "plotBorderColor",
                "plotBorderWidth",
                "plotShadow",
                "shadow"
            ],
            propsRequireReflow: [
                "margin",
                "marginTop",
                "marginRight",
                "marginBottom",
                "marginLeft",
                "spacing",
                "spacingTop",
                "spacingRight",
                "spacingBottom",
                "spacingLeft"
            ],
            propsRequireUpdateSeries: [
                "chart.inverted",
                "chart.polar",
                "chart.ignoreHiddenSeries",
                "chart.type",
                "colors",
                "plotOptions",
                "time",
                "tooltip"
            ]
        }), Q;
    }), i(e, "Extensions/ScrollablePlotArea.js", [
        e["Core/Animation/AnimationUtilities.js"],
        e["Core/Globals.js"],
        e["Core/Renderer/RendererRegistry.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i, s) {
        let { stop: r } = t, { composed: o } = e, { addEvent: a, createElement: n, css: h, defined: l, merge: d, pushUnique: c } = s;
        function p() {
            let t = this.scrollablePlotArea;
            (this.scrollablePixelsX || this.scrollablePixelsY) && !t && (this.scrollablePlotArea = t = new g(this)), t?.applyFixed();
        }
        function u() {
            this.chart.scrollablePlotArea && (this.chart.scrollablePlotArea.isDirty = !0);
        }
        class g {
            static compose(t, e, i) {
                c(o, this.compose) && (a(t, "afterInit", u), a(e, "afterSetChartSize", (t)=>this.afterSetSize(t.target, t)), a(e, "render", p), a(i, "show", u));
            }
            static afterSetSize(t, e) {
                let i, s, r;
                let { minWidth: o, minHeight: a } = t.options.chart.scrollablePlotArea || {}, { clipBox: n, plotBox: h, inverted: c, renderer: p } = t;
                if (!p.forExport && (o ? (t.scrollablePixelsX = i = Math.max(0, o - t.chartWidth), i && (t.scrollablePlotBox = d(t.plotBox), h.width = t.plotWidth += i, n[c ? "height" : "width"] += i, r = !0)) : a && (t.scrollablePixelsY = s = Math.max(0, a - t.chartHeight), l(s) && (t.scrollablePlotBox = d(t.plotBox), h.height = t.plotHeight += s, n[c ? "width" : "height"] += s, r = !1)), l(r) && !e.skipAxes)) for (let e of t.axes)e.horiz === r && (e.setAxisSize(), e.setAxisTranslation());
            }
            constructor(t){
                let e;
                let s = t.options.chart, r = i.getRendererType(), o = s.scrollablePlotArea || {}, l = this.moveFixedElements.bind(this), d = {
                    WebkitOverflowScrolling: "touch",
                    overflowX: "hidden",
                    overflowY: "hidden"
                };
                t.scrollablePixelsX && (d.overflowX = "auto"), t.scrollablePixelsY && (d.overflowY = "auto"), this.chart = t;
                let c = this.parentDiv = n("div", {
                    className: "highcharts-scrolling-parent"
                }, {
                    position: "relative"
                }, t.renderTo), p = this.scrollingContainer = n("div", {
                    className: "highcharts-scrolling"
                }, d, c), u = this.innerContainer = n("div", {
                    className: "highcharts-inner-container"
                }, void 0, p), g = this.fixedDiv = n("div", {
                    className: "highcharts-fixed"
                }, {
                    position: "absolute",
                    overflow: "hidden",
                    pointerEvents: "none",
                    zIndex: (s.style?.zIndex || 0) + 2,
                    top: 0
                }, void 0, !0), f = this.fixedRenderer = new r(g, t.chartWidth, t.chartHeight, s.style);
                this.mask = f.path().attr({
                    fill: s.backgroundColor || "#fff",
                    "fill-opacity": o.opacity ?? .85,
                    zIndex: -1
                }).addClass("highcharts-scrollable-mask").add(), p.parentNode.insertBefore(g, p), h(t.renderTo, {
                    overflow: "visible"
                }), a(t, "afterShowResetZoom", l), a(t, "afterApplyDrilldown", l), a(t, "afterLayOutTitles", l), a(p, "scroll", ()=>{
                    let { pointer: i, hoverPoint: s } = t;
                    i && (delete i.chartPosition, s && (e = s), i.runPointActions(void 0, e, !0));
                }), u.appendChild(t.container);
            }
            applyFixed() {
                let { chart: t, fixedRenderer: e, isDirty: i, scrollingContainer: s } = this, { axisOffset: o, chartWidth: a, chartHeight: n, container: d, plotHeight: c, plotLeft: p, plotTop: u, plotWidth: g, scrollablePixelsX: f = 0, scrollablePixelsY: m = 0 } = t, { scrollPositionX: x = 0, scrollPositionY: y = 0 } = t.options.chart.scrollablePlotArea || {}, b = a + f, v = n + m;
                e.setSize(a, n), (i ?? !0) && (this.isDirty = !1, this.moveFixedElements()), r(t.container), h(d, {
                    width: `${b}px`,
                    height: `${v}px`
                }), t.renderer.boxWrapper.attr({
                    width: b,
                    height: v,
                    viewBox: [
                        0,
                        0,
                        b,
                        v
                    ].join(" ")
                }), t.chartBackground?.attr({
                    width: b,
                    height: v
                }), h(s, {
                    width: `${a}px`,
                    height: `${n}px`
                }), l(i) || (s.scrollLeft = f * x, s.scrollTop = m * y);
                let S = u - o[0] - 1, k = p - o[3] - 1, C = u + c + o[2] + 1, M = p + g + o[1] + 1, w = p + g - f, T = u + c - m, A = [
                    [
                        "M",
                        0,
                        0
                    ]
                ];
                f ? A = [
                    [
                        "M",
                        0,
                        S
                    ],
                    [
                        "L",
                        p - 1,
                        S
                    ],
                    [
                        "L",
                        p - 1,
                        C
                    ],
                    [
                        "L",
                        0,
                        C
                    ],
                    [
                        "Z"
                    ],
                    [
                        "M",
                        w,
                        S
                    ],
                    [
                        "L",
                        a,
                        S
                    ],
                    [
                        "L",
                        a,
                        C
                    ],
                    [
                        "L",
                        w,
                        C
                    ],
                    [
                        "Z"
                    ]
                ] : m && (A = [
                    [
                        "M",
                        k,
                        0
                    ],
                    [
                        "L",
                        k,
                        u - 1
                    ],
                    [
                        "L",
                        M,
                        u - 1
                    ],
                    [
                        "L",
                        M,
                        0
                    ],
                    [
                        "Z"
                    ],
                    [
                        "M",
                        k,
                        T
                    ],
                    [
                        "L",
                        k,
                        n
                    ],
                    [
                        "L",
                        M,
                        n
                    ],
                    [
                        "L",
                        M,
                        T
                    ],
                    [
                        "Z"
                    ]
                ]), "adjustHeight" !== t.redrawTrigger && this.mask.attr({
                    d: A
                });
            }
            moveFixedElements() {
                let t;
                let { container: e, inverted: i, scrollablePixelsX: s, scrollablePixelsY: r } = this.chart, o = this.fixedRenderer, a = [
                    ".highcharts-breadcrumbs-group",
                    ".highcharts-contextbutton",
                    ".highcharts-caption",
                    ".highcharts-credits",
                    ".highcharts-legend",
                    ".highcharts-legend-checkbox",
                    ".highcharts-navigator-series",
                    ".highcharts-navigator-xaxis",
                    ".highcharts-navigator-yaxis",
                    ".highcharts-navigator",
                    ".highcharts-reset-zoom",
                    ".highcharts-drillup-button",
                    ".highcharts-scrollbar",
                    ".highcharts-subtitle",
                    ".highcharts-title"
                ];
                for (let n of (s && !i ? t = ".highcharts-yaxis" : s && i ? t = ".highcharts-xaxis" : r && !i ? t = ".highcharts-xaxis" : r && i && (t = ".highcharts-yaxis"), t && a.push(`${t}:not(.highcharts-radial-axis)`, `${t}-labels:not(.highcharts-radial-axis-labels)`), a))[].forEach.call(e.querySelectorAll(n), (t)=>{
                    (t.namespaceURI === o.SVG_NS ? o.box : o.box.parentNode).appendChild(t), t.style.pointerEvents = "auto";
                });
            }
        }
        return g;
    }), i(e, "Core/Axis/Stacking/StackItem.js", [
        e["Core/Templating.js"],
        e["Core/Series/SeriesRegistry.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i) {
        let { format: s } = t, { series: r } = e, { destroyObjectProperties: o, fireEvent: a, isNumber: n, pick: h } = i;
        return class {
            constructor(t, e, i, s, r){
                let o = t.chart.inverted, a = t.reversed;
                this.axis = t;
                let n = this.isNegative = !!i != !!a;
                this.options = e = e || {}, this.x = s, this.total = null, this.cumulative = null, this.points = {}, this.hasValidPoints = !1, this.stack = r, this.leftCliff = 0, this.rightCliff = 0, this.alignOptions = {
                    align: e.align || (o ? n ? "left" : "right" : "center"),
                    verticalAlign: e.verticalAlign || (o ? "middle" : n ? "bottom" : "top"),
                    y: e.y,
                    x: e.x
                }, this.textAlign = e.textAlign || (o ? n ? "right" : "left" : "center");
            }
            destroy() {
                o(this, this.axis);
            }
            render(t) {
                let e = this.axis.chart, i = this.options, r = i.format, o = r ? s(r, this, e) : i.formatter.call(this);
                if (this.label) this.label.attr({
                    text: o,
                    visibility: "hidden"
                });
                else {
                    this.label = e.renderer.label(o, null, void 0, i.shape, void 0, void 0, i.useHTML, !1, "stack-labels");
                    let s = {
                        r: i.borderRadius || 0,
                        text: o,
                        padding: h(i.padding, 5),
                        visibility: "hidden"
                    };
                    e.styledMode || (s.fill = i.backgroundColor, s.stroke = i.borderColor, s["stroke-width"] = i.borderWidth, this.label.css(i.style || {})), this.label.attr(s), this.label.added || this.label.add(t);
                }
                this.label.labelrank = e.plotSizeY, a(this, "afterRender");
            }
            setOffset(t, e, i, s, o, l) {
                let { alignOptions: d, axis: c, label: p, options: u, textAlign: g } = this, f = c.chart, m = this.getStackBox({
                    xOffset: t,
                    width: e,
                    boxBottom: i,
                    boxTop: s,
                    defaultX: o,
                    xAxis: l
                }), { verticalAlign: x } = d;
                if (p && m) {
                    let t = p.getBBox(void 0, 0), e = p.padding, i = "justify" === h(u.overflow, "justify"), s;
                    d.x = u.x || 0, d.y = u.y || 0;
                    let { x: o, y: a } = this.adjustStackPosition({
                        labelBox: t,
                        verticalAlign: x,
                        textAlign: g
                    });
                    m.x -= o, m.y -= a, p.align(d, !1, m), (s = f.isInsidePlot(p.alignAttr.x + d.x + o, p.alignAttr.y + d.y + a)) || (i = !1), i && r.prototype.justifyDataLabel.call(c, p, d, p.alignAttr, t, m), p.attr({
                        x: p.alignAttr.x,
                        y: p.alignAttr.y,
                        rotation: u.rotation,
                        rotationOriginX: t.width * ({
                            left: 0,
                            center: .5,
                            right: 1
                        })[u.textAlign || "center"],
                        rotationOriginY: t.height / 2
                    }), h(!i && u.crop, !0) && (s = n(p.x) && n(p.y) && f.isInsidePlot(p.x - e + (p.width || 0), p.y) && f.isInsidePlot(p.x + e, p.y)), p[s ? "show" : "hide"]();
                }
                a(this, "afterSetOffset", {
                    xOffset: t,
                    width: e
                });
            }
            adjustStackPosition({ labelBox: t, verticalAlign: e, textAlign: i }) {
                let s = {
                    bottom: 0,
                    middle: 1,
                    top: 2,
                    right: 1,
                    center: 0,
                    left: -1
                }, r = s[e], o = s[i];
                return {
                    x: t.width / 2 + t.width / 2 * o,
                    y: t.height / 2 * r
                };
            }
            getStackBox(t) {
                let e = this.axis, i = e.chart, { boxTop: s, defaultX: r, xOffset: o, width: a, boxBottom: l } = t, d = e.stacking.usePercentage ? 100 : h(s, this.total, 0), c = e.toPixels(d), p = t.xAxis || i.xAxis[0], u = h(r, p.translate(this.x)) + o, g = Math.abs(c - e.toPixels(l || n(e.min) && e.logarithmic && e.logarithmic.lin2log(e.min) || 0)), f = i.inverted, m = this.isNegative;
                return f ? {
                    x: (m ? c : c - g) - i.plotLeft,
                    y: p.height - u - a,
                    width: g,
                    height: a
                } : {
                    x: u + p.transB - i.plotLeft,
                    y: (m ? c - g : c) - i.plotTop,
                    width: a,
                    height: g
                };
            }
        };
    }), i(e, "Core/Axis/Stacking/StackingAxis.js", [
        e["Core/Animation/AnimationUtilities.js"],
        e["Core/Axis/Axis.js"],
        e["Core/Series/SeriesRegistry.js"],
        e["Core/Axis/Stacking/StackItem.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i, s, r) {
        var o;
        let { getDeferredAnimation: a } = t, { series: { prototype: n } } = i, { addEvent: h, correctFloat: l, defined: d, destroyObjectProperties: c, fireEvent: p, isArray: u, isNumber: g, objectEach: f, pick: m } = r;
        function x() {
            let t = this.inverted;
            this.axes.forEach((t)=>{
                t.stacking && t.stacking.stacks && t.hasVisibleSeries && (t.stacking.oldStacks = t.stacking.stacks);
            }), this.series.forEach((e)=>{
                let i = e.xAxis && e.xAxis.options || {};
                e.options.stacking && e.reserveSpace() && (e.stackKey = [
                    e.type,
                    m(e.options.stack, ""),
                    t ? i.top : i.left,
                    t ? i.height : i.width
                ].join(","));
            });
        }
        function y() {
            let t = this.stacking;
            if (t) {
                let e = t.stacks;
                f(e, (t, i)=>{
                    c(t), delete e[i];
                }), t.stackTotalGroup?.destroy();
            }
        }
        function b() {
            this.stacking || (this.stacking = new w(this));
        }
        function v(t, e, i, s) {
            return !d(t) || t.x !== e || s && t.stackKey !== s ? t = {
                x: e,
                index: 0,
                key: s,
                stackKey: s
            } : t.index++, t.key = [
                i,
                e,
                t.index
            ].join(","), t;
        }
        function S() {
            let t;
            let e = this, i = e.yAxis, s = e.stackKey || "", r = i.stacking.stacks, o = e.processedXData, a = e.options.stacking, n = e[a + "Stacker"];
            n && [
                s,
                "-" + s
            ].forEach((i)=>{
                let s = o.length, a, h, l;
                for(; s--;)a = o[s], t = e.getStackIndicator(t, a, e.index, i), h = r[i]?.[a], (l = h?.points[t.key || ""]) && n.call(e, l, h, s);
            });
        }
        function k(t, e, i) {
            let s = e.total ? 100 / e.total : 0;
            t[0] = l(t[0] * s), t[1] = l(t[1] * s), this.stackedYData[i] = t[1];
        }
        function C(t) {
            (this.is("column") || this.is("columnrange")) && (this.options.centerInCategory && !this.options.stacking && this.chart.series.length > 1 ? n.setStackedPoints.call(this, t, "group") : t.stacking.resetStacks());
        }
        function M(t, e) {
            let i, r, o, a, n, h, c, p, g;
            let f = e || this.options.stacking;
            if (!f || !this.reserveSpace() || (({
                group: "xAxis"
            })[f] || "yAxis") !== t.coll) return;
            let x = this.processedXData, y = this.processedYData, b = [], v = y.length, S = this.options, k = S.threshold || 0, C = S.startFromThreshold ? k : 0, M = S.stack, w = e ? `${this.type},${f}` : this.stackKey || "", T = "-" + w, A = this.negStacks, P = t.stacking, L = P.stacks, O = P.oldStacks;
            for(P.stacksTouched += 1, c = 0; c < v; c++){
                p = x[c], g = y[c], h = (i = this.getStackIndicator(i, p, this.index)).key || "", L[n = (r = A && g < (C ? 0 : k)) ? T : w] || (L[n] = {}), L[n][p] || (O[n]?.[p] ? (L[n][p] = O[n][p], L[n][p].total = null) : L[n][p] = new s(t, t.options.stackLabels, !!r, p, M)), o = L[n][p], null !== g ? (o.points[h] = o.points[this.index] = [
                    m(o.cumulative, C)
                ], d(o.cumulative) || (o.base = h), o.touched = P.stacksTouched, i.index > 0 && !1 === this.singleStacks && (o.points[h][0] = o.points[this.index + "," + p + ",0"][0])) : (delete o.points[h], delete o.points[this.index]);
                let e = o.total || 0;
                "percent" === f ? (a = r ? w : T, e = A && L[a]?.[p] ? (a = L[a][p]).total = Math.max(a.total || 0, e) + Math.abs(g) || 0 : l(e + (Math.abs(g) || 0))) : "group" === f ? (u(g) && (g = g[0]), null !== g && e++) : e = l(e + (g || 0)), "group" === f ? o.cumulative = (e || 1) - 1 : o.cumulative = l(m(o.cumulative, C) + (g || 0)), o.total = e, null !== g && (o.points[h].push(o.cumulative), b[c] = o.cumulative, o.hasValidPoints = !0);
            }
            "percent" === f && (P.usePercentage = !0), "group" !== f && (this.stackedYData = b), P.oldStacks = {};
        }
        class w {
            constructor(t){
                this.oldStacks = {}, this.stacks = {}, this.stacksTouched = 0, this.axis = t;
            }
            buildStacks() {
                let t, e;
                let i = this.axis, s = i.series, r = "xAxis" === i.coll, o = i.options.reversedStacks, a = s.length;
                for(this.resetStacks(), this.usePercentage = !1, e = a; e--;)t = s[o ? e : a - e - 1], r && t.setGroupedPoints(i), t.setStackedPoints(i);
                if (!r) for(e = 0; e < a; e++)s[e].modifyStacks();
                p(i, "afterBuildStacks");
            }
            cleanStacks() {
                this.oldStacks && (this.stacks = this.oldStacks, f(this.stacks, (t)=>{
                    f(t, (t)=>{
                        t.cumulative = t.total;
                    });
                }));
            }
            resetStacks() {
                f(this.stacks, (t)=>{
                    f(t, (e, i)=>{
                        g(e.touched) && e.touched < this.stacksTouched ? (e.destroy(), delete t[i]) : (e.total = null, e.cumulative = null);
                    });
                });
            }
            renderStackTotals() {
                let t = this.axis, e = t.chart, i = e.renderer, s = this.stacks, r = a(e, t.options.stackLabels?.animation || !1), o = this.stackTotalGroup = this.stackTotalGroup || i.g("stack-labels").attr({
                    zIndex: 6,
                    opacity: 0
                }).add();
                o.translate(e.plotLeft, e.plotTop), f(s, (t)=>{
                    f(t, (t)=>{
                        t.render(o);
                    });
                }), o.animate({
                    opacity: 1
                }, r);
            }
        }
        return (o || (o = {})).compose = function(t, e, i) {
            let s = e.prototype, r = i.prototype;
            s.getStacks || (h(t, "init", b), h(t, "destroy", y), s.getStacks = x, r.getStackIndicator = v, r.modifyStacks = S, r.percentStacker = k, r.setGroupedPoints = C, r.setStackedPoints = M);
        }, o;
    }), i(e, "Series/Line/LineSeries.js", [
        e["Core/Series/Series.js"],
        e["Core/Series/SeriesRegistry.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i) {
        let { defined: s, merge: r, isObject: o } = i;
        class a extends t {
            drawGraph() {
                let t = this.options, e = (this.gappedPath || this.getGraphPath).call(this), i = this.chart.styledMode;
                [
                    this,
                    ...this.zones
                ].forEach((s, a)=>{
                    let n, h = s.graph, l = h ? "animate" : "attr", d = s.dashStyle || t.dashStyle;
                    h ? (h.endX = this.preventGraphAnimation ? null : e.xMap, h.animate({
                        d: e
                    })) : e.length && (s.graph = h = this.chart.renderer.path(e).addClass("highcharts-graph" + (a ? ` highcharts-zone-graph-${a - 1} ` : " ") + (a && s.className || "")).attr({
                        zIndex: 1
                    }).add(this.group)), h && !i && (n = {
                        stroke: !a && t.lineColor || s.color || this.color || "#cccccc",
                        "stroke-width": t.lineWidth || 0,
                        fill: this.fillGraph && this.color || "none"
                    }, d ? n.dashstyle = d : "square" !== t.linecap && (n["stroke-linecap"] = n["stroke-linejoin"] = "round"), h[l](n).shadow(a < 2 && t.shadow && r({
                        filterUnits: "userSpaceOnUse"
                    }, o(t.shadow) ? t.shadow : {}))), h && (h.startX = e.xMap, h.isArea = e.isArea);
                });
            }
            getGraphPath(t, e, i) {
                let r = this, o = r.options, a = [], n = [], h, l = o.step, d = (t = t || r.points).reversed;
                return d && t.reverse(), (l = ({
                    right: 1,
                    center: 2
                })[l] || l && 3) && d && (l = 4 - l), (t = this.getValidPoints(t, !1, !(o.connectNulls && !e && !i))).forEach(function(d, c) {
                    let p;
                    let u = d.plotX, g = d.plotY, f = t[c - 1], m = d.isNull || "number" != typeof g;
                    (d.leftCliff || f && f.rightCliff) && !i && (h = !0), m && !s(e) && c > 0 ? h = !o.connectNulls : m && !e ? h = !0 : (0 === c || h ? p = [
                        [
                            "M",
                            d.plotX,
                            d.plotY
                        ]
                    ] : r.getPointSpline ? p = [
                        r.getPointSpline(t, d, c)
                    ] : l ? (p = 1 === l ? [
                        [
                            "L",
                            f.plotX,
                            g
                        ]
                    ] : 2 === l ? [
                        [
                            "L",
                            (f.plotX + u) / 2,
                            f.plotY
                        ],
                        [
                            "L",
                            (f.plotX + u) / 2,
                            g
                        ]
                    ] : [
                        [
                            "L",
                            u,
                            f.plotY
                        ]
                    ]).push([
                        "L",
                        u,
                        g
                    ]) : p = [
                        [
                            "L",
                            u,
                            g
                        ]
                    ], n.push(d.x), l && (n.push(d.x), 2 === l && n.push(d.x)), a.push.apply(a, p), h = !1);
                }), a.xMap = n, r.graphPath = a, a;
            }
        }
        return a.defaultOptions = r(t.defaultOptions, {
            legendSymbol: "lineMarker"
        }), e.registerSeriesType("line", a), a;
    }), i(e, "Series/Area/AreaSeries.js", [
        e["Core/Series/SeriesRegistry.js"],
        e["Core/Utilities.js"]
    ], function(t, e) {
        let { seriesTypes: { line: i } } = t, { extend: s, merge: r, objectEach: o, pick: a } = e;
        class n extends i {
            drawGraph() {
                this.areaPath = [], super.drawGraph.apply(this);
                let { areaPath: t, options: e } = this;
                [
                    this,
                    ...this.zones
                ].forEach((i, s)=>{
                    let r = {}, o = i.fillColor || e.fillColor, a = i.area, n = a ? "animate" : "attr";
                    a ? (a.endX = this.preventGraphAnimation ? null : t.xMap, a.animate({
                        d: t
                    })) : (r.zIndex = 0, (a = i.area = this.chart.renderer.path(t).addClass("highcharts-area" + (s ? ` highcharts-zone-area-${s - 1} ` : " ") + (s && i.className || "")).add(this.group)).isArea = !0), this.chart.styledMode || (r.fill = o || i.color || this.color, r["fill-opacity"] = o ? 1 : e.fillOpacity ?? .75, a.css({
                        pointerEvents: this.stickyTracking ? "none" : "auto"
                    })), a[n](r), a.startX = t.xMap, a.shiftUnit = e.step ? 2 : 1;
                });
            }
            getGraphPath(t) {
                let e, s, r;
                let o = i.prototype.getGraphPath, n = this.options, h = n.stacking, l = this.yAxis, d = [], c = [], p = this.index, u = l.stacking.stacks[this.stackKey], g = n.threshold, f = Math.round(l.getThreshold(n.threshold)), m = a(n.connectNulls, "percent" === h), x = function(i, s, r) {
                    let o = t[i], a = h && u[o.x].points[p], n = o[r + "Null"] || 0, m = o[r + "Cliff"] || 0, x, y, b = !0;
                    m || n ? (x = (n ? a[0] : a[1]) + m, y = a[0] + m, b = !!n) : !h && t[s] && t[s].isNull && (x = y = g), void 0 !== x && (c.push({
                        plotX: e,
                        plotY: null === x ? f : l.getThreshold(x),
                        isNull: b,
                        isCliff: !0
                    }), d.push({
                        plotX: e,
                        plotY: null === y ? f : l.getThreshold(y),
                        doCurve: !1
                    }));
                };
                t = t || this.points, h && (t = this.getStackPoints(t));
                for(let i = 0, o = t.length; i < o; ++i)h || (t[i].leftCliff = t[i].rightCliff = t[i].leftNull = t[i].rightNull = void 0), s = t[i].isNull, e = a(t[i].rectPlotX, t[i].plotX), r = h ? a(t[i].yBottom, f) : f, s && !m || (m || x(i, i - 1, "left"), s && !h && m || (c.push(t[i]), d.push({
                    x: i,
                    plotX: e,
                    plotY: r
                })), m || x(i, i + 1, "right"));
                let y = o.call(this, c, !0, !0);
                d.reversed = !0;
                let b = o.call(this, d, !0, !0), v = b[0];
                v && "M" === v[0] && (b[0] = [
                    "L",
                    v[1],
                    v[2]
                ]);
                let S = y.concat(b);
                S.length && S.push([
                    "Z"
                ]);
                let k = o.call(this, c, !1, m);
                return S.xMap = y.xMap, this.areaPath = S, k;
            }
            getStackPoints(t) {
                let e = this, i = [], s = [], r = this.xAxis, n = this.yAxis, h = n.stacking.stacks[this.stackKey], l = {}, d = n.series, c = d.length, p = n.options.reversedStacks ? 1 : -1, u = d.indexOf(e);
                if (t = t || this.points, this.options.stacking) {
                    for(let e = 0; e < t.length; e++)t[e].leftNull = t[e].rightNull = void 0, l[t[e].x] = t[e];
                    o(h, function(t, e) {
                        null !== t.total && s.push(e);
                    }), s.sort(function(t, e) {
                        return t - e;
                    });
                    let g = d.map((t)=>t.visible);
                    s.forEach(function(t, o) {
                        let f = 0, m, x;
                        if (l[t] && !l[t].isNull) i.push(l[t]), [
                            -1,
                            1
                        ].forEach(function(i) {
                            let r = 1 === i ? "rightNull" : "leftNull", a = h[s[o + i]], n = 0;
                            if (a) {
                                let i = u;
                                for(; i >= 0 && i < c;){
                                    let s = d[i].index;
                                    !(m = a.points[s]) && (s === e.index ? l[t][r] = !0 : g[i] && (x = h[t].points[s]) && (n -= x[1] - x[0])), i += p;
                                }
                            }
                            l[t][1 === i ? "rightCliff" : "leftCliff"] = n;
                        });
                        else {
                            let e = u;
                            for(; e >= 0 && e < c;){
                                let i = d[e].index;
                                if (m = h[t].points[i]) {
                                    f = m[1];
                                    break;
                                }
                                e += p;
                            }
                            f = a(f, 0), f = n.translate(f, 0, 1, 0, 1), i.push({
                                isNull: !0,
                                plotX: r.translate(t, 0, 0, 0, 1),
                                x: t,
                                plotY: f,
                                yBottom: f
                            });
                        }
                    });
                }
                return i;
            }
        }
        return n.defaultOptions = r(i.defaultOptions, {
            threshold: 0,
            legendSymbol: "areaMarker"
        }), s(n.prototype, {
            singleStacks: !1
        }), t.registerSeriesType("area", n), n;
    }), i(e, "Series/Spline/SplineSeries.js", [
        e["Core/Series/SeriesRegistry.js"],
        e["Core/Utilities.js"]
    ], function(t, e) {
        let { line: i } = t.seriesTypes, { merge: s, pick: r } = e;
        class o extends i {
            getPointSpline(t, e, i) {
                let s, o, a, n;
                let h = e.plotX || 0, l = e.plotY || 0, d = t[i - 1], c = t[i + 1];
                function p(t) {
                    return t && !t.isNull && !1 !== t.doCurve && !e.isCliff;
                }
                if (p(d) && p(c)) {
                    let t = d.plotX || 0, i = d.plotY || 0, r = c.plotX || 0, p = c.plotY || 0, u = 0;
                    s = (1.5 * h + t) / 2.5, o = (1.5 * l + i) / 2.5, a = (1.5 * h + r) / 2.5, n = (1.5 * l + p) / 2.5, a !== s && (u = (n - o) * (a - h) / (a - s) + l - n), o += u, n += u, o > i && o > l ? (o = Math.max(i, l), n = 2 * l - o) : o < i && o < l && (o = Math.min(i, l), n = 2 * l - o), n > p && n > l ? (n = Math.max(p, l), o = 2 * l - n) : n < p && n < l && (n = Math.min(p, l), o = 2 * l - n), e.rightContX = a, e.rightContY = n, e.controlPoints = {
                        low: [
                            s,
                            o
                        ],
                        high: [
                            a,
                            n
                        ]
                    };
                }
                let u = [
                    "C",
                    r(d.rightContX, d.plotX, 0),
                    r(d.rightContY, d.plotY, 0),
                    r(s, h, 0),
                    r(o, l, 0),
                    h,
                    l
                ];
                return d.rightContX = d.rightContY = void 0, u;
            }
        }
        return o.defaultOptions = s(i.defaultOptions), t.registerSeriesType("spline", o), o;
    }), i(e, "Series/AreaSpline/AreaSplineSeries.js", [
        e["Series/Spline/SplineSeries.js"],
        e["Core/Series/SeriesRegistry.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i) {
        let { area: s, area: { prototype: r } } = e.seriesTypes, { extend: o, merge: a } = i;
        class n extends t {
        }
        return n.defaultOptions = a(t.defaultOptions, s.defaultOptions), o(n.prototype, {
            getGraphPath: r.getGraphPath,
            getStackPoints: r.getStackPoints,
            drawGraph: r.drawGraph
        }), e.registerSeriesType("areaspline", n), n;
    }), i(e, "Series/Column/ColumnSeriesDefaults.js", [], function() {
        return {
            borderRadius: 3,
            centerInCategory: !1,
            groupPadding: .2,
            marker: null,
            pointPadding: .1,
            minPointLength: 0,
            cropThreshold: 50,
            pointRange: null,
            states: {
                hover: {
                    halo: !1,
                    brightness: .1
                },
                select: {
                    color: "#cccccc",
                    borderColor: "#000000"
                }
            },
            dataLabels: {
                align: void 0,
                verticalAlign: void 0,
                y: void 0
            },
            startFromThreshold: !0,
            stickyTracking: !1,
            tooltip: {
                distance: 6
            },
            threshold: 0,
            borderColor: "#ffffff"
        };
    }), i(e, "Series/Column/ColumnSeries.js", [
        e["Core/Animation/AnimationUtilities.js"],
        e["Core/Color/Color.js"],
        e["Series/Column/ColumnSeriesDefaults.js"],
        e["Core/Globals.js"],
        e["Core/Series/Series.js"],
        e["Core/Series/SeriesRegistry.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i, s, r, o, a) {
        let { animObject: n } = t, { parse: h } = e, { noop: l } = s, { clamp: d, defined: c, extend: p, fireEvent: u, isArray: g, isNumber: f, merge: m, pick: x, objectEach: y } = a;
        class b extends r {
            animate(t) {
                let e, i;
                let s = this, r = this.yAxis, o = r.pos, a = s.options, h = this.chart.inverted, l = {}, c = h ? "translateX" : "translateY";
                t ? (l.scaleY = .001, i = d(r.toPixels(a.threshold), o, o + r.len), h ? l.translateX = i - r.len : l.translateY = i, s.clipBox && s.setClip(), s.group.attr(l)) : (e = Number(s.group.attr(c)), s.group.animate({
                    scaleY: 1
                }, p(n(s.options.animation), {
                    step: function(t, i) {
                        s.group && (l[c] = e + i.pos * (o - e), s.group.attr(l));
                    }
                })));
            }
            init(t, e) {
                super.init.apply(this, arguments);
                let i = this;
                (t = i.chart).hasRendered && t.series.forEach(function(t) {
                    t.type === i.type && (t.isDirty = !0);
                });
            }
            getColumnMetrics() {
                let t = this, e = t.options, i = t.xAxis, s = t.yAxis, r = i.options.reversedStacks, o = i.reversed && !r || !i.reversed && r, a = {}, n, h = 0;
                !1 === e.grouping ? h = 1 : t.chart.series.forEach(function(e) {
                    let i;
                    let r = e.yAxis, o = e.options;
                    e.type === t.type && e.reserveSpace() && s.len === r.len && s.pos === r.pos && (o.stacking && "group" !== o.stacking ? (void 0 === a[n = e.stackKey] && (a[n] = h++), i = a[n]) : !1 !== o.grouping && (i = h++), e.columnIndex = i);
                });
                let l = Math.min(Math.abs(i.transA) * (!i.brokenAxis?.hasBreaks && i.ordinal?.slope || e.pointRange || i.closestPointRange || i.tickInterval || 1), i.len), d = l * e.groupPadding, c = (l - 2 * d) / (h || 1), p = Math.min(e.maxPointWidth || i.len, x(e.pointWidth, c * (1 - 2 * e.pointPadding))), u = (t.columnIndex || 0) + (o ? 1 : 0);
                return t.columnMetrics = {
                    width: p,
                    offset: (c - p) / 2 + (d + u * c - l / 2) * (o ? -1 : 1),
                    paddedWidth: c,
                    columnCount: h
                }, t.columnMetrics;
            }
            crispCol(t, e, i, s) {
                let r = this.borderWidth, o = -(r % 2 ? .5 : 0), a = r % 2 ? .5 : 1;
                this.options.crisp && (i = Math.round(t + i) + o - (t = Math.round(t) + o));
                let n = Math.round(e + s) + a, h = .5 >= Math.abs(e) && n > .5;
                return s = n - (e = Math.round(e) + a), h && s && (e -= 1, s += 1), {
                    x: t,
                    y: e,
                    width: i,
                    height: s
                };
            }
            adjustForMissingColumns(t, e, i, s) {
                if (!i.isNull && s.columnCount > 1) {
                    let r = this.xAxis.series.filter((t)=>t.visible).map((t)=>t.index), o = 0, a = 0;
                    y(this.xAxis.stacking?.stacks, (t)=>{
                        if ("number" == typeof i.x) {
                            let e = t[i.x.toString()];
                            if (e && g(e.points[this.index])) {
                                let t = Object.keys(e.points).filter((t)=>!t.match(",") && e.points[t] && e.points[t].length > 1).map(parseFloat).filter((t)=>-1 !== r.indexOf(t)).sort((t, e)=>e - t);
                                o = t.indexOf(this.index), a = t.length;
                            }
                        }
                    }), o = this.xAxis.reversed ? a - 1 - o : o;
                    let n = (a - 1) * s.paddedWidth + e;
                    t = (i.plotX || 0) + n / 2 - e - o * s.paddedWidth;
                }
                return t;
            }
            translate() {
                let t = this, e = t.chart, i = t.options, s = t.dense = t.closestPointRange * t.xAxis.transA < 2, o = t.borderWidth = x(i.borderWidth, s ? 0 : 1), a = t.xAxis, n = t.yAxis, h = i.threshold, l = x(i.minPointLength, 5), p = t.getColumnMetrics(), g = p.width, m = t.pointXOffset = p.offset, y = t.dataMin, b = t.dataMax, v = t.barW = Math.max(g, 1 + 2 * o), S = t.translatedThreshold = n.getThreshold(h);
                e.inverted && (S -= .5), i.pointPadding && (v = Math.ceil(v)), r.prototype.translate.apply(t), t.points.forEach(function(s) {
                    let r = x(s.yBottom, S), o = 999 + Math.abs(r), u = s.plotX || 0, k = d(s.plotY, -o, n.len + o), C, M = Math.min(k, r), w = Math.max(k, r) - M, T = g, A = u + m, P = v;
                    l && Math.abs(w) < l && (w = l, C = !n.reversed && !s.negative || n.reversed && s.negative, f(h) && f(b) && s.y === h && b <= h && (n.min || 0) < h && (y !== b || (n.max || 0) <= h) && (C = !C, s.negative = !s.negative), M = Math.abs(M - S) > l ? r - l : S - (C ? l : 0)), c(s.options.pointWidth) && (A -= Math.round(((T = P = Math.ceil(s.options.pointWidth)) - g) / 2)), i.centerInCategory && !i.stacking && (A = t.adjustForMissingColumns(A, T, s, p)), s.barX = A, s.pointWidth = T, s.tooltipPos = e.inverted ? [
                        d(n.len + n.pos - e.plotLeft - k, n.pos - e.plotLeft, n.len + n.pos - e.plotLeft),
                        a.len + a.pos - e.plotTop - A - P / 2,
                        w
                    ] : [
                        a.left - e.plotLeft + A + P / 2,
                        d(k + n.pos - e.plotTop, n.pos - e.plotTop, n.len + n.pos - e.plotTop),
                        w
                    ], s.shapeType = t.pointClass.prototype.shapeType || "roundedRect", s.shapeArgs = t.crispCol(A, s.isNull ? S : M, P, s.isNull ? 0 : w);
                }), u(this, "afterColumnTranslate");
            }
            drawGraph() {
                this.group[this.dense ? "addClass" : "removeClass"]("highcharts-dense-data");
            }
            pointAttribs(t, e) {
                let i = this.options, s = this.pointAttrToOptions || {}, r = s.stroke || "borderColor", o = s["stroke-width"] || "borderWidth", a, n, l, d = t && t.color || this.color, c = t && t[r] || i[r] || d, p = t && t.options.dashStyle || i.dashStyle, u = t && t[o] || i[o] || this[o] || 0, g = x(t && t.opacity, i.opacity, 1);
                t && this.zones.length && (n = t.getZone(), d = t.options.color || n && (n.color || t.nonZonedColor) || this.color, n && (c = n.borderColor || c, p = n.dashStyle || p, u = n.borderWidth || u)), e && t && (l = (a = m(i.states[e], t.options.states && t.options.states[e] || {})).brightness, d = a.color || void 0 !== l && h(d).brighten(a.brightness).get() || d, c = a[r] || c, u = a[o] || u, p = a.dashStyle || p, g = x(a.opacity, g));
                let f = {
                    fill: d,
                    stroke: c,
                    "stroke-width": u,
                    opacity: g
                };
                return p && (f.dashstyle = p), f;
            }
            drawPoints(t = this.points) {
                let e;
                let i = this, s = this.chart, r = i.options, o = s.renderer, a = r.animationLimit || 250;
                t.forEach(function(t) {
                    let n = t.plotY, h = t.graphic, l = !!h, d = h && s.pointCount < a ? "animate" : "attr";
                    f(n) && null !== t.y ? (e = t.shapeArgs, h && t.hasNewShapeType() && (h = h.destroy()), i.enabledDataSorting && (t.startXPos = i.xAxis.reversed ? -(e && e.width || 0) : i.xAxis.width), !h && (t.graphic = h = o[t.shapeType](e).add(t.group || i.group), h && i.enabledDataSorting && s.hasRendered && s.pointCount < a && (h.attr({
                        x: t.startXPos
                    }), l = !0, d = "animate")), h && l && h[d](m(e)), s.styledMode || h[d](i.pointAttribs(t, t.selected && "select")).shadow(!1 !== t.allowShadow && r.shadow), h && (h.addClass(t.getClassName(), !0), h.attr({
                        visibility: t.visible ? "inherit" : "hidden"
                    }))) : h && (t.graphic = h.destroy());
                });
            }
            drawTracker(t = this.points) {
                let e;
                let i = this, s = i.chart, r = s.pointer, o = function(t) {
                    let e = r?.getPointFromEvent(t);
                    r && e && i.options.enableMouseTracking && (r.isDirectTouch = !0, e.onMouseOver(t));
                };
                t.forEach(function(t) {
                    e = g(t.dataLabels) ? t.dataLabels : t.dataLabel ? [
                        t.dataLabel
                    ] : [], t.graphic && (t.graphic.element.point = t), e.forEach(function(e) {
                        (e.div || e.element).point = t;
                    });
                }), i._hasTracking || (i.trackerGroups.forEach(function(t) {
                    i[t] && (i[t].addClass("highcharts-tracker").on("mouseover", o).on("mouseout", function(t) {
                        r?.onTrackerMouseOut(t);
                    }).on("touchstart", o), !s.styledMode && i.options.cursor && i[t].css({
                        cursor: i.options.cursor
                    }));
                }), i._hasTracking = !0), u(this, "afterDrawTracker");
            }
            remove() {
                let t = this, e = t.chart;
                e.hasRendered && e.series.forEach(function(e) {
                    e.type === t.type && (e.isDirty = !0);
                }), r.prototype.remove.apply(t, arguments);
            }
        }
        return b.defaultOptions = m(r.defaultOptions, i), p(b.prototype, {
            directTouch: !0,
            getSymbol: l,
            negStacks: !0,
            trackerGroups: [
                "group",
                "dataLabelsGroup"
            ]
        }), o.registerSeriesType("column", b), b;
    }), i(e, "Core/Series/DataLabel.js", [
        e["Core/Animation/AnimationUtilities.js"],
        e["Core/Templating.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i) {
        var s;
        let { getDeferredAnimation: r } = t, { format: o } = e, { defined: a, extend: n, fireEvent: h, isArray: l, isString: d, merge: c, objectEach: p, pick: u, pInt: g, splat: f } = i;
        return function(t) {
            function e() {
                return v(this).some((t)=>t?.enabled);
            }
            function i(t, e, i, s, r) {
                let o = this.chart, h = this.isCartesian && o.inverted, l = this.enabledDataSorting, d = t.plotX, p = t.plotY, g = i.rotation || 0, f = a(d) && a(p) && o.isInsidePlot(d, Math.round(p), {
                    inverted: h,
                    paneCoordinates: !0,
                    series: this
                }), m = 0 === g && "justify" === u(i.overflow, l ? "none" : "justify"), x = this.visible && !1 !== t.visible && a(d) && (t.series.forceDL || l && !m || f || u(i.inside, !!this.options.stacking) && s && o.isInsidePlot(d, h ? s.x + 1 : s.y + s.height - 1, {
                    inverted: h,
                    paneCoordinates: !0,
                    series: this
                })), y = t.pos();
                if (x && y) {
                    var b;
                    let a = e.getBBox(), h = e.getBBox(void 0, 0), d = {
                        right: 1,
                        center: .5
                    }[i.align || 0] || 0, p = {
                        bottom: 1,
                        middle: .5
                    }[i.verticalAlign || 0] || 0;
                    if (s = n({
                        x: y[0],
                        y: Math.round(y[1]),
                        width: 0,
                        height: 0
                    }, s || {}), n(i, {
                        width: a.width,
                        height: a.height
                    }), b = s, l && this.xAxis && !m && this.setDataLabelStartPos(t, e, r, f, b), e.align(c(i, {
                        width: h.width,
                        height: h.height
                    }), !1, s, !1), e.alignAttr.x += d * (h.width - a.width), e.alignAttr.y += p * (h.height - a.height), e[e.placed ? "animate" : "attr"]({
                        x: e.alignAttr.x + (a.width - h.width) / 2,
                        y: e.alignAttr.y + (a.height - h.height) / 2,
                        rotationOriginX: (e.width || 0) / 2,
                        rotationOriginY: (e.height || 0) / 2
                    }), m && s.height >= 0) this.justifyDataLabel(e, i, e.alignAttr, a, s, r);
                    else if (u(i.crop, !0)) {
                        let { x: t, y: i } = e.alignAttr;
                        x = o.isInsidePlot(t, i, {
                            paneCoordinates: !0,
                            series: this
                        }) && o.isInsidePlot(t + a.width - 1, i + a.height - 1, {
                            paneCoordinates: !0,
                            series: this
                        });
                    }
                    i.shape && !g && e[r ? "attr" : "animate"]({
                        anchorX: y[0],
                        anchorY: y[1]
                    });
                }
                r && l && (e.placed = !1), x || l && !m ? (e.show(), e.placed = !0) : (e.hide(), e.placed = !1);
            }
            function s() {
                return this.plotGroup("dataLabelsGroup", "data-labels", this.hasRendered ? "inherit" : "hidden", this.options.dataLabels.zIndex || 6);
            }
            function m(t) {
                let e = this.hasRendered || 0, i = this.initDataLabelsGroup().attr({
                    opacity: +e
                });
                return !e && i && (this.visible && i.show(), this.options.animation ? i.animate({
                    opacity: 1
                }, t) : i.attr({
                    opacity: 1
                })), i;
            }
            function x(t) {
                let e;
                t = t || this.points;
                let i = this, s = i.chart, n = i.options, l = s.renderer, { backgroundColor: c, plotBackgroundColor: m } = s.options.chart, x = l.getContrast(d(m) && m || d(c) && c || "#000000"), y = v(i), { animation: S, defer: k } = y[0], C = k ? r(s, S, i) : {
                    defer: 0,
                    duration: 0
                };
                h(this, "drawDataLabels"), i.hasDataLabels?.() && (e = this.initDataLabels(C), t.forEach((t)=>{
                    let r = t.dataLabels || [];
                    f(b(y, t.dlOptions || t.options?.dataLabels)).forEach((h, c)=>{
                        let f = h.enabled && (t.visible || t.dataLabelOnHidden) && (!t.isNull || t.dataLabelOnNull) && function(t, e) {
                            let i = e.filter;
                            if (i) {
                                let e = i.operator, s = t[i.property], r = i.value;
                                return ">" === e && s > r || "<" === e && s < r || ">=" === e && s >= r || "<=" === e && s <= r || "==" === e && s == r || "===" === e && s === r || "!=" === e && s != r || "!==" === e && s !== r;
                            }
                            return !0;
                        }(t, h), { backgroundColor: m, borderColor: y, distance: b, style: v = {} } = h, S, k, C, M, w = {}, T = r[c], A = !T, P;
                        if (f && (k = u(h[t.formatPrefix + "Format"], h.format), S = t.getLabelConfig(), C = a(k) ? o(k, S, s) : (h[t.formatPrefix + "Formatter"] || h.formatter).call(S, h), M = h.rotation, !s.styledMode && (v.color = u(h.color, v.color, d(i.color) ? i.color : void 0, "#000000"), "contrast" === v.color ? ("none" !== m && (P = m), t.contrastColor = l.getContrast("auto" !== P && P || t.color || i.color), v.color = P || !a(b) && h.inside || 0 > g(b || 0) || n.stacking ? t.contrastColor : x) : delete t.contrastColor, n.cursor && (v.cursor = n.cursor)), w = {
                            r: h.borderRadius || 0,
                            rotation: M,
                            padding: h.padding,
                            zIndex: 1
                        }, s.styledMode || (w.fill = "auto" === m ? t.color : m, w.stroke = "auto" === y ? t.color : y, w["stroke-width"] = h.borderWidth), p(w, (t, e)=>{
                            void 0 === t && delete w[e];
                        })), !T || f && a(C) && !!T.div == !!h.useHTML && (T.rotation && h.rotation || T.rotation === h.rotation) || (T = void 0, A = !0), f && a(C) && (T ? w.text = C : (T = l.label(C, 0, 0, h.shape, void 0, void 0, h.useHTML, void 0, "data-label")).addClass(" highcharts-data-label-color-" + t.colorIndex + " " + (h.className || "") + (h.useHTML ? " highcharts-tracker" : "")), T)) {
                            T.options = h, T.attr(w), s.styledMode || T.css(v).shadow(h.shadow);
                            let o = h[t.formatPrefix + "TextPath"] || h.textPath;
                            o && !h.useHTML && (T.setTextPath(t.getDataLabelPath?.(T) || t.graphic, o), t.dataLabelPath && !o.enabled && (t.dataLabelPath = t.dataLabelPath.destroy())), T.added || T.add(e), i.alignDataLabel(t, T, h, void 0, A), T.isActive = !0, r[c] && r[c] !== T && r[c].destroy(), r[c] = T;
                        }
                    });
                    let h = r.length;
                    for(; h--;)r[h] && r[h].isActive ? r[h].isActive = !1 : (r[h]?.destroy(), r.splice(h, 1));
                    t.dataLabel = r[0], t.dataLabels = r;
                })), h(this, "afterDrawDataLabels");
            }
            function y(t, e, i, s, r, o) {
                let a = this.chart, n = e.align, h = e.verticalAlign, l = t.box ? 0 : t.padding || 0, { x: d = 0, y: c = 0 } = e, p, u;
                return (p = (i.x || 0) + l) < 0 && ("right" === n && d >= 0 ? (e.align = "left", e.inside = !0) : d -= p, u = !0), (p = (i.x || 0) + s.width - l) > a.plotWidth && ("left" === n && d <= 0 ? (e.align = "right", e.inside = !0) : d += a.plotWidth - p, u = !0), (p = i.y + l) < 0 && ("bottom" === h && c >= 0 ? (e.verticalAlign = "top", e.inside = !0) : c -= p, u = !0), (p = (i.y || 0) + s.height - l) > a.plotHeight && ("top" === h && c <= 0 ? (e.verticalAlign = "bottom", e.inside = !0) : c += a.plotHeight - p, u = !0), u && (e.x = d, e.y = c, t.placed = !o, t.align(e, void 0, r)), u;
            }
            function b(t, e) {
                let i = [], s;
                if (l(t) && !l(e)) i = t.map(function(t) {
                    return c(t, e);
                });
                else if (l(e) && !l(t)) i = e.map(function(e) {
                    return c(t, e);
                });
                else if (l(t) || l(e)) {
                    if (l(t) && l(e)) for(s = Math.max(t.length, e.length); s--;)i[s] = c(t[s], e[s]);
                } else i = c(t, e);
                return i;
            }
            function v(t) {
                let e = t.chart.options.plotOptions;
                return f(b(b(e?.series?.dataLabels, e?.[t.type]?.dataLabels), t.options.dataLabels));
            }
            function S(t, e, i, s, r) {
                let o = this.chart, a = o.inverted, n = this.xAxis, h = n.reversed, l = ((a ? e.height : e.width) || 0) / 2, d = t.pointWidth, c = d ? d / 2 : 0;
                e.startXPos = a ? r.x : h ? -l - c : n.width - l + c, e.startYPos = a ? h ? this.yAxis.height - l + c : -l - c : r.y, s ? "hidden" === e.visibility && (e.show(), e.attr({
                    opacity: 0
                }).animate({
                    opacity: 1
                })) : e.attr({
                    opacity: 1
                }).animate({
                    opacity: 0
                }, void 0, e.hide), o.hasRendered && (i && e.attr({
                    x: e.startXPos,
                    y: e.startYPos
                }), e.placed = !0);
            }
            t.compose = function(t) {
                let r = t.prototype;
                r.initDataLabels || (r.initDataLabels = m, r.initDataLabelsGroup = s, r.alignDataLabel = i, r.drawDataLabels = x, r.justifyDataLabel = y, r.setDataLabelStartPos = S, r.hasDataLabels = e);
            };
        }(s || (s = {})), s;
    }), i(e, "Series/Column/ColumnDataLabel.js", [
        e["Core/Series/DataLabel.js"],
        e["Core/Globals.js"],
        e["Core/Series/SeriesRegistry.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i, s) {
        var r;
        let { composed: o } = e, { series: a } = i, { merge: n, pick: h, pushUnique: l } = s;
        return function(e) {
            function i(t, e, i, s, r) {
                let o = this.chart.inverted, l = t.series, d = (l.xAxis ? l.xAxis.len : this.chart.plotSizeX) || 0, c = (l.yAxis ? l.yAxis.len : this.chart.plotSizeY) || 0, p = t.dlBox || t.shapeArgs, u = h(t.below, t.plotY > h(this.translatedThreshold, c)), g = h(i.inside, !!this.options.stacking);
                if (p) {
                    if (s = n(p), !("allow" === i.overflow && !1 === i.crop)) {
                        s.y < 0 && (s.height += s.y, s.y = 0);
                        let t = s.y + s.height - c;
                        t > 0 && t < s.height && (s.height -= t);
                    }
                    o && (s = {
                        x: c - s.y - s.height,
                        y: d - s.x - s.width,
                        width: s.height,
                        height: s.width
                    }), g || (o ? (s.x += u ? 0 : s.width, s.width = 0) : (s.y += u ? s.height : 0, s.height = 0));
                }
                i.align = h(i.align, !o || g ? "center" : u ? "right" : "left"), i.verticalAlign = h(i.verticalAlign, o || g ? "middle" : u ? "top" : "bottom"), a.prototype.alignDataLabel.call(this, t, e, i, s, r), i.inside && t.contrastColor && e.css({
                    color: t.contrastColor
                });
            }
            e.compose = function(e) {
                t.compose(a), l(o, "ColumnDataLabel") && (e.prototype.alignDataLabel = i);
            };
        }(r || (r = {})), r;
    }), i(e, "Series/Bar/BarSeries.js", [
        e["Series/Column/ColumnSeries.js"],
        e["Core/Series/SeriesRegistry.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i) {
        let { extend: s, merge: r } = i;
        class o extends t {
        }
        return o.defaultOptions = r(t.defaultOptions, {}), s(o.prototype, {
            inverted: !0
        }), e.registerSeriesType("bar", o), o;
    }), i(e, "Series/Scatter/ScatterSeriesDefaults.js", [], function() {
        return {
            lineWidth: 0,
            findNearestPointBy: "xy",
            jitter: {
                x: 0,
                y: 0
            },
            marker: {
                enabled: !0
            },
            tooltip: {
                headerFormat: '<span style="color:{point.color}">\u25CF</span> <span style="font-size: 0.8em"> {series.name}</span><br/>',
                pointFormat: "x: <b>{point.x}</b><br/>y: <b>{point.y}</b><br/>"
            }
        };
    }), i(e, "Series/Scatter/ScatterSeries.js", [
        e["Series/Scatter/ScatterSeriesDefaults.js"],
        e["Core/Series/SeriesRegistry.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i) {
        let { column: s, line: r } = e.seriesTypes, { addEvent: o, extend: a, merge: n } = i;
        class h extends r {
            applyJitter() {
                let t = this, e = this.options.jitter, i = this.points.length;
                e && this.points.forEach(function(s, r) {
                    [
                        "x",
                        "y"
                    ].forEach(function(o, a) {
                        let n, h = "plot" + o.toUpperCase(), l, d, c;
                        e[o] && !s.isNull && (n = t[o + "Axis"], c = e[o] * n.transA, n && !n.isLog && (l = Math.max(0, s[h] - c), d = Math.min(n.len, s[h] + c), s[h] = l + (d - l) * function(t) {
                            let e = 1e4 * Math.sin(t);
                            return e - Math.floor(e);
                        }(r + a * i), "x" === o && (s.clientX = s.plotX)));
                    });
                });
            }
            drawGraph() {
                this.options.lineWidth ? super.drawGraph() : this.graph && (this.graph = this.graph.destroy());
            }
        }
        return h.defaultOptions = n(r.defaultOptions, t), a(h.prototype, {
            drawTracker: s.prototype.drawTracker,
            sorted: !1,
            requireSorting: !1,
            noSharedTooltip: !0,
            trackerGroups: [
                "group",
                "markerGroup",
                "dataLabelsGroup"
            ]
        }), o(h, "afterTranslate", function() {
            this.applyJitter();
        }), e.registerSeriesType("scatter", h), h;
    }), i(e, "Series/CenteredUtilities.js", [
        e["Core/Globals.js"],
        e["Core/Series/Series.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i) {
        var s, r;
        let { deg2rad: o } = t, { fireEvent: a, isNumber: n, pick: h, relativeLength: l } = i;
        return (r = s || (s = {})).getCenter = function() {
            let t = this.options, i = this.chart, s = 2 * (t.slicedOffset || 0), r = i.plotWidth - 2 * s, o = i.plotHeight - 2 * s, d = t.center, c = Math.min(r, o), p = t.thickness, u, g = t.size, f = t.innerSize || 0, m, x;
            "string" == typeof g && (g = parseFloat(g)), "string" == typeof f && (f = parseFloat(f));
            let y = [
                h(d[0], "50%"),
                h(d[1], "50%"),
                h(g && g < 0 ? void 0 : t.size, "100%"),
                h(f && f < 0 ? void 0 : t.innerSize || 0, "0%")
            ];
            for(!i.angular || this instanceof e || (y[3] = 0), m = 0; m < 4; ++m)x = y[m], u = m < 2 || 2 === m && /%$/.test(x), y[m] = l(x, [
                r,
                o,
                c,
                y[2]
            ][m]) + (u ? s : 0);
            return y[3] > y[2] && (y[3] = y[2]), n(p) && 2 * p < y[2] && p > 0 && (y[3] = y[2] - 2 * p), a(this, "afterGetCenter", {
                positions: y
            }), y;
        }, r.getStartAndEndRadians = function(t, e) {
            let i = n(t) ? t : 0, s = n(e) && e > i && e - i < 360 ? e : i + 360;
            return {
                start: o * (i + -90),
                end: o * (s + -90)
            };
        }, s;
    }), i(e, "Series/Pie/PiePoint.js", [
        e["Core/Animation/AnimationUtilities.js"],
        e["Core/Series/Point.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i) {
        let { setAnimation: s } = t, { addEvent: r, defined: o, extend: a, isNumber: n, pick: h, relativeLength: l } = i;
        class d extends e {
            getConnectorPath(t) {
                let e = t.dataLabelPosition, i = t.options || {}, s = i.connectorShape, r = this.connectorShapes[s] || s;
                return e && r.call(this, {
                    ...e.computed,
                    alignment: e.alignment
                }, e.connectorPosition, i) || [];
            }
            getTranslate() {
                return this.sliced && this.slicedTranslation || {
                    translateX: 0,
                    translateY: 0
                };
            }
            haloPath(t) {
                let e = this.shapeArgs;
                return this.sliced || !this.visible ? [] : this.series.chart.renderer.symbols.arc(e.x, e.y, e.r + t, e.r + t, {
                    innerR: e.r - 1,
                    start: e.start,
                    end: e.end,
                    borderRadius: e.borderRadius
                });
            }
            constructor(t, e, i){
                super(t, e, i), this.half = 0, this.name ?? (this.name = "Slice");
                let s = (t)=>{
                    this.slice("select" === t.type);
                };
                r(this, "select", s), r(this, "unselect", s);
            }
            isValid() {
                return n(this.y) && this.y >= 0;
            }
            setVisible(t, e = !0) {
                t !== this.visible && this.update({
                    visible: t ?? !this.visible
                }, e, void 0, !1);
            }
            slice(t, e, i) {
                let r = this.series;
                s(i, r.chart), e = h(e, !0), this.sliced = this.options.sliced = t = o(t) ? t : !this.sliced, r.options.data[r.data.indexOf(this)] = this.options, this.graphic && this.graphic.animate(this.getTranslate());
            }
        }
        return a(d.prototype, {
            connectorShapes: {
                fixedOffset: function(t, e, i) {
                    let s = e.breakAt, r = e.touchingSliceAt, o = i.softConnector ? [
                        "C",
                        t.x + ("left" === t.alignment ? -5 : 5),
                        t.y,
                        2 * s.x - r.x,
                        2 * s.y - r.y,
                        s.x,
                        s.y
                    ] : [
                        "L",
                        s.x,
                        s.y
                    ];
                    return [
                        [
                            "M",
                            t.x,
                            t.y
                        ],
                        o,
                        [
                            "L",
                            r.x,
                            r.y
                        ]
                    ];
                },
                straight: function(t, e) {
                    let i = e.touchingSliceAt;
                    return [
                        [
                            "M",
                            t.x,
                            t.y
                        ],
                        [
                            "L",
                            i.x,
                            i.y
                        ]
                    ];
                },
                crookedLine: function(t, e, i) {
                    let { breakAt: s, touchingSliceAt: r } = e, { series: o } = this, [a, n, h] = o.center, d = h / 2, { plotLeft: c, plotWidth: p } = o.chart, u = "left" === t.alignment, { x: g, y: f } = t, m = s.x;
                    if (i.crookDistance) {
                        let t = l(i.crookDistance, 1);
                        m = u ? a + d + (p + c - a - d) * (1 - t) : c + (a - d) * t;
                    } else m = a + (n - f) * Math.tan((this.angle || 0) - Math.PI / 2);
                    let x = [
                        [
                            "M",
                            g,
                            f
                        ]
                    ];
                    return (u ? m <= g && m >= s.x : m >= g && m <= s.x) && x.push([
                        "L",
                        m,
                        f
                    ]), x.push([
                        "L",
                        s.x,
                        s.y
                    ], [
                        "L",
                        r.x,
                        r.y
                    ]), x;
                }
            }
        }), d;
    }), i(e, "Series/Pie/PieSeriesDefaults.js", [], function() {
        return {
            borderRadius: 3,
            center: [
                null,
                null
            ],
            clip: !1,
            colorByPoint: !0,
            dataLabels: {
                connectorPadding: 5,
                connectorShape: "crookedLine",
                crookDistance: void 0,
                distance: 30,
                enabled: !0,
                formatter: function() {
                    return this.point.isNull ? void 0 : this.point.name;
                },
                softConnector: !0,
                x: 0
            },
            fillColor: void 0,
            ignoreHiddenPoint: !0,
            inactiveOtherPoints: !0,
            legendType: "point",
            marker: null,
            size: null,
            showInLegend: !1,
            slicedOffset: 10,
            stickyTracking: !1,
            tooltip: {
                followPointer: !0
            },
            borderColor: "#ffffff",
            borderWidth: 1,
            lineWidth: void 0,
            states: {
                hover: {
                    brightness: .1
                }
            }
        };
    }), i(e, "Series/Pie/PieSeries.js", [
        e["Series/CenteredUtilities.js"],
        e["Series/Column/ColumnSeries.js"],
        e["Core/Globals.js"],
        e["Series/Pie/PiePoint.js"],
        e["Series/Pie/PieSeriesDefaults.js"],
        e["Core/Series/Series.js"],
        e["Core/Series/SeriesRegistry.js"],
        e["Core/Renderer/SVG/Symbols.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i, s, r, o, a, n, h) {
        let { getStartAndEndRadians: l } = t, { noop: d } = i, { clamp: c, extend: p, fireEvent: u, merge: g, pick: f } = h;
        class m extends o {
            animate(t) {
                let e = this, i = e.points, s = e.startAngleRad;
                t || i.forEach(function(t) {
                    let i = t.graphic, r = t.shapeArgs;
                    i && r && (i.attr({
                        r: f(t.startR, e.center && e.center[3] / 2),
                        start: s,
                        end: s
                    }), i.animate({
                        r: r.r,
                        start: r.start,
                        end: r.end
                    }, e.options.animation));
                });
            }
            drawEmpty() {
                let t, e;
                let i = this.startAngleRad, s = this.endAngleRad, r = this.options;
                0 === this.total && this.center ? (t = this.center[0], e = this.center[1], this.graph || (this.graph = this.chart.renderer.arc(t, e, this.center[1] / 2, 0, i, s).addClass("highcharts-empty-series").add(this.group)), this.graph.attr({
                    d: n.arc(t, e, this.center[2] / 2, 0, {
                        start: i,
                        end: s,
                        innerR: this.center[3] / 2
                    })
                }), this.chart.styledMode || this.graph.attr({
                    "stroke-width": r.borderWidth,
                    fill: r.fillColor || "none",
                    stroke: r.color || "#cccccc"
                })) : this.graph && (this.graph = this.graph.destroy());
            }
            drawPoints() {
                let t = this.chart.renderer;
                this.points.forEach(function(e) {
                    e.graphic && e.hasNewShapeType() && (e.graphic = e.graphic.destroy()), e.graphic || (e.graphic = t[e.shapeType](e.shapeArgs).add(e.series.group), e.delayedRendering = !0);
                });
            }
            generatePoints() {
                super.generatePoints(), this.updateTotals();
            }
            getX(t, e, i, s) {
                let r = this.center, o = this.radii ? this.radii[i.index] || 0 : r[2] / 2, a = s.dataLabelPosition, n = a?.distance || 0, h = Math.asin(c((t - r[1]) / (o + n), -1, 1));
                return r[0] + Math.cos(h) * (o + n) * (e ? -1 : 1) + (n > 0 ? (e ? -1 : 1) * (s.padding || 0) : 0);
            }
            hasData() {
                return !!this.processedXData.length;
            }
            redrawPoints() {
                let t, e, i, s;
                let r = this, o = r.chart;
                this.drawEmpty(), r.group && !o.styledMode && r.group.shadow(r.options.shadow), r.points.forEach(function(a) {
                    let n = {};
                    e = a.graphic, !a.isNull && e ? (s = a.shapeArgs, t = a.getTranslate(), o.styledMode || (i = r.pointAttribs(a, a.selected && "select")), a.delayedRendering ? (e.setRadialReference(r.center).attr(s).attr(t), o.styledMode || e.attr(i).attr({
                        "stroke-linejoin": "round"
                    }), a.delayedRendering = !1) : (e.setRadialReference(r.center), o.styledMode || g(!0, n, i), g(!0, n, s, t), e.animate(n)), e.attr({
                        visibility: a.visible ? "inherit" : "hidden"
                    }), e.addClass(a.getClassName(), !0)) : e && (a.graphic = e.destroy());
                });
            }
            sortByAngle(t, e) {
                t.sort(function(t, i) {
                    return void 0 !== t.angle && (i.angle - t.angle) * e;
                });
            }
            translate(t) {
                u(this, "translate"), this.generatePoints();
                let e = this.options, i = e.slicedOffset, s = l(e.startAngle, e.endAngle), r = this.startAngleRad = s.start, o = (this.endAngleRad = s.end) - r, a = this.points, n = e.ignoreHiddenPoint, h = a.length, d, c, p, g, f, m, x, y = 0;
                for(t || (this.center = t = this.getCenter()), m = 0; m < h; m++){
                    x = a[m], d = r + y * o, x.isValid() && (!n || x.visible) && (y += x.percentage / 100), c = r + y * o;
                    let e = {
                        x: t[0],
                        y: t[1],
                        r: t[2] / 2,
                        innerR: t[3] / 2,
                        start: Math.round(1e3 * d) / 1e3,
                        end: Math.round(1e3 * c) / 1e3
                    };
                    x.shapeType = "arc", x.shapeArgs = e, (p = (c + d) / 2) > 1.5 * Math.PI ? p -= 2 * Math.PI : p < -Math.PI / 2 && (p += 2 * Math.PI), x.slicedTranslation = {
                        translateX: Math.round(Math.cos(p) * i),
                        translateY: Math.round(Math.sin(p) * i)
                    }, g = Math.cos(p) * t[2] / 2, f = Math.sin(p) * t[2] / 2, x.tooltipPos = [
                        t[0] + .7 * g,
                        t[1] + .7 * f
                    ], x.half = p < -Math.PI / 2 || p > Math.PI / 2 ? 1 : 0, x.angle = p;
                }
                u(this, "afterTranslate");
            }
            updateTotals() {
                let t = this.points, e = t.length, i = this.options.ignoreHiddenPoint, s, r, o = 0;
                for(s = 0; s < e; s++)(r = t[s]).isValid() && (!i || r.visible) && (o += r.y);
                for(s = 0, this.total = o; s < e; s++)(r = t[s]).percentage = o > 0 && (r.visible || !i) ? r.y / o * 100 : 0, r.total = o;
            }
        }
        return m.defaultOptions = g(o.defaultOptions, r), p(m.prototype, {
            axisTypes: [],
            directTouch: !0,
            drawGraph: void 0,
            drawTracker: e.prototype.drawTracker,
            getCenter: t.getCenter,
            getSymbol: d,
            invertible: !1,
            isCartesian: !1,
            noSharedTooltip: !0,
            pointAttribs: e.prototype.pointAttribs,
            pointClass: s,
            requireSorting: !1,
            searchPoint: d,
            trackerGroups: [
                "group",
                "dataLabelsGroup"
            ]
        }), a.registerSeriesType("pie", m), m;
    }), i(e, "Series/Pie/PieDataLabel.js", [
        e["Core/Series/DataLabel.js"],
        e["Core/Globals.js"],
        e["Core/Renderer/RendererUtilities.js"],
        e["Core/Series/SeriesRegistry.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i, s, r) {
        var o;
        let { composed: a, noop: n } = e, { distribute: h } = i, { series: l } = s, { arrayMax: d, clamp: c, defined: p, pick: u, pushUnique: g, relativeLength: f } = r;
        return function(e) {
            let i = {
                radialDistributionY: function(t, e) {
                    return (e.dataLabelPosition?.top || 0) + t.distributeBox.pos;
                },
                radialDistributionX: function(t, e, i, s, r) {
                    let o = r.dataLabelPosition;
                    return t.getX(i < (o?.top || 0) + 2 || i > (o?.bottom || 0) - 2 ? s : i, e.half, e, r);
                },
                justify: function(t, e, i, s) {
                    return s[0] + (t.half ? -1 : 1) * (i + (e.dataLabelPosition?.distance || 0));
                },
                alignToPlotEdges: function(t, e, i, s) {
                    let r = t.getBBox().width;
                    return e ? r + s : i - r - s;
                },
                alignToConnectors: function(t, e, i, s) {
                    let r = 0, o;
                    return t.forEach(function(t) {
                        (o = t.dataLabel.getBBox().width) > r && (r = o);
                    }), e ? r + s : i - r - s;
                }
            };
            function s(t, e) {
                let { center: i, options: s } = this, r = i[2] / 2, o = t.angle || 0, a = Math.cos(o), n = Math.sin(o), h = i[0] + a * r, l = i[1] + n * r, d = Math.min((s.slicedOffset || 0) + (s.borderWidth || 0), e / 5);
                return {
                    natural: {
                        x: h + a * e,
                        y: l + n * e
                    },
                    computed: {},
                    alignment: e < 0 ? "center" : t.half ? "right" : "left",
                    connectorPosition: {
                        breakAt: {
                            x: h + a * d,
                            y: l + n * d
                        },
                        touchingSliceAt: {
                            x: h,
                            y: l
                        }
                    },
                    distance: e
                };
            }
            function r() {
                let t = this, e = t.points, i = t.chart, s = i.plotWidth, r = i.plotHeight, o = i.plotLeft, a = Math.round(i.chartWidth / 3), n = t.center, c = n[2] / 2, g = n[1], m = [
                    [],
                    []
                ], x = [
                    0,
                    0,
                    0,
                    0
                ], y = t.dataLabelPositioners, b, v, S, k = 0;
                t.visible && t.hasDataLabels?.() && (e.forEach((t)=>{
                    (t.dataLabels || []).forEach((t)=>{
                        t.shortened && (t.attr({
                            width: "auto"
                        }).css({
                            width: "auto",
                            textOverflow: "clip"
                        }), t.shortened = !1);
                    });
                }), l.prototype.drawDataLabels.apply(t), e.forEach((t)=>{
                    (t.dataLabels || []).forEach((e, i)=>{
                        let s = n[2] / 2, r = e.options, o = f(r?.distance || 0, s);
                        0 === i && m[t.half].push(t), !p(r?.style?.width) && e.getBBox().width > a && (e.css({
                            width: Math.round(.7 * a) + "px"
                        }), e.shortened = !0), e.dataLabelPosition = this.getDataLabelPosition(t, o), k = Math.max(k, o);
                    });
                }), m.forEach((e, a)=>{
                    let l = e.length, d = [], f, m, b = 0, C;
                    l && (t.sortByAngle(e, a - .5), k > 0 && (f = Math.max(0, g - c - k), m = Math.min(g + c + k, i.plotHeight), e.forEach((t)=>{
                        (t.dataLabels || []).forEach((e)=>{
                            let s = e.dataLabelPosition;
                            s && s.distance > 0 && (s.top = Math.max(0, g - c - s.distance), s.bottom = Math.min(g + c + s.distance, i.plotHeight), b = e.getBBox().height || 21, t.distributeBox = {
                                target: (e.dataLabelPosition?.natural.y || 0) - s.top + b / 2,
                                size: b,
                                rank: t.y
                            }, d.push(t.distributeBox));
                        });
                    }), h(d, C = m + b - f, C / 5)), e.forEach((i)=>{
                        (i.dataLabels || []).forEach((h)=>{
                            let l = h.options || {}, g = i.distributeBox, f = h.dataLabelPosition, m = f?.natural.y || 0, b = l.connectorPadding || 0, k = 0, C = m, M = "inherit";
                            if (f) {
                                if (d && p(g) && f.distance > 0 && (void 0 === g.pos ? M = "hidden" : (S = g.size, C = y.radialDistributionY(i, h))), l.justify) k = y.justify(i, h, c, n);
                                else switch(l.alignTo){
                                    case "connectors":
                                        k = y.alignToConnectors(e, a, s, o);
                                        break;
                                    case "plotEdges":
                                        k = y.alignToPlotEdges(h, a, s, o);
                                        break;
                                    default:
                                        k = y.radialDistributionX(t, i, C, m, h);
                                }
                                if (f.attribs = {
                                    visibility: M,
                                    align: f.alignment
                                }, f.posAttribs = {
                                    x: k + (l.x || 0) + (({
                                        left: b,
                                        right: -b
                                    })[f.alignment] || 0),
                                    y: C + (l.y || 0) - h.getBBox().height / 2
                                }, f.computed.x = k, f.computed.y = C, u(l.crop, !0)) {
                                    let t;
                                    k - (v = h.getBBox().width) < b && 1 === a ? (t = Math.round(v - k + b), x[3] = Math.max(t, x[3])) : k + v > s - b && 0 === a && (t = Math.round(k + v - s + b), x[1] = Math.max(t, x[1])), C - S / 2 < 0 ? x[0] = Math.max(Math.round(-C + S / 2), x[0]) : C + S / 2 > r && (x[2] = Math.max(Math.round(C + S / 2 - r), x[2])), f.sideOverflow = t;
                                }
                            }
                        });
                    }));
                }), (0 === d(x) || this.verifyDataLabelOverflow(x)) && (this.placeDataLabels(), this.points.forEach((e)=>{
                    (e.dataLabels || []).forEach((s)=>{
                        let { connectorColor: r, connectorWidth: o = 1 } = s.options || {}, a = s.dataLabelPosition;
                        if (o) {
                            let n;
                            b = s.connector, a && a.distance > 0 ? (n = !b, b || (s.connector = b = i.renderer.path().addClass("highcharts-data-label-connector  highcharts-color-" + e.colorIndex + (e.className ? " " + e.className : "")).add(t.dataLabelsGroup)), i.styledMode || b.attr({
                                "stroke-width": o,
                                stroke: r || e.color || "#666666"
                            }), b[n ? "attr" : "animate"]({
                                d: e.getConnectorPath(s)
                            }), b.attr({
                                visibility: a.attribs?.visibility
                            })) : b && (s.connector = b.destroy());
                        }
                    });
                })));
            }
            function o() {
                this.points.forEach((t)=>{
                    (t.dataLabels || []).forEach((t)=>{
                        let e = t.dataLabelPosition;
                        e ? (e.sideOverflow && (t.css({
                            width: Math.max(t.getBBox().width - e.sideOverflow, 0) + "px",
                            textOverflow: (t.options?.style || {}).textOverflow || "ellipsis"
                        }), t.shortened = !0), t.attr(e.attribs), t[t.moved ? "animate" : "attr"](e.posAttribs), t.moved = !0) : t && t.attr({
                            y: -9999
                        });
                    }), delete t.distributeBox;
                }, this);
            }
            function m(t) {
                let e = this.center, i = this.options, s = i.center, r = i.minSize || 80, o = r, a = null !== i.size;
                return !a && (null !== s[0] ? o = Math.max(e[2] - Math.max(t[1], t[3]), r) : (o = Math.max(e[2] - t[1] - t[3], r), e[0] += (t[3] - t[1]) / 2), null !== s[1] ? o = c(o, r, e[2] - Math.max(t[0], t[2])) : (o = c(o, r, e[2] - t[0] - t[2]), e[1] += (t[0] - t[2]) / 2), o < e[2] ? (e[2] = o, e[3] = Math.min(i.thickness ? Math.max(0, o - 2 * i.thickness) : Math.max(0, f(i.innerSize || 0, o)), o), this.translate(e), this.drawDataLabels && this.drawDataLabels()) : a = !0), a;
            }
            e.compose = function(e) {
                if (t.compose(l), g(a, "PieDataLabel")) {
                    let t = e.prototype;
                    t.dataLabelPositioners = i, t.alignDataLabel = n, t.drawDataLabels = r, t.getDataLabelPosition = s, t.placeDataLabels = o, t.verifyDataLabelOverflow = m;
                }
            };
        }(o || (o = {})), o;
    }), i(e, "Extensions/OverlappingDataLabels.js", [
        e["Core/Utilities.js"]
    ], function(t) {
        let { addEvent: e, fireEvent: i, objectEach: s, pick: r } = t;
        function o(t) {
            let e = t.length, s = (t, e)=>!(e.x >= t.x + t.width || e.x + e.width <= t.x || e.y >= t.y + t.height || e.y + e.height <= t.y), r, o, n, h, l, d = !1;
            for(let i = 0; i < e; i++)(r = t[i]) && (r.oldOpacity = r.opacity, r.newOpacity = 1, r.absoluteBox = function(t) {
                if (t && (!t.alignAttr || t.placed)) {
                    let e = t.box ? 0 : t.padding || 0, i = t.alignAttr || {
                        x: t.attr("x"),
                        y: t.attr("y")
                    }, s = t.getBBox();
                    return t.width = s.width, t.height = s.height, {
                        x: i.x + (t.parentGroup?.translateX || 0) + e,
                        y: i.y + (t.parentGroup?.translateY || 0) + e,
                        width: (t.width || 0) - 2 * e,
                        height: (t.height || 0) - 2 * e
                    };
                }
            }(r));
            t.sort((t, e)=>(e.labelrank || 0) - (t.labelrank || 0));
            for(let i = 0; i < e; ++i){
                h = (o = t[i]) && o.absoluteBox;
                for(let r = i + 1; r < e; ++r)l = (n = t[r]) && n.absoluteBox, h && l && o !== n && 0 !== o.newOpacity && 0 !== n.newOpacity && "hidden" !== o.visibility && "hidden" !== n.visibility && s(h, l) && ((o.labelrank < n.labelrank ? o : n).newOpacity = 0);
            }
            for (let e of t)a(e, this) && (d = !0);
            d && i(this, "afterHideAllOverlappingLabels");
        }
        function a(t, e) {
            let s, r, o = !1;
            return t && (r = t.newOpacity, t.oldOpacity !== r && (t.hasClass("highcharts-data-label") ? (t[r ? "removeClass" : "addClass"]("highcharts-data-label-hidden"), s = function() {
                e.styledMode || t.css({
                    pointerEvents: r ? "auto" : "none"
                });
            }, o = !0, t[t.isOld ? "animate" : "attr"]({
                opacity: r
            }, void 0, s), i(e, "afterHideOverlappingLabel")) : t.attr({
                opacity: r
            })), t.isOld = !0), o;
        }
        function n() {
            let t = this, e = [];
            for (let i of t.labelCollectors || [])e = e.concat(i());
            for (let i of t.yAxis || [])i.stacking && i.options.stackLabels && !i.options.stackLabels.allowOverlap && s(i.stacking.stacks, (t)=>{
                s(t, (t)=>{
                    t.label && e.push(t.label);
                });
            });
            for (let i of t.series || [])if (i.visible && i.hasDataLabels?.()) {
                let s = (i)=>{
                    for (let s of i)s.visible && (s.dataLabels || []).forEach((i)=>{
                        let o = i.options || {};
                        i.labelrank = r(o.labelrank, s.labelrank, s.shapeArgs?.height), o.allowOverlap ?? Number(o.distance) > 0 ? (i.oldOpacity = i.opacity, i.newOpacity = 1, a(i, t)) : e.push(i);
                    });
                };
                s(i.nodes || []), s(i.points);
            }
            this.hideOverlappingLabels(e);
        }
        return {
            compose: function(t) {
                let i = t.prototype;
                i.hideOverlappingLabels || (i.hideOverlappingLabels = o, e(t, "render", n));
            }
        };
    }), i(e, "Extensions/BorderRadius.js", [
        e["Core/Defaults.js"],
        e["Core/Globals.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i) {
        let { defaultOptions: s } = t, { noop: r } = e, { addEvent: o, extend: a, isObject: n, merge: h, relativeLength: l } = i, d = {
            radius: 0,
            scope: "stack",
            where: void 0
        }, c = r, p = r;
        function u(t, e, i, s, r = {}) {
            let o = c(t, e, i, s, r), { innerR: a = 0, r: n = i, start: h = 0, end: d = 0 } = r;
            if (r.open || !r.borderRadius) return o;
            let p = d - h, u = Math.sin(p / 2), g = Math.max(Math.min(l(r.borderRadius || 0, n - a), (n - a) / 2, n * u / (1 + u)), 0), f = Math.min(g, p / Math.PI * 2 * a), m = o.length - 1;
            for(; m--;)!function(t, e, i) {
                let s, r, o;
                let a = t[e], n = t[e + 1];
                if ("Z" === n[0] && (n = t[0]), ("M" === a[0] || "L" === a[0]) && "A" === n[0] ? (s = a, r = n, o = !0) : "A" === a[0] && ("M" === n[0] || "L" === n[0]) && (s = n, r = a), s && r && r.params) {
                    let a = r[1], n = r[5], h = r.params, { start: l, end: d, cx: c, cy: p } = h, u = n ? a - i : a + i, g = u ? Math.asin(i / u) : 0, f = n ? g : -g, m = Math.cos(g) * u;
                    o ? (h.start = l + f, s[1] = c + m * Math.cos(l), s[2] = p + m * Math.sin(l), t.splice(e + 1, 0, [
                        "A",
                        i,
                        i,
                        0,
                        0,
                        1,
                        c + a * Math.cos(h.start),
                        p + a * Math.sin(h.start)
                    ])) : (h.end = d - f, r[6] = c + a * Math.cos(h.end), r[7] = p + a * Math.sin(h.end), t.splice(e + 1, 0, [
                        "A",
                        i,
                        i,
                        0,
                        0,
                        1,
                        c + m * Math.cos(d),
                        p + m * Math.sin(d)
                    ])), r[4] = Math.abs(h.end - h.start) < Math.PI ? 0 : 1;
                }
            }(o, m, m > 1 ? f : g);
            return o;
        }
        function g() {
            if (this.options.borderRadius && !(this.chart.is3d && this.chart.is3d())) {
                let { options: t, yAxis: e } = this, i = "percent" === t.stacking, r = s.plotOptions?.[this.type]?.borderRadius, o = f(t.borderRadius, n(r) ? r : {}), h = e.options.reversed;
                for (let s of this.points){
                    let { shapeArgs: r } = s;
                    if ("roundedRect" === s.shapeType && r) {
                        let { width: n = 0, height: d = 0, y: c = 0 } = r, p = c, u = d;
                        if ("stack" === o.scope && s.stackTotal) {
                            let r = e.translate(i ? 100 : s.stackTotal, !1, !0, !1, !0), o = e.translate(t.threshold || 0, !1, !0, !1, !0), a = this.crispCol(0, Math.min(r, o), 0, Math.abs(r - o));
                            p = a.y, u = a.height;
                        }
                        let g = (s.negative ? -1 : 1) * (h ? -1 : 1) == -1, f = o.where;
                        !f && this.is("waterfall") && Math.abs((s.yBottom || 0) - (this.translatedThreshold || 0)) > this.borderWidth && (f = "all"), f || (f = "end");
                        let m = Math.min(l(o.radius, n), n / 2, "all" === f ? d / 2 : 1 / 0) || 0;
                        "end" === f && (g && (p -= m), u += m), a(r, {
                            brBoxHeight: u,
                            brBoxY: p,
                            r: m
                        });
                    }
                }
            }
        }
        function f(t, e) {
            return n(t) || (t = {
                radius: t || 0
            }), h(d, e, t);
        }
        function m() {
            let t = f(this.options.borderRadius);
            for (let e of this.points){
                let i = e.shapeArgs;
                i && (i.borderRadius = l(t.radius, (i.r || 0) - (i.innerR || 0)));
            }
        }
        function x(t, e, i, s, r = {}) {
            let o = p(t, e, i, s, r), { r: a = 0, brBoxHeight: n = s, brBoxY: h = e } = r, l = e - h, d = h + n - (e + s), c = l - a > -0.1 ? 0 : a, u = d - a > -0.1 ? 0 : a, g = Math.max(c && l, 0), f = Math.max(u && d, 0), m = [
                t + c,
                e
            ], x = [
                t + i - c,
                e
            ], y = [
                t + i,
                e + c
            ], b = [
                t + i,
                e + s - u
            ], v = [
                t + i - u,
                e + s
            ], S = [
                t + u,
                e + s
            ], k = [
                t,
                e + s - u
            ], C = [
                t,
                e + c
            ], M = (t, e)=>Math.sqrt(Math.pow(t, 2) - Math.pow(e, 2));
            if (g) {
                let t = M(c, c - g);
                m[0] -= t, x[0] += t, y[1] = C[1] = e + c - g;
            }
            if (s < c - g) {
                let r = M(c, c - g - s);
                y[0] = b[0] = t + i - c + r, v[0] = Math.min(y[0], v[0]), S[0] = Math.max(b[0], S[0]), k[0] = C[0] = t + c - r, y[1] = C[1] = e + s;
            }
            if (f) {
                let t = M(u, u - f);
                v[0] += t, S[0] -= t, b[1] = k[1] = e + s - u + f;
            }
            if (s < u - f) {
                let r = M(u, u - f - s);
                y[0] = b[0] = t + i - u + r, x[0] = Math.min(y[0], x[0]), m[0] = Math.max(b[0], m[0]), k[0] = C[0] = t + u - r, b[1] = k[1] = e;
            }
            return o.length = 0, o.push([
                "M",
                ...m
            ], [
                "L",
                ...x
            ], [
                "A",
                c,
                c,
                0,
                0,
                1,
                ...y
            ], [
                "L",
                ...b
            ], [
                "A",
                u,
                u,
                0,
                0,
                1,
                ...v
            ], [
                "L",
                ...S
            ], [
                "A",
                u,
                u,
                0,
                0,
                1,
                ...k
            ], [
                "L",
                ...C
            ], [
                "A",
                c,
                c,
                0,
                0,
                1,
                ...m
            ], [
                "Z"
            ]), o;
        }
        return {
            compose: function(t, e, i) {
                let s = t.types.pie;
                if (!e.symbolCustomAttribs.includes("borderRadius")) {
                    let r = i.prototype.symbols;
                    o(t, "afterColumnTranslate", g, {
                        order: 9
                    }), o(s, "afterTranslate", m), e.symbolCustomAttribs.push("borderRadius", "brBoxHeight", "brBoxY"), c = r.arc, p = r.roundedRect, r.arc = u, r.roundedRect = x;
                }
            },
            optionsToObject: f
        };
    }), i(e, "Core/Responsive.js", [
        e["Core/Utilities.js"]
    ], function(t) {
        var e;
        let { diffObjects: i, extend: s, find: r, merge: o, pick: a, uniqueKey: n } = t;
        return function(t) {
            function e(t, e) {
                let i = t.condition;
                (i.callback || function() {
                    return this.chartWidth <= a(i.maxWidth, Number.MAX_VALUE) && this.chartHeight <= a(i.maxHeight, Number.MAX_VALUE) && this.chartWidth >= a(i.minWidth, 0) && this.chartHeight >= a(i.minHeight, 0);
                }).call(this) && e.push(t._id);
            }
            function h(t, e) {
                let s = this.options.responsive, a = this.currentResponsive, h = [], l;
                !e && s && s.rules && s.rules.forEach((t)=>{
                    void 0 === t._id && (t._id = n()), this.matchResponsiveRule(t, h);
                }, this);
                let d = o(...h.map((t)=>r((s || {}).rules || [], (e)=>e._id === t)).map((t)=>t && t.chartOptions));
                d.isResponsiveOptions = !0, h = h.toString() || void 0;
                let c = a && a.ruleIds;
                h !== c && (a && this.update(a.undoOptions, t, !0), h ? ((l = i(d, this.options, !0, this.collectionsWithUpdate)).isResponsiveOptions = !0, this.currentResponsive = {
                    ruleIds: h,
                    mergedOptions: d,
                    undoOptions: l
                }, this.update(d, t, !0)) : this.currentResponsive = void 0);
            }
            t.compose = function(t) {
                let i = t.prototype;
                return i.matchResponsiveRule || s(i, {
                    matchResponsiveRule: e,
                    setResponsive: h
                }), t;
            };
        }(e || (e = {})), e;
    }), i(e, "masters/highcharts.src.js", [
        e["Core/Globals.js"],
        e["Core/Utilities.js"],
        e["Core/Defaults.js"],
        e["Core/Animation/Fx.js"],
        e["Core/Animation/AnimationUtilities.js"],
        e["Core/Renderer/HTML/AST.js"],
        e["Core/Templating.js"],
        e["Core/Renderer/RendererRegistry.js"],
        e["Core/Renderer/RendererUtilities.js"],
        e["Core/Renderer/SVG/SVGElement.js"],
        e["Core/Renderer/SVG/SVGRenderer.js"],
        e["Core/Renderer/HTML/HTMLElement.js"],
        e["Core/Axis/Axis.js"],
        e["Core/Axis/DateTimeAxis.js"],
        e["Core/Axis/LogarithmicAxis.js"],
        e["Core/Axis/PlotLineOrBand/PlotLineOrBand.js"],
        e["Core/Axis/Tick.js"],
        e["Core/Tooltip.js"],
        e["Core/Series/Point.js"],
        e["Core/Pointer.js"],
        e["Core/Legend/Legend.js"],
        e["Core/Legend/LegendSymbol.js"],
        e["Core/Chart/Chart.js"],
        e["Extensions/ScrollablePlotArea.js"],
        e["Core/Axis/Stacking/StackingAxis.js"],
        e["Core/Axis/Stacking/StackItem.js"],
        e["Core/Series/Series.js"],
        e["Core/Series/SeriesRegistry.js"],
        e["Series/Column/ColumnDataLabel.js"],
        e["Series/Pie/PieDataLabel.js"],
        e["Core/Series/DataLabel.js"],
        e["Extensions/OverlappingDataLabels.js"],
        e["Extensions/BorderRadius.js"],
        e["Core/Responsive.js"],
        e["Core/Color/Color.js"],
        e["Core/Time.js"]
    ], function(t, e, i, s, r, o, a, n, h, l, d, c, p, u, g, f, m, x, y, b, v, S, k, C, M, w, T, A, P, L, O, D, E, I, j, B) {
        return t.AST = o, t.Axis = p, t.Chart = k, t.Color = j, t.DataLabel = O, t.Fx = s, t.HTMLElement = c, t.Legend = v, t.LegendSymbol = S, t.OverlappingDataLabels = t.OverlappingDataLabels || D, t.PlotLineOrBand = f, t.Point = y, t.Pointer = b, t.RendererRegistry = n, t.Series = T, t.SeriesRegistry = A, t.StackItem = w, t.SVGElement = l, t.SVGRenderer = d, t.Templating = a, t.Tick = m, t.Time = B, t.Tooltip = x, t.animate = r.animate, t.animObject = r.animObject, t.chart = k.chart, t.color = j.parse, t.dateFormat = a.dateFormat, t.defaultOptions = i.defaultOptions, t.distribute = h.distribute, t.format = a.format, t.getDeferredAnimation = r.getDeferredAnimation, t.getOptions = i.getOptions, t.numberFormat = a.numberFormat, t.seriesType = A.seriesType, t.setAnimation = r.setAnimation, t.setOptions = i.setOptions, t.stop = r.stop, t.time = i.defaultTime, t.timers = s.timers, E.compose(t.Series, t.SVGElement, t.SVGRenderer), P.compose(t.Series.types.column), O.compose(t.Series), u.compose(t.Axis), c.compose(t.SVGRenderer), v.compose(t.Chart), g.compose(t.Axis), D.compose(t.Chart), L.compose(t.Series.types.pie), f.compose(t.Axis), b.compose(t.Chart), I.compose(t.Chart), C.compose(t.Axis, t.Chart, t.Series), M.compose(t.Axis, t.Chart, t.Series), x.compose(t.Pointer), e.extend(t, e), t;
    }), e["masters/highcharts.src.js"]._modules = e, e["masters/highcharts.src.js"];
});



var $bgb0K = parcelRequire("bgb0K");

var $6v3SG = parcelRequire("6v3SG");

var $hNNPC = parcelRequire("hNNPC");

var $iMzGG = parcelRequire("iMzGG");
var $3ea97dafd17a1a6b$exports = {};
!/**
 * Highcharts JS v11.4.0 (2024-03-04)
 *
 * (c) 2016-2024 Highsoft AS
 * Authors: Jon Arild Nygard
 *
 * License: www.highcharts.com/license
 */ function(t) {
    (0, $3ea97dafd17a1a6b$exports) ? (t.default = t, $3ea97dafd17a1a6b$exports = t) : "function" == typeof define && define.amd ? define("highcharts/modules/sunburst", [
        "highcharts"
    ], function(e) {
        return t(e), t.Highcharts = e, t;
    }) : t("undefined" != typeof Highcharts ? Highcharts : void 0);
}(function(t) {
    "use strict";
    var e = t ? t._modules : {};
    function i(t, e, i, s) {
        t.hasOwnProperty(e) || (t[e] = s.apply(null, i), "function" == typeof CustomEvent && window.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", {
            detail: {
                path: e,
                module: t[e]
            }
        })));
    }
    i(e, "Extensions/Breadcrumbs/BreadcrumbsDefaults.js", [], function() {
        return {
            lang: {
                mainBreadcrumb: "Main"
            },
            options: {
                buttonTheme: {
                    fill: "none",
                    height: 18,
                    padding: 2,
                    "stroke-width": 0,
                    zIndex: 7,
                    states: {
                        select: {
                            fill: "none"
                        }
                    },
                    style: {
                        color: "#334eff"
                    }
                },
                buttonSpacing: 5,
                floating: !1,
                format: void 0,
                relativeTo: "plotBox",
                rtl: !1,
                position: {
                    align: "left",
                    verticalAlign: "top",
                    x: 0,
                    y: void 0
                },
                separator: {
                    text: "/",
                    style: {
                        color: "#666666",
                        fontSize: "0.8em"
                    }
                },
                showFullPath: !0,
                style: {},
                useHTML: !1,
                zIndex: 7
            }
        };
    }), i(e, "Extensions/Breadcrumbs/Breadcrumbs.js", [
        e["Extensions/Breadcrumbs/BreadcrumbsDefaults.js"],
        e["Core/Templating.js"],
        e["Core/Globals.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i, s) {
        let { format: r } = e, { composed: o } = i, { addEvent: l, defined: a, extend: n, fireEvent: h, isString: d, merge: p, objectEach: u, pick: c, pushUnique: g } = s;
        function v() {
            if (this.breadcrumbs) {
                let t = this.resetZoomButton && this.resetZoomButton.getBBox(), e = this.breadcrumbs.options;
                t && "right" === e.position.align && "plotBox" === e.relativeTo && this.breadcrumbs.alignBreadcrumbsGroup(-t.width - e.buttonSpacing);
            }
        }
        function b() {
            this.breadcrumbs && (this.breadcrumbs.destroy(), this.breadcrumbs = void 0);
        }
        function m() {
            let t = this.breadcrumbs;
            if (t && !t.options.floating && t.level) {
                let e = t.options, i = e.buttonTheme, s = (i.height || 0) + 2 * (i.padding || 0) + e.buttonSpacing, r = e.position.verticalAlign;
                "bottom" === r ? (this.marginBottom = (this.marginBottom || 0) + s, t.yOffset = s) : "middle" !== r ? (this.plotTop += s, t.yOffset = -s) : t.yOffset = void 0;
            }
        }
        function f() {
            this.breadcrumbs && this.breadcrumbs.redraw();
        }
        function y(t) {
            !0 === t.resetSelection && this.breadcrumbs && this.breadcrumbs.alignBreadcrumbsGroup();
        }
        class x {
            static compose(e, i) {
                g(o, "Breadcrumbs") && (l(e, "destroy", b), l(e, "afterShowResetZoom", v), l(e, "getMargins", m), l(e, "redraw", f), l(e, "selection", y), n(i.lang, t.lang));
            }
            constructor(t, e){
                this.elementList = {}, this.isDirty = !0, this.level = 0, this.list = [];
                let i = p(t.options.drilldown && t.options.drilldown.drillUpButton, x.defaultOptions, t.options.navigation && t.options.navigation.breadcrumbs, e);
                this.chart = t, this.options = i || {};
            }
            updateProperties(t) {
                this.setList(t), this.setLevel(), this.isDirty = !0;
            }
            setList(t) {
                this.list = t;
            }
            setLevel() {
                this.level = this.list.length && this.list.length - 1;
            }
            getLevel() {
                return this.level;
            }
            getButtonText(t) {
                let e = this.chart, i = this.options, s = e.options.lang, o = c(i.format, i.showFullPath ? "{level.name}" : "\u2190 {level.name}"), l = s && c(s.drillUpText, s.mainBreadcrumb), n = i.formatter && i.formatter(t) || r(o, {
                    level: t.levelOptions
                }, e) || "";
                return (d(n) && !n.length || "\u2190 " === n) && a(l) && (n = i.showFullPath ? l : "\u2190 " + l), n;
            }
            redraw() {
                this.isDirty && this.render(), this.group && this.group.align(), this.isDirty = !1;
            }
            render() {
                let t = this.chart, e = this.options;
                !this.group && e && (this.group = t.renderer.g("breadcrumbs-group").addClass("highcharts-no-tooltip highcharts-breadcrumbs").attr({
                    zIndex: e.zIndex
                }).add()), e.showFullPath ? this.renderFullPathButtons() : this.renderSingleButton(), this.alignBreadcrumbsGroup();
            }
            renderFullPathButtons() {
                this.destroySingleButton(), this.resetElementListState(), this.updateListElements(), this.destroyListElements();
            }
            renderSingleButton() {
                let t = this.chart, e = this.list, i = this.options.buttonSpacing;
                this.destroyListElements();
                let s = this.group ? this.group.getBBox().width : i, r = e[e.length - 2];
                !t.drillUpButton && this.level > 0 ? t.drillUpButton = this.renderButton(r, s, i) : t.drillUpButton && (this.level > 0 ? this.updateSingleButton() : this.destroySingleButton());
            }
            alignBreadcrumbsGroup(t) {
                if (this.group) {
                    let e = this.options, i = e.buttonTheme, s = e.position, r = "chart" === e.relativeTo || "spacingBox" === e.relativeTo ? void 0 : "plotBox", o = this.group.getBBox(), l = 2 * (i.padding || 0) + e.buttonSpacing;
                    s.width = o.width + l, s.height = o.height + l;
                    let a = p(s);
                    t && (a.x += t), this.options.rtl && (a.x += s.width), a.y = c(a.y, this.yOffset, 0), this.group.align(a, !0, r);
                }
            }
            renderButton(t, e, i) {
                let s = this, r = this.chart, o = s.options, l = p(o.buttonTheme), a = r.renderer.button(s.getButtonText(t), e, i, function(e) {
                    let i;
                    let r = o.events && o.events.click;
                    r && (i = r.call(s, e, t)), !1 !== i && (o.showFullPath ? e.newLevel = t.level : e.newLevel = s.level - 1, h(s, "up", e));
                }, l).addClass("highcharts-breadcrumbs-button").add(s.group);
                return r.styledMode || a.attr(o.style), a;
            }
            renderSeparator(t, e) {
                let i = this.chart, s = this.options.separator, r = i.renderer.label(s.text, t, e, void 0, void 0, void 0, !1).addClass("highcharts-breadcrumbs-separator").add(this.group);
                return i.styledMode || r.css(s.style), r;
            }
            update(t) {
                p(!0, this.options, t), this.destroy(), this.isDirty = !0;
            }
            updateSingleButton() {
                let t = this.chart, e = this.list[this.level - 1];
                t.drillUpButton && t.drillUpButton.attr({
                    text: this.getButtonText(e)
                });
            }
            destroy() {
                this.destroySingleButton(), this.destroyListElements(!0), this.group && this.group.destroy(), this.group = void 0;
            }
            destroyListElements(t) {
                let e = this.elementList;
                u(e, (i, s)=>{
                    (t || !e[s].updated) && ((i = e[s]).button && i.button.destroy(), i.separator && i.separator.destroy(), delete i.button, delete i.separator, delete e[s]);
                }), t && (this.elementList = {});
            }
            destroySingleButton() {
                this.chart.drillUpButton && (this.chart.drillUpButton.destroy(), this.chart.drillUpButton = void 0);
            }
            resetElementListState() {
                u(this.elementList, (t)=>{
                    t.updated = !1;
                });
            }
            updateListElements() {
                let t = this.elementList, e = this.options.buttonSpacing, i = this.list, s = this.options.rtl, r = s ? -1 : 1, o = function(t, e) {
                    return r * t.getBBox().width + r * e;
                }, l = function(t, e, i) {
                    t.translate(e - t.getBBox().width, i);
                }, a = this.group ? o(this.group, e) : e, n, h;
                for(let d = 0, p = i.length; d < p; ++d){
                    let u, c;
                    let g = d === p - 1;
                    t[(h = i[d]).level] ? (u = (n = t[h.level]).button, n.separator || g ? n.separator && g && (n.separator.destroy(), delete n.separator) : (a += r * e, n.separator = this.renderSeparator(a, e), s && l(n.separator, a, e), a += o(n.separator, e)), t[h.level].updated = !0) : (u = this.renderButton(h, a, e), s && l(u, a, e), a += o(u, e), g || (c = this.renderSeparator(a, e), s && l(c, a, e), a += o(c, e)), t[h.level] = {
                        button: u,
                        separator: c,
                        updated: !0
                    }), u && u.setState(g ? 2 : 0);
                }
            }
        }
        return x.defaultOptions = t.options, x;
    }), i(e, "Series/ColorMapComposition.js", [
        e["Core/Series/SeriesRegistry.js"],
        e["Core/Utilities.js"]
    ], function(t, e) {
        var i;
        let { column: { prototype: s } } = t.seriesTypes, { addEvent: r, defined: o } = e;
        return function(t) {
            function e(t) {
                this.moveToTopOnHover && this.graphic && this.graphic.attr({
                    zIndex: t && "hover" === t.state ? 1 : 0
                });
            }
            t.pointMembers = {
                dataLabelOnNull: !0,
                moveToTopOnHover: !0,
                isValid: function() {
                    return null !== this.value && this.value !== 1 / 0 && this.value !== -1 / 0 && (void 0 === this.value || !isNaN(this.value));
                }
            }, t.seriesMembers = {
                colorKey: "value",
                axisTypes: [
                    "xAxis",
                    "yAxis",
                    "colorAxis"
                ],
                parallelArrays: [
                    "x",
                    "y",
                    "value"
                ],
                pointArrayMap: [
                    "value"
                ],
                trackerGroups: [
                    "group",
                    "markerGroup",
                    "dataLabelsGroup"
                ],
                colorAttribs: function(t) {
                    let e = {};
                    return o(t.color) && (!t.state || "normal" === t.state) && (e[this.colorProp || "fill"] = t.color), e;
                },
                pointAttribs: s.pointAttribs
            }, t.compose = function(t) {
                return r(t.prototype.pointClass, "afterSetState", e), t;
            };
        }(i || (i = {})), i;
    }), i(e, "Series/Treemap/TreemapAlgorithmGroup.js", [], function() {
        return class {
            constructor(t, e, i, s){
                this.height = t, this.width = e, this.plot = s, this.direction = i, this.startDirection = i, this.total = 0, this.nW = 0, this.lW = 0, this.nH = 0, this.lH = 0, this.elArr = [], this.lP = {
                    total: 0,
                    lH: 0,
                    nH: 0,
                    lW: 0,
                    nW: 0,
                    nR: 0,
                    lR: 0,
                    aspectRatio: function(t, e) {
                        return Math.max(t / e, e / t);
                    }
                };
            }
            addElement(t) {
                this.lP.total = this.elArr[this.elArr.length - 1], this.total = this.total + t, 0 === this.direction ? (this.lW = this.nW, this.lP.lH = this.lP.total / this.lW, this.lP.lR = this.lP.aspectRatio(this.lW, this.lP.lH), this.nW = this.total / this.height, this.lP.nH = this.lP.total / this.nW, this.lP.nR = this.lP.aspectRatio(this.nW, this.lP.nH)) : (this.lH = this.nH, this.lP.lW = this.lP.total / this.lH, this.lP.lR = this.lP.aspectRatio(this.lP.lW, this.lH), this.nH = this.total / this.width, this.lP.nW = this.lP.total / this.nH, this.lP.nR = this.lP.aspectRatio(this.lP.nW, this.nH)), this.elArr.push(t);
            }
            reset() {
                this.nW = 0, this.lW = 0, this.elArr = [], this.total = 0;
            }
        };
    }), i(e, "Series/Treemap/TreemapNode.js", [], function() {
        return class {
            constructor(){
                this.childrenTotal = 0, this.visible = !1;
            }
            init(t, e, i, s, r, o, l) {
                return this.id = t, this.i = e, this.children = i, this.height = s, this.level = r, this.series = o, this.parent = l, this;
            }
        };
    }), i(e, "Series/DrawPointUtilities.js", [], function() {
        return {
            draw: function(t, e) {
                let { animatableAttribs: i, onComplete: s, css: r, renderer: o } = e, l = t.series && t.series.chart.hasRendered ? void 0 : t.series && t.series.options.animation, a = t.graphic;
                if (e.attribs = {
                    ...e.attribs,
                    class: t.getClassName()
                }, t.shouldDraw()) a || (a = "text" === e.shapeType ? o.text() : "image" === e.shapeType ? o.image(e.imageUrl || "").attr(e.shapeArgs || {}) : o[e.shapeType](e.shapeArgs || {}), t.graphic = a, a.add(e.group)), r && a.css(r), a.attr(e.attribs).animate(i, !e.isNew && l, s);
                else if (a) {
                    let e = ()=>{
                        t.graphic = a = a && a.destroy(), "function" == typeof s && s();
                    };
                    Object.keys(i).length ? a.animate(i, void 0, ()=>e()) : e();
                }
            }
        };
    }), i(e, "Series/Treemap/TreemapPoint.js", [
        e["Series/DrawPointUtilities.js"],
        e["Core/Series/SeriesRegistry.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i) {
        let { pie: { prototype: { pointClass: s } }, scatter: { prototype: { pointClass: r } } } = e.seriesTypes, { extend: o, isNumber: l, pick: a } = i;
        class n extends r {
            constructor(){
                super(...arguments), this.shapeType = "rect";
            }
            draw(e) {
                t.draw(this, e);
            }
            getClassName() {
                let t = this.series, e = t.options, i = super.getClassName();
                return this.node.level <= t.nodeMap[t.rootNode].level ? i += " highcharts-above-level" : this.node.isLeaf || a(e.interactByLeaf, !e.allowTraversingTree) ? this.node.isLeaf || (i += " highcharts-internal-node") : i += " highcharts-internal-node-interactive", i;
            }
            isValid() {
                return !!(this.id || l(this.value));
            }
            setState(t) {
                super.setState.apply(this, arguments), this.graphic && this.graphic.attr({
                    zIndex: "hover" === t ? 1 : 0
                });
            }
            shouldDraw() {
                return l(this.plotY) && null !== this.y;
            }
        }
        return o(n.prototype, {
            setVisible: s.prototype.setVisible
        }), n;
    }), i(e, "Series/Treemap/TreemapSeriesDefaults.js", [
        e["Core/Series/SeriesRegistry.js"],
        e["Core/Utilities.js"]
    ], function(t, e) {
        let { isString: i } = e;
        return {
            allowTraversingTree: !1,
            animationLimit: 250,
            borderRadius: 0,
            showInLegend: !1,
            marker: void 0,
            colorByPoint: !1,
            dataLabels: {
                defer: !1,
                enabled: !0,
                formatter: function() {
                    let t = this && this.point ? this.point : {};
                    return i(t.name) ? t.name : "";
                },
                inside: !0,
                verticalAlign: "middle"
            },
            tooltip: {
                headerFormat: "",
                pointFormat: "<b>{point.name}</b>: {point.value}<br/>"
            },
            ignoreHiddenPoint: !0,
            layoutAlgorithm: "sliceAndDice",
            layoutStartingDirection: "vertical",
            alternateStartingDirection: !1,
            levelIsConstant: !0,
            traverseUpButton: {
                position: {
                    align: "right",
                    x: -10,
                    y: 10
                }
            },
            borderColor: "#e6e6e6",
            borderWidth: 1,
            colorKey: "colorValue",
            opacity: .15,
            states: {
                hover: {
                    borderColor: "#999999",
                    brightness: t.seriesTypes.heatmap ? 0 : .1,
                    halo: !1,
                    opacity: .75,
                    shadow: !1
                }
            },
            legendSymbol: "rectangle"
        };
    }), i(e, "Series/Treemap/TreemapUtilities.js", [], function() {
        var t;
        return (t || (t = {})).recursive = function t(e, i, s) {
            let r;
            !1 !== (r = i.call(s || this, e)) && t(r, i, s);
        }, t;
    }), i(e, "Series/TreeUtilities.js", [
        e["Core/Color/Color.js"],
        e["Core/Utilities.js"]
    ], function(t, e) {
        let { extend: i, isArray: s, isNumber: r, isObject: o, merge: l, pick: a, relativeLength: n } = e;
        return {
            getColor: function(e, i) {
                let s, r, o, l, n, h;
                let d = i.index, p = i.mapOptionsToLevel, u = i.parentColor, c = i.parentColorIndex, g = i.series, v = i.colors, b = i.siblings, m = g.points, f = g.chart.options.chart;
                return e && (s = m[e.i], r = p[e.level] || {}, s && r.colorByPoint && (l = s.index % (v ? v.length : f.colorCount), o = v && v[l]), g.chart.styledMode || (n = a(s && s.options.color, r && r.color, o, u && ((e)=>{
                    let i = r && r.colorVariation;
                    return i && "brightness" === i.key && d && b ? t.parse(e).brighten(i.to * (d / b)).get() : e;
                })(u), g.color)), h = a(s && s.options.colorIndex, r && r.colorIndex, l, c, i.colorIndex)), {
                    color: n,
                    colorIndex: h
                };
            },
            getLevelOptions: function(t) {
                let e = {}, i, n, h, d, p, u;
                if (o(t)) for(d = r(t.from) ? t.from : 1, u = t.levels, n = {}, i = o(t.defaults) ? t.defaults : {}, s(u) && (n = u.reduce((t, e)=>{
                    let s, n, h;
                    return o(e) && r(e.level) && (n = a((h = l({}, e)).levelIsConstant, i.levelIsConstant), delete h.levelIsConstant, delete h.level, o(t[s = e.level + (n ? 0 : d - 1)]) ? l(!0, t[s], h) : t[s] = h), t;
                }, {})), p = r(t.to) ? t.to : 1, h = 0; h <= p; h++)e[h] = l({}, i, o(n[h]) ? n[h] : {});
                return e;
            },
            getNodeWidth: function(t, e) {
                let { chart: i, options: s } = t, { nodeDistance: r = 0, nodeWidth: o = 0 } = s, { plotSizeX: l = 1 } = i;
                if ("auto" === o) {
                    if ("string" == typeof r && /%$/.test(r)) return l / (e + parseFloat(r) / 100 * (e - 1));
                    let t = Number(r);
                    return (l + t) / (e || 1) - t;
                }
                return n(o, l);
            },
            setTreeValues: function t(e, s) {
                let r = s.before, o = s.idRoot, l = s.mapIdToNode[o], n = !1 !== s.levelIsConstant, h = s.points[e.i], d = h && h.options || {}, p = [], u = 0;
                e.levelDynamic = e.level - (n ? 0 : l.level), e.name = a(h && h.name, ""), e.visible = o === e.id || !0 === s.visible, "function" == typeof r && (e = r(e, s)), e.children.forEach((r, o)=>{
                    let l = i({}, s);
                    i(l, {
                        index: o,
                        siblings: e.children.length,
                        visible: e.visible
                    }), r = t(r, l), p.push(r), r.visible && (u += r.val);
                });
                let c = a(d.value, u);
                return e.visible = c >= 0 && (u > 0 || e.visible), e.children = p, e.childrenTotal = u, e.isLeaf = e.visible && !u, e.val = c, e;
            },
            updateRootId: function(t) {
                let e, i;
                return o(t) && (i = o(t.options) ? t.options : {}, e = a(t.rootNode, i.rootId, ""), o(t.userOptions) && (t.userOptions.rootId = e), t.rootNode = e), e;
            }
        };
    }), i(e, "Series/Treemap/TreemapSeries.js", [
        e["Extensions/Breadcrumbs/Breadcrumbs.js"],
        e["Core/Color/Color.js"],
        e["Series/ColorMapComposition.js"],
        e["Core/Globals.js"],
        e["Core/Series/SeriesRegistry.js"],
        e["Series/Treemap/TreemapAlgorithmGroup.js"],
        e["Series/Treemap/TreemapNode.js"],
        e["Series/Treemap/TreemapPoint.js"],
        e["Series/Treemap/TreemapSeriesDefaults.js"],
        e["Series/Treemap/TreemapUtilities.js"],
        e["Series/TreeUtilities.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i, s, r, o, l, a, n, h, d, p) {
        let { parse: u } = e, { composed: c, noop: g } = s, { column: v, scatter: b } = r.seriesTypes, { getColor: m, getLevelOptions: f, updateRootId: y } = d, { addEvent: x, correctFloat: T, defined: S, error: L, extend: P, fireEvent: w, isArray: A, isObject: C, isString: R, merge: B, pick: I, pushUnique: O, stableSort: M } = p, j = !1;
        function N() {
            let t;
            let e = this.xAxis, i = this.yAxis;
            e && i && (this.is("treemap") ? (t = {
                endOnTick: !1,
                gridLineWidth: 0,
                lineWidth: 0,
                min: 0,
                minPadding: 0,
                max: 100,
                maxPadding: 0,
                startOnTick: !1,
                title: void 0,
                tickPositions: []
            }, P(i.options, t), P(e.options, t), j = !0) : j && (i.setOptions(i.userOptions), e.setOptions(e.userOptions), j = !1));
        }
        class D extends b {
            static compose(t) {
                O(c, "TreemapSeries") && x(t, "afterBindAxes", N);
            }
            algorithmCalcPoints(t, e, i, s) {
                let r = i.plot, o = i.elArr.length - 1, l, a, n, h, d = i.lW, p = i.lH, u, c = 0;
                for (let t of (e ? (d = i.nW, p = i.nH) : u = i.elArr[o], i.elArr))(e || c < o) && (0 === i.direction ? (l = r.x, a = r.y, h = t / (n = d)) : (l = r.x, a = r.y, n = t / (h = p)), s.push({
                    x: l,
                    y: a,
                    width: n,
                    height: T(h)
                }), 0 === i.direction ? r.y = r.y + h : r.x = r.x + n), c += 1;
                i.reset(), 0 === i.direction ? i.width = i.width - d : i.height = i.height - p, r.y = r.parent.y + (r.parent.height - i.height), r.x = r.parent.x + (r.parent.width - i.width), t && (i.direction = 1 - i.direction), e || i.addElement(u);
            }
            algorithmFill(t, e, i) {
                let s = [], r, o = e.direction, l = e.x, a = e.y, n = e.width, h = e.height, d, p, u, c;
                for (let g of i)r = e.width * e.height * (g.val / e.val), d = l, p = a, 0 === o ? (n -= u = r / (c = h), l += u) : (h -= c = r / (u = n), a += c), s.push({
                    x: d,
                    y: p,
                    width: u,
                    height: c
                }), t && (o = 1 - o);
                return s;
            }
            algorithmLowAspectRatio(t, e, i) {
                let s = [], r = {
                    x: e.x,
                    y: e.y,
                    parent: e
                }, l = e.direction, a = i.length - 1, n = new o(e.height, e.width, l, r), h, d = 0;
                for (let o of i)h = e.width * e.height * (o.val / e.val), n.addElement(h), n.lP.nR > n.lP.lR && this.algorithmCalcPoints(t, !1, n, s, r), d === a && this.algorithmCalcPoints(t, !0, n, s, r), ++d;
                return s;
            }
            alignDataLabel(t, e, i) {
                let s = i.style;
                s && !S(s.textOverflow) && e.text && e.getBBox().width > (e.text.textWidth || 0) && e.css({
                    textOverflow: "ellipsis",
                    width: s.width += "px"
                }), v.prototype.alignDataLabel.apply(this, arguments), t.dataLabel && t.dataLabel.attr({
                    zIndex: (t.node.zIndex || 0) + 1
                });
            }
            calculateChildrenAreas(t, e) {
                let i = this.options, s = this.mapOptionsToLevel[t.level + 1], r = I(this[s && s.layoutAlgorithm] && s.layoutAlgorithm, i.layoutAlgorithm), o = i.alternateStartingDirection, l = t.children.filter((t)=>!t.ignore), a = [];
                s && s.layoutStartingDirection && (e.direction = "vertical" === s.layoutStartingDirection ? 0 : 1), a = this[r](e, l);
                let n = -1;
                for (let t of l){
                    let i = a[++n];
                    t.values = B(i, {
                        val: t.childrenTotal,
                        direction: o ? 1 - e.direction : e.direction
                    }), t.pointValues = B(i, {
                        x: i.x / this.axisRatio,
                        y: 100 - i.y - i.height,
                        width: i.width / this.axisRatio
                    }), t.children.length && this.calculateChildrenAreas(t, t.values);
                }
            }
            createList(t) {
                let e = this.chart, i = e.breadcrumbs, s = [];
                if (i) {
                    let i = 0;
                    s.push({
                        level: i,
                        levelOptions: e.series[0]
                    });
                    let r = t.target.nodeMap[t.newRootId], o = [];
                    for(; r.parent || "" === r.parent;)o.push(r), r = t.target.nodeMap[r.parent];
                    for (let t of o.reverse())s.push({
                        level: ++i,
                        levelOptions: t
                    });
                    s.length <= 1 && (s.length = 0);
                }
                return s;
            }
            drawDataLabels() {
                let t, e;
                let i = this.mapOptionsToLevel;
                for (let s of this.points.filter(function(t) {
                    return t.node.visible;
                }))e = i[s.node.level], t = {
                    style: {}
                }, s.node.isLeaf || (t.enabled = !1), e && e.dataLabels && (t = B(t, e.dataLabels), this.hasDataLabels = ()=>!0), s.shapeArgs && (t.style.width = s.shapeArgs.width, s.dataLabel && s.dataLabel.css({
                    width: s.shapeArgs.width + "px"
                })), s.dlOptions = B(t, s.options.dataLabels);
                super.drawDataLabels();
            }
            drawPoints(t = this.points) {
                let e = this.chart, i = e.renderer, s = e.styledMode, r = this.options, o = s ? {} : r.shadow, l = r.borderRadius, a = e.pointCount < r.animationLimit, n = r.allowTraversingTree;
                for (let e of t){
                    let t = e.node.levelDynamic, h = {}, d = {}, p = {}, u = "level-group-" + e.node.level, c = !!e.graphic, g = a && c, v = e.shapeArgs;
                    e.shouldDraw() && (e.isInside = !0, l && (d.r = l), B(!0, g ? h : d, c ? v : {}, s ? {} : this.pointAttribs(e, e.selected ? "select" : void 0)), this.colorAttribs && s && P(p, this.colorAttribs(e)), this[u] || (this[u] = i.g(u).attr({
                        zIndex: 1e3 - (t || 0)
                    }).add(this.group), this[u].survive = !0)), e.draw({
                        animatableAttribs: h,
                        attribs: d,
                        css: p,
                        group: this[u],
                        imageUrl: e.imageUrl,
                        renderer: i,
                        shadow: o,
                        shapeArgs: v,
                        shapeType: e.shapeType
                    }), n && e.graphic && (e.drillId = r.interactByLeaf ? this.drillToByLeaf(e) : this.drillToByGroup(e));
                }
            }
            drillToByGroup(t) {
                let e = !1;
                return t.node.isLeaf || t.node.level - this.nodeMap[this.rootNode].level != 1 || (e = t.id), e;
            }
            drillToByLeaf(t) {
                let e = !1, i;
                if (t.node.parent !== this.rootNode && t.node.isLeaf) for(i = t.node; !e;)(i = this.nodeMap[i.parent]).parent === this.rootNode && (e = i.id);
                return e;
            }
            drillToNode(t, e) {
                L(32, !1, void 0, {
                    "treemap.drillToNode": "use treemap.setRootNode"
                }), this.setRootNode(t, e);
            }
            drillUp() {
                let t = this.nodeMap[this.rootNode];
                t && R(t.parent) && this.setRootNode(t.parent, !0, {
                    trigger: "traverseUpButton"
                });
            }
            getExtremes() {
                let { dataMin: t, dataMax: e } = super.getExtremes(this.colorValueData);
                return this.valueMin = t, this.valueMax = e, super.getExtremes();
            }
            getListOfParents(t, e) {
                let i = A(t) ? t : [], s = A(e) ? e : [], r = i.reduce(function(t, e, i) {
                    let s = I(e.parent, "");
                    return void 0 === t[s] && (t[s] = []), t[s].push(i), t;
                }, {
                    "": []
                });
                for (let t of Object.keys(r)){
                    let e = r[t];
                    if ("" !== t && -1 === s.indexOf(t)) {
                        for (let t of e)r[""].push(t);
                        delete r[t];
                    }
                }
                return r;
            }
            getTree() {
                let t = this.data.map(function(t) {
                    return t.id;
                }), e = this.getListOfParents(this.data, t);
                return this.nodeMap = {}, this.nodeList = [], this.buildTree("", -1, 0, e);
            }
            buildTree(t, e, i, s, r) {
                let o = [], l = this.points[e], a = 0, n;
                for (let e of s[t] || [])a = Math.max((n = this.buildTree(this.points[e].id, e, i + 1, s, t)).height + 1, a), o.push(n);
                let h = new this.NodeClass().init(t, e, o, a, i, this, r);
                for (let t of o)t.parentNode = h;
                return this.nodeMap[h.id] = h, this.nodeList.push(h), l && (l.node = h, h.point = l), h;
            }
            hasData() {
                return !!this.processedXData.length;
            }
            init(e, i) {
                let s = this, r = B(i.drillUpButton, i.breadcrumbs), o = x(s, "setOptions", (t)=>{
                    let e = t.userOptions;
                    S(e.allowDrillToNode) && !S(e.allowTraversingTree) && (e.allowTraversingTree = e.allowDrillToNode, delete e.allowDrillToNode), S(e.drillUpButton) && !S(e.traverseUpButton) && (e.traverseUpButton = e.drillUpButton, delete e.drillUpButton);
                });
                super.init(e, i), delete s.opacity, s.eventsToUnbind.push(o), s.options.allowTraversingTree && (s.eventsToUnbind.push(x(s, "click", s.onClickDrillToNode)), s.eventsToUnbind.push(x(s, "setRootNode", function(t) {
                    let e = s.chart;
                    e.breadcrumbs && e.breadcrumbs.updateProperties(s.createList(t));
                })), s.eventsToUnbind.push(x(s, "update", function(t, e) {
                    let i = this.chart.breadcrumbs;
                    i && t.options.breadcrumbs && i.update(t.options.breadcrumbs);
                })), s.eventsToUnbind.push(x(s, "destroy", function(t) {
                    let e = this.chart;
                    e.breadcrumbs && !t.keepEventsForUpdate && (e.breadcrumbs.destroy(), e.breadcrumbs = void 0);
                }))), e.breadcrumbs || (e.breadcrumbs = new t(e, r)), s.eventsToUnbind.push(x(e.breadcrumbs, "up", function(t) {
                    let e = this.level - t.newLevel;
                    for(let t = 0; t < e; t++)s.drillUp();
                }));
            }
            onClickDrillToNode(t) {
                let e = t.point, i = e && e.drillId;
                R(i) && (e.setState(""), this.setRootNode(i, !0, {
                    trigger: "click"
                }));
            }
            pointAttribs(t, e) {
                let i;
                let s = C(this.mapOptionsToLevel) ? this.mapOptionsToLevel : {}, r = t && s[t.node.level] || {}, o = this.options, l = e && o.states && o.states[e] || {}, a = t && t.getClassName() || "", n = {
                    stroke: t && t.borderColor || r.borderColor || l.borderColor || o.borderColor,
                    "stroke-width": I(t && t.borderWidth, r.borderWidth, l.borderWidth, o.borderWidth),
                    dashstyle: t && t.borderDashStyle || r.borderDashStyle || l.borderDashStyle || o.borderDashStyle,
                    fill: t && t.color || this.color
                };
                return -1 !== a.indexOf("highcharts-above-level") ? (n.fill = "none", n["stroke-width"] = 0) : -1 !== a.indexOf("highcharts-internal-node-interactive") ? (i = I(l.opacity, o.opacity), n.fill = u(n.fill).setOpacity(i).get(), n.cursor = "pointer") : -1 !== a.indexOf("highcharts-internal-node") ? n.fill = "none" : e && (n.fill = u(n.fill).brighten(l.brightness).get()), n;
            }
            setColorRecursive(t, e, i, s, r) {
                let o = this && this.chart, l = o && o.options && o.options.colors;
                if (t) {
                    let o = m(t, {
                        colors: l,
                        index: s,
                        mapOptionsToLevel: this.mapOptionsToLevel,
                        parentColor: e,
                        parentColorIndex: i,
                        series: this,
                        siblings: r
                    }), a = this.points[t.i];
                    a && (a.color = o.color, a.colorIndex = o.colorIndex);
                    let n = -1;
                    for (let e of t.children || [])this.setColorRecursive(e, o.color, o.colorIndex, ++n, t.children.length);
                }
            }
            setPointValues() {
                let t = this, { points: e, xAxis: i, yAxis: s } = t, r = t.chart.styledMode, o = (e)=>r ? 0 : (t.pointAttribs(e)["stroke-width"] || 0) % 2 / 2;
                for (let t of e){
                    let { pointValues: e, visible: r } = t.node;
                    if (e && r) {
                        let { height: r, width: l, x: a, y: n } = e, h = o(t), d = Math.round(i.toPixels(a, !0)) - h, p = Math.round(i.toPixels(a + l, !0)) - h, u = Math.round(s.toPixels(n, !0)) - h, c = Math.round(s.toPixels(n + r, !0)) - h, g = {
                            x: Math.min(d, p),
                            y: Math.min(u, c),
                            width: Math.abs(p - d),
                            height: Math.abs(c - u)
                        };
                        t.plotX = g.x + g.width / 2, t.plotY = g.y + g.height / 2, t.shapeArgs = g;
                    } else delete t.plotX, delete t.plotY;
                }
            }
            setRootNode(t, e, i) {
                w(this, "setRootNode", P({
                    newRootId: t,
                    previousRootId: this.rootNode,
                    redraw: I(e, !0),
                    series: this
                }, i), function(t) {
                    let e = t.series;
                    e.idPreviousRoot = t.previousRootId, e.rootNode = t.newRootId, e.isDirty = !0, t.redraw && e.chart.redraw();
                });
            }
            setState(t) {
                this.options.inactiveOtherPoints = !0, super.setState(t, !1), this.options.inactiveOtherPoints = !1;
            }
            setTreeValues(t) {
                let e = this.options, i = this.rootNode, s = this.nodeMap[i], r = "boolean" != typeof e.levelIsConstant || e.levelIsConstant, o = [], l = this.points[t.i], a = 0;
                for (let e of t.children)e = this.setTreeValues(e), o.push(e), e.ignore || (a += e.val);
                M(o, (t, e)=>(t.sortIndex || 0) - (e.sortIndex || 0));
                let n = I(l && l.options.value, a);
                return l && (l.value = n), P(t, {
                    children: o,
                    childrenTotal: a,
                    ignore: !(I(l && l.visible, !0) && n > 0),
                    isLeaf: t.visible && !a,
                    levelDynamic: t.level - (r ? 0 : s.level),
                    name: I(l && l.name, ""),
                    sortIndex: I(l && l.sortIndex, -n),
                    val: n
                }), t;
            }
            sliceAndDice(t, e) {
                return this.algorithmFill(!0, t, e);
            }
            squarified(t, e) {
                return this.algorithmLowAspectRatio(!0, t, e);
            }
            strip(t, e) {
                return this.algorithmLowAspectRatio(!1, t, e);
            }
            stripes(t, e) {
                return this.algorithmFill(!1, t, e);
            }
            translate() {
                let t = this, e = t.options, i = y(t), s, r, o, l;
                super.translate();
                let a = t.tree = t.getTree();
                s = t.nodeMap[i], "" === i || s && s.children.length || (t.setRootNode("", !1), i = t.rootNode, s = t.nodeMap[i]), t.mapOptionsToLevel = f({
                    from: s.level + 1,
                    levels: e.levels,
                    to: a.height,
                    defaults: {
                        levelIsConstant: t.options.levelIsConstant,
                        colorByPoint: e.colorByPoint
                    }
                }), h.recursive(t.nodeMap[t.rootNode], (e)=>{
                    let i = e.parent, s = !1;
                    return e.visible = !0, (i || "" === i) && (s = t.nodeMap[i]), s;
                }), h.recursive(t.nodeMap[t.rootNode].children, (t)=>{
                    let e = !1;
                    for (let i of t)i.visible = !0, i.children.length && (e = (e || []).concat(i.children));
                    return e;
                }), t.setTreeValues(a), t.axisRatio = t.xAxis.len / t.yAxis.len, t.nodeMap[""].pointValues = r = {
                    x: 0,
                    y: 0,
                    width: 100,
                    height: 100
                }, t.nodeMap[""].values = o = B(r, {
                    width: r.width * t.axisRatio,
                    direction: "vertical" === e.layoutStartingDirection ? 0 : 1,
                    val: a.val
                }), t.calculateChildrenAreas(a, o), t.colorAxis || e.colorByPoint || t.setColorRecursive(t.tree), e.allowTraversingTree && (l = s.pointValues, t.xAxis.setExtremes(l.x, l.x + l.width, !1), t.yAxis.setExtremes(l.y, l.y + l.height, !1), t.xAxis.setScale(), t.yAxis.setScale()), t.setPointValues();
            }
        }
        return D.defaultOptions = B(b.defaultOptions, n), P(D.prototype, {
            buildKDTree: g,
            colorAttribs: i.seriesMembers.colorAttribs,
            colorKey: "colorValue",
            directTouch: !0,
            getExtremesFromAll: !0,
            getSymbol: g,
            optionalAxis: "colorAxis",
            parallelArrays: [
                "x",
                "y",
                "value",
                "colorValue"
            ],
            pointArrayMap: [
                "value"
            ],
            pointClass: a,
            NodeClass: l,
            trackerGroups: [
                "group",
                "dataLabelsGroup"
            ],
            utils: h
        }), i.compose(D), r.registerSeriesType("treemap", D), D;
    }), i(e, "Series/Sunburst/SunburstPoint.js", [
        e["Core/Series/SeriesRegistry.js"],
        e["Core/Utilities.js"]
    ], function(t, e) {
        let { series: { prototype: { pointClass: i } }, seriesTypes: { treemap: { prototype: { pointClass: s } } } } = t, { correctFloat: r, extend: o, pInt: l } = e;
        class a extends s {
            getDataLabelPath(t) {
                let e = this.series.chart.renderer, i = this.shapeExisting, s = i.r + l(t.options?.distance || 0), o = i.start, a = i.end, n = o + (a - o) / 2, h = n < 0 && n > -Math.PI || n > Math.PI, d;
                return o === -Math.PI / 2 && r(a) === r(1.5 * Math.PI) && (o = -Math.PI + Math.PI / 360, a = -Math.PI / 360, h = !0), a - o > Math.PI && (h = !1, d = !0, a - o > 2 * Math.PI - .01 && (o += .01, a -= .01)), this.dataLabelPath && (this.dataLabelPath = this.dataLabelPath.destroy()), this.dataLabelPath = e.arc({
                    open: !0,
                    longArc: d ? 1 : 0
                }).attr({
                    start: h ? o : a,
                    end: h ? a : o,
                    clockwise: +h,
                    x: i.x,
                    y: i.y,
                    r: (s + i.innerR) / 2
                }).add(e.defs), this.dataLabelPath;
            }
            isValid() {
                return !0;
            }
        }
        return o(a.prototype, {
            getClassName: i.prototype.getClassName,
            haloPath: i.prototype.haloPath,
            setState: i.prototype.setState
        }), a;
    }), i(e, "Series/Sunburst/SunburstUtilities.js", [
        e["Core/Series/SeriesRegistry.js"],
        e["Core/Utilities.js"]
    ], function(t, e) {
        let { seriesTypes: { treemap: i } } = t, { isNumber: s, isObject: r, merge: o } = e;
        function l(t, e) {
            let i = [];
            if (s(t) && s(e) && t <= e) for(let s = t; s <= e; s++)i.push(s);
            return i;
        }
        return {
            calculateLevelSizes: function(t, e) {
                let i = r(e) ? e : {}, a, n = 0, h, d, p, u;
                if (r(t)) {
                    for (let e of (a = o({}, t), d = l(s(i.from) ? i.from : 0, s(i.to) ? i.to : 0), p = Object.keys(a).filter((t)=>-1 === d.indexOf(+t)), h = u = s(i.diffRadius) ? i.diffRadius : 0, d)){
                        let t = a[e], i = t.levelSize.unit, s = t.levelSize.value;
                        "weight" === i ? n += s : "percentage" === i ? (t.levelSize = {
                            unit: "pixels",
                            value: s / 100 * h
                        }, u -= t.levelSize.value) : "pixels" === i && (u -= s);
                    }
                    for (let t of d){
                        let e = a[t];
                        if ("weight" === e.levelSize.unit) {
                            let i = e.levelSize.value;
                            a[t].levelSize = {
                                unit: "pixels",
                                value: i / n * u
                            };
                        }
                    }
                    for (let t of p)a[t].levelSize = {
                        value: 0,
                        unit: "pixels"
                    };
                }
                return a;
            },
            getLevelFromAndTo: function({ level: t, height: e }) {
                return {
                    from: t > 0 ? t : 1,
                    to: t + e
                };
            },
            range: l,
            recursive: i.prototype.utils.recursive
        };
    }), i(e, "Series/Sunburst/SunburstNode.js", [
        e["Series/Treemap/TreemapNode.js"]
    ], function(t) {
        return class extends t {
        };
    }), i(e, "Series/Sunburst/SunburstSeriesDefaults.js", [], function() {
        return {
            center: [
                "50%",
                "50%"
            ],
            clip: !1,
            colorByPoint: !1,
            opacity: 1,
            dataLabels: {
                allowOverlap: !0,
                defer: !0,
                rotationMode: "circular",
                style: {
                    textOverflow: "ellipsis"
                }
            },
            rootId: void 0,
            levelIsConstant: !0,
            levelSize: {
                value: 1,
                unit: "weight"
            },
            slicedOffset: 10
        };
    }), i(e, "Series/Sunburst/SunburstSeries.js", [
        e["Series/CenteredUtilities.js"],
        e["Core/Globals.js"],
        e["Core/Series/SeriesRegistry.js"],
        e["Series/Sunburst/SunburstPoint.js"],
        e["Series/Sunburst/SunburstUtilities.js"],
        e["Series/TreeUtilities.js"],
        e["Core/Utilities.js"],
        e["Series/Sunburst/SunburstNode.js"],
        e["Series/Sunburst/SunburstSeriesDefaults.js"]
    ], function(t, e, i, s, r, o, l, a, n) {
        let { getCenter: h, getStartAndEndRadians: d } = t, { noop: p } = e, { column: u, treemap: c } = i.seriesTypes, { getColor: g, getLevelOptions: v, setTreeValues: b, updateRootId: m } = o, { defined: f, error: y, extend: x, fireEvent: T, isNumber: S, isObject: L, isString: P, merge: w, splat: A } = l, C = 180 / Math.PI, R = function(t, e, i, s) {
            return {
                x: t + Math.cos(i) * s,
                y: e + Math.sin(i) * s
            };
        };
        function B(t, e) {
            let i = e.mapIdToNode, s = t.parent, r = s ? i[s] : void 0, o = e.series, l = o.chart, a = o.points[t.i], n = g(t, {
                colors: o.options.colors || l && l.options.colors,
                colorIndex: o.colorIndex,
                index: e.index,
                mapOptionsToLevel: e.mapOptionsToLevel,
                parentColor: r && r.color,
                parentColorIndex: r && r.colorIndex,
                series: e.series,
                siblings: e.siblings
            });
            return t.color = n.color, t.colorIndex = n.colorIndex, a && (a.color = t.color, a.colorIndex = t.colorIndex, t.sliced = t.id !== e.idRoot && a.sliced), t;
        }
        class I extends c {
            alignDataLabel(t, e, i) {
                if (!i.textPath || !i.textPath.enabled) return super.alignDataLabel.apply(this, arguments);
            }
            animate(t) {
                let e;
                let i = this.chart, s = [
                    i.plotWidth / 2,
                    i.plotHeight / 2
                ], r = i.plotLeft, o = i.plotTop, l = this.group;
                t ? (e = {
                    translateX: s[0] + r,
                    translateY: s[1] + o,
                    scaleX: .001,
                    scaleY: .001,
                    rotation: 10,
                    opacity: .01
                }, l.attr(e)) : (e = {
                    translateX: r,
                    translateY: o,
                    scaleX: 1,
                    scaleY: 1,
                    rotation: 0,
                    opacity: 1
                }, l.animate(e, this.options.animation));
            }
            drawPoints() {
                let t = this, e = t.mapOptionsToLevel, i = t.shapeRoot, s = t.group, r = t.hasRendered, o = t.rootNode, l = t.idPreviousRoot, a = t.nodeMap, n = a[l], h = n && n.shapeArgs, d = t.points, p = t.startAndEndRadians, c = t.chart, g = c && c.options && c.options.chart || {}, v = "boolean" != typeof g.animation || g.animation, b = t.center, m = {
                    x: b[0],
                    y: b[1]
                }, y = b[3] / 2, T = t.chart.renderer, P = !!(v && r && o !== l && t.dataLabelsGroup), R, B = !1, I = !1;
                for (let n of (P && (t.dataLabelsGroup.attr({
                    opacity: 0
                }), R = function() {
                    B = !0, t.dataLabelsGroup && t.dataLabelsGroup.animate({
                        opacity: 1,
                        visibility: "inherit"
                    });
                }), d)){
                    let d, u;
                    let g = n.node, b = e[g.level], P = n.shapeExisting || {}, B = g.shapeArgs || {}, O = !!(g.visible && g.shapeArgs);
                    B.borderRadius = t.options.borderRadius, d = r && v ? function(t, e) {
                        let i = e.point, s = e.radians, r = e.innerR, o = e.idRoot, l = e.idPreviousRoot, a = e.shapeExisting, n = e.shapeRoot, h = e.shapePreviousRoot, d = e.visible, p = {}, u = {
                            end: t.end,
                            start: t.start,
                            innerR: t.innerR,
                            r: t.r,
                            x: t.x,
                            y: t.y
                        };
                        return d ? !i.graphic && h && ((p = o === i.id ? {
                            start: s.start,
                            end: s.end
                        } : h.end <= t.start ? {
                            start: s.end,
                            end: s.end
                        } : {
                            start: s.start,
                            end: s.start
                        }).innerR = p.r = r) : i.graphic && (l === i.id ? u = {
                            innerR: r,
                            r: r
                        } : n && (u = n.end <= a.start ? {
                            innerR: r,
                            r: r,
                            start: s.end,
                            end: s.end
                        } : {
                            innerR: r,
                            r: r,
                            start: s.start,
                            end: s.start
                        })), {
                            from: p,
                            to: u
                        };
                    }(B, {
                        center: m,
                        point: n,
                        radians: p,
                        innerR: y,
                        idRoot: o,
                        idPreviousRoot: l,
                        shapeExisting: P,
                        shapeRoot: i,
                        shapePreviousRoot: h,
                        visible: O
                    }) : {
                        to: B,
                        from: {}
                    }, x(n, {
                        shapeExisting: B,
                        tooltipPos: [
                            B.plotX,
                            B.plotY
                        ],
                        drillId: function(t, e, i) {
                            let s;
                            return t.node.isLeaf || (s = e === t.id ? i[e].parent : t.id), s;
                        }(n, o, a),
                        name: "" + (n.name || n.id || n.index),
                        plotX: B.plotX,
                        plotY: B.plotY,
                        value: g.val,
                        isInside: O,
                        isNull: !O
                    }), n.dlOptions = function(t) {
                        let e = t.point, i = L(t.shapeArgs) ? t.shapeArgs : {}, s = L(t.optionsPoint) ? t.optionsPoint.dataLabels : {}, r = w({
                            style: {}
                        }, A(L(t.level) ? t.level.dataLabels : {})[0], s), o, l, a = r.rotationMode;
                        return S(r.rotation) || (("auto" === a || "circular" === a) && (r.useHTML && "circular" === a && (a = "auto"), e.innerArcLength < 1 && e.outerArcLength > i.radius ? (o = 0, e.dataLabelPath && "circular" === a && (r.textPath = {
                            enabled: !0
                        })) : e.innerArcLength > 1 && e.outerArcLength > 1.5 * i.radius ? "circular" === a ? r.textPath = {
                            enabled: !0,
                            attributes: {
                                dy: 5
                            }
                        } : a = "parallel" : (e.dataLabel && e.dataLabel.textPath && "circular" === a && (r.textPath = {
                            enabled: !1
                        }), a = "perpendicular")), "auto" !== a && "circular" !== a && (e.dataLabel && e.dataLabel.textPath && (r.textPath = {
                            enabled: !1
                        }), o = i.end - (i.end - i.start) / 2), "parallel" === a ? r.style.width = Math.min(2.5 * i.radius, (e.outerArcLength + e.innerArcLength) / 2) : !f(r.style.width) && i.radius && (r.style.width = 1 === e.node.level ? 2 * i.radius : i.radius), "perpendicular" === a && e.outerArcLength < 16 && (r.style.width = 1), r.style.width = Math.max(r.style.width - 2 * (r.padding || 0), 1), l = o * C % 180, "parallel" === a && (l -= 90), l > 90 ? l -= 180 : l < -90 && (l += 180), r.rotation = l), r.textPath && (0 === e.shapeExisting.innerR && r.textPath.enabled ? (r.rotation = 0, r.textPath.enabled = !1, r.style.width = Math.max(2 * e.shapeExisting.r - 2 * (r.padding || 0), 1)) : e.dlOptions && e.dlOptions.textPath && !e.dlOptions.textPath.enabled && "circular" === a && (r.textPath.enabled = !0), r.textPath.enabled && (r.rotation = 0, r.style.width = Math.max((e.outerArcLength + e.innerArcLength) / 2 - 2 * (r.padding || 0), 1))), r;
                    }({
                        point: n,
                        level: b,
                        optionsPoint: n.options,
                        shapeArgs: B
                    }), !I && O && (I = !0, u = R), n.draw({
                        animatableAttribs: d.to,
                        attribs: x(d.from, !c.styledMode && t.pointAttribs(n, n.selected && "select")),
                        onComplete: u,
                        group: s,
                        renderer: T,
                        shapeType: "arc",
                        shapeArgs: B
                    });
                }
                P && I ? (t.hasRendered = !1, t.options.dataLabels.defer = !0, u.prototype.drawDataLabels.call(t), t.hasRendered = !0, B && R()) : u.prototype.drawDataLabels.call(t), t.idPreviousRoot = o;
            }
            layoutAlgorithm(t, e, i) {
                let s = t.start, r = t.end - s, o = t.val, l = t.x, a = t.y, n = i && L(i.levelSize) && S(i.levelSize.value) ? i.levelSize.value : 0, h = t.r, d = h + n, p = i && S(i.slicedOffset) ? i.slicedOffset : 0;
                return (e || []).reduce((t, e)=>{
                    let i = 1 / o * e.val * r, u = R(l, a, s + i / 2, p), c = {
                        x: e.sliced ? u.x : l,
                        y: e.sliced ? u.y : a,
                        innerR: h,
                        r: d,
                        radius: n,
                        start: s,
                        end: s + i
                    };
                    return t.push(c), s = c.end, t;
                }, []);
            }
            setRootNode(t, e, i) {
                if (1 === this.nodeMap[t].level && 1 === this.nodeList.filter((t)=>1 === t.level).length) {
                    if ("" === this.idPreviousRoot) return;
                    t = "";
                }
                super.setRootNode(t, e, i);
            }
            setShapeArgs(t, e, i) {
                let s = i[t.level + 1], r = t.children.filter(function(t) {
                    return t.visible;
                }), o = [];
                o = this.layoutAlgorithm(e, r, s);
                let l = -1;
                for (let t of r){
                    let e = o[++l], s = e.start + (e.end - e.start) / 2, r = e.innerR + (e.r - e.innerR) / 2, a = e.end - e.start, n = 0 === e.innerR && a > 6.28 ? {
                        x: e.x,
                        y: e.y
                    } : R(e.x, e.y, s, r), h = t.val ? t.childrenTotal > t.val ? t.childrenTotal : t.val : t.childrenTotal;
                    this.points[t.i] && (this.points[t.i].innerArcLength = a * e.innerR, this.points[t.i].outerArcLength = a * e.r), t.shapeArgs = w(e, {
                        plotX: n.x,
                        plotY: n.y
                    }), t.values = w(e, {
                        val: h
                    }), t.children.length && this.setShapeArgs(t, t.values, i);
                }
            }
            translate() {
                let t = this.options, e = this.center = this.getCenter(), i = this.startAndEndRadians = d(t.startAngle, t.endAngle), s = e[3] / 2, o = e[2] / 2, l = m(this), a = this.nodeMap, n, h = a && a[l], p = {};
                this.shapeRoot = h && h.shapeArgs, this.processedXData || this.processData(), this.generatePoints(), T(this, "afterTranslate");
                let u = this.tree = this.getTree(), c = P((h = (a = this.nodeMap)[l]).parent) ? h.parent : "", g = a[c], { from: f, to: x } = r.getLevelFromAndTo(h);
                n = v({
                    from: f,
                    levels: this.options.levels,
                    to: x,
                    defaults: {
                        colorByPoint: t.colorByPoint,
                        dataLabels: t.dataLabels,
                        levelIsConstant: t.levelIsConstant,
                        levelSize: t.levelSize,
                        slicedOffset: t.slicedOffset
                    }
                }), n = r.calculateLevelSizes(n, {
                    diffRadius: o - s,
                    from: f,
                    to: x
                }), b(u, {
                    before: B,
                    idRoot: l,
                    levelIsConstant: t.levelIsConstant,
                    mapOptionsToLevel: n,
                    mapIdToNode: a,
                    points: this.points,
                    series: this
                });
                let S = a[""].shapeArgs = {
                    end: i.end,
                    r: s,
                    start: i.start,
                    val: h.val,
                    x: e[0],
                    y: e[1]
                };
                for (let t of (this.setShapeArgs(g, S, n), this.mapOptionsToLevel = n, this.points))p[t.id] && y(31, !1, this.chart), p[t.id] = !0;
            }
        }
        return I.defaultOptions = w(c.defaultOptions, n), x(I.prototype, {
            axisTypes: [],
            drawDataLabels: p,
            getCenter: h,
            isCartesian: !1,
            onPointSupported: !0,
            pointAttribs: u.prototype.pointAttribs,
            pointClass: s,
            NodeClass: a,
            utils: r
        }), i.registerSeriesType("sunburst", I), I;
    }), i(e, "masters/modules/sunburst.src.js", [
        e["Core/Globals.js"],
        e["Extensions/Breadcrumbs/Breadcrumbs.js"]
    ], function(t, e) {
        return t.Breadcrumbs = t.Breadcrumbs || e, t.Breadcrumbs.compose(t.Chart, t.defaultOptions), t;
    });
});


document.documentElement.style.setProperty("--highcharts-background-color", "transparent");
(0, (/*@__PURE__*/$parcel$interopDefault($bgb0K)))((0, (/*@__PURE__*/$parcel$interopDefault($e4258fc7f271b870$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($6v3SG)))((0, (/*@__PURE__*/$parcel$interopDefault($e4258fc7f271b870$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($hNNPC)))((0, (/*@__PURE__*/$parcel$interopDefault($e4258fc7f271b870$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($iMzGG)))((0, (/*@__PURE__*/$parcel$interopDefault($e4258fc7f271b870$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($3ea97dafd17a1a6b$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($e4258fc7f271b870$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($e4258fc7f271b870$exports))).setOptions({
    chart: {
        height: "100%",
        styledMode: true
    },
    credits: {
        enabled: false
    }
});
window.Highcharts = (0, (/*@__PURE__*/$parcel$interopDefault($e4258fc7f271b870$exports)));
window.group_stats = function(url, chart_selector) {
    $.getJSON(url, function(data) {
        $(chart_selector).each(function(_, e) {
            const dataset = e.dataset.dataset;
            if (!dataset) {
                console.log("dataset data attribute not set");
                return;
            }
            const area = e.dataset.area;
            if (!area) {
                console.log("area data attribute not set");
                return;
            }
            const chart = (0, (/*@__PURE__*/$parcel$interopDefault($e4258fc7f271b870$exports))).chart(e, {
                title: {
                    text: `${dataset == "docs" ? "Documents" : "Pages"} in ${area.toUpperCase()}`
                },
                series: [
                    {
                        type: "sunburst",
                        data: [],
                        tooltip: {
                            pointFormatter: function() {
                                return `There ${this.value == 1 ? "is" : "are"} ${this.value} ${dataset == "docs" ? "documents" : "pages"} in ${this.name}.`;
                            }
                        },
                        dataLabels: {
                            formatter () {
                                return this.point.active ? this.point.name : `(${this.point.name})`;
                            }
                        },
                        allowDrillToNode: true,
                        cursor: "pointer",
                        levels: [
                            {
                                level: 1,
                                color: "transparent",
                                levelSize: {
                                    value: .5
                                }
                            },
                            {
                                level: 2,
                                colorByPoint: true
                            },
                            {
                                level: 3,
                                colorVariation: {
                                    key: "brightness",
                                    to: 0.5
                                }
                            }
                        ]
                    }
                ]
            });
            // limit data to area if set and (for now) drop docs
            const slice = data.filter((d)=>area == "ietf" && d.grandparent == area || d.parent == area || d.id == area).map((d)=>{
                return {
                    value: d[dataset],
                    id: d.id,
                    parent: d.parent,
                    grandparent: d.grandparent,
                    active: d.active
                };
            }).sort((a, b)=>{
                if (a.parent != b.parent) {
                    if (a.parent < b.parent) return -1;
                    if (a.parent > b.parent) return 1;
                } else if (a.parent == area) {
                    if (a.id < b.id) return 1;
                    if (a.id > b.id) return -1;
                    return 0;
                }
                return b.value - a.value;
            });
            chart.series[0].setData(slice);
        });
    });
};

})();
//# sourceMappingURL=highcharts.js.map
